/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Thatch API for web components
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessRequestsAccessRequest,
  AccessRequestsAccessRequestList,
  AdminComplianceAudit,
  AdminComplianceCheck,
  AdminComplianceOwner,
  AdminCompliancePolicy,
  AdminConsistentDeductionList,
  AdminCsvUploadResult,
  AdminEmployeesData,
  AdminEmployer,
  AdminEmployerData,
  AdminEmployerICHRAConfigAllowanceStructure,
  AdminEmployerOpenEnrollment,
  AdminEmployerOpenEnrollmentConfig,
  AdminEmployerOpenEnrollmentList,
  AdminEmployerProfile,
  AdminEnrollmentEvent,
  AdminEnrollmentEvents,
  AdminFinchOutput,
  AdminGenerateProjectedPricesResponse,
  AdminGranularAllowanceConfig,
  AdminGranularAllowanceConfigList,
  AdminIneligibleSpendEmployersList,
  AdminIneligibleSpendGenerationResponse,
  AdminIneligibleSpendPublishResponse,
  AdminMedicalPlanDataIngestionJobsScheduled,
  AdminMedicalPlanDataStateIngestionStatusList,
  AdminMedicalPlanDataStatusReport,
  AdminMedicalPlanIngestionsIngestionJobsList,
  AdminMergeIsolvedClientsList,
  AdminMergeUpdateResponse,
  AdminPaginatedEmployers,
  AdminPaginatedLedgerAccounts,
  AdminPaginatedLedgerEntries,
  AdminPaginatedMappedPlans,
  AdminPaginatedMedicalPlanProjections,
  AdminPaginatedReimbursements,
  AdminPaginatedSubstantiations,
  AdminPaginatedUnmappedPlans,
  AdminPartner,
  AdminPlaidAccount,
  AdminReimbursement,
  AdminReplaceProjectionsResponse,
  AdminSubstantiation,
  BrokersBrokerAttentionNeededItem,
  BrokersBrokerList,
  BrokersBrokerMemberDenormalized,
  BrokersBrokerage,
  BrokersCoverage,
  BrokersCoverageAuditLog,
  BrokersCoveredParticipant,
  BrokersEmployerICHRAConfig,
  BrokersEnrollment,
  BrokersEnrollmentEnriched,
  BrokersEnrollmentMappingOption,
  BrokersEnrollmentWithPaymentsOrCoverages,
  BrokersHandler,
  BrokersHold,
  BrokersICHRAData,
  BrokersJobStatistics,
  BrokersJobSummary,
  BrokersMonthlyCostOfCoverage,
  BrokersNote,
  BrokersNoteList,
  BrokersPaginatedAuditList,
  BrokersPaginatedBrokerAttentionNeededItemList,
  BrokersPaginatedCoverageAuditLogList,
  BrokersPaginatedEmployeeList,
  BrokersPaginatedEmployerList,
  BrokersPaginatedMemberList,
  BrokersPaginatedQualifyingLifeEventList,
  BrokersPaginatedStripeIssuingCardsList,
  BrokersPaginatedTaskList,
  BrokersPaginatedUnprocessedEnrollmentList,
  BrokersPaginatedWorkflowList,
  BrokersPremium,
  BrokersStripeIssuingCard,
  BrokersStripeIssuingCardCardholderDetails,
  BrokersStripeIssuingCardEphemeralKey,
  BrokersTag,
  BrokersTask,
  BrokersTaskCommand,
  BrokersTaskDetail,
  BrokersTaskJob,
  BrokersTaskResult,
  BrokersTaskType,
  BrokersTaskTypeStatistics,
  BrokersTaskTypeSummary,
  BrokersV2Hold,
  BrokersV2TaskStatistics,
  BrokersWorkflow,
  ChargeOrTxn,
  DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams,
  DeleteBrokersMembersMemberIdFileUploadsBlobIdParams,
  DeleteBrokersTasksByIdTaskIdLeaseParams,
  DeletePayrollPaySchedulesDeactivateParams,
  DeletePayrollPaySchedulesRemoveEmployeeParams,
  DepositAccountDetail,
  EmployersBankingPlaidAccount,
  EmployersBankingPlaidLinkToken,
  EmployersCompleteOnboardingOptions,
  EmployersComplianceOwner,
  EmployersCreatedUser,
  EmployersEmployee,
  EmployersEmployeesList,
  EmployersEmployer,
  EmployersEmployerAdmin,
  EmployersRenewalsEmployeeListMetadata,
  EmployersRenewalsPaginatedEmployeeList,
  EmployersRenewalsRateSummaryList,
  EmployersRenewalsRenewalConfig,
  EmployersRenewalsRenewalQuoteResults,
  GetAccessRequestsParams,
  GetAdminCompliancePoliciesParams,
  GetAdminEmployerOpenEnrollmentParams,
  GetAdminEmployersParams,
  GetAdminEnrollmentEventParams,
  GetAdminFinchApiBenefitsParams,
  GetAdminFinchApiDirectoryParams,
  GetAdminFinchApiEmploymentParams,
  GetAdminFinchApiIndividualParams,
  GetAdminFinchApiIntrospectParams,
  GetAdminFinchApiPayGroupParams,
  GetAdminFinchApiPayGroupsParams,
  GetAdminFinchApiPayStatementParams,
  GetAdminFinchApiPaymentParams,
  GetAdminFinchEmployerEmployeesParams,
  GetAdminFinchEmployerParams,
  GetAdminIneligibleSpendReportsParams,
  GetAdminLedgerAccountsIdParams,
  GetAdminLedgerAccountsParams,
  GetAdminLedgerEntriesParams,
  GetAdminMappedPlansParams,
  GetAdminMedicalPlanDataParams,
  GetAdminMedicalPlanIngestionsParams,
  GetAdminMedicalPlanProjectionsDownloadProjectionsParams,
  GetAdminMedicalPlanProjectionsParams,
  GetAdminMemberConsistentDeductionsParams,
  GetAdminMergeEmployerIsolvedClientsParams,
  GetAdminPartnersParams,
  GetAdminPlanMappingsDownloadTemplateParams,
  GetAdminReimbursementsParams,
  GetAdminSearchParams,
  GetAdminSubstantiationsParams,
  GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams,
  GetAdminUnmappedPlansParams,
  GetBrokersAuditsParams,
  GetBrokersBrokerAttentionNeededItemsParams,
  GetBrokersBrokerAttentionNeededItemsStatisticsParams,
  GetBrokersBrokersParams,
  GetBrokersCoverageAuditLogsParams,
  GetBrokersEmployersEmployerIdEmployeesParams,
  GetBrokersEmployersParams,
  GetBrokersMembersMemberIdCoveredParticipantsParams,
  GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams,
  GetBrokersMembersMemberIdEnrollmentsParams,
  GetBrokersMembersMemberIdIchraDataParams,
  GetBrokersMembersMemberIdQualifyingLifeEventsParams,
  GetBrokersMembersMemberIdStripeIssuingCardsParams,
  GetBrokersMembersMemberIdTransactionsParams,
  GetBrokersMembersParams,
  GetBrokersNotesParams,
  GetBrokersTagsParams,
  GetBrokersTaskWorkflowsParams,
  GetBrokersTasksByIdTaskIdPlaywrightCommandParams,
  GetBrokersTasksParams,
  GetBrokersTasksTaskTypesParams,
  GetBrokersTasksV2HoldsParams,
  GetBrokersTasksV2StatisticsParams,
  GetBrokersUnprocessedEnrollmentsParams,
  GetEmployersEmployeesDuplicatesParams,
  GetEmployersEmployeesParams,
  GetEmployersEmployeesPaySchedulesPayScheduleIdParams,
  GetEmployersRenewalsRenewalConfigsIdEmployeesParams,
  GetFeedbackPromptsNextParams,
  GetMarketplaceProductsParams,
  GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams,
  GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams,
  GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams,
  GetMemberOnboardingProofOfCoverageMostRecentParams,
  GetMemberOnboardingRecommendedPlansParams,
  GetMembersDepositAccountDetailsParams,
  GetMembersEnrollmentsParams,
  GetMembersInstructionsParams,
  GetMembersReimbursementsParams,
  GetMembersTransactionsBalanceAndBreakdownsParams,
  GetMembersTransactionsParams,
  GetPartnersEmployersParams,
  GetPartnersPartnerIdPartnerAdminsParams,
  GetPayrollAdpConnectCallbackParams,
  GetPayrollConsistentDeductionsParams,
  GetPayrollPayPeriodsParams,
  GetPayrollPaySchedulesParams,
  GetPayrollPaySchedulesPreviewParams,
  GetQuotingPricesQuoteIdParams,
  GetQuotingProspectsParams,
  GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams,
  GetQuotingProspectsProspectIdCensusParams,
  GetQuotingProspectsProspectIdQuotesParams,
  GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams,
  GetQuotingQuoteResultsQuoteIdPlansParams,
  GetQuotingQuoteResultsQuoteIdResultsParams,
  MarketplaceHappiestBabyAddEmployeeResult,
  MarketplaceProductList,
  MarketplaceProductRequest,
  MarketplacePurchase,
  MemberICHRAConfig,
  MemberOnboardingAdditionalParticipant,
  MemberOnboardingAdditionalParticipantsList,
  MemberOnboardingCarrierAgreement,
  MemberOnboardingDentalPlanList,
  MemberOnboardingInNetworkVerificationRecord,
  MemberOnboardingMedicalPlanDisplayItemDetailsList,
  MemberOnboardingMedicalPlanDisplayItemList,
  MemberOnboardingMemberEnrollment,
  MemberOnboardingMemberPlanChangesProps,
  MemberOnboardingOnboarding,
  MemberOnboardingPlanSelectionPreference,
  MemberOnboardingProofOfCoverage,
  MemberOnboardingRecommendedPlanListByCategory,
  MemberOnboardingSelectedPlan,
  MemberOnboardingSelectedPlansList,
  MemberOnboardingSmartBudgetRecommendations,
  MemberOnboardingVisionPlanList,
  MembersBalance,
  MembersCategorizedEnrollments,
  MembersPaginatedBalanceTransactionList,
  MembersPaginatedReimbursements,
  PaginatedChargeOrTxnList,
  PaginatedEnrollmentList,
  PartnersAdpOnboardingSessionRedirect,
  PartnersAdpResetResponse,
  PartnersEmbeddedMagicLink,
  PartnersEmbeddedSessionStatus,
  PartnersEmployer,
  PartnersPaginatedPartnerAdminList,
  PartnersPartner,
  PartnersPartnerAdmin,
  PatchAdminEmployersEmployerId,
  PatchAdminGranularAllowanceConfigsId,
  PatchAdminReimbursements,
  PatchAdminSubstantiations,
  PatchAdminSubstantiationsSubstantiationIdMatchReceipt,
  PatchBrokersBrokerAttentionNeededItems,
  PatchBrokersBrokerAttentionNeededItemsId,
  PatchBrokersCoverageAuditLogsAuditLogId,
  PatchBrokersMembersMemberIdCoveredParticipantsId,
  PatchBrokersMembersMemberIdTransactionsId,
  PatchBrokersNotesId,
  PatchBrokersTagsId,
  PatchBrokersTagsIdArchived,
  PatchBrokersTaskWorkflows,
  PatchBrokersTasks,
  PatchBrokersTasksJobsJobIdHoldsHoldId,
  PatchBrokersTasksTaskTypes,
  PatchBrokersTasksV2HoldsHoldId,
  PatchEmployersRenewalsRenewalConfigsIdUpdate,
  PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate,
  PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId,
  PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding,
  PatchMemberOnboardingPlanSelectionPreferencesId,
  PatchMembersInstructionsInstructionId,
  PatchPartnersEmployersIdAssignee,
  PatchQuotingProspectsProspectIdQuotesId,
  PayrollAdpConfig,
  PayrollPayPeriodConsistentDeductionsList,
  PayrollPayPeriodList,
  PayrollPaySchedule,
  PayrollPayScheduleList,
  PayrollPayrollConfig,
  PayrollProviderConfig,
  PayrollProviderConfigList,
  PayrollSamplePayPeriodList,
  PostAccessRequests,
  PostAdminComplianceChecks,
  PostAdminComplianceChecksCheckIdOverrideFailingCheck,
  PostAdminComplianceOwners,
  PostAdminEmployerOpenEnrollmentIdCohort,
  PostAdminEmployersEmployerIdComplianceAudits,
  PostAdminEnrollmentEvent,
  PostAdminFinchEmployerMergeEmployees,
  PostAdminFinchEmployerSync,
  PostAdminGranularAllowanceConfigs,
  PostAdminIneligibleSpendReportsEmployerIdGenerate,
  PostAdminIneligibleSpendReportsGenerateAll,
  PostAdminMedicalPlanDataRefreshStateStatusReport,
  PostAdminMedicalPlanDataRunIngestion,
  PostAdminMedicalPlanProjectionsGenerateProjectedPrices,
  PostAdminPlanMappingsAction,
  PostBrokersBrokerAttentionNeededItems,
  PostBrokersEmployersEmployerIdEmployeesInvite,
  PostBrokersMembersMemberIdCoveredParticipants,
  PostBrokersMembersMemberIdEnrollments,
  PostBrokersMembersMemberIdEnrollmentsIdCoverage,
  PostBrokersMembersMemberIdStripeIssuingCards,
  PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey,
  PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap,
  PostBrokersMembersMemberIdTransactionsIdMarkLoss,
  PostBrokersNotes,
  PostBrokersTags,
  PostBrokersTaskWorkflowsIdAction,
  PostBrokersTasksHandlersHandlerNameJobs,
  PostBrokersTasksJobsJobIdHolds,
  PostBrokersTasksTaskTypesTaskTypeExecute201,
  PostBrokersTasksTaskTypesTaskTypeHolds,
  PostBrokersTasksV2Holds,
  PostBrokersUnprocessedEnrollmentsIdAction,
  PostBrokersUnprocessedEnrollmentsIdAssign,
  PostEmployersBankingPlaidProcessLink,
  PostEmployersEmployeesDuplicates,
  PostEmployersEmployeesPaySchedulesPayScheduleId,
  PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote,
  PostEmployersEmployers,
  PostEmployersEmployersSetCurrentEmployer,
  PostEmployersOwners,
  PostEmployersRegistration,
  PostEmployersReportingEmployeeStatus,
  PostEmployersReportingEmployerBillingInvoice,
  PostFeedbackPrompts,
  PostFeedbackSubmissions,
  PostMarketplaceProductRequest,
  PostMarketplacePurchases,
  PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants,
  PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll,
  PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments,
  PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll,
  PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations,
  PostMemberOnboardingInNetworkVerification,
  PostMemberOnboardingPhoneVerificationVerify,
  PostMemberOnboardingPlanSelectionPreferences,
  PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate,
  PostMemberOnboardingRecommendedPlansSelect,
  PostPartnersAdpEmbeddedImportProspect,
  PostPartnersAdpEmbeddedJobIdOnboardingSession,
  PostPartnersAdpEmbeddedResetEmployerData,
  PostPartnersEmbeddedOnboardingSetPassword,
  PostPartnersPartnerIdPartnerAdmins,
  PostPayrollAdpConnectAuthorizeUri,
  PostPayrollFinchCreateConnectSession,
  PostPayrollFinchExchangeAuthorizationCode,
  PostPayrollKomboActivate,
  PostPayrollKomboCreateConnectLink,
  PostPayrollManageAutomatedDeductions,
  PostPayrollMergeCreateLinkToken,
  PostPayrollMergeExchangePublicToken,
  PostPayrollMergeSharedConnection,
  PostPayrollPaySchedules,
  PostQuotingProspectsProspectIdCensusCensusIdEmployees,
  PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate,
  PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents,
  PostQuotingProspectsProspectIdQuotes,
  PostQuotingProspectsProspectIdQuotesIdGenerate,
  PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity,
  PostQuotingProspectsProspectIdQuotesQuoteIdAllowances,
  PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks,
  PostQuotingQuoteResultsQuoteIdInvite,
  PostReimbursementsBodyOne,
  PostUsersOrganizationsSetCurrent,
  PutAdminComplianceOwnersOwnerId,
  PutAdminEnrollmentEventEnrollmentEventId,
  PutAdminFinchEmployerUpdateFinchConnectionStatus,
  PutAdminMergeEmployerUpdateCompanyId,
  PutAdminPayrollProviderConfigsId,
  PutAdminStripePricesEmployerId,
  PutBrokersMemberIchraConfigOptedIn,
  PutBrokersMemberIchraConfigQmeTreatment,
  PutBrokersMembersMemberIdEnrollmentsId,
  PutBrokersMembersMemberIdEnrollmentsIdCoverages,
  PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums,
  PutEmployersEmployersIdProfile,
  PutEmployersEmployersIdUpdateOwnerInvitationFormStatus,
  PutEmployersOwnersId,
  PutMemberOnboardingMemberIchraConfigOptOut,
  PutPartnersPartnerIdPartnerAdminsPartnerAdminId,
  PutPayrollPaySchedulesId,
  PutQuotingPricesQuoteId,
  PutQuotingProspectsId,
  PutQuotingProspectsProspectIdCensusCensusIdEmployeesId,
  QuotingEmployee,
  QuotingEmployeeCensus,
  QuotingMedicalPlanDisplayItem,
  QuotingPaginatedEmployeeCensusList,
  QuotingPaginatedEmployeeList,
  QuotingPaginatedProspectList,
  QuotingPaginatedQuoteList,
  QuotingPlanAvailability,
  QuotingProspect,
  QuotingQuote,
  QuotingQuoteAllowance,
  QuotingQuoteGenerationOptions,
  QuotingQuotePricing,
  QuotingQuoteResult,
  QuotingRecommendedQuoteResults,
  ReimbursementsReimbursementCreated,
  ReportingReport,
  ResourceAccessTokensInvitationResult,
  ResourceAccessTokensRedemptionResult,
  ResourceAccessTokensResourceAccessTokenRecipient,
  UsersUserOrganizations,
  ValidationError,
  WebAPIEntitiesAdpJob,
  WebAPIEntitiesAdpProspectImportResponse,
  WebAPIFeedbackEntitiesPrompt,
  WebAPIFeedbackEntitiesSubmission
} from './web_api.schemas';

import { customFetch } from './web_api/mutator/custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * List access requests
 */
export const getGetAccessRequestsUrl = (params?: GetAccessRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[requested_resources][]","filter[requested_by_ids][]","filter[request_states][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/access_requests?${stringifiedParams}` : `/api/web/access_requests`
}

export const getAccessRequests = async (params?: GetAccessRequestsParams, options?: RequestInit): Promise<AccessRequestsAccessRequestList> => {
  
  return customFetch<AccessRequestsAccessRequestList>(getGetAccessRequestsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAccessRequestsQueryKey = (params?: GetAccessRequestsParams,) => {
    return [
    `/api/web/access_requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAccessRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getAccessRequests>>, TError = unknown>(params?: GetAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessRequests>>> = ({ signal }) => getAccessRequests(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessRequests>>>
export type GetAccessRequestsQueryError = unknown


export function useGetAccessRequests<TData = Awaited<ReturnType<typeof getAccessRequests>>, TError = unknown>(
 params: undefined |  GetAccessRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessRequests>>,
          TError,
          Awaited<ReturnType<typeof getAccessRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessRequests<TData = Awaited<ReturnType<typeof getAccessRequests>>, TError = unknown>(
 params?: GetAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessRequests>>,
          TError,
          Awaited<ReturnType<typeof getAccessRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessRequests<TData = Awaited<ReturnType<typeof getAccessRequests>>, TError = unknown>(
 params?: GetAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAccessRequests<TData = Awaited<ReturnType<typeof getAccessRequests>>, TError = unknown>(
 params?: GetAccessRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessRequests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create an access request
 */
export const getPostAccessRequestsUrl = () => {


  

  return `/api/web/access_requests`
}

export const postAccessRequests = async (postAccessRequests: PostAccessRequests, options?: RequestInit): Promise<AccessRequestsAccessRequest> => {
  
  return customFetch<AccessRequestsAccessRequest>(getPostAccessRequestsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAccessRequests,)
  }
);}




export const getPostAccessRequestsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessRequests>>, TError,{data: PostAccessRequests}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccessRequests>>, TError,{data: PostAccessRequests}, TContext> => {

const mutationKey = ['postAccessRequests'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessRequests>>, {data: PostAccessRequests}> = (props) => {
          const {data} = props ?? {};

          return  postAccessRequests(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccessRequestsMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessRequests>>>
    export type PostAccessRequestsMutationBody = PostAccessRequests
    export type PostAccessRequestsMutationError = unknown

    export const usePostAccessRequests = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessRequests>>, TError,{data: PostAccessRequests}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccessRequests>>,
        TError,
        {data: PostAccessRequests},
        TContext
      > => {

      const mutationOptions = getPostAccessRequestsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a single compliance check by check ID
 */
export const getGetAdminComplianceChecksCheckIdUrl = (checkId: string,) => {


  

  return `/api/web/admin/compliance_checks/${checkId}`
}

export const getAdminComplianceChecksCheckId = async (checkId: string, options?: RequestInit): Promise<AdminComplianceCheck> => {
  
  return customFetch<AdminComplianceCheck>(getGetAdminComplianceChecksCheckIdUrl(checkId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminComplianceChecksCheckIdQueryKey = (checkId?: string,) => {
    return [
    `/api/web/admin/compliance_checks/${checkId}`
    ] as const;
    }

    
export const getGetAdminComplianceChecksCheckIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError = unknown>(checkId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminComplianceChecksCheckIdQueryKey(checkId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>> = ({ signal }) => getAdminComplianceChecksCheckId(checkId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(checkId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminComplianceChecksCheckIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>>
export type GetAdminComplianceChecksCheckIdQueryError = unknown


export function useGetAdminComplianceChecksCheckId<TData = Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError = unknown>(
 checkId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>,
          TError,
          Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminComplianceChecksCheckId<TData = Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError = unknown>(
 checkId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>,
          TError,
          Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminComplianceChecksCheckId<TData = Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError = unknown>(
 checkId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminComplianceChecksCheckId<TData = Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError = unknown>(
 checkId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceChecksCheckId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminComplianceChecksCheckIdQueryOptions(checkId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Override a failing compliance check to passing
 */
export const getPostAdminComplianceChecksCheckIdOverrideFailingCheckUrl = (checkId: string,) => {


  

  return `/api/web/admin/compliance_checks/${checkId}/override_failing_check`
}

export const postAdminComplianceChecksCheckIdOverrideFailingCheck = async (checkId: string,
    postAdminComplianceChecksCheckIdOverrideFailingCheck: PostAdminComplianceChecksCheckIdOverrideFailingCheck, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminComplianceChecksCheckIdOverrideFailingCheckUrl(checkId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminComplianceChecksCheckIdOverrideFailingCheck,)
  }
);}




export const getPostAdminComplianceChecksCheckIdOverrideFailingCheckMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceChecksCheckIdOverrideFailingCheck>>, TError,{checkId: string;data: PostAdminComplianceChecksCheckIdOverrideFailingCheck}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceChecksCheckIdOverrideFailingCheck>>, TError,{checkId: string;data: PostAdminComplianceChecksCheckIdOverrideFailingCheck}, TContext> => {

const mutationKey = ['postAdminComplianceChecksCheckIdOverrideFailingCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminComplianceChecksCheckIdOverrideFailingCheck>>, {checkId: string;data: PostAdminComplianceChecksCheckIdOverrideFailingCheck}> = (props) => {
          const {checkId,data} = props ?? {};

          return  postAdminComplianceChecksCheckIdOverrideFailingCheck(checkId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminComplianceChecksCheckIdOverrideFailingCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminComplianceChecksCheckIdOverrideFailingCheck>>>
    export type PostAdminComplianceChecksCheckIdOverrideFailingCheckMutationBody = PostAdminComplianceChecksCheckIdOverrideFailingCheck
    export type PostAdminComplianceChecksCheckIdOverrideFailingCheckMutationError = unknown

    export const usePostAdminComplianceChecksCheckIdOverrideFailingCheck = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceChecksCheckIdOverrideFailingCheck>>, TError,{checkId: string;data: PostAdminComplianceChecksCheckIdOverrideFailingCheck}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminComplianceChecksCheckIdOverrideFailingCheck>>,
        TError,
        {checkId: string;data: PostAdminComplianceChecksCheckIdOverrideFailingCheck},
        TContext
      > => {

      const mutationOptions = getPostAdminComplianceChecksCheckIdOverrideFailingCheckMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create and execute a new Compliance::Check
 */
export const getPostAdminComplianceChecksUrl = () => {


  

  return `/api/web/admin/compliance_checks`
}

export const postAdminComplianceChecks = async (postAdminComplianceChecks: PostAdminComplianceChecks, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminComplianceChecksUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminComplianceChecks,)
  }
);}




export const getPostAdminComplianceChecksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceChecks>>, TError,{data: PostAdminComplianceChecks}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceChecks>>, TError,{data: PostAdminComplianceChecks}, TContext> => {

const mutationKey = ['postAdminComplianceChecks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminComplianceChecks>>, {data: PostAdminComplianceChecks}> = (props) => {
          const {data} = props ?? {};

          return  postAdminComplianceChecks(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminComplianceChecksMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminComplianceChecks>>>
    export type PostAdminComplianceChecksMutationBody = PostAdminComplianceChecks
    export type PostAdminComplianceChecksMutationError = unknown

    export const usePostAdminComplianceChecks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceChecks>>, TError,{data: PostAdminComplianceChecks}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminComplianceChecks>>,
        TError,
        {data: PostAdminComplianceChecks},
        TContext
      > => {

      const mutationOptions = getPostAdminComplianceChecksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a single compliance owner by owner ID
 */
export const getGetAdminComplianceOwnersOwnerIdUrl = (ownerId: string,) => {


  

  return `/api/web/admin/compliance_owners/${ownerId}`
}

export const getAdminComplianceOwnersOwnerId = async (ownerId: string, options?: RequestInit): Promise<AdminComplianceOwner> => {
  
  return customFetch<AdminComplianceOwner>(getGetAdminComplianceOwnersOwnerIdUrl(ownerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminComplianceOwnersOwnerIdQueryKey = (ownerId?: string,) => {
    return [
    `/api/web/admin/compliance_owners/${ownerId}`
    ] as const;
    }

    
export const getGetAdminComplianceOwnersOwnerIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError = unknown>(ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminComplianceOwnersOwnerIdQueryKey(ownerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>> = ({ signal }) => getAdminComplianceOwnersOwnerId(ownerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(ownerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminComplianceOwnersOwnerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>>
export type GetAdminComplianceOwnersOwnerIdQueryError = unknown


export function useGetAdminComplianceOwnersOwnerId<TData = Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError = unknown>(
 ownerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminComplianceOwnersOwnerId<TData = Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError = unknown>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminComplianceOwnersOwnerId<TData = Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError = unknown>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminComplianceOwnersOwnerId<TData = Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError = unknown>(
 ownerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminComplianceOwnersOwnerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminComplianceOwnersOwnerIdQueryOptions(ownerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update a compliance owner
 */
export const getPutAdminComplianceOwnersOwnerIdUrl = (ownerId: string,) => {


  

  return `/api/web/admin/compliance_owners/${ownerId}`
}

export const putAdminComplianceOwnersOwnerId = async (ownerId: string,
    putAdminComplianceOwnersOwnerId: PutAdminComplianceOwnersOwnerId, options?: RequestInit): Promise<AdminComplianceOwner> => {
  
  return customFetch<AdminComplianceOwner>(getPutAdminComplianceOwnersOwnerIdUrl(ownerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAdminComplianceOwnersOwnerId,)
  }
);}




export const getPutAdminComplianceOwnersOwnerIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminComplianceOwnersOwnerId>>, TError,{ownerId: string;data: PutAdminComplianceOwnersOwnerId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminComplianceOwnersOwnerId>>, TError,{ownerId: string;data: PutAdminComplianceOwnersOwnerId}, TContext> => {

const mutationKey = ['putAdminComplianceOwnersOwnerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminComplianceOwnersOwnerId>>, {ownerId: string;data: PutAdminComplianceOwnersOwnerId}> = (props) => {
          const {ownerId,data} = props ?? {};

          return  putAdminComplianceOwnersOwnerId(ownerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminComplianceOwnersOwnerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminComplianceOwnersOwnerId>>>
    export type PutAdminComplianceOwnersOwnerIdMutationBody = PutAdminComplianceOwnersOwnerId
    export type PutAdminComplianceOwnersOwnerIdMutationError = unknown

    export const usePutAdminComplianceOwnersOwnerId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminComplianceOwnersOwnerId>>, TError,{ownerId: string;data: PutAdminComplianceOwnersOwnerId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminComplianceOwnersOwnerId>>,
        TError,
        {ownerId: string;data: PutAdminComplianceOwnersOwnerId},
        TContext
      > => {

      const mutationOptions = getPutAdminComplianceOwnersOwnerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a new compliance owner
 */
export const getPostAdminComplianceOwnersUrl = () => {


  

  return `/api/web/admin/compliance_owners`
}

export const postAdminComplianceOwners = async (postAdminComplianceOwners: PostAdminComplianceOwners, options?: RequestInit): Promise<AdminComplianceOwner> => {
  
  return customFetch<AdminComplianceOwner>(getPostAdminComplianceOwnersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminComplianceOwners,)
  }
);}




export const getPostAdminComplianceOwnersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceOwners>>, TError,{data: PostAdminComplianceOwners}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceOwners>>, TError,{data: PostAdminComplianceOwners}, TContext> => {

const mutationKey = ['postAdminComplianceOwners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminComplianceOwners>>, {data: PostAdminComplianceOwners}> = (props) => {
          const {data} = props ?? {};

          return  postAdminComplianceOwners(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminComplianceOwnersMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminComplianceOwners>>>
    export type PostAdminComplianceOwnersMutationBody = PostAdminComplianceOwners
    export type PostAdminComplianceOwnersMutationError = unknown

    export const usePostAdminComplianceOwners = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminComplianceOwners>>, TError,{data: PostAdminComplianceOwners}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminComplianceOwners>>,
        TError,
        {data: PostAdminComplianceOwners},
        TContext
      > => {

      const mutationOptions = getPostAdminComplianceOwnersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a compliance policy by provider and entity type
 */
export const getGetAdminCompliancePoliciesUrl = (params: GetAdminCompliancePoliciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/compliance_policies?${stringifiedParams}` : `/api/web/admin/compliance_policies`
}

export const getAdminCompliancePolicies = async (params: GetAdminCompliancePoliciesParams, options?: RequestInit): Promise<AdminCompliancePolicy> => {
  
  return customFetch<AdminCompliancePolicy>(getGetAdminCompliancePoliciesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminCompliancePoliciesQueryKey = (params?: GetAdminCompliancePoliciesParams,) => {
    return [
    `/api/web/admin/compliance_policies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminCompliancePoliciesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError = unknown>(params: GetAdminCompliancePoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCompliancePoliciesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCompliancePolicies>>> = ({ signal }) => getAdminCompliancePolicies(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCompliancePoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCompliancePolicies>>>
export type GetAdminCompliancePoliciesQueryError = unknown


export function useGetAdminCompliancePolicies<TData = Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError = unknown>(
 params: GetAdminCompliancePoliciesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCompliancePolicies>>,
          TError,
          Awaited<ReturnType<typeof getAdminCompliancePolicies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCompliancePolicies<TData = Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError = unknown>(
 params: GetAdminCompliancePoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCompliancePolicies>>,
          TError,
          Awaited<ReturnType<typeof getAdminCompliancePolicies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCompliancePolicies<TData = Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError = unknown>(
 params: GetAdminCompliancePoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminCompliancePolicies<TData = Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError = unknown>(
 params: GetAdminCompliancePoliciesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePolicies>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCompliancePoliciesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a single compliance policy by policy ID
 */
export const getGetAdminCompliancePoliciesPolicyIdUrl = (policyId: string,) => {


  

  return `/api/web/admin/compliance_policies/${policyId}`
}

export const getAdminCompliancePoliciesPolicyId = async (policyId: string, options?: RequestInit): Promise<AdminCompliancePolicy> => {
  
  return customFetch<AdminCompliancePolicy>(getGetAdminCompliancePoliciesPolicyIdUrl(policyId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminCompliancePoliciesPolicyIdQueryKey = (policyId?: string,) => {
    return [
    `/api/web/admin/compliance_policies/${policyId}`
    ] as const;
    }

    
export const getGetAdminCompliancePoliciesPolicyIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError = unknown>(policyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCompliancePoliciesPolicyIdQueryKey(policyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>> = ({ signal }) => getAdminCompliancePoliciesPolicyId(policyId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(policyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCompliancePoliciesPolicyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>>
export type GetAdminCompliancePoliciesPolicyIdQueryError = unknown


export function useGetAdminCompliancePoliciesPolicyId<TData = Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError = unknown>(
 policyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCompliancePoliciesPolicyId<TData = Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError = unknown>(
 policyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>,
          TError,
          Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCompliancePoliciesPolicyId<TData = Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError = unknown>(
 policyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminCompliancePoliciesPolicyId<TData = Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError = unknown>(
 policyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCompliancePoliciesPolicyId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCompliancePoliciesPolicyIdQueryOptions(policyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch employer information for access to Finch
 */
export const getGetAdminFinchEmployerUrl = (params: GetAdminFinchEmployerParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/employer?${stringifiedParams}` : `/api/web/admin/finch/employer`
}

export const getAdminFinchEmployer = async (params: GetAdminFinchEmployerParams, options?: RequestInit): Promise<AdminEmployerData> => {
  
  return customFetch<AdminEmployerData>(getGetAdminFinchEmployerUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchEmployerQueryKey = (params?: GetAdminFinchEmployerParams,) => {
    return [
    `/api/web/admin/finch/employer`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchEmployerQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError = unknown>(params: GetAdminFinchEmployerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchEmployerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchEmployer>>> = ({ signal }) => getAdminFinchEmployer(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchEmployerQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchEmployer>>>
export type GetAdminFinchEmployerQueryError = unknown


export function useGetAdminFinchEmployer<TData = Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError = unknown>(
 params: GetAdminFinchEmployerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchEmployer>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchEmployer<TData = Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError = unknown>(
 params: GetAdminFinchEmployerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchEmployer>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchEmployer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchEmployer<TData = Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError = unknown>(
 params: GetAdminFinchEmployerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchEmployer<TData = Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError = unknown>(
 params: GetAdminFinchEmployerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployer>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchEmployerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch employee information for individual Finch information
 */
export const getGetAdminFinchEmployerEmployeesUrl = (params: GetAdminFinchEmployerEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/employer/employees?${stringifiedParams}` : `/api/web/admin/finch/employer/employees`
}

export const getAdminFinchEmployerEmployees = async (params: GetAdminFinchEmployerEmployeesParams, options?: RequestInit): Promise<AdminEmployeesData> => {
  
  return customFetch<AdminEmployeesData>(getGetAdminFinchEmployerEmployeesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchEmployerEmployeesQueryKey = (params?: GetAdminFinchEmployerEmployeesParams,) => {
    return [
    `/api/web/admin/finch/employer/employees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchEmployerEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError = unknown>(params: GetAdminFinchEmployerEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchEmployerEmployeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>> = ({ signal }) => getAdminFinchEmployerEmployees(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchEmployerEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>>
export type GetAdminFinchEmployerEmployeesQueryError = unknown


export function useGetAdminFinchEmployerEmployees<TData = Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError = unknown>(
 params: GetAdminFinchEmployerEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchEmployerEmployees<TData = Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError = unknown>(
 params: GetAdminFinchEmployerEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchEmployerEmployees<TData = Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError = unknown>(
 params: GetAdminFinchEmployerEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchEmployerEmployees<TData = Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError = unknown>(
 params: GetAdminFinchEmployerEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchEmployerEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchEmployerEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sync employer directory with Finch
 */
export const getPostAdminFinchEmployerSyncUrl = () => {


  

  return `/api/web/admin/finch/employer/sync`
}

export const postAdminFinchEmployerSync = async (postAdminFinchEmployerSync: PostAdminFinchEmployerSync, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminFinchEmployerSyncUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminFinchEmployerSync,)
  }
);}




export const getPostAdminFinchEmployerSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminFinchEmployerSync>>, TError,{data: PostAdminFinchEmployerSync}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminFinchEmployerSync>>, TError,{data: PostAdminFinchEmployerSync}, TContext> => {

const mutationKey = ['postAdminFinchEmployerSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminFinchEmployerSync>>, {data: PostAdminFinchEmployerSync}> = (props) => {
          const {data} = props ?? {};

          return  postAdminFinchEmployerSync(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminFinchEmployerSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminFinchEmployerSync>>>
    export type PostAdminFinchEmployerSyncMutationBody = PostAdminFinchEmployerSync
    export type PostAdminFinchEmployerSyncMutationError = unknown

    export const usePostAdminFinchEmployerSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminFinchEmployerSync>>, TError,{data: PostAdminFinchEmployerSync}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminFinchEmployerSync>>,
        TError,
        {data: PostAdminFinchEmployerSync},
        TContext
      > => {

      const mutationOptions = getPostAdminFinchEmployerSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update the Employers Finch connection status
 */
export const getPutAdminFinchEmployerUpdateFinchConnectionStatusUrl = () => {


  

  return `/api/web/admin/finch/employer/update_finch_connection_status`
}

export const putAdminFinchEmployerUpdateFinchConnectionStatus = async (putAdminFinchEmployerUpdateFinchConnectionStatus: PutAdminFinchEmployerUpdateFinchConnectionStatus, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPutAdminFinchEmployerUpdateFinchConnectionStatusUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAdminFinchEmployerUpdateFinchConnectionStatus,)
  }
);}




export const getPutAdminFinchEmployerUpdateFinchConnectionStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFinchEmployerUpdateFinchConnectionStatus>>, TError,{data: PutAdminFinchEmployerUpdateFinchConnectionStatus}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminFinchEmployerUpdateFinchConnectionStatus>>, TError,{data: PutAdminFinchEmployerUpdateFinchConnectionStatus}, TContext> => {

const mutationKey = ['putAdminFinchEmployerUpdateFinchConnectionStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminFinchEmployerUpdateFinchConnectionStatus>>, {data: PutAdminFinchEmployerUpdateFinchConnectionStatus}> = (props) => {
          const {data} = props ?? {};

          return  putAdminFinchEmployerUpdateFinchConnectionStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminFinchEmployerUpdateFinchConnectionStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminFinchEmployerUpdateFinchConnectionStatus>>>
    export type PutAdminFinchEmployerUpdateFinchConnectionStatusMutationBody = PutAdminFinchEmployerUpdateFinchConnectionStatus
    export type PutAdminFinchEmployerUpdateFinchConnectionStatusMutationError = unknown

    export const usePutAdminFinchEmployerUpdateFinchConnectionStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminFinchEmployerUpdateFinchConnectionStatus>>, TError,{data: PutAdminFinchEmployerUpdateFinchConnectionStatus}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminFinchEmployerUpdateFinchConnectionStatus>>,
        TError,
        {data: PutAdminFinchEmployerUpdateFinchConnectionStatus},
        TContext
      > => {

      const mutationOptions = getPutAdminFinchEmployerUpdateFinchConnectionStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Merge employees with duplicates
 */
export const getPostAdminFinchEmployerMergeEmployeesUrl = () => {


  

  return `/api/web/admin/finch/employer/merge_employees`
}

export const postAdminFinchEmployerMergeEmployees = async (postAdminFinchEmployerMergeEmployees: PostAdminFinchEmployerMergeEmployees, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminFinchEmployerMergeEmployeesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminFinchEmployerMergeEmployees,)
  }
);}




export const getPostAdminFinchEmployerMergeEmployeesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminFinchEmployerMergeEmployees>>, TError,{data: PostAdminFinchEmployerMergeEmployees}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminFinchEmployerMergeEmployees>>, TError,{data: PostAdminFinchEmployerMergeEmployees}, TContext> => {

const mutationKey = ['postAdminFinchEmployerMergeEmployees'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminFinchEmployerMergeEmployees>>, {data: PostAdminFinchEmployerMergeEmployees}> = (props) => {
          const {data} = props ?? {};

          return  postAdminFinchEmployerMergeEmployees(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminFinchEmployerMergeEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminFinchEmployerMergeEmployees>>>
    export type PostAdminFinchEmployerMergeEmployeesMutationBody = PostAdminFinchEmployerMergeEmployees
    export type PostAdminFinchEmployerMergeEmployeesMutationError = unknown

    export const usePostAdminFinchEmployerMergeEmployees = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminFinchEmployerMergeEmployees>>, TError,{data: PostAdminFinchEmployerMergeEmployees}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminFinchEmployerMergeEmployees>>,
        TError,
        {data: PostAdminFinchEmployerMergeEmployees},
        TContext
      > => {

      const mutationOptions = getPostAdminFinchEmployerMergeEmployeesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Finch /introspect endpoint
 */
export const getGetAdminFinchApiIntrospectUrl = (params: GetAdminFinchApiIntrospectParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/introspect?${stringifiedParams}` : `/api/web/admin/finch/api/introspect`
}

export const getAdminFinchApiIntrospect = async (params: GetAdminFinchApiIntrospectParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiIntrospectUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiIntrospectQueryKey = (params?: GetAdminFinchApiIntrospectParams,) => {
    return [
    `/api/web/admin/finch/api/introspect`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiIntrospectQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError = unknown>(params: GetAdminFinchApiIntrospectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiIntrospectQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>> = ({ signal }) => getAdminFinchApiIntrospect(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiIntrospectQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>>
export type GetAdminFinchApiIntrospectQueryError = unknown


export function useGetAdminFinchApiIntrospect<TData = Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError = unknown>(
 params: GetAdminFinchApiIntrospectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiIntrospect<TData = Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError = unknown>(
 params: GetAdminFinchApiIntrospectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiIntrospect<TData = Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError = unknown>(
 params: GetAdminFinchApiIntrospectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiIntrospect<TData = Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError = unknown>(
 params: GetAdminFinchApiIntrospectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIntrospect>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiIntrospectQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /directory endpoint
 */
export const getGetAdminFinchApiDirectoryUrl = (params: GetAdminFinchApiDirectoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/directory?${stringifiedParams}` : `/api/web/admin/finch/api/directory`
}

export const getAdminFinchApiDirectory = async (params: GetAdminFinchApiDirectoryParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiDirectoryUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiDirectoryQueryKey = (params?: GetAdminFinchApiDirectoryParams,) => {
    return [
    `/api/web/admin/finch/api/directory`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiDirectoryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError = unknown>(params: GetAdminFinchApiDirectoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiDirectoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>> = ({ signal }) => getAdminFinchApiDirectory(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiDirectoryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>>
export type GetAdminFinchApiDirectoryQueryError = unknown


export function useGetAdminFinchApiDirectory<TData = Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError = unknown>(
 params: GetAdminFinchApiDirectoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiDirectory>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiDirectory<TData = Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError = unknown>(
 params: GetAdminFinchApiDirectoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiDirectory>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiDirectory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiDirectory<TData = Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError = unknown>(
 params: GetAdminFinchApiDirectoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiDirectory<TData = Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError = unknown>(
 params: GetAdminFinchApiDirectoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiDirectory>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiDirectoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /individual endpoint for the provided Finch individual IDs
 */
export const getGetAdminFinchApiIndividualUrl = (params: GetAdminFinchApiIndividualParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["finch_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/individual?${stringifiedParams}` : `/api/web/admin/finch/api/individual`
}

export const getAdminFinchApiIndividual = async (params: GetAdminFinchApiIndividualParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiIndividualUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiIndividualQueryKey = (params?: GetAdminFinchApiIndividualParams,) => {
    return [
    `/api/web/admin/finch/api/individual`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiIndividualQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError = unknown>(params: GetAdminFinchApiIndividualParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiIndividualQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>> = ({ signal }) => getAdminFinchApiIndividual(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiIndividualQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>>
export type GetAdminFinchApiIndividualQueryError = unknown


export function useGetAdminFinchApiIndividual<TData = Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError = unknown>(
 params: GetAdminFinchApiIndividualParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiIndividual>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiIndividual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiIndividual<TData = Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError = unknown>(
 params: GetAdminFinchApiIndividualParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiIndividual>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiIndividual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiIndividual<TData = Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError = unknown>(
 params: GetAdminFinchApiIndividualParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiIndividual<TData = Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError = unknown>(
 params: GetAdminFinchApiIndividualParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiIndividual>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiIndividualQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /employment endpoint for the provided Finch individual IDs
 */
export const getGetAdminFinchApiEmploymentUrl = (params: GetAdminFinchApiEmploymentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["finch_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/employment?${stringifiedParams}` : `/api/web/admin/finch/api/employment`
}

export const getAdminFinchApiEmployment = async (params: GetAdminFinchApiEmploymentParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiEmploymentUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiEmploymentQueryKey = (params?: GetAdminFinchApiEmploymentParams,) => {
    return [
    `/api/web/admin/finch/api/employment`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiEmploymentQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError = unknown>(params: GetAdminFinchApiEmploymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiEmploymentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>> = ({ signal }) => getAdminFinchApiEmployment(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiEmploymentQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>>
export type GetAdminFinchApiEmploymentQueryError = unknown


export function useGetAdminFinchApiEmployment<TData = Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError = unknown>(
 params: GetAdminFinchApiEmploymentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiEmployment>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiEmployment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiEmployment<TData = Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError = unknown>(
 params: GetAdminFinchApiEmploymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiEmployment>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiEmployment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiEmployment<TData = Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError = unknown>(
 params: GetAdminFinchApiEmploymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiEmployment<TData = Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError = unknown>(
 params: GetAdminFinchApiEmploymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiEmployment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiEmploymentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /payment endpoint for the provided period between start and end date
 */
export const getGetAdminFinchApiPaymentUrl = (params: GetAdminFinchApiPaymentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/payment?${stringifiedParams}` : `/api/web/admin/finch/api/payment`
}

export const getAdminFinchApiPayment = async (params: GetAdminFinchApiPaymentParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiPaymentUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiPaymentQueryKey = (params?: GetAdminFinchApiPaymentParams,) => {
    return [
    `/api/web/admin/finch/api/payment`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiPaymentQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError = unknown>(params: GetAdminFinchApiPaymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiPaymentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiPayment>>> = ({ signal }) => getAdminFinchApiPayment(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiPayment>>>
export type GetAdminFinchApiPaymentQueryError = unknown


export function useGetAdminFinchApiPayment<TData = Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError = unknown>(
 params: GetAdminFinchApiPaymentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayment>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayment<TData = Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError = unknown>(
 params: GetAdminFinchApiPaymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayment>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayment<TData = Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError = unknown>(
 params: GetAdminFinchApiPaymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiPayment<TData = Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError = unknown>(
 params: GetAdminFinchApiPaymentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiPaymentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /pay_statement endpoint for the provided Payment IDs
 */
export const getGetAdminFinchApiPayStatementUrl = (params: GetAdminFinchApiPayStatementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["payment_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/pay_statement?${stringifiedParams}` : `/api/web/admin/finch/api/pay_statement`
}

export const getAdminFinchApiPayStatement = async (params: GetAdminFinchApiPayStatementParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiPayStatementUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiPayStatementQueryKey = (params?: GetAdminFinchApiPayStatementParams,) => {
    return [
    `/api/web/admin/finch/api/pay_statement`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiPayStatementQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError = unknown>(params: GetAdminFinchApiPayStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiPayStatementQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>> = ({ signal }) => getAdminFinchApiPayStatement(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiPayStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>>
export type GetAdminFinchApiPayStatementQueryError = unknown


export function useGetAdminFinchApiPayStatement<TData = Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError = unknown>(
 params: GetAdminFinchApiPayStatementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayStatement<TData = Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError = unknown>(
 params: GetAdminFinchApiPayStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayStatement<TData = Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError = unknown>(
 params: GetAdminFinchApiPayStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiPayStatement<TData = Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError = unknown>(
 params: GetAdminFinchApiPayStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayStatement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiPayStatementQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /benefits endpoint
 */
export const getGetAdminFinchApiBenefitsUrl = (params: GetAdminFinchApiBenefitsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/benefits?${stringifiedParams}` : `/api/web/admin/finch/api/benefits`
}

export const getAdminFinchApiBenefits = async (params: GetAdminFinchApiBenefitsParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiBenefitsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiBenefitsQueryKey = (params?: GetAdminFinchApiBenefitsParams,) => {
    return [
    `/api/web/admin/finch/api/benefits`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiBenefitsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError = unknown>(params: GetAdminFinchApiBenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiBenefitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>> = ({ signal }) => getAdminFinchApiBenefits(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiBenefitsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>>
export type GetAdminFinchApiBenefitsQueryError = unknown


export function useGetAdminFinchApiBenefits<TData = Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError = unknown>(
 params: GetAdminFinchApiBenefitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiBenefits>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiBenefits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiBenefits<TData = Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError = unknown>(
 params: GetAdminFinchApiBenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiBenefits>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiBenefits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiBenefits<TData = Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError = unknown>(
 params: GetAdminFinchApiBenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiBenefits<TData = Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError = unknown>(
 params: GetAdminFinchApiBenefitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiBenefits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiBenefitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /pay_groups endpoint
 */
export const getGetAdminFinchApiPayGroupsUrl = (params: GetAdminFinchApiPayGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/pay_groups?${stringifiedParams}` : `/api/web/admin/finch/api/pay_groups`
}

export const getAdminFinchApiPayGroups = async (params: GetAdminFinchApiPayGroupsParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiPayGroupsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiPayGroupsQueryKey = (params?: GetAdminFinchApiPayGroupsParams,) => {
    return [
    `/api/web/admin/finch/api/pay_groups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiPayGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError = unknown>(params: GetAdminFinchApiPayGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiPayGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>> = ({ signal }) => getAdminFinchApiPayGroups(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiPayGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>>
export type GetAdminFinchApiPayGroupsQueryError = unknown


export function useGetAdminFinchApiPayGroups<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayGroups<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayGroups<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiPayGroups<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroups>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiPayGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Finch /pay_group endpoint for the provided Pay Group ID
 */
export const getGetAdminFinchApiPayGroupUrl = (params: GetAdminFinchApiPayGroupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/finch/api/pay_group?${stringifiedParams}` : `/api/web/admin/finch/api/pay_group`
}

export const getAdminFinchApiPayGroup = async (params: GetAdminFinchApiPayGroupParams, options?: RequestInit): Promise<AdminFinchOutput> => {
  
  return customFetch<AdminFinchOutput>(getGetAdminFinchApiPayGroupUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminFinchApiPayGroupQueryKey = (params?: GetAdminFinchApiPayGroupParams,) => {
    return [
    `/api/web/admin/finch/api/pay_group`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminFinchApiPayGroupQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError = unknown>(params: GetAdminFinchApiPayGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFinchApiPayGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>> = ({ signal }) => getAdminFinchApiPayGroup(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminFinchApiPayGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>>
export type GetAdminFinchApiPayGroupQueryError = unknown


export function useGetAdminFinchApiPayGroup<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayGroup<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>,
          TError,
          Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminFinchApiPayGroup<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminFinchApiPayGroup<TData = Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError = unknown>(
 params: GetAdminFinchApiPayGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminFinchApiPayGroup>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminFinchApiPayGroupQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch iSolved clients for the employer
 */
export const getGetAdminMergeEmployerIsolvedClientsUrl = (params: GetAdminMergeEmployerIsolvedClientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/merge/employer/isolved_clients?${stringifiedParams}` : `/api/web/admin/merge/employer/isolved_clients`
}

export const getAdminMergeEmployerIsolvedClients = async (params: GetAdminMergeEmployerIsolvedClientsParams, options?: RequestInit): Promise<AdminMergeIsolvedClientsList> => {
  
  return customFetch<AdminMergeIsolvedClientsList>(getGetAdminMergeEmployerIsolvedClientsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMergeEmployerIsolvedClientsQueryKey = (params?: GetAdminMergeEmployerIsolvedClientsParams,) => {
    return [
    `/api/web/admin/merge/employer/isolved_clients`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMergeEmployerIsolvedClientsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError = unknown>(params: GetAdminMergeEmployerIsolvedClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMergeEmployerIsolvedClientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>> = ({ signal }) => getAdminMergeEmployerIsolvedClients(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMergeEmployerIsolvedClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>>
export type GetAdminMergeEmployerIsolvedClientsQueryError = unknown


export function useGetAdminMergeEmployerIsolvedClients<TData = Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError = unknown>(
 params: GetAdminMergeEmployerIsolvedClientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>,
          TError,
          Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMergeEmployerIsolvedClients<TData = Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError = unknown>(
 params: GetAdminMergeEmployerIsolvedClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>,
          TError,
          Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMergeEmployerIsolvedClients<TData = Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError = unknown>(
 params: GetAdminMergeEmployerIsolvedClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMergeEmployerIsolvedClients<TData = Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError = unknown>(
 params: GetAdminMergeEmployerIsolvedClientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMergeEmployerIsolvedClients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMergeEmployerIsolvedClientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update the company ID for the employer's Merge config
 */
export const getPutAdminMergeEmployerUpdateCompanyIdUrl = () => {


  

  return `/api/web/admin/merge/employer/update_company_id`
}

export const putAdminMergeEmployerUpdateCompanyId = async (putAdminMergeEmployerUpdateCompanyId: PutAdminMergeEmployerUpdateCompanyId, options?: RequestInit): Promise<AdminMergeUpdateResponse> => {
  
  return customFetch<AdminMergeUpdateResponse>(getPutAdminMergeEmployerUpdateCompanyIdUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAdminMergeEmployerUpdateCompanyId,)
  }
);}




export const getPutAdminMergeEmployerUpdateCompanyIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminMergeEmployerUpdateCompanyId>>, TError,{data: PutAdminMergeEmployerUpdateCompanyId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminMergeEmployerUpdateCompanyId>>, TError,{data: PutAdminMergeEmployerUpdateCompanyId}, TContext> => {

const mutationKey = ['putAdminMergeEmployerUpdateCompanyId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminMergeEmployerUpdateCompanyId>>, {data: PutAdminMergeEmployerUpdateCompanyId}> = (props) => {
          const {data} = props ?? {};

          return  putAdminMergeEmployerUpdateCompanyId(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminMergeEmployerUpdateCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminMergeEmployerUpdateCompanyId>>>
    export type PutAdminMergeEmployerUpdateCompanyIdMutationBody = PutAdminMergeEmployerUpdateCompanyId
    export type PutAdminMergeEmployerUpdateCompanyIdMutationError = unknown

    export const usePutAdminMergeEmployerUpdateCompanyId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminMergeEmployerUpdateCompanyId>>, TError,{data: PutAdminMergeEmployerUpdateCompanyId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminMergeEmployerUpdateCompanyId>>,
        TError,
        {data: PutAdminMergeEmployerUpdateCompanyId},
        TContext
      > => {

      const mutationOptions = getPutAdminMergeEmployerUpdateCompanyIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get employers with open enrollment configs
 */
export const getGetAdminEmployerOpenEnrollmentUrl = (params: GetAdminEmployerOpenEnrollmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[status][]","filter[cohort][]","filter[employer_ids][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/employer_open_enrollment?${stringifiedParams}` : `/api/web/admin/employer_open_enrollment`
}

export const getAdminEmployerOpenEnrollment = async (params: GetAdminEmployerOpenEnrollmentParams, options?: RequestInit): Promise<AdminEmployerOpenEnrollmentList> => {
  
  return customFetch<AdminEmployerOpenEnrollmentList>(getGetAdminEmployerOpenEnrollmentUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployerOpenEnrollmentQueryKey = (params?: GetAdminEmployerOpenEnrollmentParams,) => {
    return [
    `/api/web/admin/employer_open_enrollment`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminEmployerOpenEnrollmentQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError = unknown>(params: GetAdminEmployerOpenEnrollmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployerOpenEnrollmentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>> = ({ signal }) => getAdminEmployerOpenEnrollment(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployerOpenEnrollmentQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>>
export type GetAdminEmployerOpenEnrollmentQueryError = unknown


export function useGetAdminEmployerOpenEnrollment<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError = unknown>(
 params: GetAdminEmployerOpenEnrollmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerOpenEnrollment<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError = unknown>(
 params: GetAdminEmployerOpenEnrollmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerOpenEnrollment<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError = unknown>(
 params: GetAdminEmployerOpenEnrollmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployerOpenEnrollment<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError = unknown>(
 params: GetAdminEmployerOpenEnrollmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollment>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployerOpenEnrollmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a single employer open enrollment config with full details
 */
export const getGetAdminEmployerOpenEnrollmentIdUrl = (id: string,) => {


  

  return `/api/web/admin/employer_open_enrollment/${id}`
}

export const getAdminEmployerOpenEnrollmentId = async (id: string, options?: RequestInit): Promise<AdminEmployerOpenEnrollment> => {
  
  return customFetch<AdminEmployerOpenEnrollment>(getGetAdminEmployerOpenEnrollmentIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployerOpenEnrollmentIdQueryKey = (id?: string,) => {
    return [
    `/api/web/admin/employer_open_enrollment/${id}`
    ] as const;
    }

    
export const getGetAdminEmployerOpenEnrollmentIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployerOpenEnrollmentIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>> = ({ signal }) => getAdminEmployerOpenEnrollmentId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployerOpenEnrollmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>>
export type GetAdminEmployerOpenEnrollmentIdQueryError = unknown


export function useGetAdminEmployerOpenEnrollmentId<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerOpenEnrollmentId<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerOpenEnrollmentId<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployerOpenEnrollmentId<TData = Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerOpenEnrollmentId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployerOpenEnrollmentIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update cohort for an employer's open enrollment config
 */
export const getPostAdminEmployerOpenEnrollmentIdCohortUrl = (id: string,) => {


  

  return `/api/web/admin/employer_open_enrollment/${id}/cohort`
}

export const postAdminEmployerOpenEnrollmentIdCohort = async (id: string,
    postAdminEmployerOpenEnrollmentIdCohort: PostAdminEmployerOpenEnrollmentIdCohort, options?: RequestInit): Promise<AdminEmployerOpenEnrollmentConfig> => {
  
  return customFetch<AdminEmployerOpenEnrollmentConfig>(getPostAdminEmployerOpenEnrollmentIdCohortUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminEmployerOpenEnrollmentIdCohort,)
  }
);}




export const getPostAdminEmployerOpenEnrollmentIdCohortMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEmployerOpenEnrollmentIdCohort>>, TError,{id: string;data: PostAdminEmployerOpenEnrollmentIdCohort}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminEmployerOpenEnrollmentIdCohort>>, TError,{id: string;data: PostAdminEmployerOpenEnrollmentIdCohort}, TContext> => {

const mutationKey = ['postAdminEmployerOpenEnrollmentIdCohort'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminEmployerOpenEnrollmentIdCohort>>, {id: string;data: PostAdminEmployerOpenEnrollmentIdCohort}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminEmployerOpenEnrollmentIdCohort(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminEmployerOpenEnrollmentIdCohortMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminEmployerOpenEnrollmentIdCohort>>>
    export type PostAdminEmployerOpenEnrollmentIdCohortMutationBody = PostAdminEmployerOpenEnrollmentIdCohort
    export type PostAdminEmployerOpenEnrollmentIdCohortMutationError = unknown

    export const usePostAdminEmployerOpenEnrollmentIdCohort = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEmployerOpenEnrollmentIdCohort>>, TError,{id: string;data: PostAdminEmployerOpenEnrollmentIdCohort}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminEmployerOpenEnrollmentIdCohort>>,
        TError,
        {id: string;data: PostAdminEmployerOpenEnrollmentIdCohort},
        TContext
      > => {

      const mutationOptions = getPostAdminEmployerOpenEnrollmentIdCohortMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch employee enrollment events
 */
export const getGetAdminEnrollmentEventUrl = (params: GetAdminEnrollmentEventParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/enrollment_event?${stringifiedParams}` : `/api/web/admin/enrollment_event`
}

export const getAdminEnrollmentEvent = async (params: GetAdminEnrollmentEventParams, options?: RequestInit): Promise<AdminEnrollmentEvents> => {
  
  return customFetch<AdminEnrollmentEvents>(getGetAdminEnrollmentEventUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEnrollmentEventQueryKey = (params?: GetAdminEnrollmentEventParams,) => {
    return [
    `/api/web/admin/enrollment_event`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminEnrollmentEventQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError = unknown>(params: GetAdminEnrollmentEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEnrollmentEventQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>> = ({ signal }) => getAdminEnrollmentEvent(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEnrollmentEventQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>>
export type GetAdminEnrollmentEventQueryError = unknown


export function useGetAdminEnrollmentEvent<TData = Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError = unknown>(
 params: GetAdminEnrollmentEventParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEnrollmentEvent>>,
          TError,
          Awaited<ReturnType<typeof getAdminEnrollmentEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEnrollmentEvent<TData = Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError = unknown>(
 params: GetAdminEnrollmentEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEnrollmentEvent>>,
          TError,
          Awaited<ReturnType<typeof getAdminEnrollmentEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEnrollmentEvent<TData = Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError = unknown>(
 params: GetAdminEnrollmentEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEnrollmentEvent<TData = Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError = unknown>(
 params: GetAdminEnrollmentEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEvent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEnrollmentEventQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create employee enrollment event
 */
export const getPostAdminEnrollmentEventUrl = () => {


  

  return `/api/web/admin/enrollment_event`
}

export const postAdminEnrollmentEvent = async (postAdminEnrollmentEvent: PostAdminEnrollmentEvent, options?: RequestInit): Promise<AdminEnrollmentEvent> => {
  
  return customFetch<AdminEnrollmentEvent>(getPostAdminEnrollmentEventUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminEnrollmentEvent,)
  }
);}




export const getPostAdminEnrollmentEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEnrollmentEvent>>, TError,{data: PostAdminEnrollmentEvent}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminEnrollmentEvent>>, TError,{data: PostAdminEnrollmentEvent}, TContext> => {

const mutationKey = ['postAdminEnrollmentEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminEnrollmentEvent>>, {data: PostAdminEnrollmentEvent}> = (props) => {
          const {data} = props ?? {};

          return  postAdminEnrollmentEvent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminEnrollmentEventMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminEnrollmentEvent>>>
    export type PostAdminEnrollmentEventMutationBody = PostAdminEnrollmentEvent
    export type PostAdminEnrollmentEventMutationError = unknown

    export const usePostAdminEnrollmentEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEnrollmentEvent>>, TError,{data: PostAdminEnrollmentEvent}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminEnrollmentEvent>>,
        TError,
        {data: PostAdminEnrollmentEvent},
        TContext
      > => {

      const mutationOptions = getPostAdminEnrollmentEventMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update employee enrollment event
 */
export const getPutAdminEnrollmentEventEnrollmentEventIdUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/admin/enrollment_event/${enrollmentEventId}`
}

export const putAdminEnrollmentEventEnrollmentEventId = async (enrollmentEventId: string,
    putAdminEnrollmentEventEnrollmentEventId: PutAdminEnrollmentEventEnrollmentEventId, options?: RequestInit): Promise<AdminEnrollmentEvent> => {
  
  return customFetch<AdminEnrollmentEvent>(getPutAdminEnrollmentEventEnrollmentEventIdUrl(enrollmentEventId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAdminEnrollmentEventEnrollmentEventId,)
  }
);}




export const getPutAdminEnrollmentEventEnrollmentEventIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminEnrollmentEventEnrollmentEventId>>, TError,{enrollmentEventId: string;data: PutAdminEnrollmentEventEnrollmentEventId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminEnrollmentEventEnrollmentEventId>>, TError,{enrollmentEventId: string;data: PutAdminEnrollmentEventEnrollmentEventId}, TContext> => {

const mutationKey = ['putAdminEnrollmentEventEnrollmentEventId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminEnrollmentEventEnrollmentEventId>>, {enrollmentEventId: string;data: PutAdminEnrollmentEventEnrollmentEventId}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  putAdminEnrollmentEventEnrollmentEventId(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminEnrollmentEventEnrollmentEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminEnrollmentEventEnrollmentEventId>>>
    export type PutAdminEnrollmentEventEnrollmentEventIdMutationBody = PutAdminEnrollmentEventEnrollmentEventId
    export type PutAdminEnrollmentEventEnrollmentEventIdMutationError = unknown

    export const usePutAdminEnrollmentEventEnrollmentEventId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminEnrollmentEventEnrollmentEventId>>, TError,{enrollmentEventId: string;data: PutAdminEnrollmentEventEnrollmentEventId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminEnrollmentEventEnrollmentEventId>>,
        TError,
        {enrollmentEventId: string;data: PutAdminEnrollmentEventEnrollmentEventId},
        TContext
      > => {

      const mutationOptions = getPutAdminEnrollmentEventEnrollmentEventIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get enrollment event options
 */
export const getGetAdminEnrollmentEventOptionsUrl = () => {


  

  return `/api/web/admin/enrollment_event/options`
}

export const getAdminEnrollmentEventOptions = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminEnrollmentEventOptionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEnrollmentEventOptionsQueryKey = () => {
    return [
    `/api/web/admin/enrollment_event/options`
    ] as const;
    }

    
export const getGetAdminEnrollmentEventOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEnrollmentEventOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>> = ({ signal }) => getAdminEnrollmentEventOptions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEnrollmentEventOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>>
export type GetAdminEnrollmentEventOptionsQueryError = unknown


export function useGetAdminEnrollmentEventOptions<TData = Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>,
          TError,
          Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEnrollmentEventOptions<TData = Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>,
          TError,
          Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEnrollmentEventOptions<TData = Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEnrollmentEventOptions<TData = Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEnrollmentEventOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEnrollmentEventOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the allowance structure for an EmployerICHRAConfig
 */
export const getGetAdminEmployerIchraConfigsIdAllowanceStructureUrl = (id: string,) => {


  

  return `/api/web/admin/employer_ichra_configs/${id}/allowance_structure`
}

export const getAdminEmployerIchraConfigsIdAllowanceStructure = async (id: string, options?: RequestInit): Promise<AdminEmployerICHRAConfigAllowanceStructure> => {
  
  return customFetch<AdminEmployerICHRAConfigAllowanceStructure>(getGetAdminEmployerIchraConfigsIdAllowanceStructureUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployerIchraConfigsIdAllowanceStructureQueryKey = (id?: string,) => {
    return [
    `/api/web/admin/employer_ichra_configs/${id}/allowance_structure`
    ] as const;
    }

    
export const getGetAdminEmployerIchraConfigsIdAllowanceStructureQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployerIchraConfigsIdAllowanceStructureQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>> = ({ signal }) => getAdminEmployerIchraConfigsIdAllowanceStructure(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployerIchraConfigsIdAllowanceStructureQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>>
export type GetAdminEmployerIchraConfigsIdAllowanceStructureQueryError = unknown


export function useGetAdminEmployerIchraConfigsIdAllowanceStructure<TData = Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerIchraConfigsIdAllowanceStructure<TData = Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerIchraConfigsIdAllowanceStructure<TData = Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployerIchraConfigsIdAllowanceStructure<TData = Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerIchraConfigsIdAllowanceStructure>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployerIchraConfigsIdAllowanceStructureQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a single employer profile by employer ID
 */
export const getGetAdminEmployerProfilesEmployerProfileIdUrl = (employerProfileId: string,) => {


  

  return `/api/web/admin/employer_profiles/${employerProfileId}`
}

export const getAdminEmployerProfilesEmployerProfileId = async (employerProfileId: string, options?: RequestInit): Promise<AdminEmployerProfile> => {
  
  return customFetch<AdminEmployerProfile>(getGetAdminEmployerProfilesEmployerProfileIdUrl(employerProfileId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployerProfilesEmployerProfileIdQueryKey = (employerProfileId?: string,) => {
    return [
    `/api/web/admin/employer_profiles/${employerProfileId}`
    ] as const;
    }

    
export const getGetAdminEmployerProfilesEmployerProfileIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError = unknown>(employerProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployerProfilesEmployerProfileIdQueryKey(employerProfileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>> = ({ signal }) => getAdminEmployerProfilesEmployerProfileId(employerProfileId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerProfileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployerProfilesEmployerProfileIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>>
export type GetAdminEmployerProfilesEmployerProfileIdQueryError = unknown


export function useGetAdminEmployerProfilesEmployerProfileId<TData = Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError = unknown>(
 employerProfileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerProfilesEmployerProfileId<TData = Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError = unknown>(
 employerProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployerProfilesEmployerProfileId<TData = Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError = unknown>(
 employerProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployerProfilesEmployerProfileId<TData = Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError = unknown>(
 employerProfileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployerProfilesEmployerProfileId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployerProfilesEmployerProfileIdQueryOptions(employerProfileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List employers
 */
export const getGetAdminEmployersUrl = (params?: GetAdminEmployersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[review_statuses][]","filter[employer_ids][]","filter[bank_partners][]","filter[plaid_account_verification_status][]","filter[onboarding_status][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/employers?${stringifiedParams}` : `/api/web/admin/employers`
}

export const getAdminEmployers = async (params?: GetAdminEmployersParams, options?: RequestInit): Promise<AdminPaginatedEmployers> => {
  
  return customFetch<AdminPaginatedEmployers>(getGetAdminEmployersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersQueryKey = (params?: GetAdminEmployersParams,) => {
    return [
    `/api/web/admin/employers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminEmployersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployers>>, TError = unknown>(params?: GetAdminEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployers>>> = ({ signal }) => getAdminEmployers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployers>>>
export type GetAdminEmployersQueryError = unknown


export function useGetAdminEmployers<TData = Awaited<ReturnType<typeof getAdminEmployers>>, TError = unknown>(
 params: undefined |  GetAdminEmployersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployers>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployers<TData = Awaited<ReturnType<typeof getAdminEmployers>>, TError = unknown>(
 params?: GetAdminEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployers>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployers<TData = Awaited<ReturnType<typeof getAdminEmployers>>, TError = unknown>(
 params?: GetAdminEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployers<TData = Awaited<ReturnType<typeof getAdminEmployers>>, TError = unknown>(
 params?: GetAdminEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a single employer by employer ID
 */
export const getGetAdminEmployersEmployerIdUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}`
}

export const getAdminEmployersEmployerId = async (employerId: string, options?: RequestInit): Promise<AdminEmployer> => {
  
  return customFetch<AdminEmployer>(getGetAdminEmployersEmployerIdUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersEmployerIdQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/employers/${employerId}`
    ] as const;
    }

    
export const getGetAdminEmployersEmployerIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersEmployerIdQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>> = ({ signal }) => getAdminEmployersEmployerId(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersEmployerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>>
export type GetAdminEmployersEmployerIdQueryError = unknown


export function useGetAdminEmployersEmployerId<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerId<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerId<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployersEmployerId<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersEmployerIdQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update employer review status
 */
export const getPatchAdminEmployersEmployerIdUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}`
}

export const patchAdminEmployersEmployerId = async (employerId: string,
    patchAdminEmployersEmployerId: PatchAdminEmployersEmployerId, options?: RequestInit): Promise<AdminEmployer> => {
  
  return customFetch<AdminEmployer>(getPatchAdminEmployersEmployerIdUrl(employerId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchAdminEmployersEmployerId,)
  }
);}




export const getPatchAdminEmployersEmployerIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminEmployersEmployerId>>, TError,{employerId: string;data: PatchAdminEmployersEmployerId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminEmployersEmployerId>>, TError,{employerId: string;data: PatchAdminEmployersEmployerId}, TContext> => {

const mutationKey = ['patchAdminEmployersEmployerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminEmployersEmployerId>>, {employerId: string;data: PatchAdminEmployersEmployerId}> = (props) => {
          const {employerId,data} = props ?? {};

          return  patchAdminEmployersEmployerId(employerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminEmployersEmployerIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminEmployersEmployerId>>>
    export type PatchAdminEmployersEmployerIdMutationBody = PatchAdminEmployersEmployerId
    export type PatchAdminEmployersEmployerIdMutationError = unknown

    export const usePatchAdminEmployersEmployerId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminEmployersEmployerId>>, TError,{employerId: string;data: PatchAdminEmployersEmployerId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminEmployersEmployerId>>,
        TError,
        {employerId: string;data: PatchAdminEmployersEmployerId},
        TContext
      > => {

      const mutationOptions = getPatchAdminEmployersEmployerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all compliance checks for an employer
 */
export const getGetAdminEmployersEmployerIdComplianceChecksUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}/compliance_checks`
}

export const getAdminEmployersEmployerIdComplianceChecks = async (employerId: string, options?: RequestInit): Promise<AdminComplianceCheck[]> => {
  
  return customFetch<AdminComplianceCheck[]>(getGetAdminEmployersEmployerIdComplianceChecksUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersEmployerIdComplianceChecksQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/employers/${employerId}/compliance_checks`
    ] as const;
    }

    
export const getGetAdminEmployersEmployerIdComplianceChecksQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersEmployerIdComplianceChecksQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>> = ({ signal }) => getAdminEmployersEmployerIdComplianceChecks(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersEmployerIdComplianceChecksQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>>
export type GetAdminEmployersEmployerIdComplianceChecksQueryError = unknown


export function useGetAdminEmployersEmployerIdComplianceChecks<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdComplianceChecks<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdComplianceChecks<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployersEmployerIdComplianceChecks<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersEmployerIdComplianceChecksQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all compliance owners for employer
 */
export const getGetAdminEmployersEmployerIdComplianceOwnersUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}/compliance_owners`
}

export const getAdminEmployersEmployerIdComplianceOwners = async (employerId: string, options?: RequestInit): Promise<AdminComplianceOwner[]> => {
  
  return customFetch<AdminComplianceOwner[]>(getGetAdminEmployersEmployerIdComplianceOwnersUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersEmployerIdComplianceOwnersQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/employers/${employerId}/compliance_owners`
    ] as const;
    }

    
export const getGetAdminEmployersEmployerIdComplianceOwnersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersEmployerIdComplianceOwnersQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>> = ({ signal }) => getAdminEmployersEmployerIdComplianceOwners(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersEmployerIdComplianceOwnersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>>
export type GetAdminEmployersEmployerIdComplianceOwnersQueryError = unknown


export function useGetAdminEmployersEmployerIdComplianceOwners<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdComplianceOwners<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdComplianceOwners<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployersEmployerIdComplianceOwners<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceOwners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersEmployerIdComplianceOwnersQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all admins under employer
 */
export const getGetAdminEmployersEmployerIdAdminsUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}/admins`
}

export const getAdminEmployersEmployerIdAdmins = async (employerId: string, options?: RequestInit): Promise<EmployersEmployerAdmin[]> => {
  
  return customFetch<EmployersEmployerAdmin[]>(getGetAdminEmployersEmployerIdAdminsUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersEmployerIdAdminsQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/employers/${employerId}/admins`
    ] as const;
    }

    
export const getGetAdminEmployersEmployerIdAdminsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersEmployerIdAdminsQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>> = ({ signal }) => getAdminEmployersEmployerIdAdmins(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersEmployerIdAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>>
export type GetAdminEmployersEmployerIdAdminsQueryError = unknown


export function useGetAdminEmployersEmployerIdAdmins<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdAdmins<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdAdmins<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployersEmployerIdAdmins<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdAdmins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersEmployerIdAdminsQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all compliance audits for an employer
 */
export const getGetAdminEmployersEmployerIdComplianceAuditsUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}/compliance_audits`
}

export const getAdminEmployersEmployerIdComplianceAudits = async (employerId: string, options?: RequestInit): Promise<AdminComplianceAudit[]> => {
  
  return customFetch<AdminComplianceAudit[]>(getGetAdminEmployersEmployerIdComplianceAuditsUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersEmployerIdComplianceAuditsQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/employers/${employerId}/compliance_audits`
    ] as const;
    }

    
export const getGetAdminEmployersEmployerIdComplianceAuditsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersEmployerIdComplianceAuditsQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>> = ({ signal }) => getAdminEmployersEmployerIdComplianceAudits(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersEmployerIdComplianceAuditsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>>
export type GetAdminEmployersEmployerIdComplianceAuditsQueryError = unknown


export function useGetAdminEmployersEmployerIdComplianceAudits<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdComplianceAudits<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdComplianceAudits<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployersEmployerIdComplianceAudits<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdComplianceAudits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersEmployerIdComplianceAuditsQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create new compliance audit for an employer
 */
export const getPostAdminEmployersEmployerIdComplianceAuditsUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}/compliance_audits`
}

export const postAdminEmployersEmployerIdComplianceAudits = async (employerId: string,
    postAdminEmployersEmployerIdComplianceAudits: PostAdminEmployersEmployerIdComplianceAudits, options?: RequestInit): Promise<AdminComplianceAudit> => {
  
  return customFetch<AdminComplianceAudit>(getPostAdminEmployersEmployerIdComplianceAuditsUrl(employerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminEmployersEmployerIdComplianceAudits,)
  }
);}




export const getPostAdminEmployersEmployerIdComplianceAuditsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEmployersEmployerIdComplianceAudits>>, TError,{employerId: string;data: PostAdminEmployersEmployerIdComplianceAudits}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminEmployersEmployerIdComplianceAudits>>, TError,{employerId: string;data: PostAdminEmployersEmployerIdComplianceAudits}, TContext> => {

const mutationKey = ['postAdminEmployersEmployerIdComplianceAudits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminEmployersEmployerIdComplianceAudits>>, {employerId: string;data: PostAdminEmployersEmployerIdComplianceAudits}> = (props) => {
          const {employerId,data} = props ?? {};

          return  postAdminEmployersEmployerIdComplianceAudits(employerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminEmployersEmployerIdComplianceAuditsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminEmployersEmployerIdComplianceAudits>>>
    export type PostAdminEmployersEmployerIdComplianceAuditsMutationBody = PostAdminEmployersEmployerIdComplianceAudits
    export type PostAdminEmployersEmployerIdComplianceAuditsMutationError = unknown

    export const usePostAdminEmployersEmployerIdComplianceAudits = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEmployersEmployerIdComplianceAudits>>, TError,{employerId: string;data: PostAdminEmployersEmployerIdComplianceAudits}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminEmployersEmployerIdComplianceAudits>>,
        TError,
        {employerId: string;data: PostAdminEmployersEmployerIdComplianceAudits},
        TContext
      > => {

      const mutationOptions = getPostAdminEmployersEmployerIdComplianceAuditsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Plaid account for employer
 */
export const getGetAdminEmployersEmployerIdPlaidAccountUrl = (employerId: string,) => {


  

  return `/api/web/admin/employers/${employerId}/plaid_account`
}

export const getAdminEmployersEmployerIdPlaidAccount = async (employerId: string, options?: RequestInit): Promise<AdminPlaidAccount> => {
  
  return customFetch<AdminPlaidAccount>(getGetAdminEmployersEmployerIdPlaidAccountUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminEmployersEmployerIdPlaidAccountQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/employers/${employerId}/plaid_account`
    ] as const;
    }

    
export const getGetAdminEmployersEmployerIdPlaidAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEmployersEmployerIdPlaidAccountQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>> = ({ signal }) => getAdminEmployersEmployerIdPlaidAccount(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminEmployersEmployerIdPlaidAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>>
export type GetAdminEmployersEmployerIdPlaidAccountQueryError = unknown


export function useGetAdminEmployersEmployerIdPlaidAccount<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdPlaidAccount<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>,
          TError,
          Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminEmployersEmployerIdPlaidAccount<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminEmployersEmployerIdPlaidAccount<TData = Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminEmployersEmployerIdPlaidAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminEmployersEmployerIdPlaidAccountQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all Granular Allowance Configs
 */
export const getGetAdminGranularAllowanceConfigsUrl = () => {


  

  return `/api/web/admin/granular_allowance_configs`
}

export const getAdminGranularAllowanceConfigs = async ( options?: RequestInit): Promise<AdminGranularAllowanceConfigList> => {
  
  return customFetch<AdminGranularAllowanceConfigList>(getGetAdminGranularAllowanceConfigsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminGranularAllowanceConfigsQueryKey = () => {
    return [
    `/api/web/admin/granular_allowance_configs`
    ] as const;
    }

    
export const getGetAdminGranularAllowanceConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminGranularAllowanceConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>> = ({ signal }) => getAdminGranularAllowanceConfigs({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminGranularAllowanceConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>>
export type GetAdminGranularAllowanceConfigsQueryError = unknown


export function useGetAdminGranularAllowanceConfigs<TData = Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminGranularAllowanceConfigs<TData = Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminGranularAllowanceConfigs<TData = Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminGranularAllowanceConfigs<TData = Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGranularAllowanceConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminGranularAllowanceConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new Granular Allowance Config
 */
export const getPostAdminGranularAllowanceConfigsUrl = () => {


  

  return `/api/web/admin/granular_allowance_configs`
}

export const postAdminGranularAllowanceConfigs = async (postAdminGranularAllowanceConfigs: PostAdminGranularAllowanceConfigs, options?: RequestInit): Promise<AdminGranularAllowanceConfig> => {
  
  return customFetch<AdminGranularAllowanceConfig>(getPostAdminGranularAllowanceConfigsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminGranularAllowanceConfigs,)
  }
);}




export const getPostAdminGranularAllowanceConfigsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigs>>, TError,{data: PostAdminGranularAllowanceConfigs}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigs>>, TError,{data: PostAdminGranularAllowanceConfigs}, TContext> => {

const mutationKey = ['postAdminGranularAllowanceConfigs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigs>>, {data: PostAdminGranularAllowanceConfigs}> = (props) => {
          const {data} = props ?? {};

          return  postAdminGranularAllowanceConfigs(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminGranularAllowanceConfigsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigs>>>
    export type PostAdminGranularAllowanceConfigsMutationBody = PostAdminGranularAllowanceConfigs
    export type PostAdminGranularAllowanceConfigsMutationError = unknown

    export const usePostAdminGranularAllowanceConfigs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigs>>, TError,{data: PostAdminGranularAllowanceConfigs}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminGranularAllowanceConfigs>>,
        TError,
        {data: PostAdminGranularAllowanceConfigs},
        TContext
      > => {

      const mutationOptions = getPostAdminGranularAllowanceConfigsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a Granular Allowance Config
 */
export const getPatchAdminGranularAllowanceConfigsIdUrl = (id: string,) => {


  

  return `/api/web/admin/granular_allowance_configs/${id}`
}

export const patchAdminGranularAllowanceConfigsId = async (id: string,
    patchAdminGranularAllowanceConfigsId: PatchAdminGranularAllowanceConfigsId, options?: RequestInit): Promise<AdminGranularAllowanceConfig> => {
  
  return customFetch<AdminGranularAllowanceConfig>(getPatchAdminGranularAllowanceConfigsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchAdminGranularAllowanceConfigsId,)
  }
);}




export const getPatchAdminGranularAllowanceConfigsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminGranularAllowanceConfigsId>>, TError,{id: string;data: PatchAdminGranularAllowanceConfigsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminGranularAllowanceConfigsId>>, TError,{id: string;data: PatchAdminGranularAllowanceConfigsId}, TContext> => {

const mutationKey = ['patchAdminGranularAllowanceConfigsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminGranularAllowanceConfigsId>>, {id: string;data: PatchAdminGranularAllowanceConfigsId}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAdminGranularAllowanceConfigsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminGranularAllowanceConfigsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminGranularAllowanceConfigsId>>>
    export type PatchAdminGranularAllowanceConfigsIdMutationBody = PatchAdminGranularAllowanceConfigsId
    export type PatchAdminGranularAllowanceConfigsIdMutationError = unknown

    export const usePatchAdminGranularAllowanceConfigsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminGranularAllowanceConfigsId>>, TError,{id: string;data: PatchAdminGranularAllowanceConfigsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminGranularAllowanceConfigsId>>,
        TError,
        {id: string;data: PatchAdminGranularAllowanceConfigsId},
        TContext
      > => {

      const mutationOptions = getPatchAdminGranularAllowanceConfigsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Trigger job to generate allowances for a config
 */
export const getPostAdminGranularAllowanceConfigsIdGenerateUrl = (id: string,) => {


  

  return `/api/web/admin/granular_allowance_configs/${id}/generate`
}

export const postAdminGranularAllowanceConfigsIdGenerate = async (id: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminGranularAllowanceConfigsIdGenerateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostAdminGranularAllowanceConfigsIdGenerateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdGenerate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdGenerate>>, TError,{id: string}, TContext> => {

const mutationKey = ['postAdminGranularAllowanceConfigsIdGenerate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdGenerate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postAdminGranularAllowanceConfigsIdGenerate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminGranularAllowanceConfigsIdGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdGenerate>>>
    
    export type PostAdminGranularAllowanceConfigsIdGenerateMutationError = unknown

    export const usePostAdminGranularAllowanceConfigsIdGenerate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdGenerate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdGenerate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostAdminGranularAllowanceConfigsIdGenerateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Promote a config to active status
 */
export const getPostAdminGranularAllowanceConfigsIdPromoteUrl = (id: string,) => {


  

  return `/api/web/admin/granular_allowance_configs/${id}/promote`
}

export const postAdminGranularAllowanceConfigsIdPromote = async (id: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminGranularAllowanceConfigsIdPromoteUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostAdminGranularAllowanceConfigsIdPromoteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdPromote>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdPromote>>, TError,{id: string}, TContext> => {

const mutationKey = ['postAdminGranularAllowanceConfigsIdPromote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdPromote>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postAdminGranularAllowanceConfigsIdPromote(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminGranularAllowanceConfigsIdPromoteMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdPromote>>>
    
    export type PostAdminGranularAllowanceConfigsIdPromoteMutationError = unknown

    export const usePostAdminGranularAllowanceConfigsIdPromote = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdPromote>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminGranularAllowanceConfigsIdPromote>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostAdminGranularAllowanceConfigsIdPromoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Search by ID or a name/email
 */
export const getGetAdminSearchUrl = (params: GetAdminSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/search?${stringifiedParams}` : `/api/web/admin/search`
}

export const getAdminSearch = async (params: GetAdminSearchParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminSearchUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminSearchQueryKey = (params?: GetAdminSearchParams,) => {
    return [
    `/api/web/admin/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminSearchQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSearch>>, TError = unknown>(params: GetAdminSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSearch>>> = ({ signal }) => getAdminSearch(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSearch>>>
export type GetAdminSearchQueryError = unknown


export function useGetAdminSearch<TData = Awaited<ReturnType<typeof getAdminSearch>>, TError = unknown>(
 params: GetAdminSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSearch>>,
          TError,
          Awaited<ReturnType<typeof getAdminSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSearch<TData = Awaited<ReturnType<typeof getAdminSearch>>, TError = unknown>(
 params: GetAdminSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSearch>>,
          TError,
          Awaited<ReturnType<typeof getAdminSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSearch<TData = Awaited<ReturnType<typeof getAdminSearch>>, TError = unknown>(
 params: GetAdminSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminSearch<TData = Awaited<ReturnType<typeof getAdminSearch>>, TError = unknown>(
 params: GetAdminSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSearch>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List all partners
 */
export const getGetAdminPartnersUrl = (params?: GetAdminPartnersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/partners?${stringifiedParams}` : `/api/web/admin/partners`
}

export const getAdminPartners = async (params?: GetAdminPartnersParams, options?: RequestInit): Promise<AdminPartner[]> => {
  
  return customFetch<AdminPartner[]>(getGetAdminPartnersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminPartnersQueryKey = (params?: GetAdminPartnersParams,) => {
    return [
    `/api/web/admin/partners`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminPartnersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPartners>>, TError = unknown>(params?: GetAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPartnersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPartners>>> = ({ signal }) => getAdminPartners(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPartners>>>
export type GetAdminPartnersQueryError = unknown


export function useGetAdminPartners<TData = Awaited<ReturnType<typeof getAdminPartners>>, TError = unknown>(
 params: undefined |  GetAdminPartnersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPartners<TData = Awaited<ReturnType<typeof getAdminPartners>>, TError = unknown>(
 params?: GetAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPartners>>,
          TError,
          Awaited<ReturnType<typeof getAdminPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPartners<TData = Awaited<ReturnType<typeof getAdminPartners>>, TError = unknown>(
 params?: GetAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminPartners<TData = Awaited<ReturnType<typeof getAdminPartners>>, TError = unknown>(
 params?: GetAdminPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPartnersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all payroll provider configs
 */
export const getGetAdminPayrollProviderConfigsUrl = () => {


  

  return `/api/web/admin/payroll_provider_configs`
}

export const getAdminPayrollProviderConfigs = async ( options?: RequestInit): Promise<PayrollProviderConfig> => {
  
  return customFetch<PayrollProviderConfig>(getGetAdminPayrollProviderConfigsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminPayrollProviderConfigsQueryKey = () => {
    return [
    `/api/web/admin/payroll_provider_configs`
    ] as const;
    }

    
export const getGetAdminPayrollProviderConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPayrollProviderConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>> = ({ signal }) => getAdminPayrollProviderConfigs({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPayrollProviderConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>>
export type GetAdminPayrollProviderConfigsQueryError = unknown


export function useGetAdminPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPayrollProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPayrollProviderConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update the payroll provider config
 */
export const getPutAdminPayrollProviderConfigsIdUrl = (id: string,) => {


  

  return `/api/web/admin/payroll_provider_configs/${id}`
}

export const putAdminPayrollProviderConfigsId = async (id: string,
    putAdminPayrollProviderConfigsId: PutAdminPayrollProviderConfigsId, options?: RequestInit): Promise<PayrollProviderConfig> => {
  
  return customFetch<PayrollProviderConfig>(getPutAdminPayrollProviderConfigsIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAdminPayrollProviderConfigsId,)
  }
);}




export const getPutAdminPayrollProviderConfigsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPayrollProviderConfigsId>>, TError,{id: string;data: PutAdminPayrollProviderConfigsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminPayrollProviderConfigsId>>, TError,{id: string;data: PutAdminPayrollProviderConfigsId}, TContext> => {

const mutationKey = ['putAdminPayrollProviderConfigsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminPayrollProviderConfigsId>>, {id: string;data: PutAdminPayrollProviderConfigsId}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminPayrollProviderConfigsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminPayrollProviderConfigsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminPayrollProviderConfigsId>>>
    export type PutAdminPayrollProviderConfigsIdMutationBody = PutAdminPayrollProviderConfigsId
    export type PutAdminPayrollProviderConfigsIdMutationError = unknown

    export const usePutAdminPayrollProviderConfigsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPayrollProviderConfigsId>>, TError,{id: string;data: PutAdminPayrollProviderConfigsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminPayrollProviderConfigsId>>,
        TError,
        {id: string;data: PutAdminPayrollProviderConfigsId},
        TContext
      > => {

      const mutationOptions = getPutAdminPayrollProviderConfigsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sync payroll provider configs
 */
export const getPostAdminPayrollProviderConfigsSyncUrl = () => {


  

  return `/api/web/admin/payroll_provider_configs/sync`
}

export const postAdminPayrollProviderConfigsSync = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminPayrollProviderConfigsSyncUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostAdminPayrollProviderConfigsSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPayrollProviderConfigsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPayrollProviderConfigsSync>>, TError,void, TContext> => {

const mutationKey = ['postAdminPayrollProviderConfigsSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPayrollProviderConfigsSync>>, void> = () => {
          

          return  postAdminPayrollProviderConfigsSync(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPayrollProviderConfigsSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPayrollProviderConfigsSync>>>
    
    export type PostAdminPayrollProviderConfigsSyncMutationError = unknown

    export const usePostAdminPayrollProviderConfigsSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPayrollProviderConfigsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPayrollProviderConfigsSync>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAdminPayrollProviderConfigsSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List all ledger accounts
 */
export const getGetAdminLedgerAccountsUrl = (params?: GetAdminLedgerAccountsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/ledger_accounts?${stringifiedParams}` : `/api/web/admin/ledger_accounts`
}

export const getAdminLedgerAccounts = async (params?: GetAdminLedgerAccountsParams, options?: RequestInit): Promise<AdminPaginatedLedgerAccounts> => {
  
  return customFetch<AdminPaginatedLedgerAccounts>(getGetAdminLedgerAccountsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminLedgerAccountsQueryKey = (params?: GetAdminLedgerAccountsParams,) => {
    return [
    `/api/web/admin/ledger_accounts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminLedgerAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError = unknown>(params?: GetAdminLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLedgerAccountsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLedgerAccounts>>> = ({ signal }) => getAdminLedgerAccounts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminLedgerAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLedgerAccounts>>>
export type GetAdminLedgerAccountsQueryError = unknown


export function useGetAdminLedgerAccounts<TData = Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError = unknown>(
 params: undefined |  GetAdminLedgerAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedgerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedgerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerAccounts<TData = Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError = unknown>(
 params?: GetAdminLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedgerAccounts>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedgerAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerAccounts<TData = Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError = unknown>(
 params?: GetAdminLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminLedgerAccounts<TData = Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError = unknown>(
 params?: GetAdminLedgerAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccounts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminLedgerAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a single ledger account's details
 */
export const getGetAdminLedgerAccountsIdUrl = (id: string,
    params?: GetAdminLedgerAccountsIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/ledger_accounts/${id}?${stringifiedParams}` : `/api/web/admin/ledger_accounts/${id}`
}

export const getAdminLedgerAccountsId = async (id: string,
    params?: GetAdminLedgerAccountsIdParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminLedgerAccountsIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminLedgerAccountsIdQueryKey = (id?: string,
    params?: GetAdminLedgerAccountsIdParams,) => {
    return [
    `/api/web/admin/ledger_accounts/${id}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminLedgerAccountsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError = unknown>(id: string,
    params?: GetAdminLedgerAccountsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLedgerAccountsIdQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>> = ({ signal }) => getAdminLedgerAccountsId(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminLedgerAccountsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>>
export type GetAdminLedgerAccountsIdQueryError = unknown


export function useGetAdminLedgerAccountsId<TData = Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError = unknown>(
 id: string,
    params: undefined |  GetAdminLedgerAccountsIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedgerAccountsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedgerAccountsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerAccountsId<TData = Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError = unknown>(
 id: string,
    params?: GetAdminLedgerAccountsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedgerAccountsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedgerAccountsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerAccountsId<TData = Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError = unknown>(
 id: string,
    params?: GetAdminLedgerAccountsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminLedgerAccountsId<TData = Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError = unknown>(
 id: string,
    params?: GetAdminLedgerAccountsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerAccountsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminLedgerAccountsIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List all ledger entries for a ledger account
 */
export const getGetAdminLedgerEntriesUrl = (params?: GetAdminLedgerEntriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/ledger_entries?${stringifiedParams}` : `/api/web/admin/ledger_entries`
}

export const getAdminLedgerEntries = async (params?: GetAdminLedgerEntriesParams, options?: RequestInit): Promise<AdminPaginatedLedgerEntries> => {
  
  return customFetch<AdminPaginatedLedgerEntries>(getGetAdminLedgerEntriesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminLedgerEntriesQueryKey = (params?: GetAdminLedgerEntriesParams,) => {
    return [
    `/api/web/admin/ledger_entries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminLedgerEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError = unknown>(params?: GetAdminLedgerEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminLedgerEntriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLedgerEntries>>> = ({ signal }) => getAdminLedgerEntries(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminLedgerEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLedgerEntries>>>
export type GetAdminLedgerEntriesQueryError = unknown


export function useGetAdminLedgerEntries<TData = Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError = unknown>(
 params: undefined |  GetAdminLedgerEntriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedgerEntries>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedgerEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerEntries<TData = Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError = unknown>(
 params?: GetAdminLedgerEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminLedgerEntries>>,
          TError,
          Awaited<ReturnType<typeof getAdminLedgerEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminLedgerEntries<TData = Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError = unknown>(
 params?: GetAdminLedgerEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminLedgerEntries<TData = Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError = unknown>(
 params?: GetAdminLedgerEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLedgerEntries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminLedgerEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get ingestion status of medical plan data of all states for a given year
 */
export const getGetAdminMedicalPlanDataUrl = (params?: GetAdminMedicalPlanDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/medical_plan_data?${stringifiedParams}` : `/api/web/admin/medical_plan_data`
}

export const getAdminMedicalPlanData = async (params?: GetAdminMedicalPlanDataParams, options?: RequestInit): Promise<AdminMedicalPlanDataStateIngestionStatusList> => {
  
  return customFetch<AdminMedicalPlanDataStateIngestionStatusList>(getGetAdminMedicalPlanDataUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMedicalPlanDataQueryKey = (params?: GetAdminMedicalPlanDataParams,) => {
    return [
    `/api/web/admin/medical_plan_data`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMedicalPlanDataQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError = unknown>(params?: GetAdminMedicalPlanDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMedicalPlanDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMedicalPlanData>>> = ({ signal }) => getAdminMedicalPlanData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMedicalPlanDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMedicalPlanData>>>
export type GetAdminMedicalPlanDataQueryError = unknown


export function useGetAdminMedicalPlanData<TData = Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError = unknown>(
 params: undefined |  GetAdminMedicalPlanDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanData>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanData<TData = Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError = unknown>(
 params?: GetAdminMedicalPlanDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanData>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanData<TData = Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError = unknown>(
 params?: GetAdminMedicalPlanDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMedicalPlanData<TData = Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError = unknown>(
 params?: GetAdminMedicalPlanDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMedicalPlanDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Refresh ingestion status of medical plan data for selected states
 */
export const getPostAdminMedicalPlanDataRefreshStateStatusReportUrl = () => {


  

  return `/api/web/admin/medical_plan_data/refresh_state_status_report`
}

export const postAdminMedicalPlanDataRefreshStateStatusReport = async (postAdminMedicalPlanDataRefreshStateStatusReport: PostAdminMedicalPlanDataRefreshStateStatusReport, options?: RequestInit): Promise<AdminMedicalPlanDataStatusReport> => {
  
  return customFetch<AdminMedicalPlanDataStatusReport>(getPostAdminMedicalPlanDataRefreshStateStatusReportUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminMedicalPlanDataRefreshStateStatusReport,)
  }
);}




export const getPostAdminMedicalPlanDataRefreshStateStatusReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanDataRefreshStateStatusReport>>, TError,{data: PostAdminMedicalPlanDataRefreshStateStatusReport}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanDataRefreshStateStatusReport>>, TError,{data: PostAdminMedicalPlanDataRefreshStateStatusReport}, TContext> => {

const mutationKey = ['postAdminMedicalPlanDataRefreshStateStatusReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminMedicalPlanDataRefreshStateStatusReport>>, {data: PostAdminMedicalPlanDataRefreshStateStatusReport}> = (props) => {
          const {data} = props ?? {};

          return  postAdminMedicalPlanDataRefreshStateStatusReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminMedicalPlanDataRefreshStateStatusReportMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminMedicalPlanDataRefreshStateStatusReport>>>
    export type PostAdminMedicalPlanDataRefreshStateStatusReportMutationBody = PostAdminMedicalPlanDataRefreshStateStatusReport
    export type PostAdminMedicalPlanDataRefreshStateStatusReportMutationError = unknown

    export const usePostAdminMedicalPlanDataRefreshStateStatusReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanDataRefreshStateStatusReport>>, TError,{data: PostAdminMedicalPlanDataRefreshStateStatusReport}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminMedicalPlanDataRefreshStateStatusReport>>,
        TError,
        {data: PostAdminMedicalPlanDataRefreshStateStatusReport},
        TContext
      > => {

      const mutationOptions = getPostAdminMedicalPlanDataRefreshStateStatusReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Run medical plan data ingestion jobs
 */
export const getPostAdminMedicalPlanDataRunIngestionUrl = () => {


  

  return `/api/web/admin/medical_plan_data/run_ingestion`
}

export const postAdminMedicalPlanDataRunIngestion = async (postAdminMedicalPlanDataRunIngestion: PostAdminMedicalPlanDataRunIngestion, options?: RequestInit): Promise<AdminMedicalPlanDataIngestionJobsScheduled> => {
  
  return customFetch<AdminMedicalPlanDataIngestionJobsScheduled>(getPostAdminMedicalPlanDataRunIngestionUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminMedicalPlanDataRunIngestion,)
  }
);}




export const getPostAdminMedicalPlanDataRunIngestionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanDataRunIngestion>>, TError,{data: PostAdminMedicalPlanDataRunIngestion}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanDataRunIngestion>>, TError,{data: PostAdminMedicalPlanDataRunIngestion}, TContext> => {

const mutationKey = ['postAdminMedicalPlanDataRunIngestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminMedicalPlanDataRunIngestion>>, {data: PostAdminMedicalPlanDataRunIngestion}> = (props) => {
          const {data} = props ?? {};

          return  postAdminMedicalPlanDataRunIngestion(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminMedicalPlanDataRunIngestionMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminMedicalPlanDataRunIngestion>>>
    export type PostAdminMedicalPlanDataRunIngestionMutationBody = PostAdminMedicalPlanDataRunIngestion
    export type PostAdminMedicalPlanDataRunIngestionMutationError = unknown

    export const usePostAdminMedicalPlanDataRunIngestion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanDataRunIngestion>>, TError,{data: PostAdminMedicalPlanDataRunIngestion}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminMedicalPlanDataRunIngestion>>,
        TError,
        {data: PostAdminMedicalPlanDataRunIngestion},
        TContext
      > => {

      const mutationOptions = getPostAdminMedicalPlanDataRunIngestionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get available filter options for medical plan ingestion jobs
 */
export const getGetAdminMedicalPlanIngestionsFiltersUrl = () => {


  

  return `/api/web/admin/medical_plan_ingestions/filters`
}

export const getAdminMedicalPlanIngestionsFilters = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminMedicalPlanIngestionsFiltersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMedicalPlanIngestionsFiltersQueryKey = () => {
    return [
    `/api/web/admin/medical_plan_ingestions/filters`
    ] as const;
    }

    
export const getGetAdminMedicalPlanIngestionsFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMedicalPlanIngestionsFiltersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>> = ({ signal }) => getAdminMedicalPlanIngestionsFilters({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMedicalPlanIngestionsFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>>
export type GetAdminMedicalPlanIngestionsFiltersQueryError = unknown


export function useGetAdminMedicalPlanIngestionsFilters<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanIngestionsFilters<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanIngestionsFilters<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMedicalPlanIngestionsFilters<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestionsFilters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMedicalPlanIngestionsFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get medical plan ingestion jobs grouped by job_id
 */
export const getGetAdminMedicalPlanIngestionsUrl = (params?: GetAdminMedicalPlanIngestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/medical_plan_ingestions?${stringifiedParams}` : `/api/web/admin/medical_plan_ingestions`
}

export const getAdminMedicalPlanIngestions = async (params?: GetAdminMedicalPlanIngestionsParams, options?: RequestInit): Promise<AdminMedicalPlanIngestionsIngestionJobsList> => {
  
  return customFetch<AdminMedicalPlanIngestionsIngestionJobsList>(getGetAdminMedicalPlanIngestionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMedicalPlanIngestionsQueryKey = (params?: GetAdminMedicalPlanIngestionsParams,) => {
    return [
    `/api/web/admin/medical_plan_ingestions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMedicalPlanIngestionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError = unknown>(params?: GetAdminMedicalPlanIngestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMedicalPlanIngestionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>> = ({ signal }) => getAdminMedicalPlanIngestions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMedicalPlanIngestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>>
export type GetAdminMedicalPlanIngestionsQueryError = unknown


export function useGetAdminMedicalPlanIngestions<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError = unknown>(
 params: undefined |  GetAdminMedicalPlanIngestionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanIngestions<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError = unknown>(
 params?: GetAdminMedicalPlanIngestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanIngestions<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError = unknown>(
 params?: GetAdminMedicalPlanIngestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMedicalPlanIngestions<TData = Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError = unknown>(
 params?: GetAdminMedicalPlanIngestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanIngestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMedicalPlanIngestionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List consistent deductions for a member
 */
export const getGetAdminMemberConsistentDeductionsUrl = (params: GetAdminMemberConsistentDeductionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/member_consistent_deductions?${stringifiedParams}` : `/api/web/admin/member_consistent_deductions`
}

export const getAdminMemberConsistentDeductions = async (params: GetAdminMemberConsistentDeductionsParams, options?: RequestInit): Promise<AdminConsistentDeductionList> => {
  
  return customFetch<AdminConsistentDeductionList>(getGetAdminMemberConsistentDeductionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMemberConsistentDeductionsQueryKey = (params?: GetAdminMemberConsistentDeductionsParams,) => {
    return [
    `/api/web/admin/member_consistent_deductions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMemberConsistentDeductionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError = unknown>(params: GetAdminMemberConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMemberConsistentDeductionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>> = ({ signal }) => getAdminMemberConsistentDeductions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMemberConsistentDeductionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>>
export type GetAdminMemberConsistentDeductionsQueryError = unknown


export function useGetAdminMemberConsistentDeductions<TData = Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError = unknown>(
 params: GetAdminMemberConsistentDeductionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>,
          TError,
          Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMemberConsistentDeductions<TData = Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError = unknown>(
 params: GetAdminMemberConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>,
          TError,
          Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMemberConsistentDeductions<TData = Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError = unknown>(
 params: GetAdminMemberConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMemberConsistentDeductions<TData = Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError = unknown>(
 params: GetAdminMemberConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMemberConsistentDeductions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMemberConsistentDeductionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all Stripe prices
 */
export const getGetAdminStripePricesUrl = () => {


  

  return `/api/web/admin/stripe/prices`
}

export const getAdminStripePrices = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminStripePricesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminStripePricesQueryKey = () => {
    return [
    `/api/web/admin/stripe/prices`
    ] as const;
    }

    
export const getGetAdminStripePricesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStripePrices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePrices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStripePricesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStripePrices>>> = ({ signal }) => getAdminStripePrices({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePrices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminStripePricesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStripePrices>>>
export type GetAdminStripePricesQueryError = unknown


export function useGetAdminStripePrices<TData = Awaited<ReturnType<typeof getAdminStripePrices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePrices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStripePrices>>,
          TError,
          Awaited<ReturnType<typeof getAdminStripePrices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStripePrices<TData = Awaited<ReturnType<typeof getAdminStripePrices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePrices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStripePrices>>,
          TError,
          Awaited<ReturnType<typeof getAdminStripePrices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStripePrices<TData = Awaited<ReturnType<typeof getAdminStripePrices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePrices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminStripePrices<TData = Awaited<ReturnType<typeof getAdminStripePrices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePrices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminStripePricesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get employer stripe price ids
 */
export const getGetAdminStripePricesEmployerIdUrl = (employerId: string,) => {


  

  return `/api/web/admin/stripe/prices/${employerId}`
}

export const getAdminStripePricesEmployerId = async (employerId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminStripePricesEmployerIdUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminStripePricesEmployerIdQueryKey = (employerId?: string,) => {
    return [
    `/api/web/admin/stripe/prices/${employerId}`
    ] as const;
    }

    
export const getGetAdminStripePricesEmployerIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStripePricesEmployerIdQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>> = ({ signal }) => getAdminStripePricesEmployerId(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminStripePricesEmployerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>>
export type GetAdminStripePricesEmployerIdQueryError = unknown


export function useGetAdminStripePricesEmployerId<TData = Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStripePricesEmployerId<TData = Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>,
          TError,
          Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminStripePricesEmployerId<TData = Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminStripePricesEmployerId<TData = Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminStripePricesEmployerId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminStripePricesEmployerIdQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update employer stripe price ids and sync with Stripe
 */
export const getPutAdminStripePricesEmployerIdUrl = (employerId: string,) => {


  

  return `/api/web/admin/stripe/prices/${employerId}`
}

export const putAdminStripePricesEmployerId = async (employerId: string,
    putAdminStripePricesEmployerId: PutAdminStripePricesEmployerId, options?: RequestInit): Promise<AdminEmployer> => {
  
  return customFetch<AdminEmployer>(getPutAdminStripePricesEmployerIdUrl(employerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAdminStripePricesEmployerId,)
  }
);}




export const getPutAdminStripePricesEmployerIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminStripePricesEmployerId>>, TError,{employerId: string;data: PutAdminStripePricesEmployerId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putAdminStripePricesEmployerId>>, TError,{employerId: string;data: PutAdminStripePricesEmployerId}, TContext> => {

const mutationKey = ['putAdminStripePricesEmployerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminStripePricesEmployerId>>, {employerId: string;data: PutAdminStripePricesEmployerId}> = (props) => {
          const {employerId,data} = props ?? {};

          return  putAdminStripePricesEmployerId(employerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminStripePricesEmployerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminStripePricesEmployerId>>>
    export type PutAdminStripePricesEmployerIdMutationBody = PutAdminStripePricesEmployerId
    export type PutAdminStripePricesEmployerIdMutationError = unknown

    export const usePutAdminStripePricesEmployerId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminStripePricesEmployerId>>, TError,{employerId: string;data: PutAdminStripePricesEmployerId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminStripePricesEmployerId>>,
        TError,
        {employerId: string;data: PutAdminStripePricesEmployerId},
        TContext
      > => {

      const mutationOptions = getPutAdminStripePricesEmployerIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Substantiations
 */
export const getGetAdminSubstantiationsUrl = (params?: GetAdminSubstantiationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[review_statuses][]","filter[medical_care][]","filter[ongoing_coverage][]","filter[member_ids][]","filter[employer_ids][]","filter[broker_ids][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/substantiations?${stringifiedParams}` : `/api/web/admin/substantiations`
}

export const getAdminSubstantiations = async (params?: GetAdminSubstantiationsParams, options?: RequestInit): Promise<AdminPaginatedSubstantiations> => {
  
  return customFetch<AdminPaginatedSubstantiations>(getGetAdminSubstantiationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminSubstantiationsQueryKey = (params?: GetAdminSubstantiationsParams,) => {
    return [
    `/api/web/admin/substantiations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminSubstantiationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSubstantiations>>, TError = unknown>(params?: GetAdminSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSubstantiationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSubstantiations>>> = ({ signal }) => getAdminSubstantiations(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSubstantiationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSubstantiations>>>
export type GetAdminSubstantiationsQueryError = unknown


export function useGetAdminSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiations>>, TError = unknown>(
 params: undefined |  GetAdminSubstantiationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSubstantiations>>,
          TError,
          Awaited<ReturnType<typeof getAdminSubstantiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiations>>, TError = unknown>(
 params?: GetAdminSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSubstantiations>>,
          TError,
          Awaited<ReturnType<typeof getAdminSubstantiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiations>>, TError = unknown>(
 params?: GetAdminSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiations>>, TError = unknown>(
 params?: GetAdminSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSubstantiationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Modify Substantiation
 */
export const getPatchAdminSubstantiationsUrl = () => {


  

  return `/api/web/admin/substantiations`
}

export const patchAdminSubstantiations = async (patchAdminSubstantiations: PatchAdminSubstantiations, options?: RequestInit): Promise<AdminSubstantiation[]> => {
  
  return customFetch<AdminSubstantiation[]>(getPatchAdminSubstantiationsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchAdminSubstantiations,)
  }
);}




export const getPatchAdminSubstantiationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminSubstantiations>>, TError,{data: PatchAdminSubstantiations}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminSubstantiations>>, TError,{data: PatchAdminSubstantiations}, TContext> => {

const mutationKey = ['patchAdminSubstantiations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminSubstantiations>>, {data: PatchAdminSubstantiations}> = (props) => {
          const {data} = props ?? {};

          return  patchAdminSubstantiations(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminSubstantiationsMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminSubstantiations>>>
    export type PatchAdminSubstantiationsMutationBody = PatchAdminSubstantiations
    export type PatchAdminSubstantiationsMutationError = unknown

    export const usePatchAdminSubstantiations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminSubstantiations>>, TError,{data: PatchAdminSubstantiations}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminSubstantiations>>,
        TError,
        {data: PatchAdminSubstantiations},
        TContext
      > => {

      const mutationOptions = getPatchAdminSubstantiationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Match receipt to a substantiation transaction
 */
export const getPatchAdminSubstantiationsSubstantiationIdMatchReceiptUrl = (substantiationId: string,) => {


  

  return `/api/web/admin/substantiations/${substantiationId}/match_receipt`
}

export const patchAdminSubstantiationsSubstantiationIdMatchReceipt = async (substantiationId: string,
    patchAdminSubstantiationsSubstantiationIdMatchReceipt: PatchAdminSubstantiationsSubstantiationIdMatchReceipt, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPatchAdminSubstantiationsSubstantiationIdMatchReceiptUrl(substantiationId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchAdminSubstantiationsSubstantiationIdMatchReceipt,)
  }
);}




export const getPatchAdminSubstantiationsSubstantiationIdMatchReceiptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminSubstantiationsSubstantiationIdMatchReceipt>>, TError,{substantiationId: string;data: PatchAdminSubstantiationsSubstantiationIdMatchReceipt}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminSubstantiationsSubstantiationIdMatchReceipt>>, TError,{substantiationId: string;data: PatchAdminSubstantiationsSubstantiationIdMatchReceipt}, TContext> => {

const mutationKey = ['patchAdminSubstantiationsSubstantiationIdMatchReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminSubstantiationsSubstantiationIdMatchReceipt>>, {substantiationId: string;data: PatchAdminSubstantiationsSubstantiationIdMatchReceipt}> = (props) => {
          const {substantiationId,data} = props ?? {};

          return  patchAdminSubstantiationsSubstantiationIdMatchReceipt(substantiationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminSubstantiationsSubstantiationIdMatchReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminSubstantiationsSubstantiationIdMatchReceipt>>>
    export type PatchAdminSubstantiationsSubstantiationIdMatchReceiptMutationBody = PatchAdminSubstantiationsSubstantiationIdMatchReceipt
    export type PatchAdminSubstantiationsSubstantiationIdMatchReceiptMutationError = unknown

    export const usePatchAdminSubstantiationsSubstantiationIdMatchReceipt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminSubstantiationsSubstantiationIdMatchReceipt>>, TError,{substantiationId: string;data: PatchAdminSubstantiationsSubstantiationIdMatchReceipt}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminSubstantiationsSubstantiationIdMatchReceipt>>,
        TError,
        {substantiationId: string;data: PatchAdminSubstantiationsSubstantiationIdMatchReceipt},
        TContext
      > => {

      const mutationOptions = getPatchAdminSubstantiationsSubstantiationIdMatchReceiptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get rejected substantiations
 */
export const getGetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsUrl = (substantiationId: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/substantiations/${substantiationId}/rejected_substantiations?${stringifiedParams}` : `/api/web/admin/substantiations/${substantiationId}/rejected_substantiations`
}

export const getAdminSubstantiationsSubstantiationIdRejectedSubstantiations = async (substantiationId: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsUrl(substantiationId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsQueryKey = (substantiationId?: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams,) => {
    return [
    `/api/web/admin/substantiations/${substantiationId}/rejected_substantiations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError = unknown>(substantiationId: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsQueryKey(substantiationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>> = ({ signal }) => getAdminSubstantiationsSubstantiationIdRejectedSubstantiations(substantiationId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(substantiationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>>
export type GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsQueryError = unknown


export function useGetAdminSubstantiationsSubstantiationIdRejectedSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError = unknown>(
 substantiationId: string,
    params: undefined |  GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>,
          TError,
          Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSubstantiationsSubstantiationIdRejectedSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError = unknown>(
 substantiationId: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>,
          TError,
          Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSubstantiationsSubstantiationIdRejectedSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError = unknown>(
 substantiationId: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminSubstantiationsSubstantiationIdRejectedSubstantiations<TData = Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError = unknown>(
 substantiationId: string,
    params?: GetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSubstantiationsSubstantiationIdRejectedSubstantiations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSubstantiationsSubstantiationIdRejectedSubstantiationsQueryOptions(substantiationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get Reimbursements
 */
export const getGetAdminReimbursementsUrl = (params?: GetAdminReimbursementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[states][]","filter[purposes][]","filter[enrollment_categories][]","filter[member_ids][]","filter[employer_ids][]","filter[broker_ids][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/reimbursements?${stringifiedParams}` : `/api/web/admin/reimbursements`
}

export const getAdminReimbursements = async (params?: GetAdminReimbursementsParams, options?: RequestInit): Promise<AdminPaginatedReimbursements> => {
  
  return customFetch<AdminPaginatedReimbursements>(getGetAdminReimbursementsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminReimbursementsQueryKey = (params?: GetAdminReimbursementsParams,) => {
    return [
    `/api/web/admin/reimbursements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminReimbursementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminReimbursements>>, TError = unknown>(params?: GetAdminReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReimbursements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminReimbursementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminReimbursements>>> = ({ signal }) => getAdminReimbursements(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminReimbursements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminReimbursementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminReimbursements>>>
export type GetAdminReimbursementsQueryError = unknown


export function useGetAdminReimbursements<TData = Awaited<ReturnType<typeof getAdminReimbursements>>, TError = unknown>(
 params: undefined |  GetAdminReimbursementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReimbursements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminReimbursements>>,
          TError,
          Awaited<ReturnType<typeof getAdminReimbursements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminReimbursements<TData = Awaited<ReturnType<typeof getAdminReimbursements>>, TError = unknown>(
 params?: GetAdminReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReimbursements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminReimbursements>>,
          TError,
          Awaited<ReturnType<typeof getAdminReimbursements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminReimbursements<TData = Awaited<ReturnType<typeof getAdminReimbursements>>, TError = unknown>(
 params?: GetAdminReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReimbursements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminReimbursements<TData = Awaited<ReturnType<typeof getAdminReimbursements>>, TError = unknown>(
 params?: GetAdminReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminReimbursements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminReimbursementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Modify Broker Attention Needed Items
 */
export const getPatchAdminReimbursementsUrl = () => {


  

  return `/api/web/admin/reimbursements`
}

export const patchAdminReimbursements = async (patchAdminReimbursements: PatchAdminReimbursements, options?: RequestInit): Promise<AdminReimbursement[]> => {
  
  return customFetch<AdminReimbursement[]>(getPatchAdminReimbursementsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchAdminReimbursements,)
  }
);}




export const getPatchAdminReimbursementsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminReimbursements>>, TError,{data: PatchAdminReimbursements}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminReimbursements>>, TError,{data: PatchAdminReimbursements}, TContext> => {

const mutationKey = ['patchAdminReimbursements'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminReimbursements>>, {data: PatchAdminReimbursements}> = (props) => {
          const {data} = props ?? {};

          return  patchAdminReimbursements(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminReimbursementsMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminReimbursements>>>
    export type PatchAdminReimbursementsMutationBody = PatchAdminReimbursements
    export type PatchAdminReimbursementsMutationError = unknown

    export const usePatchAdminReimbursements = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminReimbursements>>, TError,{data: PatchAdminReimbursements}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminReimbursements>>,
        TError,
        {data: PatchAdminReimbursements},
        TContext
      > => {

      const mutationOptions = getPatchAdminReimbursementsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Medical Plan Projections
 */
export const getGetAdminMedicalPlanProjectionsUrl = (params: GetAdminMedicalPlanProjectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/medical_plan_projections?${stringifiedParams}` : `/api/web/admin/medical_plan_projections`
}

export const getAdminMedicalPlanProjections = async (params: GetAdminMedicalPlanProjectionsParams, options?: RequestInit): Promise<AdminPaginatedMedicalPlanProjections> => {
  
  return customFetch<AdminPaginatedMedicalPlanProjections>(getGetAdminMedicalPlanProjectionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMedicalPlanProjectionsQueryKey = (params?: GetAdminMedicalPlanProjectionsParams,) => {
    return [
    `/api/web/admin/medical_plan_projections`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMedicalPlanProjectionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError = unknown>(params: GetAdminMedicalPlanProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMedicalPlanProjectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>> = ({ signal }) => getAdminMedicalPlanProjections(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMedicalPlanProjectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>>
export type GetAdminMedicalPlanProjectionsQueryError = unknown


export function useGetAdminMedicalPlanProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMedicalPlanProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMedicalPlanProjectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download Template CSV
 */
export const getGetAdminMedicalPlanProjectionsDownloadTemplateUrl = () => {


  

  return `/api/web/admin/medical_plan_projections/download_template`
}

export const getAdminMedicalPlanProjectionsDownloadTemplate = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminMedicalPlanProjectionsDownloadTemplateUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMedicalPlanProjectionsDownloadTemplateQueryKey = () => {
    return [
    `/api/web/admin/medical_plan_projections/download_template`
    ] as const;
    }

    
export const getGetAdminMedicalPlanProjectionsDownloadTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMedicalPlanProjectionsDownloadTemplateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>> = ({ signal }) => getAdminMedicalPlanProjectionsDownloadTemplate({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMedicalPlanProjectionsDownloadTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>>
export type GetAdminMedicalPlanProjectionsDownloadTemplateQueryError = unknown


export function useGetAdminMedicalPlanProjectionsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanProjectionsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanProjectionsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMedicalPlanProjectionsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMedicalPlanProjectionsDownloadTemplateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download Projections CSV
 */
export const getGetAdminMedicalPlanProjectionsDownloadProjectionsUrl = (params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/medical_plan_projections/download_projections?${stringifiedParams}` : `/api/web/admin/medical_plan_projections/download_projections`
}

export const getAdminMedicalPlanProjectionsDownloadProjections = async (params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminMedicalPlanProjectionsDownloadProjectionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMedicalPlanProjectionsDownloadProjectionsQueryKey = (params?: GetAdminMedicalPlanProjectionsDownloadProjectionsParams,) => {
    return [
    `/api/web/admin/medical_plan_projections/download_projections`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMedicalPlanProjectionsDownloadProjectionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError = unknown>(params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMedicalPlanProjectionsDownloadProjectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>> = ({ signal }) => getAdminMedicalPlanProjectionsDownloadProjections(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMedicalPlanProjectionsDownloadProjectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>>
export type GetAdminMedicalPlanProjectionsDownloadProjectionsQueryError = unknown


export function useGetAdminMedicalPlanProjectionsDownloadProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanProjectionsDownloadProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>,
          TError,
          Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMedicalPlanProjectionsDownloadProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMedicalPlanProjectionsDownloadProjections<TData = Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError = unknown>(
 params: GetAdminMedicalPlanProjectionsDownloadProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMedicalPlanProjectionsDownloadProjections>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMedicalPlanProjectionsDownloadProjectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replace Projections CSV
 */
export const getPostAdminMedicalPlanProjectionsReplaceProjectionsUrl = () => {


  

  return `/api/web/admin/medical_plan_projections/replace_projections`
}

export const postAdminMedicalPlanProjectionsReplaceProjections = async ( options?: RequestInit): Promise<AdminReplaceProjectionsResponse> => {
  
  return customFetch<AdminReplaceProjectionsResponse>(getPostAdminMedicalPlanProjectionsReplaceProjectionsUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostAdminMedicalPlanProjectionsReplaceProjectionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsReplaceProjections>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsReplaceProjections>>, TError,void, TContext> => {

const mutationKey = ['postAdminMedicalPlanProjectionsReplaceProjections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsReplaceProjections>>, void> = () => {
          

          return  postAdminMedicalPlanProjectionsReplaceProjections(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminMedicalPlanProjectionsReplaceProjectionsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsReplaceProjections>>>
    
    export type PostAdminMedicalPlanProjectionsReplaceProjectionsMutationError = unknown

    export const usePostAdminMedicalPlanProjectionsReplaceProjections = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsReplaceProjections>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsReplaceProjections>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAdminMedicalPlanProjectionsReplaceProjectionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Generate Projected Prices
 */
export const getPostAdminMedicalPlanProjectionsGenerateProjectedPricesUrl = () => {


  

  return `/api/web/admin/medical_plan_projections/generate_projected_prices`
}

export const postAdminMedicalPlanProjectionsGenerateProjectedPrices = async (postAdminMedicalPlanProjectionsGenerateProjectedPrices: PostAdminMedicalPlanProjectionsGenerateProjectedPrices, options?: RequestInit): Promise<AdminGenerateProjectedPricesResponse> => {
  
  return customFetch<AdminGenerateProjectedPricesResponse>(getPostAdminMedicalPlanProjectionsGenerateProjectedPricesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminMedicalPlanProjectionsGenerateProjectedPrices,)
  }
);}




export const getPostAdminMedicalPlanProjectionsGenerateProjectedPricesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsGenerateProjectedPrices>>, TError,{data: PostAdminMedicalPlanProjectionsGenerateProjectedPrices}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsGenerateProjectedPrices>>, TError,{data: PostAdminMedicalPlanProjectionsGenerateProjectedPrices}, TContext> => {

const mutationKey = ['postAdminMedicalPlanProjectionsGenerateProjectedPrices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsGenerateProjectedPrices>>, {data: PostAdminMedicalPlanProjectionsGenerateProjectedPrices}> = (props) => {
          const {data} = props ?? {};

          return  postAdminMedicalPlanProjectionsGenerateProjectedPrices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminMedicalPlanProjectionsGenerateProjectedPricesMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsGenerateProjectedPrices>>>
    export type PostAdminMedicalPlanProjectionsGenerateProjectedPricesMutationBody = PostAdminMedicalPlanProjectionsGenerateProjectedPrices
    export type PostAdminMedicalPlanProjectionsGenerateProjectedPricesMutationError = unknown

    export const usePostAdminMedicalPlanProjectionsGenerateProjectedPrices = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsGenerateProjectedPrices>>, TError,{data: PostAdminMedicalPlanProjectionsGenerateProjectedPrices}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminMedicalPlanProjectionsGenerateProjectedPrices>>,
        TError,
        {data: PostAdminMedicalPlanProjectionsGenerateProjectedPrices},
        TContext
      > => {

      const mutationOptions = getPostAdminMedicalPlanProjectionsGenerateProjectedPricesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get employers with draft ineligible spend reports
 */
export const getGetAdminIneligibleSpendReportsUrl = (params?: GetAdminIneligibleSpendReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/ineligible_spend_reports?${stringifiedParams}` : `/api/web/admin/ineligible_spend_reports`
}

export const getAdminIneligibleSpendReports = async (params?: GetAdminIneligibleSpendReportsParams, options?: RequestInit): Promise<AdminIneligibleSpendEmployersList> => {
  
  return customFetch<AdminIneligibleSpendEmployersList>(getGetAdminIneligibleSpendReportsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminIneligibleSpendReportsQueryKey = (params?: GetAdminIneligibleSpendReportsParams,) => {
    return [
    `/api/web/admin/ineligible_spend_reports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminIneligibleSpendReportsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError = unknown>(params?: GetAdminIneligibleSpendReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminIneligibleSpendReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>> = ({ signal }) => getAdminIneligibleSpendReports(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminIneligibleSpendReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>>
export type GetAdminIneligibleSpendReportsQueryError = unknown


export function useGetAdminIneligibleSpendReports<TData = Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError = unknown>(
 params: undefined |  GetAdminIneligibleSpendReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>,
          TError,
          Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIneligibleSpendReports<TData = Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError = unknown>(
 params?: GetAdminIneligibleSpendReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>,
          TError,
          Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIneligibleSpendReports<TData = Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError = unknown>(
 params?: GetAdminIneligibleSpendReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminIneligibleSpendReports<TData = Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError = unknown>(
 params?: GetAdminIneligibleSpendReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIneligibleSpendReports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminIneligibleSpendReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generate ineligible spend reports for all employers
 */
export const getPostAdminIneligibleSpendReportsGenerateAllUrl = () => {


  

  return `/api/web/admin/ineligible_spend_reports/generate_all`
}

export const postAdminIneligibleSpendReportsGenerateAll = async (postAdminIneligibleSpendReportsGenerateAll: PostAdminIneligibleSpendReportsGenerateAll, options?: RequestInit): Promise<AdminIneligibleSpendGenerationResponse> => {
  
  return customFetch<AdminIneligibleSpendGenerationResponse>(getPostAdminIneligibleSpendReportsGenerateAllUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminIneligibleSpendReportsGenerateAll,)
  }
);}




export const getPostAdminIneligibleSpendReportsGenerateAllMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsGenerateAll>>, TError,{data: PostAdminIneligibleSpendReportsGenerateAll}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsGenerateAll>>, TError,{data: PostAdminIneligibleSpendReportsGenerateAll}, TContext> => {

const mutationKey = ['postAdminIneligibleSpendReportsGenerateAll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsGenerateAll>>, {data: PostAdminIneligibleSpendReportsGenerateAll}> = (props) => {
          const {data} = props ?? {};

          return  postAdminIneligibleSpendReportsGenerateAll(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminIneligibleSpendReportsGenerateAllMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsGenerateAll>>>
    export type PostAdminIneligibleSpendReportsGenerateAllMutationBody = PostAdminIneligibleSpendReportsGenerateAll
    export type PostAdminIneligibleSpendReportsGenerateAllMutationError = unknown

    export const usePostAdminIneligibleSpendReportsGenerateAll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsGenerateAll>>, TError,{data: PostAdminIneligibleSpendReportsGenerateAll}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminIneligibleSpendReportsGenerateAll>>,
        TError,
        {data: PostAdminIneligibleSpendReportsGenerateAll},
        TContext
      > => {

      const mutationOptions = getPostAdminIneligibleSpendReportsGenerateAllMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Generate ineligible spend report for a specific employer
 */
export const getPostAdminIneligibleSpendReportsEmployerIdGenerateUrl = (employerId: string,) => {


  

  return `/api/web/admin/ineligible_spend_reports/${employerId}/generate`
}

export const postAdminIneligibleSpendReportsEmployerIdGenerate = async (employerId: string,
    postAdminIneligibleSpendReportsEmployerIdGenerate: PostAdminIneligibleSpendReportsEmployerIdGenerate, options?: RequestInit): Promise<AdminIneligibleSpendGenerationResponse> => {
  
  return customFetch<AdminIneligibleSpendGenerationResponse>(getPostAdminIneligibleSpendReportsEmployerIdGenerateUrl(employerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminIneligibleSpendReportsEmployerIdGenerate,)
  }
);}




export const getPostAdminIneligibleSpendReportsEmployerIdGenerateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdGenerate>>, TError,{employerId: string;data: PostAdminIneligibleSpendReportsEmployerIdGenerate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdGenerate>>, TError,{employerId: string;data: PostAdminIneligibleSpendReportsEmployerIdGenerate}, TContext> => {

const mutationKey = ['postAdminIneligibleSpendReportsEmployerIdGenerate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdGenerate>>, {employerId: string;data: PostAdminIneligibleSpendReportsEmployerIdGenerate}> = (props) => {
          const {employerId,data} = props ?? {};

          return  postAdminIneligibleSpendReportsEmployerIdGenerate(employerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminIneligibleSpendReportsEmployerIdGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdGenerate>>>
    export type PostAdminIneligibleSpendReportsEmployerIdGenerateMutationBody = PostAdminIneligibleSpendReportsEmployerIdGenerate
    export type PostAdminIneligibleSpendReportsEmployerIdGenerateMutationError = unknown

    export const usePostAdminIneligibleSpendReportsEmployerIdGenerate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdGenerate>>, TError,{employerId: string;data: PostAdminIneligibleSpendReportsEmployerIdGenerate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdGenerate>>,
        TError,
        {employerId: string;data: PostAdminIneligibleSpendReportsEmployerIdGenerate},
        TContext
      > => {

      const mutationOptions = getPostAdminIneligibleSpendReportsEmployerIdGenerateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Publish ineligible spend report for a specific employer
 */
export const getPostAdminIneligibleSpendReportsEmployerIdPublishUrl = (employerId: string,) => {


  

  return `/api/web/admin/ineligible_spend_reports/${employerId}/publish`
}

export const postAdminIneligibleSpendReportsEmployerIdPublish = async (employerId: string, options?: RequestInit): Promise<AdminIneligibleSpendPublishResponse> => {
  
  return customFetch<AdminIneligibleSpendPublishResponse>(getPostAdminIneligibleSpendReportsEmployerIdPublishUrl(employerId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostAdminIneligibleSpendReportsEmployerIdPublishMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdPublish>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdPublish>>, TError,{employerId: string}, TContext> => {

const mutationKey = ['postAdminIneligibleSpendReportsEmployerIdPublish'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdPublish>>, {employerId: string}> = (props) => {
          const {employerId} = props ?? {};

          return  postAdminIneligibleSpendReportsEmployerIdPublish(employerId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminIneligibleSpendReportsEmployerIdPublishMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdPublish>>>
    
    export type PostAdminIneligibleSpendReportsEmployerIdPublishMutationError = unknown

    export const usePostAdminIneligibleSpendReportsEmployerIdPublish = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdPublish>>, TError,{employerId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminIneligibleSpendReportsEmployerIdPublish>>,
        TError,
        {employerId: string},
        TContext
      > => {

      const mutationOptions = getPostAdminIneligibleSpendReportsEmployerIdPublishMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Required Plan Mappings
 */
export const getGetAdminUnmappedPlansUrl = (params?: GetAdminUnmappedPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filters[states][]","filters[carrier_names][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/unmapped_plans?${stringifiedParams}` : `/api/web/admin/unmapped_plans`
}

export const getAdminUnmappedPlans = async (params?: GetAdminUnmappedPlansParams, options?: RequestInit): Promise<AdminPaginatedUnmappedPlans> => {
  
  return customFetch<AdminPaginatedUnmappedPlans>(getGetAdminUnmappedPlansUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminUnmappedPlansQueryKey = (params?: GetAdminUnmappedPlansParams,) => {
    return [
    `/api/web/admin/unmapped_plans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminUnmappedPlansQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError = unknown>(params?: GetAdminUnmappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUnmappedPlansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUnmappedPlans>>> = ({ signal }) => getAdminUnmappedPlans(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUnmappedPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUnmappedPlans>>>
export type GetAdminUnmappedPlansQueryError = unknown


export function useGetAdminUnmappedPlans<TData = Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError = unknown>(
 params: undefined |  GetAdminUnmappedPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUnmappedPlans>>,
          TError,
          Awaited<ReturnType<typeof getAdminUnmappedPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUnmappedPlans<TData = Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError = unknown>(
 params?: GetAdminUnmappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUnmappedPlans>>,
          TError,
          Awaited<ReturnType<typeof getAdminUnmappedPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUnmappedPlans<TData = Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError = unknown>(
 params?: GetAdminUnmappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminUnmappedPlans<TData = Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError = unknown>(
 params?: GetAdminUnmappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUnmappedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUnmappedPlansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get Mapped Plan Mappings
 */
export const getGetAdminMappedPlansUrl = (params?: GetAdminMappedPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filters[states][]","filters[carrier_names][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/mapped_plans?${stringifiedParams}` : `/api/web/admin/mapped_plans`
}

export const getAdminMappedPlans = async (params?: GetAdminMappedPlansParams, options?: RequestInit): Promise<AdminPaginatedMappedPlans> => {
  
  return customFetch<AdminPaginatedMappedPlans>(getGetAdminMappedPlansUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminMappedPlansQueryKey = (params?: GetAdminMappedPlansParams,) => {
    return [
    `/api/web/admin/mapped_plans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminMappedPlansQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMappedPlans>>, TError = unknown>(params?: GetAdminMappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMappedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMappedPlansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMappedPlans>>> = ({ signal }) => getAdminMappedPlans(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMappedPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMappedPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMappedPlans>>>
export type GetAdminMappedPlansQueryError = unknown


export function useGetAdminMappedPlans<TData = Awaited<ReturnType<typeof getAdminMappedPlans>>, TError = unknown>(
 params: undefined |  GetAdminMappedPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMappedPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMappedPlans>>,
          TError,
          Awaited<ReturnType<typeof getAdminMappedPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMappedPlans<TData = Awaited<ReturnType<typeof getAdminMappedPlans>>, TError = unknown>(
 params?: GetAdminMappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMappedPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMappedPlans>>,
          TError,
          Awaited<ReturnType<typeof getAdminMappedPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMappedPlans<TData = Awaited<ReturnType<typeof getAdminMappedPlans>>, TError = unknown>(
 params?: GetAdminMappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMappedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminMappedPlans<TData = Awaited<ReturnType<typeof getAdminMappedPlans>>, TError = unknown>(
 params?: GetAdminMappedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMappedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMappedPlansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create Plan Mappings from CSV
 */
export const getPostAdminPlanMappingsCreateMappingsUrl = () => {


  

  return `/api/web/admin/plan_mappings/create_mappings`
}

export const postAdminPlanMappingsCreateMappings = async ( options?: RequestInit): Promise<AdminCsvUploadResult> => {
  
  return customFetch<AdminCsvUploadResult>(getPostAdminPlanMappingsCreateMappingsUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostAdminPlanMappingsCreateMappingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPlanMappingsCreateMappings>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPlanMappingsCreateMappings>>, TError,void, TContext> => {

const mutationKey = ['postAdminPlanMappingsCreateMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPlanMappingsCreateMappings>>, void> = () => {
          

          return  postAdminPlanMappingsCreateMappings(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPlanMappingsCreateMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPlanMappingsCreateMappings>>>
    
    export type PostAdminPlanMappingsCreateMappingsMutationError = unknown

    export const usePostAdminPlanMappingsCreateMappings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPlanMappingsCreateMappings>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPlanMappingsCreateMappings>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAdminPlanMappingsCreateMappingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Toggle plan mapping activation (deactivate or reactivate)
 */
export const getPostAdminPlanMappingsActionUrl = (action: 'deactivate' | 'reactivate',) => {


  

  return `/api/web/admin/plan_mappings/${action}`
}

export const postAdminPlanMappingsAction = async (action: 'deactivate' | 'reactivate',
    postAdminPlanMappingsAction: PostAdminPlanMappingsAction, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostAdminPlanMappingsActionUrl(action),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAdminPlanMappingsAction,)
  }
);}




export const getPostAdminPlanMappingsActionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPlanMappingsAction>>, TError,{action: 'deactivate' | 'reactivate';data: PostAdminPlanMappingsAction}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPlanMappingsAction>>, TError,{action: 'deactivate' | 'reactivate';data: PostAdminPlanMappingsAction}, TContext> => {

const mutationKey = ['postAdminPlanMappingsAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPlanMappingsAction>>, {action: 'deactivate' | 'reactivate';data: PostAdminPlanMappingsAction}> = (props) => {
          const {action,data} = props ?? {};

          return  postAdminPlanMappingsAction(action,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPlanMappingsActionMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPlanMappingsAction>>>
    export type PostAdminPlanMappingsActionMutationBody = PostAdminPlanMappingsAction
    export type PostAdminPlanMappingsActionMutationError = unknown

    export const usePostAdminPlanMappingsAction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPlanMappingsAction>>, TError,{action: 'deactivate' | 'reactivate';data: PostAdminPlanMappingsAction}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPlanMappingsAction>>,
        TError,
        {action: 'deactivate' | 'reactivate';data: PostAdminPlanMappingsAction},
        TContext
      > => {

      const mutationOptions = getPostAdminPlanMappingsActionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Download CSV Template
 */
export const getGetAdminPlanMappingsDownloadTemplateUrl = (params: GetAdminPlanMappingsDownloadTemplateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/admin/plan_mappings/download_template?${stringifiedParams}` : `/api/web/admin/plan_mappings/download_template`
}

export const getAdminPlanMappingsDownloadTemplate = async (params: GetAdminPlanMappingsDownloadTemplateParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetAdminPlanMappingsDownloadTemplateUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminPlanMappingsDownloadTemplateQueryKey = (params?: GetAdminPlanMappingsDownloadTemplateParams,) => {
    return [
    `/api/web/admin/plan_mappings/download_template`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminPlanMappingsDownloadTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError = unknown>(params: GetAdminPlanMappingsDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPlanMappingsDownloadTemplateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>> = ({ signal }) => getAdminPlanMappingsDownloadTemplate(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPlanMappingsDownloadTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>>
export type GetAdminPlanMappingsDownloadTemplateQueryError = unknown


export function useGetAdminPlanMappingsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError = unknown>(
 params: GetAdminPlanMappingsDownloadTemplateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPlanMappingsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError = unknown>(
 params: GetAdminPlanMappingsDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>,
          TError,
          Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPlanMappingsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError = unknown>(
 params: GetAdminPlanMappingsDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAdminPlanMappingsDownloadTemplate<TData = Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError = unknown>(
 params: GetAdminPlanMappingsDownloadTemplateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPlanMappingsDownloadTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPlanMappingsDownloadTemplateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get paginated audits for a specific model
 */
export const getGetBrokersAuditsUrl = (params: GetBrokersAuditsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/audits?${stringifiedParams}` : `/api/web/brokers/audits`
}

export const getBrokersAudits = async (params: GetBrokersAuditsParams, options?: RequestInit): Promise<BrokersPaginatedAuditList> => {
  
  return customFetch<BrokersPaginatedAuditList>(getGetBrokersAuditsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersAuditsQueryKey = (params?: GetBrokersAuditsParams,) => {
    return [
    `/api/web/brokers/audits`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersAuditsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersAudits>>, TError = unknown>(params: GetBrokersAuditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersAudits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersAuditsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersAudits>>> = ({ signal }) => getBrokersAudits(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersAudits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersAuditsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersAudits>>>
export type GetBrokersAuditsQueryError = unknown


export function useGetBrokersAudits<TData = Awaited<ReturnType<typeof getBrokersAudits>>, TError = unknown>(
 params: GetBrokersAuditsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersAudits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersAudits>>,
          TError,
          Awaited<ReturnType<typeof getBrokersAudits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersAudits<TData = Awaited<ReturnType<typeof getBrokersAudits>>, TError = unknown>(
 params: GetBrokersAuditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersAudits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersAudits>>,
          TError,
          Awaited<ReturnType<typeof getBrokersAudits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersAudits<TData = Awaited<ReturnType<typeof getBrokersAudits>>, TError = unknown>(
 params: GetBrokersAuditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersAudits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersAudits<TData = Awaited<ReturnType<typeof getBrokersAudits>>, TError = unknown>(
 params: GetBrokersAuditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersAudits>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersAuditsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List employers
 */
export const getGetBrokersEmployersUrl = (params?: GetBrokersEmployersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[review_statuses][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/employers?${stringifiedParams}` : `/api/web/brokers/employers`
}

export const getBrokersEmployers = async (params?: GetBrokersEmployersParams, options?: RequestInit): Promise<BrokersPaginatedEmployerList> => {
  
  return customFetch<BrokersPaginatedEmployerList>(getGetBrokersEmployersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersEmployersQueryKey = (params?: GetBrokersEmployersParams,) => {
    return [
    `/api/web/brokers/employers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersEmployersQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersEmployers>>, TError = unknown>(params?: GetBrokersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersEmployersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersEmployers>>> = ({ signal }) => getBrokersEmployers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersEmployers>>>
export type GetBrokersEmployersQueryError = unknown


export function useGetBrokersEmployers<TData = Awaited<ReturnType<typeof getBrokersEmployers>>, TError = unknown>(
 params: undefined |  GetBrokersEmployersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployers<TData = Awaited<ReturnType<typeof getBrokersEmployers>>, TError = unknown>(
 params?: GetBrokersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployers<TData = Awaited<ReturnType<typeof getBrokersEmployers>>, TError = unknown>(
 params?: GetBrokersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersEmployers<TData = Awaited<ReturnType<typeof getBrokersEmployers>>, TError = unknown>(
 params?: GetBrokersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List employees
 */
export const getGetBrokersEmployersEmployerIdEmployeesUrl = (employerId: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/employers/${employerId}/employees?${stringifiedParams}` : `/api/web/brokers/employers/${employerId}/employees`
}

export const getBrokersEmployersEmployerIdEmployees = async (employerId: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams, options?: RequestInit): Promise<BrokersPaginatedEmployeeList> => {
  
  return customFetch<BrokersPaginatedEmployeeList>(getGetBrokersEmployersEmployerIdEmployeesUrl(employerId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersEmployersEmployerIdEmployeesQueryKey = (employerId?: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams,) => {
    return [
    `/api/web/brokers/employers/${employerId}/employees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersEmployersEmployerIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError = unknown>(employerId: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersEmployersEmployerIdEmployeesQueryKey(employerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>> = ({ signal }) => getBrokersEmployersEmployerIdEmployees(employerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersEmployersEmployerIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>>
export type GetBrokersEmployersEmployerIdEmployeesQueryError = unknown


export function useGetBrokersEmployersEmployerIdEmployees<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError = unknown>(
 employerId: string,
    params: undefined |  GetBrokersEmployersEmployerIdEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdEmployees<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError = unknown>(
 employerId: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdEmployees<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError = unknown>(
 employerId: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersEmployersEmployerIdEmployees<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError = unknown>(
 employerId: string,
    params?: GetBrokersEmployersEmployerIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersEmployersEmployerIdEmployeesQueryOptions(employerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Invite employees
 */
export const getPostBrokersEmployersEmployerIdEmployeesInviteUrl = (employerId: string,) => {


  

  return `/api/web/brokers/employers/${employerId}/employees/invite`
}

export const postBrokersEmployersEmployerIdEmployeesInvite = async (employerId: string,
    postBrokersEmployersEmployerIdEmployeesInvite: PostBrokersEmployersEmployerIdEmployeesInvite, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostBrokersEmployersEmployerIdEmployeesInviteUrl(employerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersEmployersEmployerIdEmployeesInvite,)
  }
);}




export const getPostBrokersEmployersEmployerIdEmployeesInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersEmployersEmployerIdEmployeesInvite>>, TError,{employerId: string;data: PostBrokersEmployersEmployerIdEmployeesInvite}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersEmployersEmployerIdEmployeesInvite>>, TError,{employerId: string;data: PostBrokersEmployersEmployerIdEmployeesInvite}, TContext> => {

const mutationKey = ['postBrokersEmployersEmployerIdEmployeesInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersEmployersEmployerIdEmployeesInvite>>, {employerId: string;data: PostBrokersEmployersEmployerIdEmployeesInvite}> = (props) => {
          const {employerId,data} = props ?? {};

          return  postBrokersEmployersEmployerIdEmployeesInvite(employerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersEmployersEmployerIdEmployeesInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersEmployersEmployerIdEmployeesInvite>>>
    export type PostBrokersEmployersEmployerIdEmployeesInviteMutationBody = PostBrokersEmployersEmployerIdEmployeesInvite
    export type PostBrokersEmployersEmployerIdEmployeesInviteMutationError = unknown

    export const usePostBrokersEmployersEmployerIdEmployeesInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersEmployersEmployerIdEmployeesInvite>>, TError,{employerId: string;data: PostBrokersEmployersEmployerIdEmployeesInvite}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersEmployersEmployerIdEmployeesInvite>>,
        TError,
        {employerId: string;data: PostBrokersEmployersEmployerIdEmployeesInvite},
        TContext
      > => {

      const mutationOptions = getPostBrokersEmployersEmployerIdEmployeesInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get employee invite options
 */
export const getGetBrokersEmployersEmployerIdEmployeesInviteOptionsUrl = (employerId: string,) => {


  

  return `/api/web/brokers/employers/${employerId}/employees/invite_options`
}

export const getBrokersEmployersEmployerIdEmployeesInviteOptions = async (employerId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetBrokersEmployersEmployerIdEmployeesInviteOptionsUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersEmployersEmployerIdEmployeesInviteOptionsQueryKey = (employerId?: string,) => {
    return [
    `/api/web/brokers/employers/${employerId}/employees/invite_options`
    ] as const;
    }

    
export const getGetBrokersEmployersEmployerIdEmployeesInviteOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersEmployersEmployerIdEmployeesInviteOptionsQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>> = ({ signal }) => getBrokersEmployersEmployerIdEmployeesInviteOptions(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersEmployersEmployerIdEmployeesInviteOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>>
export type GetBrokersEmployersEmployerIdEmployeesInviteOptionsQueryError = unknown


export function useGetBrokersEmployersEmployerIdEmployeesInviteOptions<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdEmployeesInviteOptions<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdEmployeesInviteOptions<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersEmployersEmployerIdEmployeesInviteOptions<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdEmployeesInviteOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersEmployersEmployerIdEmployeesInviteOptionsQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get formatted allowances
 */
export const getGetBrokersEmployersEmployerIdAllowancesUrl = (employerId: string,) => {


  

  return `/api/web/brokers/employers/${employerId}/allowances`
}

export const getBrokersEmployersEmployerIdAllowances = async (employerId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetBrokersEmployersEmployerIdAllowancesUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersEmployersEmployerIdAllowancesQueryKey = (employerId?: string,) => {
    return [
    `/api/web/brokers/employers/${employerId}/allowances`
    ] as const;
    }

    
export const getGetBrokersEmployersEmployerIdAllowancesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersEmployersEmployerIdAllowancesQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>> = ({ signal }) => getBrokersEmployersEmployerIdAllowances(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersEmployersEmployerIdAllowancesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>>
export type GetBrokersEmployersEmployerIdAllowancesQueryError = unknown


export function useGetBrokersEmployersEmployerIdAllowances<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdAllowances<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdAllowances<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersEmployersEmployerIdAllowances<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdAllowances>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersEmployersEmployerIdAllowancesQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List employer ichra configs
 */
export const getGetBrokersEmployersEmployerIdIchraConfigsUrl = (employerId: string,) => {


  

  return `/api/web/brokers/employers/${employerId}/ichra_configs`
}

export const getBrokersEmployersEmployerIdIchraConfigs = async (employerId: string, options?: RequestInit): Promise<BrokersEmployerICHRAConfig> => {
  
  return customFetch<BrokersEmployerICHRAConfig>(getGetBrokersEmployersEmployerIdIchraConfigsUrl(employerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersEmployersEmployerIdIchraConfigsQueryKey = (employerId?: string,) => {
    return [
    `/api/web/brokers/employers/${employerId}/ichra_configs`
    ] as const;
    }

    
export const getGetBrokersEmployersEmployerIdIchraConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError = unknown>(employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersEmployersEmployerIdIchraConfigsQueryKey(employerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>> = ({ signal }) => getBrokersEmployersEmployerIdIchraConfigs(employerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(employerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersEmployersEmployerIdIchraConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>>
export type GetBrokersEmployersEmployerIdIchraConfigsQueryError = unknown


export function useGetBrokersEmployersEmployerIdIchraConfigs<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError = unknown>(
 employerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdIchraConfigs<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersEmployersEmployerIdIchraConfigs<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersEmployersEmployerIdIchraConfigs<TData = Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError = unknown>(
 employerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersEmployersEmployerIdIchraConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersEmployersEmployerIdIchraConfigsQueryOptions(employerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List members
 */
export const getGetBrokersMembersUrl = (params?: GetBrokersMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members?${stringifiedParams}` : `/api/web/brokers/members`
}

export const getBrokersMembers = async (params?: GetBrokersMembersParams, options?: RequestInit): Promise<BrokersPaginatedMemberList> => {
  
  return customFetch<BrokersPaginatedMemberList>(getGetBrokersMembersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersQueryKey = (params?: GetBrokersMembersParams,) => {
    return [
    `/api/web/brokers/members`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembers>>, TError = unknown>(params?: GetBrokersMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembers>>> = ({ signal }) => getBrokersMembers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembers>>>
export type GetBrokersMembersQueryError = unknown


export function useGetBrokersMembers<TData = Awaited<ReturnType<typeof getBrokersMembers>>, TError = unknown>(
 params: undefined |  GetBrokersMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembers<TData = Awaited<ReturnType<typeof getBrokersMembers>>, TError = unknown>(
 params?: GetBrokersMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembers<TData = Awaited<ReturnType<typeof getBrokersMembers>>, TError = unknown>(
 params?: GetBrokersMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembers<TData = Awaited<ReturnType<typeof getBrokersMembers>>, TError = unknown>(
 params?: GetBrokersMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a member
 */
export const getGetBrokersMembersMemberIdUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}`
}

export const getBrokersMembersMemberId = async (memberId: string, options?: RequestInit): Promise<BrokersBrokerMemberDenormalized> => {
  
  return customFetch<BrokersBrokerMemberDenormalized>(getGetBrokersMembersMemberIdUrl(memberId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdQueryKey = (memberId?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError = unknown>(memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdQueryKey(memberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberId>>> = ({ signal }) => getBrokersMembersMemberId(memberId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberId>>>
export type GetBrokersMembersMemberIdQueryError = unknown


export function useGetBrokersMembersMemberId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError = unknown>(
 memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdQueryOptions(memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get ICHRA data for a member
 */
export const getGetBrokersMembersMemberIdIchraDataUrl = (memberId: string,
    params?: GetBrokersMembersMemberIdIchraDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/ichra_data?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/ichra_data`
}

export const getBrokersMembersMemberIdIchraData = async (memberId: string,
    params?: GetBrokersMembersMemberIdIchraDataParams, options?: RequestInit): Promise<BrokersICHRAData> => {
  
  return customFetch<BrokersICHRAData>(getGetBrokersMembersMemberIdIchraDataUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdIchraDataQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdIchraDataParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/ichra_data`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdIchraDataQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError = unknown>(memberId: string,
    params?: GetBrokersMembersMemberIdIchraDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdIchraDataQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>> = ({ signal }) => getBrokersMembersMemberIdIchraData(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdIchraDataQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>>
export type GetBrokersMembersMemberIdIchraDataQueryError = unknown


export function useGetBrokersMembersMemberIdIchraData<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError = unknown>(
 memberId: string,
    params: undefined |  GetBrokersMembersMemberIdIchraDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdIchraData<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdIchraDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdIchraData<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdIchraDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdIchraData<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdIchraDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdIchraData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdIchraDataQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Upload files for a member
 */
export const getPostBrokersMembersMemberIdUploadFilesUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/upload_files`
}

export const postBrokersMembersMemberIdUploadFiles = async (memberId: string, options?: RequestInit): Promise<BrokersBrokerMemberDenormalized> => {
  
  return customFetch<BrokersBrokerMemberDenormalized>(getPostBrokersMembersMemberIdUploadFilesUrl(memberId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersMembersMemberIdUploadFilesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdUploadFiles>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdUploadFiles>>, TError,{memberId: string}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdUploadFiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdUploadFiles>>, {memberId: string}> = (props) => {
          const {memberId} = props ?? {};

          return  postBrokersMembersMemberIdUploadFiles(memberId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdUploadFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdUploadFiles>>>
    
    export type PostBrokersMembersMemberIdUploadFilesMutationError = unknown

    export const usePostBrokersMembersMemberIdUploadFiles = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdUploadFiles>>, TError,{memberId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdUploadFiles>>,
        TError,
        {memberId: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdUploadFilesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a file upload for a member
 */
export const getDeleteBrokersMembersMemberIdFileUploadsBlobIdUrl = (memberId: string,
    blobId: string,
    params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/file_uploads/${blobId}?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/file_uploads/${blobId}`
}

export const deleteBrokersMembersMemberIdFileUploadsBlobId = async (memberId: string,
    blobId: string,
    params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams, options?: RequestInit): Promise<BrokersBrokerMemberDenormalized> => {
  
  return customFetch<BrokersBrokerMemberDenormalized>(getDeleteBrokersMembersMemberIdFileUploadsBlobIdUrl(memberId,blobId,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteBrokersMembersMemberIdFileUploadsBlobIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdFileUploadsBlobId>>, TError,{memberId: string;blobId: string;params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdFileUploadsBlobId>>, TError,{memberId: string;blobId: string;params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams}, TContext> => {

const mutationKey = ['deleteBrokersMembersMemberIdFileUploadsBlobId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdFileUploadsBlobId>>, {memberId: string;blobId: string;params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams}> = (props) => {
          const {memberId,blobId,params} = props ?? {};

          return  deleteBrokersMembersMemberIdFileUploadsBlobId(memberId,blobId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrokersMembersMemberIdFileUploadsBlobIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdFileUploadsBlobId>>>
    
    export type DeleteBrokersMembersMemberIdFileUploadsBlobIdMutationError = unknown

    export const useDeleteBrokersMembersMemberIdFileUploadsBlobId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdFileUploadsBlobId>>, TError,{memberId: string;blobId: string;params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrokersMembersMemberIdFileUploadsBlobId>>,
        TError,
        {memberId: string;blobId: string;params: DeleteBrokersMembersMemberIdFileUploadsBlobIdParams},
        TContext
      > => {

      const mutationOptions = getDeleteBrokersMembersMemberIdFileUploadsBlobIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List charges and transactions
 */
export const getGetBrokersMembersMemberIdTransactionsUrl = (memberId: string,
    params?: GetBrokersMembersMemberIdTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/transactions?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/transactions`
}

export const getBrokersMembersMemberIdTransactions = async (memberId: string,
    params?: GetBrokersMembersMemberIdTransactionsParams, options?: RequestInit): Promise<PaginatedChargeOrTxnList> => {
  
  return customFetch<PaginatedChargeOrTxnList>(getGetBrokersMembersMemberIdTransactionsUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdTransactionsQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdTransactionsParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError = unknown>(memberId: string,
    params?: GetBrokersMembersMemberIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdTransactionsQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>> = ({ signal }) => getBrokersMembersMemberIdTransactions(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>>
export type GetBrokersMembersMemberIdTransactionsQueryError = unknown


export function useGetBrokersMembersMemberIdTransactions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError = unknown>(
 memberId: string,
    params: undefined |  GetBrokersMembersMemberIdTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdTransactions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdTransactions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdTransactions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdTransactionsQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update transaction
 */
export const getPatchBrokersMembersMemberIdTransactionsIdUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/transactions/${id}`
}

export const patchBrokersMembersMemberIdTransactionsId = async (memberId: string,
    id: string,
    patchBrokersMembersMemberIdTransactionsId: PatchBrokersMembersMemberIdTransactionsId, options?: RequestInit): Promise<ChargeOrTxn> => {
  
  return customFetch<ChargeOrTxn>(getPatchBrokersMembersMemberIdTransactionsIdUrl(memberId,id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersMembersMemberIdTransactionsId,)
  }
);}




export const getPatchBrokersMembersMemberIdTransactionsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersMembersMemberIdTransactionsId>>, TError,{memberId: string;id: string;data: PatchBrokersMembersMemberIdTransactionsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersMembersMemberIdTransactionsId>>, TError,{memberId: string;id: string;data: PatchBrokersMembersMemberIdTransactionsId}, TContext> => {

const mutationKey = ['patchBrokersMembersMemberIdTransactionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersMembersMemberIdTransactionsId>>, {memberId: string;id: string;data: PatchBrokersMembersMemberIdTransactionsId}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  patchBrokersMembersMemberIdTransactionsId(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersMembersMemberIdTransactionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersMembersMemberIdTransactionsId>>>
    export type PatchBrokersMembersMemberIdTransactionsIdMutationBody = PatchBrokersMembersMemberIdTransactionsId
    export type PatchBrokersMembersMemberIdTransactionsIdMutationError = unknown

    export const usePatchBrokersMembersMemberIdTransactionsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersMembersMemberIdTransactionsId>>, TError,{memberId: string;id: string;data: PatchBrokersMembersMemberIdTransactionsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersMembersMemberIdTransactionsId>>,
        TError,
        {memberId: string;id: string;data: PatchBrokersMembersMemberIdTransactionsId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersMembersMemberIdTransactionsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Mark transaction as loss
 */
export const getPostBrokersMembersMemberIdTransactionsIdMarkLossUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/transactions/${id}/mark_loss`
}

export const postBrokersMembersMemberIdTransactionsIdMarkLoss = async (memberId: string,
    id: string,
    postBrokersMembersMemberIdTransactionsIdMarkLoss: PostBrokersMembersMemberIdTransactionsIdMarkLoss, options?: RequestInit): Promise<ChargeOrTxn> => {
  
  return customFetch<ChargeOrTxn>(getPostBrokersMembersMemberIdTransactionsIdMarkLossUrl(memberId,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdTransactionsIdMarkLoss,)
  }
);}




export const getPostBrokersMembersMemberIdTransactionsIdMarkLossMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdTransactionsIdMarkLoss>>, TError,{memberId: string;id: string;data: PostBrokersMembersMemberIdTransactionsIdMarkLoss}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdTransactionsIdMarkLoss>>, TError,{memberId: string;id: string;data: PostBrokersMembersMemberIdTransactionsIdMarkLoss}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdTransactionsIdMarkLoss'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdTransactionsIdMarkLoss>>, {memberId: string;id: string;data: PostBrokersMembersMemberIdTransactionsIdMarkLoss}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  postBrokersMembersMemberIdTransactionsIdMarkLoss(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdTransactionsIdMarkLossMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdTransactionsIdMarkLoss>>>
    export type PostBrokersMembersMemberIdTransactionsIdMarkLossMutationBody = PostBrokersMembersMemberIdTransactionsIdMarkLoss
    export type PostBrokersMembersMemberIdTransactionsIdMarkLossMutationError = unknown

    export const usePostBrokersMembersMemberIdTransactionsIdMarkLoss = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdTransactionsIdMarkLoss>>, TError,{memberId: string;id: string;data: PostBrokersMembersMemberIdTransactionsIdMarkLoss}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdTransactionsIdMarkLoss>>,
        TError,
        {memberId: string;id: string;data: PostBrokersMembersMemberIdTransactionsIdMarkLoss},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdTransactionsIdMarkLossMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List enrollments
 */
export const getGetBrokersMembersMemberIdEnrollmentsUrl = (memberId: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/enrollments?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/enrollments`
}

export const getBrokersMembersMemberIdEnrollments = async (memberId: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams, options?: RequestInit): Promise<PaginatedEnrollmentList> => {
  
  return customFetch<PaginatedEnrollmentList>(getGetBrokersMembersMemberIdEnrollmentsUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdEnrollmentsQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/enrollments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError = unknown>(memberId: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdEnrollmentsQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>> = ({ signal }) => getBrokersMembersMemberIdEnrollments(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>>
export type GetBrokersMembersMemberIdEnrollmentsQueryError = unknown


export function useGetBrokersMembersMemberIdEnrollments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError = unknown>(
 memberId: string,
    params: undefined |  GetBrokersMembersMemberIdEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdEnrollments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdEnrollmentsQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create member enrollment
 */
export const getPostBrokersMembersMemberIdEnrollmentsUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments`
}

export const postBrokersMembersMemberIdEnrollments = async (memberId: string,
    postBrokersMembersMemberIdEnrollments: PostBrokersMembersMemberIdEnrollments, options?: RequestInit): Promise<BrokersEnrollment> => {
  
  return customFetch<BrokersEnrollment>(getPostBrokersMembersMemberIdEnrollmentsUrl(memberId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdEnrollments,)
  }
);}




export const getPostBrokersMembersMemberIdEnrollmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollments>>, TError,{memberId: string;data: PostBrokersMembersMemberIdEnrollments}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollments>>, TError,{memberId: string;data: PostBrokersMembersMemberIdEnrollments}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdEnrollments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollments>>, {memberId: string;data: PostBrokersMembersMemberIdEnrollments}> = (props) => {
          const {memberId,data} = props ?? {};

          return  postBrokersMembersMemberIdEnrollments(memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdEnrollmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollments>>>
    export type PostBrokersMembersMemberIdEnrollmentsMutationBody = PostBrokersMembersMemberIdEnrollments
    export type PostBrokersMembersMemberIdEnrollmentsMutationError = unknown

    export const usePostBrokersMembersMemberIdEnrollments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollments>>, TError,{memberId: string;data: PostBrokersMembersMemberIdEnrollments}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollments>>,
        TError,
        {memberId: string;data: PostBrokersMembersMemberIdEnrollments},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdEnrollmentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List enrollments with coverages or payments
 */
export const getGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/has_coverages_or_payments`
}

export const getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments = async (memberId: string, options?: RequestInit): Promise<BrokersEnrollmentWithPaymentsOrCoverages[]> => {
  
  return customFetch<BrokersEnrollmentWithPaymentsOrCoverages[]>(getGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsUrl(memberId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsQueryKey = (memberId?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}/enrollments/has_coverages_or_payments`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError = unknown>(memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsQueryKey(memberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>> = ({ signal }) => getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments(memberId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>>
export type GetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsQueryError = unknown


export function useGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError = unknown>(
 memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsHasCoveragesOrPayments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdEnrollmentsHasCoveragesOrPaymentsQueryOptions(memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List mapping option enrollments
 */
export const getGetBrokersMembersMemberIdEnrollmentsMappingOptionsUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/mapping_options`
}

export const getBrokersMembersMemberIdEnrollmentsMappingOptions = async (memberId: string, options?: RequestInit): Promise<BrokersEnrollmentMappingOption[]> => {
  
  return customFetch<BrokersEnrollmentMappingOption[]>(getGetBrokersMembersMemberIdEnrollmentsMappingOptionsUrl(memberId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdEnrollmentsMappingOptionsQueryKey = (memberId?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}/enrollments/mapping_options`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdEnrollmentsMappingOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError = unknown>(memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdEnrollmentsMappingOptionsQueryKey(memberId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>> = ({ signal }) => getBrokersMembersMemberIdEnrollmentsMappingOptions(memberId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdEnrollmentsMappingOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>>
export type GetBrokersMembersMemberIdEnrollmentsMappingOptionsQueryError = unknown


export function useGetBrokersMembersMemberIdEnrollmentsMappingOptions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError = unknown>(
 memberId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsMappingOptions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsMappingOptions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdEnrollmentsMappingOptions<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError = unknown>(
 memberId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsMappingOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdEnrollmentsMappingOptionsQueryOptions(memberId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get monthly cost of coverage for a member
 */
export const getGetBrokersMembersMemberIdEnrollmentsCostOfCoverageUrl = (memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/enrollments/cost_of_coverage?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/enrollments/cost_of_coverage`
}

export const getBrokersMembersMemberIdEnrollmentsCostOfCoverage = async (memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams, options?: RequestInit): Promise<BrokersMonthlyCostOfCoverage> => {
  
  return customFetch<BrokersMonthlyCostOfCoverage>(getGetBrokersMembersMemberIdEnrollmentsCostOfCoverageUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdEnrollmentsCostOfCoverageQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/enrollments/cost_of_coverage`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdEnrollmentsCostOfCoverageQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError = unknown>(memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdEnrollmentsCostOfCoverageQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>> = ({ signal }) => getBrokersMembersMemberIdEnrollmentsCostOfCoverage(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdEnrollmentsCostOfCoverageQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>>
export type GetBrokersMembersMemberIdEnrollmentsCostOfCoverageQueryError = unknown


export function useGetBrokersMembersMemberIdEnrollmentsCostOfCoverage<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsCostOfCoverage<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsCostOfCoverage<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdEnrollmentsCostOfCoverage<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdEnrollmentsCostOfCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsCostOfCoverage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdEnrollmentsCostOfCoverageQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update one or more enrollment fields.
 */
export const getPutBrokersMembersMemberIdEnrollmentsIdUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/${id}`
}

export const putBrokersMembersMemberIdEnrollmentsId = async (memberId: string,
    id: string,
    putBrokersMembersMemberIdEnrollmentsId: PutBrokersMembersMemberIdEnrollmentsId, options?: RequestInit): Promise<BrokersEnrollmentEnriched> => {
  
  return customFetch<BrokersEnrollmentEnriched>(getPutBrokersMembersMemberIdEnrollmentsIdUrl(memberId,id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putBrokersMembersMemberIdEnrollmentsId,)
  }
);}




export const getPutBrokersMembersMemberIdEnrollmentsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsId>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsId>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsId}, TContext> => {

const mutationKey = ['putBrokersMembersMemberIdEnrollmentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsId>>, {memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsId}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  putBrokersMembersMemberIdEnrollmentsId(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBrokersMembersMemberIdEnrollmentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsId>>>
    export type PutBrokersMembersMemberIdEnrollmentsIdMutationBody = PutBrokersMembersMemberIdEnrollmentsId
    export type PutBrokersMembersMemberIdEnrollmentsIdMutationError = unknown

    export const usePutBrokersMembersMemberIdEnrollmentsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsId>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsId>>,
        TError,
        {memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsId},
        TContext
      > => {

      const mutationOptions = getPutBrokersMembersMemberIdEnrollmentsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get coverages for a single enrollment
 */
export const getGetBrokersMembersMemberIdEnrollmentsIdCoveragesUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/${id}/coverages`
}

export const getBrokersMembersMemberIdEnrollmentsIdCoverages = async (memberId: string,
    id: string, options?: RequestInit): Promise<BrokersCoverage> => {
  
  return customFetch<BrokersCoverage>(getGetBrokersMembersMemberIdEnrollmentsIdCoveragesUrl(memberId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdEnrollmentsIdCoveragesQueryKey = (memberId?: string,
    id?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}/enrollments/${id}/coverages`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdEnrollmentsIdCoveragesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError = unknown>(memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdEnrollmentsIdCoveragesQueryKey(memberId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>> = ({ signal }) => getBrokersMembersMemberIdEnrollmentsIdCoverages(memberId,id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdEnrollmentsIdCoveragesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>>
export type GetBrokersMembersMemberIdEnrollmentsIdCoveragesQueryError = unknown


export function useGetBrokersMembersMemberIdEnrollmentsIdCoverages<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError = unknown>(
 memberId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsIdCoverages<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError = unknown>(
 memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsIdCoverages<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError = unknown>(
 memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdEnrollmentsIdCoverages<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError = unknown>(
 memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdEnrollmentsIdCoveragesQueryOptions(memberId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update coverages for an enrollment
 */
export const getPutBrokersMembersMemberIdEnrollmentsIdCoveragesUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/${id}/coverages`
}

export const putBrokersMembersMemberIdEnrollmentsIdCoverages = async (memberId: string,
    id: string,
    putBrokersMembersMemberIdEnrollmentsIdCoverages: PutBrokersMembersMemberIdEnrollmentsIdCoverages, options?: RequestInit): Promise<BrokersCoverage> => {
  
  return customFetch<BrokersCoverage>(getPutBrokersMembersMemberIdEnrollmentsIdCoveragesUrl(memberId,id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putBrokersMembersMemberIdEnrollmentsIdCoverages,)
  }
);}




export const getPutBrokersMembersMemberIdEnrollmentsIdCoveragesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdCoverages}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdCoverages}, TContext> => {

const mutationKey = ['putBrokersMembersMemberIdEnrollmentsIdCoverages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdCoverages>>, {memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdCoverages}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  putBrokersMembersMemberIdEnrollmentsIdCoverages(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBrokersMembersMemberIdEnrollmentsIdCoveragesMutationResult = NonNullable<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdCoverages>>>
    export type PutBrokersMembersMemberIdEnrollmentsIdCoveragesMutationBody = PutBrokersMembersMemberIdEnrollmentsIdCoverages
    export type PutBrokersMembersMemberIdEnrollmentsIdCoveragesMutationError = unknown

    export const usePutBrokersMembersMemberIdEnrollmentsIdCoverages = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdCoverages>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdCoverages}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdCoverages>>,
        TError,
        {memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdCoverages},
        TContext
      > => {

      const mutationOptions = getPutBrokersMembersMemberIdEnrollmentsIdCoveragesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates coverages for an enrollment
 */
export const getPostBrokersMembersMemberIdEnrollmentsIdCoverageUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/${id}/coverage`
}

export const postBrokersMembersMemberIdEnrollmentsIdCoverage = async (memberId: string,
    id: string,
    postBrokersMembersMemberIdEnrollmentsIdCoverage: PostBrokersMembersMemberIdEnrollmentsIdCoverage, options?: RequestInit): Promise<BrokersCoverage> => {
  
  return customFetch<BrokersCoverage>(getPostBrokersMembersMemberIdEnrollmentsIdCoverageUrl(memberId,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdEnrollmentsIdCoverage,)
  }
);}




export const getPostBrokersMembersMemberIdEnrollmentsIdCoverageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollmentsIdCoverage>>, TError,{memberId: string;id: string;data: PostBrokersMembersMemberIdEnrollmentsIdCoverage}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollmentsIdCoverage>>, TError,{memberId: string;id: string;data: PostBrokersMembersMemberIdEnrollmentsIdCoverage}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdEnrollmentsIdCoverage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollmentsIdCoverage>>, {memberId: string;id: string;data: PostBrokersMembersMemberIdEnrollmentsIdCoverage}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  postBrokersMembersMemberIdEnrollmentsIdCoverage(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdEnrollmentsIdCoverageMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollmentsIdCoverage>>>
    export type PostBrokersMembersMemberIdEnrollmentsIdCoverageMutationBody = PostBrokersMembersMemberIdEnrollmentsIdCoverage
    export type PostBrokersMembersMemberIdEnrollmentsIdCoverageMutationError = unknown

    export const usePostBrokersMembersMemberIdEnrollmentsIdCoverage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollmentsIdCoverage>>, TError,{memberId: string;id: string;data: PostBrokersMembersMemberIdEnrollmentsIdCoverage}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdEnrollmentsIdCoverage>>,
        TError,
        {memberId: string;id: string;data: PostBrokersMembersMemberIdEnrollmentsIdCoverage},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdEnrollmentsIdCoverageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes coverage from an enrollment
 */
export const getDeleteBrokersMembersMemberIdEnrollmentsIdCoverageUrl = (memberId: string,
    id: string,
    params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/enrollments/${id}/coverage?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/enrollments/${id}/coverage`
}

export const deleteBrokersMembersMemberIdEnrollmentsIdCoverage = async (memberId: string,
    id: string,
    params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams, options?: RequestInit): Promise<BrokersCoverage> => {
  
  return customFetch<BrokersCoverage>(getDeleteBrokersMembersMemberIdEnrollmentsIdCoverageUrl(memberId,id,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteBrokersMembersMemberIdEnrollmentsIdCoverageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdEnrollmentsIdCoverage>>, TError,{memberId: string;id: string;params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdEnrollmentsIdCoverage>>, TError,{memberId: string;id: string;params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams}, TContext> => {

const mutationKey = ['deleteBrokersMembersMemberIdEnrollmentsIdCoverage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdEnrollmentsIdCoverage>>, {memberId: string;id: string;params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams}> = (props) => {
          const {memberId,id,params} = props ?? {};

          return  deleteBrokersMembersMemberIdEnrollmentsIdCoverage(memberId,id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrokersMembersMemberIdEnrollmentsIdCoverageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdEnrollmentsIdCoverage>>>
    
    export type DeleteBrokersMembersMemberIdEnrollmentsIdCoverageMutationError = unknown

    export const useDeleteBrokersMembersMemberIdEnrollmentsIdCoverage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersMembersMemberIdEnrollmentsIdCoverage>>, TError,{memberId: string;id: string;params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrokersMembersMemberIdEnrollmentsIdCoverage>>,
        TError,
        {memberId: string;id: string;params: DeleteBrokersMembersMemberIdEnrollmentsIdCoverageParams},
        TContext
      > => {

      const mutationOptions = getDeleteBrokersMembersMemberIdEnrollmentsIdCoverageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a single enrollments insurance premiums
 */
export const getGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/${id}/insurance_premiums`
}

export const getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums = async (memberId: string,
    id: string, options?: RequestInit): Promise<BrokersPremium> => {
  
  return customFetch<BrokersPremium>(getGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsUrl(memberId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsQueryKey = (memberId?: string,
    id?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}/enrollments/${id}/insurance_premiums`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError = unknown>(memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsQueryKey(memberId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>> = ({ signal }) => getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums(memberId,id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>>
export type GetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsQueryError = unknown


export function useGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiums<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError = unknown>(
 memberId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiums<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError = unknown>(
 memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiums<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError = unknown>(
 memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiums<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError = unknown>(
 memberId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsQueryOptions(memberId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update an enrollment's insurance premiums
 */
export const getPutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/enrollments/${id}/insurance_premiums`
}

export const putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums = async (memberId: string,
    id: string,
    putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums, options?: RequestInit): Promise<BrokersPremium> => {
  
  return customFetch<BrokersPremium>(getPutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsUrl(memberId,id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums,)
  }
);}




export const getPutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums}, TContext> => {

const mutationKey = ['putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, {memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsMutationResult = NonNullable<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>>
    export type PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsMutationBody = PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums
    export type PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsMutationError = unknown

    export const usePutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>, TError,{memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBrokersMembersMemberIdEnrollmentsIdInsurancePremiums>>,
        TError,
        {memberId: string;id: string;data: PutBrokersMembersMemberIdEnrollmentsIdInsurancePremiums},
        TContext
      > => {

      const mutationOptions = getPutBrokersMembersMemberIdEnrollmentsIdInsurancePremiumsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List covered participants for plan year
 */
export const getGetBrokersMembersMemberIdCoveredParticipantsUrl = (memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/covered_participants?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/covered_participants`
}

export const getBrokersMembersMemberIdCoveredParticipants = async (memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams, options?: RequestInit): Promise<BrokersCoveredParticipant[]> => {
  
  return customFetch<BrokersCoveredParticipant[]>(getGetBrokersMembersMemberIdCoveredParticipantsUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdCoveredParticipantsQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdCoveredParticipantsParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/covered_participants`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdCoveredParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError = unknown>(memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdCoveredParticipantsQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>> = ({ signal }) => getBrokersMembersMemberIdCoveredParticipants(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdCoveredParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>>
export type GetBrokersMembersMemberIdCoveredParticipantsQueryError = unknown


export function useGetBrokersMembersMemberIdCoveredParticipants<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdCoveredParticipants<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdCoveredParticipants<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdCoveredParticipants<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError = unknown>(
 memberId: string,
    params: GetBrokersMembersMemberIdCoveredParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdCoveredParticipants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdCoveredParticipantsQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new covered participant
 */
export const getPostBrokersMembersMemberIdCoveredParticipantsUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/covered_participants`
}

export const postBrokersMembersMemberIdCoveredParticipants = async (memberId: string,
    postBrokersMembersMemberIdCoveredParticipants: PostBrokersMembersMemberIdCoveredParticipants, options?: RequestInit): Promise<BrokersCoveredParticipant> => {
  
  return customFetch<BrokersCoveredParticipant>(getPostBrokersMembersMemberIdCoveredParticipantsUrl(memberId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdCoveredParticipants,)
  }
);}




export const getPostBrokersMembersMemberIdCoveredParticipantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdCoveredParticipants>>, TError,{memberId: string;data: PostBrokersMembersMemberIdCoveredParticipants}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdCoveredParticipants>>, TError,{memberId: string;data: PostBrokersMembersMemberIdCoveredParticipants}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdCoveredParticipants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdCoveredParticipants>>, {memberId: string;data: PostBrokersMembersMemberIdCoveredParticipants}> = (props) => {
          const {memberId,data} = props ?? {};

          return  postBrokersMembersMemberIdCoveredParticipants(memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdCoveredParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdCoveredParticipants>>>
    export type PostBrokersMembersMemberIdCoveredParticipantsMutationBody = PostBrokersMembersMemberIdCoveredParticipants
    export type PostBrokersMembersMemberIdCoveredParticipantsMutationError = unknown

    export const usePostBrokersMembersMemberIdCoveredParticipants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdCoveredParticipants>>, TError,{memberId: string;data: PostBrokersMembersMemberIdCoveredParticipants}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdCoveredParticipants>>,
        TError,
        {memberId: string;data: PostBrokersMembersMemberIdCoveredParticipants},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdCoveredParticipantsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a covered participant
 */
export const getPatchBrokersMembersMemberIdCoveredParticipantsIdUrl = (memberId: string,
    id: string,) => {


  

  return `/api/web/brokers/members/${memberId}/covered_participants/${id}`
}

export const patchBrokersMembersMemberIdCoveredParticipantsId = async (memberId: string,
    id: string,
    patchBrokersMembersMemberIdCoveredParticipantsId: PatchBrokersMembersMemberIdCoveredParticipantsId, options?: RequestInit): Promise<BrokersCoveredParticipant> => {
  
  return customFetch<BrokersCoveredParticipant>(getPatchBrokersMembersMemberIdCoveredParticipantsIdUrl(memberId,id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersMembersMemberIdCoveredParticipantsId,)
  }
);}




export const getPatchBrokersMembersMemberIdCoveredParticipantsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersMembersMemberIdCoveredParticipantsId>>, TError,{memberId: string;id: string;data: PatchBrokersMembersMemberIdCoveredParticipantsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersMembersMemberIdCoveredParticipantsId>>, TError,{memberId: string;id: string;data: PatchBrokersMembersMemberIdCoveredParticipantsId}, TContext> => {

const mutationKey = ['patchBrokersMembersMemberIdCoveredParticipantsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersMembersMemberIdCoveredParticipantsId>>, {memberId: string;id: string;data: PatchBrokersMembersMemberIdCoveredParticipantsId}> = (props) => {
          const {memberId,id,data} = props ?? {};

          return  patchBrokersMembersMemberIdCoveredParticipantsId(memberId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersMembersMemberIdCoveredParticipantsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersMembersMemberIdCoveredParticipantsId>>>
    export type PatchBrokersMembersMemberIdCoveredParticipantsIdMutationBody = PatchBrokersMembersMemberIdCoveredParticipantsId
    export type PatchBrokersMembersMemberIdCoveredParticipantsIdMutationError = unknown

    export const usePatchBrokersMembersMemberIdCoveredParticipantsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersMembersMemberIdCoveredParticipantsId>>, TError,{memberId: string;id: string;data: PatchBrokersMembersMemberIdCoveredParticipantsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersMembersMemberIdCoveredParticipantsId>>,
        TError,
        {memberId: string;id: string;data: PatchBrokersMembersMemberIdCoveredParticipantsId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersMembersMemberIdCoveredParticipantsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List qualifying life events
 */
export const getGetBrokersMembersMemberIdQualifyingLifeEventsUrl = (memberId: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/qualifying_life_events?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/qualifying_life_events`
}

export const getBrokersMembersMemberIdQualifyingLifeEvents = async (memberId: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams, options?: RequestInit): Promise<BrokersPaginatedQualifyingLifeEventList> => {
  
  return customFetch<BrokersPaginatedQualifyingLifeEventList>(getGetBrokersMembersMemberIdQualifyingLifeEventsUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdQualifyingLifeEventsQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/qualifying_life_events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdQualifyingLifeEventsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError = unknown>(memberId: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdQualifyingLifeEventsQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>> = ({ signal }) => getBrokersMembersMemberIdQualifyingLifeEvents(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdQualifyingLifeEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>>
export type GetBrokersMembersMemberIdQualifyingLifeEventsQueryError = unknown


export function useGetBrokersMembersMemberIdQualifyingLifeEvents<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError = unknown>(
 memberId: string,
    params: undefined |  GetBrokersMembersMemberIdQualifyingLifeEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdQualifyingLifeEvents<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdQualifyingLifeEvents<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdQualifyingLifeEvents<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdQualifyingLifeEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdQualifyingLifeEvents>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdQualifyingLifeEventsQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List Stripe issuing cards for a member
 */
export const getGetBrokersMembersMemberIdStripeIssuingCardsUrl = (memberId: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/members/${memberId}/stripe_issuing_cards?${stringifiedParams}` : `/api/web/brokers/members/${memberId}/stripe_issuing_cards`
}

export const getBrokersMembersMemberIdStripeIssuingCards = async (memberId: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams, options?: RequestInit): Promise<BrokersPaginatedStripeIssuingCardsList> => {
  
  return customFetch<BrokersPaginatedStripeIssuingCardsList>(getGetBrokersMembersMemberIdStripeIssuingCardsUrl(memberId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdStripeIssuingCardsQueryKey = (memberId?: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams,) => {
    return [
    `/api/web/brokers/members/${memberId}/stripe_issuing_cards`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdStripeIssuingCardsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError = unknown>(memberId: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdStripeIssuingCardsQueryKey(memberId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>> = ({ signal }) => getBrokersMembersMemberIdStripeIssuingCards(memberId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdStripeIssuingCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>>
export type GetBrokersMembersMemberIdStripeIssuingCardsQueryError = unknown


export function useGetBrokersMembersMemberIdStripeIssuingCards<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError = unknown>(
 memberId: string,
    params: undefined |  GetBrokersMembersMemberIdStripeIssuingCardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdStripeIssuingCards<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdStripeIssuingCards<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdStripeIssuingCards<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError = unknown>(
 memberId: string,
    params?: GetBrokersMembersMemberIdStripeIssuingCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCards>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdStripeIssuingCardsQueryOptions(memberId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new Stripe issuing card for a member
 */
export const getPostBrokersMembersMemberIdStripeIssuingCardsUrl = (memberId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards`
}

export const postBrokersMembersMemberIdStripeIssuingCards = async (memberId: string,
    postBrokersMembersMemberIdStripeIssuingCards: PostBrokersMembersMemberIdStripeIssuingCards, options?: RequestInit): Promise<BrokersStripeIssuingCard> => {
  
  return customFetch<BrokersStripeIssuingCard>(getPostBrokersMembersMemberIdStripeIssuingCardsUrl(memberId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdStripeIssuingCards,)
  }
);}




export const getPostBrokersMembersMemberIdStripeIssuingCardsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCards>>, TError,{memberId: string;data: PostBrokersMembersMemberIdStripeIssuingCards}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCards>>, TError,{memberId: string;data: PostBrokersMembersMemberIdStripeIssuingCards}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdStripeIssuingCards'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCards>>, {memberId: string;data: PostBrokersMembersMemberIdStripeIssuingCards}> = (props) => {
          const {memberId,data} = props ?? {};

          return  postBrokersMembersMemberIdStripeIssuingCards(memberId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdStripeIssuingCardsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCards>>>
    export type PostBrokersMembersMemberIdStripeIssuingCardsMutationBody = PostBrokersMembersMemberIdStripeIssuingCards
    export type PostBrokersMembersMemberIdStripeIssuingCardsMutationError = unknown

    export const usePostBrokersMembersMemberIdStripeIssuingCards = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCards>>, TError,{memberId: string;data: PostBrokersMembersMemberIdStripeIssuingCards}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCards>>,
        TError,
        {memberId: string;data: PostBrokersMembersMemberIdStripeIssuingCards},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdStripeIssuingCardsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get cardholder details for a specific Stripe issuing card
 */
export const getGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/cardholder_details`
}

export const getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails = async (memberId: string,
    cardId: string, options?: RequestInit): Promise<BrokersStripeIssuingCardCardholderDetails> => {
  
  return customFetch<BrokersStripeIssuingCardCardholderDetails>(getGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsUrl(memberId,cardId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsQueryKey = (memberId?: string,
    cardId?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/cardholder_details`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError = unknown>(memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsQueryKey(memberId,cardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>> = ({ signal }) => getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails(memberId,cardId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId && cardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>>
export type GetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsQueryError = unknown


export function useGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError = unknown>(
 memberId: string,
    cardId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError = unknown>(
 memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError = unknown>(
 memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError = unknown>(
 memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdStripeIssuingCardsCardIdCardholderDetailsQueryOptions(memberId,cardId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create ephemeral key for Stripe issuing card elements
 */
export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/ephemeral_key`
}

export const postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey = async (memberId: string,
    cardId: string,
    postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey: PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey, options?: RequestInit): Promise<BrokersStripeIssuingCardEphemeralKey> => {
  
  return customFetch<BrokersStripeIssuingCardEphemeralKey>(getPostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyUrl(memberId,cardId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey,)
  }
);}




export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey>>, TError,{memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey>>, TError,{memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey>>, {memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey}> = (props) => {
          const {memberId,cardId,data} = props ?? {};

          return  postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey(memberId,cardId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey>>>
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyMutationBody = PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyMutationError = unknown

    export const usePostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey>>, TError,{memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey>>,
        TError,
        {memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKey},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdStripeIssuingCardsCardIdEphemeralKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a specific Stripe issuing card
 */
export const getGetBrokersMembersMemberIdStripeIssuingCardsCardIdUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}`
}

export const getBrokersMembersMemberIdStripeIssuingCardsCardId = async (memberId: string,
    cardId: string, options?: RequestInit): Promise<BrokersStripeIssuingCard> => {
  
  return customFetch<BrokersStripeIssuingCard>(getGetBrokersMembersMemberIdStripeIssuingCardsCardIdUrl(memberId,cardId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMembersMemberIdStripeIssuingCardsCardIdQueryKey = (memberId?: string,
    cardId?: string,) => {
    return [
    `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}`
    ] as const;
    }

    
export const getGetBrokersMembersMemberIdStripeIssuingCardsCardIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError = unknown>(memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMembersMemberIdStripeIssuingCardsCardIdQueryKey(memberId,cardId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>> = ({ signal }) => getBrokersMembersMemberIdStripeIssuingCardsCardId(memberId,cardId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(memberId && cardId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMembersMemberIdStripeIssuingCardsCardIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>>
export type GetBrokersMembersMemberIdStripeIssuingCardsCardIdQueryError = unknown


export function useGetBrokersMembersMemberIdStripeIssuingCardsCardId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError = unknown>(
 memberId: string,
    cardId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdStripeIssuingCardsCardId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError = unknown>(
 memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMembersMemberIdStripeIssuingCardsCardId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError = unknown>(
 memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMembersMemberIdStripeIssuingCardsCardId<TData = Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError = unknown>(
 memberId: string,
    cardId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMembersMemberIdStripeIssuingCardsCardId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMembersMemberIdStripeIssuingCardsCardIdQueryOptions(memberId,cardId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sync card status with Stripe
 */
export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatusUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/sync_status`
}

export const postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus = async (memberId: string,
    cardId: string, options?: RequestInit): Promise<BrokersStripeIssuingCard> => {
  
  return customFetch<BrokersStripeIssuingCard>(getPostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatusUrl(memberId,cardId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus>>, TError,{memberId: string;cardId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus>>, TError,{memberId: string;cardId: string}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus>>, {memberId: string;cardId: string}> = (props) => {
          const {memberId,cardId} = props ?? {};

          return  postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus(memberId,cardId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus>>>
    
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatusMutationError = unknown

    export const usePostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus>>, TError,{memberId: string;cardId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatus>>,
        TError,
        {memberId: string;cardId: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdStripeIssuingCardsCardIdSyncStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Activate Stripe issuing card
 */
export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdActivateUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/activate`
}

export const postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate = async (memberId: string,
    cardId: string, options?: RequestInit): Promise<BrokersStripeIssuingCard> => {
  
  return customFetch<BrokersStripeIssuingCard>(getPostBrokersMembersMemberIdStripeIssuingCardsCardIdActivateUrl(memberId,cardId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate>>, TError,{memberId: string;cardId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate>>, TError,{memberId: string;cardId: string}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate>>, {memberId: string;cardId: string}> = (props) => {
          const {memberId,cardId} = props ?? {};

          return  postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate(memberId,cardId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate>>>
    
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdActivateMutationError = unknown

    export const usePostBrokersMembersMemberIdStripeIssuingCardsCardIdActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate>>, TError,{memberId: string;cardId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdActivate>>,
        TError,
        {memberId: string;cardId: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdStripeIssuingCardsCardIdActivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deactivate Stripe issuing card
 */
export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivateUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/deactivate`
}

export const postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate = async (memberId: string,
    cardId: string, options?: RequestInit): Promise<BrokersStripeIssuingCard> => {
  
  return customFetch<BrokersStripeIssuingCard>(getPostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivateUrl(memberId,cardId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate>>, TError,{memberId: string;cardId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate>>, TError,{memberId: string;cardId: string}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate>>, {memberId: string;cardId: string}> = (props) => {
          const {memberId,cardId} = props ?? {};

          return  postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate(memberId,cardId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate>>>
    
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivateMutationError = unknown

    export const usePostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate>>, TError,{memberId: string;cardId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivate>>,
        TError,
        {memberId: string;cardId: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdStripeIssuingCardsCardIdDeactivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remap Stripe issuing card to a different enrollment
 */
export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapUrl = (memberId: string,
    cardId: string,) => {


  

  return `/api/web/brokers/members/${memberId}/stripe_issuing_cards/${cardId}/remap`
}

export const postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap = async (memberId: string,
    cardId: string,
    postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap: PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap, options?: RequestInit): Promise<BrokersStripeIssuingCard> => {
  
  return customFetch<BrokersStripeIssuingCard>(getPostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapUrl(memberId,cardId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap,)
  }
);}




export const getPostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap>>, TError,{memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap>>, TError,{memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap}, TContext> => {

const mutationKey = ['postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap>>, {memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap}> = (props) => {
          const {memberId,cardId,data} = props ?? {};

          return  postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap(memberId,cardId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap>>>
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapMutationBody = PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap
    export type PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapMutationError = unknown

    export const usePostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap>>, TError,{memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersMembersMemberIdStripeIssuingCardsCardIdRemap>>,
        TError,
        {memberId: string;cardId: string;data: PostBrokersMembersMemberIdStripeIssuingCardsCardIdRemap},
        TContext
      > => {

      const mutationOptions = getPostBrokersMembersMemberIdStripeIssuingCardsCardIdRemapMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List notes accessible to the user
 */
export const getGetBrokersNotesUrl = (params?: GetBrokersNotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/notes?${stringifiedParams}` : `/api/web/brokers/notes`
}

export const getBrokersNotes = async (params?: GetBrokersNotesParams, options?: RequestInit): Promise<BrokersNoteList> => {
  
  return customFetch<BrokersNoteList>(getGetBrokersNotesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersNotesQueryKey = (params?: GetBrokersNotesParams,) => {
    return [
    `/api/web/brokers/notes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersNotesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersNotes>>, TError = unknown>(params?: GetBrokersNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersNotes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersNotesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersNotes>>> = ({ signal }) => getBrokersNotes(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersNotesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersNotes>>>
export type GetBrokersNotesQueryError = unknown


export function useGetBrokersNotes<TData = Awaited<ReturnType<typeof getBrokersNotes>>, TError = unknown>(
 params: undefined |  GetBrokersNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersNotes>>,
          TError,
          Awaited<ReturnType<typeof getBrokersNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersNotes<TData = Awaited<ReturnType<typeof getBrokersNotes>>, TError = unknown>(
 params?: GetBrokersNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersNotes>>,
          TError,
          Awaited<ReturnType<typeof getBrokersNotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersNotes<TData = Awaited<ReturnType<typeof getBrokersNotes>>, TError = unknown>(
 params?: GetBrokersNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersNotes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersNotes<TData = Awaited<ReturnType<typeof getBrokersNotes>>, TError = unknown>(
 params?: GetBrokersNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersNotes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersNotesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new note.
 */
export const getPostBrokersNotesUrl = () => {


  

  return `/api/web/brokers/notes`
}

export const postBrokersNotes = async (postBrokersNotes: PostBrokersNotes, options?: RequestInit): Promise<BrokersNote> => {
  
  return customFetch<BrokersNote>(getPostBrokersNotesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersNotes,)
  }
);}




export const getPostBrokersNotesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersNotes>>, TError,{data: PostBrokersNotes}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersNotes>>, TError,{data: PostBrokersNotes}, TContext> => {

const mutationKey = ['postBrokersNotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersNotes>>, {data: PostBrokersNotes}> = (props) => {
          const {data} = props ?? {};

          return  postBrokersNotes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersNotesMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersNotes>>>
    export type PostBrokersNotesMutationBody = PostBrokersNotes
    export type PostBrokersNotesMutationError = unknown

    export const usePostBrokersNotes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersNotes>>, TError,{data: PostBrokersNotes}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersNotes>>,
        TError,
        {data: PostBrokersNotes},
        TContext
      > => {

      const mutationOptions = getPostBrokersNotesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a note
 */
export const getPatchBrokersNotesIdUrl = (id: string,) => {


  

  return `/api/web/brokers/notes/${id}`
}

export const patchBrokersNotesId = async (id: string,
    patchBrokersNotesId: PatchBrokersNotesId, options?: RequestInit): Promise<BrokersNote> => {
  
  return customFetch<BrokersNote>(getPatchBrokersNotesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersNotesId,)
  }
);}




export const getPatchBrokersNotesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersNotesId>>, TError,{id: string;data: PatchBrokersNotesId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersNotesId>>, TError,{id: string;data: PatchBrokersNotesId}, TContext> => {

const mutationKey = ['patchBrokersNotesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersNotesId>>, {id: string;data: PatchBrokersNotesId}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBrokersNotesId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersNotesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersNotesId>>>
    export type PatchBrokersNotesIdMutationBody = PatchBrokersNotesId
    export type PatchBrokersNotesIdMutationError = unknown

    export const usePatchBrokersNotesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersNotesId>>, TError,{id: string;data: PatchBrokersNotesId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersNotesId>>,
        TError,
        {id: string;data: PatchBrokersNotesId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersNotesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List unprocessed enrollments
 */
export const getGetBrokersUnprocessedEnrollmentsUrl = (params?: GetBrokersUnprocessedEnrollmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/unprocessed_enrollments?${stringifiedParams}` : `/api/web/brokers/unprocessed_enrollments`
}

export const getBrokersUnprocessedEnrollments = async (params?: GetBrokersUnprocessedEnrollmentsParams, options?: RequestInit): Promise<BrokersPaginatedUnprocessedEnrollmentList> => {
  
  return customFetch<BrokersPaginatedUnprocessedEnrollmentList>(getGetBrokersUnprocessedEnrollmentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersUnprocessedEnrollmentsQueryKey = (params?: GetBrokersUnprocessedEnrollmentsParams,) => {
    return [
    `/api/web/brokers/unprocessed_enrollments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersUnprocessedEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError = unknown>(params?: GetBrokersUnprocessedEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersUnprocessedEnrollmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>> = ({ signal }) => getBrokersUnprocessedEnrollments(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersUnprocessedEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>>
export type GetBrokersUnprocessedEnrollmentsQueryError = unknown


export function useGetBrokersUnprocessedEnrollments<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError = unknown>(
 params: undefined |  GetBrokersUnprocessedEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersUnprocessedEnrollments<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError = unknown>(
 params?: GetBrokersUnprocessedEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersUnprocessedEnrollments<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError = unknown>(
 params?: GetBrokersUnprocessedEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersUnprocessedEnrollments<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError = unknown>(
 params?: GetBrokersUnprocessedEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersUnprocessedEnrollmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch a single enrollment
 */
export const getGetBrokersUnprocessedEnrollmentsIdUrl = (id: string,) => {


  

  return `/api/web/brokers/unprocessed_enrollments/${id}`
}

export const getBrokersUnprocessedEnrollmentsId = async (id: string, options?: RequestInit): Promise<BrokersEnrollmentEnriched> => {
  
  return customFetch<BrokersEnrollmentEnriched>(getGetBrokersUnprocessedEnrollmentsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersUnprocessedEnrollmentsIdQueryKey = (id?: string,) => {
    return [
    `/api/web/brokers/unprocessed_enrollments/${id}`
    ] as const;
    }

    
export const getGetBrokersUnprocessedEnrollmentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersUnprocessedEnrollmentsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>> = ({ signal }) => getBrokersUnprocessedEnrollmentsId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersUnprocessedEnrollmentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>>
export type GetBrokersUnprocessedEnrollmentsIdQueryError = unknown


export function useGetBrokersUnprocessedEnrollmentsId<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersUnprocessedEnrollmentsId<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersUnprocessedEnrollmentsId<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersUnprocessedEnrollmentsId<TData = Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersUnprocessedEnrollmentsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersUnprocessedEnrollmentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a broker action to update an enrollment
 */
export const getPostBrokersUnprocessedEnrollmentsIdActionUrl = (id: string,) => {


  

  return `/api/web/brokers/unprocessed_enrollments/${id}/action`
}

export const postBrokersUnprocessedEnrollmentsIdAction = async (id: string,
    postBrokersUnprocessedEnrollmentsIdAction: PostBrokersUnprocessedEnrollmentsIdAction, options?: RequestInit): Promise<BrokersEnrollmentEnriched> => {
  
  return customFetch<BrokersEnrollmentEnriched>(getPostBrokersUnprocessedEnrollmentsIdActionUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersUnprocessedEnrollmentsIdAction,)
  }
);}




export const getPostBrokersUnprocessedEnrollmentsIdActionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAction>>, TError,{id: string;data: PostBrokersUnprocessedEnrollmentsIdAction}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAction>>, TError,{id: string;data: PostBrokersUnprocessedEnrollmentsIdAction}, TContext> => {

const mutationKey = ['postBrokersUnprocessedEnrollmentsIdAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAction>>, {id: string;data: PostBrokersUnprocessedEnrollmentsIdAction}> = (props) => {
          const {id,data} = props ?? {};

          return  postBrokersUnprocessedEnrollmentsIdAction(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersUnprocessedEnrollmentsIdActionMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAction>>>
    export type PostBrokersUnprocessedEnrollmentsIdActionMutationBody = PostBrokersUnprocessedEnrollmentsIdAction
    export type PostBrokersUnprocessedEnrollmentsIdActionMutationError = unknown

    export const usePostBrokersUnprocessedEnrollmentsIdAction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAction>>, TError,{id: string;data: PostBrokersUnprocessedEnrollmentsIdAction}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAction>>,
        TError,
        {id: string;data: PostBrokersUnprocessedEnrollmentsIdAction},
        TContext
      > => {

      const mutationOptions = getPostBrokersUnprocessedEnrollmentsIdActionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Assign an enrollment to a broker
 */
export const getPostBrokersUnprocessedEnrollmentsIdAssignUrl = (id: string,) => {


  

  return `/api/web/brokers/unprocessed_enrollments/${id}/assign`
}

export const postBrokersUnprocessedEnrollmentsIdAssign = async (id: string,
    postBrokersUnprocessedEnrollmentsIdAssign: PostBrokersUnprocessedEnrollmentsIdAssign, options?: RequestInit): Promise<BrokersEnrollmentEnriched> => {
  
  return customFetch<BrokersEnrollmentEnriched>(getPostBrokersUnprocessedEnrollmentsIdAssignUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersUnprocessedEnrollmentsIdAssign,)
  }
);}




export const getPostBrokersUnprocessedEnrollmentsIdAssignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAssign>>, TError,{id: string;data: PostBrokersUnprocessedEnrollmentsIdAssign}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAssign>>, TError,{id: string;data: PostBrokersUnprocessedEnrollmentsIdAssign}, TContext> => {

const mutationKey = ['postBrokersUnprocessedEnrollmentsIdAssign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAssign>>, {id: string;data: PostBrokersUnprocessedEnrollmentsIdAssign}> = (props) => {
          const {id,data} = props ?? {};

          return  postBrokersUnprocessedEnrollmentsIdAssign(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersUnprocessedEnrollmentsIdAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAssign>>>
    export type PostBrokersUnprocessedEnrollmentsIdAssignMutationBody = PostBrokersUnprocessedEnrollmentsIdAssign
    export type PostBrokersUnprocessedEnrollmentsIdAssignMutationError = unknown

    export const usePostBrokersUnprocessedEnrollmentsIdAssign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAssign>>, TError,{id: string;data: PostBrokersUnprocessedEnrollmentsIdAssign}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersUnprocessedEnrollmentsIdAssign>>,
        TError,
        {id: string;data: PostBrokersUnprocessedEnrollmentsIdAssign},
        TContext
      > => {

      const mutationOptions = getPostBrokersUnprocessedEnrollmentsIdAssignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List brokers
 */
export const getGetBrokersBrokersUrl = (params?: GetBrokersBrokersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/brokers?${stringifiedParams}` : `/api/web/brokers/brokers`
}

export const getBrokersBrokers = async (params?: GetBrokersBrokersParams, options?: RequestInit): Promise<BrokersBrokerList> => {
  
  return customFetch<BrokersBrokerList>(getGetBrokersBrokersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersBrokersQueryKey = (params?: GetBrokersBrokersParams,) => {
    return [
    `/api/web/brokers/brokers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersBrokersQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersBrokers>>, TError = unknown>(params?: GetBrokersBrokersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersBrokersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersBrokers>>> = ({ signal }) => getBrokersBrokers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersBrokersQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersBrokers>>>
export type GetBrokersBrokersQueryError = unknown


export function useGetBrokersBrokers<TData = Awaited<ReturnType<typeof getBrokersBrokers>>, TError = unknown>(
 params: undefined |  GetBrokersBrokersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersBrokers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersBrokers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersBrokers<TData = Awaited<ReturnType<typeof getBrokersBrokers>>, TError = unknown>(
 params?: GetBrokersBrokersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersBrokers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersBrokers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersBrokers<TData = Awaited<ReturnType<typeof getBrokersBrokers>>, TError = unknown>(
 params?: GetBrokersBrokersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersBrokers<TData = Awaited<ReturnType<typeof getBrokersBrokers>>, TError = unknown>(
 params?: GetBrokersBrokersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersBrokersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update Opted In status for a specific Member ICHRA Config
 */
export const getPutBrokersMemberIchraConfigOptedInUrl = () => {


  

  return `/api/web/brokers/member_ichra_config/opted_in`
}

export const putBrokersMemberIchraConfigOptedIn = async (putBrokersMemberIchraConfigOptedIn: PutBrokersMemberIchraConfigOptedIn, options?: RequestInit): Promise<MemberICHRAConfig> => {
  
  return customFetch<MemberICHRAConfig>(getPutBrokersMemberIchraConfigOptedInUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putBrokersMemberIchraConfigOptedIn,)
  }
);}




export const getPutBrokersMemberIchraConfigOptedInMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMemberIchraConfigOptedIn>>, TError,{data: PutBrokersMemberIchraConfigOptedIn}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putBrokersMemberIchraConfigOptedIn>>, TError,{data: PutBrokersMemberIchraConfigOptedIn}, TContext> => {

const mutationKey = ['putBrokersMemberIchraConfigOptedIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBrokersMemberIchraConfigOptedIn>>, {data: PutBrokersMemberIchraConfigOptedIn}> = (props) => {
          const {data} = props ?? {};

          return  putBrokersMemberIchraConfigOptedIn(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBrokersMemberIchraConfigOptedInMutationResult = NonNullable<Awaited<ReturnType<typeof putBrokersMemberIchraConfigOptedIn>>>
    export type PutBrokersMemberIchraConfigOptedInMutationBody = PutBrokersMemberIchraConfigOptedIn
    export type PutBrokersMemberIchraConfigOptedInMutationError = unknown

    export const usePutBrokersMemberIchraConfigOptedIn = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMemberIchraConfigOptedIn>>, TError,{data: PutBrokersMemberIchraConfigOptedIn}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBrokersMemberIchraConfigOptedIn>>,
        TError,
        {data: PutBrokersMemberIchraConfigOptedIn},
        TContext
      > => {

      const mutationOptions = getPutBrokersMemberIchraConfigOptedInMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update QME Treatment for a specific Member ICHRA Config
 */
export const getPutBrokersMemberIchraConfigQmeTreatmentUrl = () => {


  

  return `/api/web/brokers/member_ichra_config/qme_treatment`
}

export const putBrokersMemberIchraConfigQmeTreatment = async (putBrokersMemberIchraConfigQmeTreatment: PutBrokersMemberIchraConfigQmeTreatment, options?: RequestInit): Promise<MemberICHRAConfig> => {
  
  return customFetch<MemberICHRAConfig>(getPutBrokersMemberIchraConfigQmeTreatmentUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putBrokersMemberIchraConfigQmeTreatment,)
  }
);}




export const getPutBrokersMemberIchraConfigQmeTreatmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMemberIchraConfigQmeTreatment>>, TError,{data: PutBrokersMemberIchraConfigQmeTreatment}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putBrokersMemberIchraConfigQmeTreatment>>, TError,{data: PutBrokersMemberIchraConfigQmeTreatment}, TContext> => {

const mutationKey = ['putBrokersMemberIchraConfigQmeTreatment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBrokersMemberIchraConfigQmeTreatment>>, {data: PutBrokersMemberIchraConfigQmeTreatment}> = (props) => {
          const {data} = props ?? {};

          return  putBrokersMemberIchraConfigQmeTreatment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBrokersMemberIchraConfigQmeTreatmentMutationResult = NonNullable<Awaited<ReturnType<typeof putBrokersMemberIchraConfigQmeTreatment>>>
    export type PutBrokersMemberIchraConfigQmeTreatmentMutationBody = PutBrokersMemberIchraConfigQmeTreatment
    export type PutBrokersMemberIchraConfigQmeTreatmentMutationError = unknown

    export const usePutBrokersMemberIchraConfigQmeTreatment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBrokersMemberIchraConfigQmeTreatment>>, TError,{data: PutBrokersMemberIchraConfigQmeTreatment}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBrokersMemberIchraConfigQmeTreatment>>,
        TError,
        {data: PutBrokersMemberIchraConfigQmeTreatment},
        TContext
      > => {

      const mutationOptions = getPutBrokersMemberIchraConfigQmeTreatmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of carriers and their plan counts
 */
export const getGetBrokersMedicalPlansCarriersUrl = () => {


  

  return `/api/web/brokers/medical_plans/carriers`
}

export const getBrokersMedicalPlansCarriers = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetBrokersMedicalPlansCarriersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersMedicalPlansCarriersQueryKey = () => {
    return [
    `/api/web/brokers/medical_plans/carriers`
    ] as const;
    }

    
export const getGetBrokersMedicalPlansCarriersQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersMedicalPlansCarriersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>> = ({ signal }) => getBrokersMedicalPlansCarriers({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersMedicalPlansCarriersQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>>
export type GetBrokersMedicalPlansCarriersQueryError = unknown


export function useGetBrokersMedicalPlansCarriers<TData = Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMedicalPlansCarriers<TData = Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersMedicalPlansCarriers<TData = Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersMedicalPlansCarriers<TData = Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersMedicalPlansCarriers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersMedicalPlansCarriersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List brokerages
 */
export const getGetBrokersRelevantBrokeragesUrl = () => {


  

  return `/api/web/brokers/relevant_brokerages`
}

export const getBrokersRelevantBrokerages = async ( options?: RequestInit): Promise<BrokersBrokerage[]> => {
  
  return customFetch<BrokersBrokerage[]>(getGetBrokersRelevantBrokeragesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersRelevantBrokeragesQueryKey = () => {
    return [
    `/api/web/brokers/relevant_brokerages`
    ] as const;
    }

    
export const getGetBrokersRelevantBrokeragesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersRelevantBrokeragesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>> = ({ signal }) => getBrokersRelevantBrokerages({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersRelevantBrokeragesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>>
export type GetBrokersRelevantBrokeragesQueryError = unknown


export function useGetBrokersRelevantBrokerages<TData = Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>,
          TError,
          Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersRelevantBrokerages<TData = Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>,
          TError,
          Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersRelevantBrokerages<TData = Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersRelevantBrokerages<TData = Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersRelevantBrokerages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersRelevantBrokeragesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List tags
 */
export const getGetBrokersTagsUrl = (params?: GetBrokersTagsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tags?${stringifiedParams}` : `/api/web/brokers/tags`
}

export const getBrokersTags = async (params?: GetBrokersTagsParams, options?: RequestInit): Promise<BrokersTag[]> => {
  
  return customFetch<BrokersTag[]>(getGetBrokersTagsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTagsQueryKey = (params?: GetBrokersTagsParams,) => {
    return [
    `/api/web/brokers/tags`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTagsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTags>>, TError = unknown>(params?: GetBrokersTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTags>>> = ({ signal }) => getBrokersTags(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTags>>>
export type GetBrokersTagsQueryError = unknown


export function useGetBrokersTags<TData = Awaited<ReturnType<typeof getBrokersTags>>, TError = unknown>(
 params: undefined |  GetBrokersTagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTags>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTags<TData = Awaited<ReturnType<typeof getBrokersTags>>, TError = unknown>(
 params?: GetBrokersTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTags>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTags<TData = Awaited<ReturnType<typeof getBrokersTags>>, TError = unknown>(
 params?: GetBrokersTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTags<TData = Awaited<ReturnType<typeof getBrokersTags>>, TError = unknown>(
 params?: GetBrokersTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTags>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTagsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create tag
 */
export const getPostBrokersTagsUrl = () => {


  

  return `/api/web/brokers/tags`
}

export const postBrokersTags = async (postBrokersTags: PostBrokersTags, options?: RequestInit): Promise<BrokersTag> => {
  
  return customFetch<BrokersTag>(getPostBrokersTagsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersTags,)
  }
);}




export const getPostBrokersTagsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTags>>, TError,{data: PostBrokersTags}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTags>>, TError,{data: PostBrokersTags}, TContext> => {

const mutationKey = ['postBrokersTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTags>>, {data: PostBrokersTags}> = (props) => {
          const {data} = props ?? {};

          return  postBrokersTags(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTagsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTags>>>
    export type PostBrokersTagsMutationBody = PostBrokersTags
    export type PostBrokersTagsMutationError = unknown

    export const usePostBrokersTags = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTags>>, TError,{data: PostBrokersTags}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTags>>,
        TError,
        {data: PostBrokersTags},
        TContext
      > => {

      const mutationOptions = getPostBrokersTagsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Edit tag
 */
export const getPatchBrokersTagsIdUrl = (id: string,) => {


  

  return `/api/web/brokers/tags/${id}`
}

export const patchBrokersTagsId = async (id: string,
    patchBrokersTagsId: PatchBrokersTagsId, options?: RequestInit): Promise<BrokersTag> => {
  
  return customFetch<BrokersTag>(getPatchBrokersTagsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTagsId,)
  }
);}




export const getPatchBrokersTagsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTagsId>>, TError,{id: string;data: PatchBrokersTagsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTagsId>>, TError,{id: string;data: PatchBrokersTagsId}, TContext> => {

const mutationKey = ['patchBrokersTagsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTagsId>>, {id: string;data: PatchBrokersTagsId}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBrokersTagsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTagsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTagsId>>>
    export type PatchBrokersTagsIdMutationBody = PatchBrokersTagsId
    export type PatchBrokersTagsIdMutationError = unknown

    export const usePatchBrokersTagsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTagsId>>, TError,{id: string;data: PatchBrokersTagsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTagsId>>,
        TError,
        {id: string;data: PatchBrokersTagsId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTagsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Edit archived status
 */
export const getPatchBrokersTagsIdArchivedUrl = (id: string,) => {


  

  return `/api/web/brokers/tags/${id}/archived`
}

export const patchBrokersTagsIdArchived = async (id: string,
    patchBrokersTagsIdArchived: PatchBrokersTagsIdArchived, options?: RequestInit): Promise<BrokersTag> => {
  
  return customFetch<BrokersTag>(getPatchBrokersTagsIdArchivedUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTagsIdArchived,)
  }
);}




export const getPatchBrokersTagsIdArchivedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTagsIdArchived>>, TError,{id: string;data: PatchBrokersTagsIdArchived}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTagsIdArchived>>, TError,{id: string;data: PatchBrokersTagsIdArchived}, TContext> => {

const mutationKey = ['patchBrokersTagsIdArchived'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTagsIdArchived>>, {id: string;data: PatchBrokersTagsIdArchived}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBrokersTagsIdArchived(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTagsIdArchivedMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTagsIdArchived>>>
    export type PatchBrokersTagsIdArchivedMutationBody = PatchBrokersTagsIdArchived
    export type PatchBrokersTagsIdArchivedMutationError = unknown

    export const usePatchBrokersTagsIdArchived = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTagsIdArchived>>, TError,{id: string;data: PatchBrokersTagsIdArchived}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTagsIdArchived>>,
        TError,
        {id: string;data: PatchBrokersTagsIdArchived},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTagsIdArchivedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Broker Attention Needed Item statistics
 */
export const getGetBrokersBrokerAttentionNeededItemsStatisticsUrl = (params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[statuses][]","filter[exclude_statuses][]","filter[reasons][]","filter[exclude_reasons][]","filter[enrollment_types][]","filter[exclude_enrollment_types][]","filter[enrollment_categories][]","filter[exclude_enrollment_categories][]","filter[member_ids][]","filter[exclude_member_ids][]","filter[employer_ids][]","filter[exclude_employer_ids][]","filter[broker_ids][]","filter[exclude_broker_ids][]","filter[tag_ids][]","filter[exclude_tag_ids][]","filter[carrier_names][]","filter[exclude_carrier_names][]","filter[plan_years][]","filter[exclude_plan_years][]","filter[submission_methods][]","filter[exclude_submission_methods][]","filter[employment_statuses][]","filter[exclude_employment_statuses][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/broker_attention_needed_items/statistics?${stringifiedParams}` : `/api/web/brokers/broker_attention_needed_items/statistics`
}

export const getBrokersBrokerAttentionNeededItemsStatistics = async (params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetBrokersBrokerAttentionNeededItemsStatisticsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersBrokerAttentionNeededItemsStatisticsQueryKey = (params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams,) => {
    return [
    `/api/web/brokers/broker_attention_needed_items/statistics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersBrokerAttentionNeededItemsStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError = unknown>(params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersBrokerAttentionNeededItemsStatisticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>> = ({ signal }) => getBrokersBrokerAttentionNeededItemsStatistics(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersBrokerAttentionNeededItemsStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>>
export type GetBrokersBrokerAttentionNeededItemsStatisticsQueryError = unknown


export function useGetBrokersBrokerAttentionNeededItemsStatistics<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError = unknown>(
 params: undefined |  GetBrokersBrokerAttentionNeededItemsStatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersBrokerAttentionNeededItemsStatistics<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError = unknown>(
 params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersBrokerAttentionNeededItemsStatistics<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError = unknown>(
 params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersBrokerAttentionNeededItemsStatistics<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError = unknown>(
 params?: GetBrokersBrokerAttentionNeededItemsStatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItemsStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersBrokerAttentionNeededItemsStatisticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get Broker Attention Needed Items w/ filtering and sorting
 */
export const getGetBrokersBrokerAttentionNeededItemsUrl = (params?: GetBrokersBrokerAttentionNeededItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[statuses][]","filter[exclude_statuses][]","filter[reasons][]","filter[exclude_reasons][]","filter[enrollment_types][]","filter[exclude_enrollment_types][]","filter[enrollment_categories][]","filter[exclude_enrollment_categories][]","filter[member_ids][]","filter[exclude_member_ids][]","filter[employer_ids][]","filter[exclude_employer_ids][]","filter[broker_ids][]","filter[exclude_broker_ids][]","filter[tag_ids][]","filter[exclude_tag_ids][]","filter[carrier_names][]","filter[exclude_carrier_names][]","filter[plan_years][]","filter[exclude_plan_years][]","filter[submission_methods][]","filter[exclude_submission_methods][]","filter[employment_statuses][]","filter[exclude_employment_statuses][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/broker_attention_needed_items?${stringifiedParams}` : `/api/web/brokers/broker_attention_needed_items`
}

export const getBrokersBrokerAttentionNeededItems = async (params?: GetBrokersBrokerAttentionNeededItemsParams, options?: RequestInit): Promise<BrokersPaginatedBrokerAttentionNeededItemList> => {
  
  return customFetch<BrokersPaginatedBrokerAttentionNeededItemList>(getGetBrokersBrokerAttentionNeededItemsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersBrokerAttentionNeededItemsQueryKey = (params?: GetBrokersBrokerAttentionNeededItemsParams,) => {
    return [
    `/api/web/brokers/broker_attention_needed_items`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersBrokerAttentionNeededItemsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError = unknown>(params?: GetBrokersBrokerAttentionNeededItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersBrokerAttentionNeededItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>> = ({ signal }) => getBrokersBrokerAttentionNeededItems(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersBrokerAttentionNeededItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>>
export type GetBrokersBrokerAttentionNeededItemsQueryError = unknown


export function useGetBrokersBrokerAttentionNeededItems<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError = unknown>(
 params: undefined |  GetBrokersBrokerAttentionNeededItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>,
          TError,
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersBrokerAttentionNeededItems<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError = unknown>(
 params?: GetBrokersBrokerAttentionNeededItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>,
          TError,
          Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersBrokerAttentionNeededItems<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError = unknown>(
 params?: GetBrokersBrokerAttentionNeededItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersBrokerAttentionNeededItems<TData = Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError = unknown>(
 params?: GetBrokersBrokerAttentionNeededItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersBrokerAttentionNeededItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersBrokerAttentionNeededItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a Broker Attention Needed Item for one or more enrollments
 */
export const getPostBrokersBrokerAttentionNeededItemsUrl = () => {


  

  return `/api/web/brokers/broker_attention_needed_items`
}

export const postBrokersBrokerAttentionNeededItems = async (postBrokersBrokerAttentionNeededItems: PostBrokersBrokerAttentionNeededItems, options?: RequestInit): Promise<BrokersBrokerAttentionNeededItem> => {
  
  return customFetch<BrokersBrokerAttentionNeededItem>(getPostBrokersBrokerAttentionNeededItemsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersBrokerAttentionNeededItems,)
  }
);}




export const getPostBrokersBrokerAttentionNeededItemsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersBrokerAttentionNeededItems>>, TError,{data: PostBrokersBrokerAttentionNeededItems}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersBrokerAttentionNeededItems>>, TError,{data: PostBrokersBrokerAttentionNeededItems}, TContext> => {

const mutationKey = ['postBrokersBrokerAttentionNeededItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersBrokerAttentionNeededItems>>, {data: PostBrokersBrokerAttentionNeededItems}> = (props) => {
          const {data} = props ?? {};

          return  postBrokersBrokerAttentionNeededItems(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersBrokerAttentionNeededItemsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersBrokerAttentionNeededItems>>>
    export type PostBrokersBrokerAttentionNeededItemsMutationBody = PostBrokersBrokerAttentionNeededItems
    export type PostBrokersBrokerAttentionNeededItemsMutationError = unknown

    export const usePostBrokersBrokerAttentionNeededItems = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersBrokerAttentionNeededItems>>, TError,{data: PostBrokersBrokerAttentionNeededItems}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersBrokerAttentionNeededItems>>,
        TError,
        {data: PostBrokersBrokerAttentionNeededItems},
        TContext
      > => {

      const mutationOptions = getPostBrokersBrokerAttentionNeededItemsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Modify Broker Attention Needed Items
 */
export const getPatchBrokersBrokerAttentionNeededItemsUrl = () => {


  

  return `/api/web/brokers/broker_attention_needed_items`
}

export const patchBrokersBrokerAttentionNeededItems = async (patchBrokersBrokerAttentionNeededItems: PatchBrokersBrokerAttentionNeededItems, options?: RequestInit): Promise<BrokersBrokerAttentionNeededItem[]> => {
  
  return customFetch<BrokersBrokerAttentionNeededItem[]>(getPatchBrokersBrokerAttentionNeededItemsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersBrokerAttentionNeededItems,)
  }
);}




export const getPatchBrokersBrokerAttentionNeededItemsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItems>>, TError,{data: PatchBrokersBrokerAttentionNeededItems}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItems>>, TError,{data: PatchBrokersBrokerAttentionNeededItems}, TContext> => {

const mutationKey = ['patchBrokersBrokerAttentionNeededItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItems>>, {data: PatchBrokersBrokerAttentionNeededItems}> = (props) => {
          const {data} = props ?? {};

          return  patchBrokersBrokerAttentionNeededItems(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersBrokerAttentionNeededItemsMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItems>>>
    export type PatchBrokersBrokerAttentionNeededItemsMutationBody = PatchBrokersBrokerAttentionNeededItems
    export type PatchBrokersBrokerAttentionNeededItemsMutationError = unknown

    export const usePatchBrokersBrokerAttentionNeededItems = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItems>>, TError,{data: PatchBrokersBrokerAttentionNeededItems}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItems>>,
        TError,
        {data: PatchBrokersBrokerAttentionNeededItems},
        TContext
      > => {

      const mutationOptions = getPatchBrokersBrokerAttentionNeededItemsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Modify a Broker Attention Needed Item
 */
export const getPatchBrokersBrokerAttentionNeededItemsIdUrl = (id: string,) => {


  

  return `/api/web/brokers/broker_attention_needed_items/${id}`
}

export const patchBrokersBrokerAttentionNeededItemsId = async (id: string,
    patchBrokersBrokerAttentionNeededItemsId: PatchBrokersBrokerAttentionNeededItemsId, options?: RequestInit): Promise<BrokersBrokerAttentionNeededItem> => {
  
  return customFetch<BrokersBrokerAttentionNeededItem>(getPatchBrokersBrokerAttentionNeededItemsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersBrokerAttentionNeededItemsId,)
  }
);}




export const getPatchBrokersBrokerAttentionNeededItemsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItemsId>>, TError,{id: string;data: PatchBrokersBrokerAttentionNeededItemsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItemsId>>, TError,{id: string;data: PatchBrokersBrokerAttentionNeededItemsId}, TContext> => {

const mutationKey = ['patchBrokersBrokerAttentionNeededItemsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItemsId>>, {id: string;data: PatchBrokersBrokerAttentionNeededItemsId}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBrokersBrokerAttentionNeededItemsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersBrokerAttentionNeededItemsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItemsId>>>
    export type PatchBrokersBrokerAttentionNeededItemsIdMutationBody = PatchBrokersBrokerAttentionNeededItemsId
    export type PatchBrokersBrokerAttentionNeededItemsIdMutationError = unknown

    export const usePatchBrokersBrokerAttentionNeededItemsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItemsId>>, TError,{id: string;data: PatchBrokersBrokerAttentionNeededItemsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersBrokerAttentionNeededItemsId>>,
        TError,
        {id: string;data: PatchBrokersBrokerAttentionNeededItemsId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersBrokerAttentionNeededItemsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Tasks w/ filtering and sorting
 */
export const getGetBrokersTasksUrl = (params?: GetBrokersTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filters[statuses][]","filters[execution_methods][]","filters[handlers][]","filters[member_ids][]","filters[broker_ids][]","filters[carrier_names][]","filters[enrollment_categories][]","filters[task_types][]","filters[task_categories][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tasks?${stringifiedParams}` : `/api/web/brokers/tasks`
}

export const getBrokersTasks = async (params?: GetBrokersTasksParams, options?: RequestInit): Promise<BrokersPaginatedTaskList> => {
  
  return customFetch<BrokersPaginatedTaskList>(getGetBrokersTasksUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksQueryKey = (params?: GetBrokersTasksParams,) => {
    return [
    `/api/web/brokers/tasks`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTasksQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasks>>, TError = unknown>(params?: GetBrokersTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasks>>> = ({ signal }) => getBrokersTasks(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasks>>>
export type GetBrokersTasksQueryError = unknown


export function useGetBrokersTasks<TData = Awaited<ReturnType<typeof getBrokersTasks>>, TError = unknown>(
 params: undefined |  GetBrokersTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasks>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasks<TData = Awaited<ReturnType<typeof getBrokersTasks>>, TError = unknown>(
 params?: GetBrokersTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasks>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasks<TData = Awaited<ReturnType<typeof getBrokersTasks>>, TError = unknown>(
 params?: GetBrokersTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasks<TData = Awaited<ReturnType<typeof getBrokersTasks>>, TError = unknown>(
 params?: GetBrokersTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Modify Broker Tasks
 */
export const getPatchBrokersTasksUrl = () => {


  

  return `/api/web/brokers/tasks`
}

export const patchBrokersTasks = async (patchBrokersTasks: PatchBrokersTasks, options?: RequestInit): Promise<BrokersTask[]> => {
  
  return customFetch<BrokersTask[]>(getPatchBrokersTasksUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTasks,)
  }
);}




export const getPatchBrokersTasksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasks>>, TError,{data: PatchBrokersTasks}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasks>>, TError,{data: PatchBrokersTasks}, TContext> => {

const mutationKey = ['patchBrokersTasks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTasks>>, {data: PatchBrokersTasks}> = (props) => {
          const {data} = props ?? {};

          return  patchBrokersTasks(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTasksMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTasks>>>
    export type PatchBrokersTasksMutationBody = PatchBrokersTasks
    export type PatchBrokersTasksMutationError = unknown

    export const usePatchBrokersTasks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasks>>, TError,{data: PatchBrokersTasks}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTasks>>,
        TError,
        {data: PatchBrokersTasks},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTasksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all task jobs
 */
export const getGetBrokersTasksJobsUrl = () => {


  

  return `/api/web/brokers/tasks/jobs`
}

export const getBrokersTasksJobs = async ( options?: RequestInit): Promise<BrokersTaskJob[]> => {
  
  return customFetch<BrokersTaskJob[]>(getGetBrokersTasksJobsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksJobsQueryKey = () => {
    return [
    `/api/web/brokers/tasks/jobs`
    ] as const;
    }

    
export const getGetBrokersTasksJobsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksJobsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksJobs>>> = ({ signal }) => getBrokersTasksJobs({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksJobs>>>
export type GetBrokersTasksJobsQueryError = unknown


export function useGetBrokersTasksJobs<TData = Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksJobs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksJobs<TData = Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksJobs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksJobs<TData = Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksJobs<TData = Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksJobsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get job and task statistics
 */
export const getGetBrokersTasksJobsStatisticsUrl = () => {


  

  return `/api/web/brokers/tasks/jobs/statistics`
}

export const getBrokersTasksJobsStatistics = async ( options?: RequestInit): Promise<BrokersJobStatistics> => {
  
  return customFetch<BrokersJobStatistics>(getGetBrokersTasksJobsStatisticsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksJobsStatisticsQueryKey = () => {
    return [
    `/api/web/brokers/tasks/jobs/statistics`
    ] as const;
    }

    
export const getGetBrokersTasksJobsStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksJobsStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>> = ({ signal }) => getBrokersTasksJobsStatistics({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksJobsStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>>
export type GetBrokersTasksJobsStatisticsQueryError = unknown


export function useGetBrokersTasksJobsStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksJobsStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksJobsStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksJobsStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksJobsStatisticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all holds for a specific job
 */
export const getGetBrokersTasksJobsJobIdHoldsUrl = (jobId: string,) => {


  

  return `/api/web/brokers/tasks/jobs/${jobId}/holds`
}

export const getBrokersTasksJobsJobIdHolds = async (jobId: string, options?: RequestInit): Promise<BrokersHold[]> => {
  
  return customFetch<BrokersHold[]>(getGetBrokersTasksJobsJobIdHoldsUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksJobsJobIdHoldsQueryKey = (jobId?: string,) => {
    return [
    `/api/web/brokers/tasks/jobs/${jobId}/holds`
    ] as const;
    }

    
export const getGetBrokersTasksJobsJobIdHoldsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError = unknown>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksJobsJobIdHoldsQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>> = ({ signal }) => getBrokersTasksJobsJobIdHolds(jobId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksJobsJobIdHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>>
export type GetBrokersTasksJobsJobIdHoldsQueryError = unknown


export function useGetBrokersTasksJobsJobIdHolds<TData = Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError = unknown>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksJobsJobIdHolds<TData = Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError = unknown>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksJobsJobIdHolds<TData = Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError = unknown>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksJobsJobIdHolds<TData = Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError = unknown>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksJobsJobIdHolds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksJobsJobIdHoldsQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new hold for a specific job
 */
export const getPostBrokersTasksJobsJobIdHoldsUrl = (jobId: string,) => {


  

  return `/api/web/brokers/tasks/jobs/${jobId}/holds`
}

export const postBrokersTasksJobsJobIdHolds = async (jobId: string,
    postBrokersTasksJobsJobIdHolds: PostBrokersTasksJobsJobIdHolds, options?: RequestInit): Promise<BrokersHold> => {
  
  return customFetch<BrokersHold>(getPostBrokersTasksJobsJobIdHoldsUrl(jobId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersTasksJobsJobIdHolds,)
  }
);}




export const getPostBrokersTasksJobsJobIdHoldsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksJobsJobIdHolds>>, TError,{jobId: string;data: PostBrokersTasksJobsJobIdHolds}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksJobsJobIdHolds>>, TError,{jobId: string;data: PostBrokersTasksJobsJobIdHolds}, TContext> => {

const mutationKey = ['postBrokersTasksJobsJobIdHolds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksJobsJobIdHolds>>, {jobId: string;data: PostBrokersTasksJobsJobIdHolds}> = (props) => {
          const {jobId,data} = props ?? {};

          return  postBrokersTasksJobsJobIdHolds(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksJobsJobIdHoldsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksJobsJobIdHolds>>>
    export type PostBrokersTasksJobsJobIdHoldsMutationBody = PostBrokersTasksJobsJobIdHolds
    export type PostBrokersTasksJobsJobIdHoldsMutationError = unknown

    export const usePostBrokersTasksJobsJobIdHolds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksJobsJobIdHolds>>, TError,{jobId: string;data: PostBrokersTasksJobsJobIdHolds}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksJobsJobIdHolds>>,
        TError,
        {jobId: string;data: PostBrokersTasksJobsJobIdHolds},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksJobsJobIdHoldsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a hold (clear or unclear)
 */
export const getPatchBrokersTasksJobsJobIdHoldsHoldIdUrl = (jobId: string,
    holdId: string,) => {


  

  return `/api/web/brokers/tasks/jobs/${jobId}/holds/${holdId}`
}

export const patchBrokersTasksJobsJobIdHoldsHoldId = async (jobId: string,
    holdId: string,
    patchBrokersTasksJobsJobIdHoldsHoldId: PatchBrokersTasksJobsJobIdHoldsHoldId, options?: RequestInit): Promise<BrokersHold> => {
  
  return customFetch<BrokersHold>(getPatchBrokersTasksJobsJobIdHoldsHoldIdUrl(jobId,holdId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTasksJobsJobIdHoldsHoldId,)
  }
);}




export const getPatchBrokersTasksJobsJobIdHoldsHoldIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksJobsJobIdHoldsHoldId>>, TError,{jobId: string;holdId: string;data: PatchBrokersTasksJobsJobIdHoldsHoldId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksJobsJobIdHoldsHoldId>>, TError,{jobId: string;holdId: string;data: PatchBrokersTasksJobsJobIdHoldsHoldId}, TContext> => {

const mutationKey = ['patchBrokersTasksJobsJobIdHoldsHoldId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTasksJobsJobIdHoldsHoldId>>, {jobId: string;holdId: string;data: PatchBrokersTasksJobsJobIdHoldsHoldId}> = (props) => {
          const {jobId,holdId,data} = props ?? {};

          return  patchBrokersTasksJobsJobIdHoldsHoldId(jobId,holdId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTasksJobsJobIdHoldsHoldIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTasksJobsJobIdHoldsHoldId>>>
    export type PatchBrokersTasksJobsJobIdHoldsHoldIdMutationBody = PatchBrokersTasksJobsJobIdHoldsHoldId
    export type PatchBrokersTasksJobsJobIdHoldsHoldIdMutationError = unknown

    export const usePatchBrokersTasksJobsJobIdHoldsHoldId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksJobsJobIdHoldsHoldId>>, TError,{jobId: string;holdId: string;data: PatchBrokersTasksJobsJobIdHoldsHoldId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTasksJobsJobIdHoldsHoldId>>,
        TError,
        {jobId: string;holdId: string;data: PatchBrokersTasksJobsJobIdHoldsHoldId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTasksJobsJobIdHoldsHoldIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all registered V2 task types without statistics (lightweight)
 */
export const getGetBrokersTasksRegisteredTaskTypesUrl = () => {


  

  return `/api/web/brokers/tasks/registered_task_types`
}

export const getBrokersTasksRegisteredTaskTypes = async ( options?: RequestInit): Promise<BrokersTaskType[]> => {
  
  return customFetch<BrokersTaskType[]>(getGetBrokersTasksRegisteredTaskTypesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksRegisteredTaskTypesQueryKey = () => {
    return [
    `/api/web/brokers/tasks/registered_task_types`
    ] as const;
    }

    
export const getGetBrokersTasksRegisteredTaskTypesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksRegisteredTaskTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>> = ({ signal }) => getBrokersTasksRegisteredTaskTypes({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksRegisteredTaskTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>>
export type GetBrokersTasksRegisteredTaskTypesQueryError = unknown


export function useGetBrokersTasksRegisteredTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksRegisteredTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksRegisteredTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksRegisteredTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksRegisteredTaskTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksRegisteredTaskTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all V2 task types with summaries
 */
export const getGetBrokersTasksTaskTypesUrl = (params?: GetBrokersTasksTaskTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tasks/task_types?${stringifiedParams}` : `/api/web/brokers/tasks/task_types`
}

export const getBrokersTasksTaskTypes = async (params?: GetBrokersTasksTaskTypesParams, options?: RequestInit): Promise<BrokersTaskTypeSummary[]> => {
  
  return customFetch<BrokersTaskTypeSummary[]>(getGetBrokersTasksTaskTypesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksTaskTypesQueryKey = (params?: GetBrokersTasksTaskTypesParams,) => {
    return [
    `/api/web/brokers/tasks/task_types`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTasksTaskTypesQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError = unknown>(params?: GetBrokersTasksTaskTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksTaskTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>> = ({ signal }) => getBrokersTasksTaskTypes(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksTaskTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>>
export type GetBrokersTasksTaskTypesQueryError = unknown


export function useGetBrokersTasksTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError = unknown>(
 params: undefined |  GetBrokersTasksTaskTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError = unknown>(
 params?: GetBrokersTasksTaskTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError = unknown>(
 params?: GetBrokersTasksTaskTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksTaskTypes<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError = unknown>(
 params?: GetBrokersTasksTaskTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksTaskTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Bulk update holds for multiple task types
 */
export const getPatchBrokersTasksTaskTypesUrl = () => {


  

  return `/api/web/brokers/tasks/task_types`
}

export const patchBrokersTasksTaskTypes = async (patchBrokersTasksTaskTypes: PatchBrokersTasksTaskTypes, options?: RequestInit): Promise<BrokersV2Hold[]> => {
  
  return customFetch<BrokersV2Hold[]>(getPatchBrokersTasksTaskTypesUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTasksTaskTypes,)
  }
);}




export const getPatchBrokersTasksTaskTypesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksTaskTypes>>, TError,{data: PatchBrokersTasksTaskTypes}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksTaskTypes>>, TError,{data: PatchBrokersTasksTaskTypes}, TContext> => {

const mutationKey = ['patchBrokersTasksTaskTypes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTasksTaskTypes>>, {data: PatchBrokersTasksTaskTypes}> = (props) => {
          const {data} = props ?? {};

          return  patchBrokersTasksTaskTypes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTasksTaskTypesMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTasksTaskTypes>>>
    export type PatchBrokersTasksTaskTypesMutationBody = PatchBrokersTasksTaskTypes
    export type PatchBrokersTasksTaskTypesMutationError = unknown

    export const usePatchBrokersTasksTaskTypes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksTaskTypes>>, TError,{data: PatchBrokersTasksTaskTypes}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTasksTaskTypes>>,
        TError,
        {data: PatchBrokersTasksTaskTypes},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTasksTaskTypesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get statistics for a specific V2 task type
 */
export const getGetBrokersTasksTaskTypesTaskTypeStatisticsUrl = (taskType: string,) => {


  

  return `/api/web/brokers/tasks/task_types/${taskType}/statistics`
}

export const getBrokersTasksTaskTypesTaskTypeStatistics = async (taskType: string, options?: RequestInit): Promise<BrokersTaskTypeStatistics> => {
  
  return customFetch<BrokersTaskTypeStatistics>(getGetBrokersTasksTaskTypesTaskTypeStatisticsUrl(taskType),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksTaskTypesTaskTypeStatisticsQueryKey = (taskType?: string,) => {
    return [
    `/api/web/brokers/tasks/task_types/${taskType}/statistics`
    ] as const;
    }

    
export const getGetBrokersTasksTaskTypesTaskTypeStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError = unknown>(taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksTaskTypesTaskTypeStatisticsQueryKey(taskType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>> = ({ signal }) => getBrokersTasksTaskTypesTaskTypeStatistics(taskType, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(taskType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksTaskTypesTaskTypeStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>>
export type GetBrokersTasksTaskTypesTaskTypeStatisticsQueryError = unknown


export function useGetBrokersTasksTaskTypesTaskTypeStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError = unknown>(
 taskType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskTypesTaskTypeStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError = unknown>(
 taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskTypesTaskTypeStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError = unknown>(
 taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksTaskTypesTaskTypeStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError = unknown>(
 taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksTaskTypesTaskTypeStatisticsQueryOptions(taskType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Queue execution for all automated tasks of this type
 */
export const getPostBrokersTasksTaskTypesTaskTypeExecuteUrl = (taskType: string,) => {


  

  return `/api/web/brokers/tasks/task_types/${taskType}/execute`
}

export const postBrokersTasksTaskTypesTaskTypeExecute = async (taskType: string, options?: RequestInit): Promise<PostBrokersTasksTaskTypesTaskTypeExecute201> => {
  
  return customFetch<PostBrokersTasksTaskTypesTaskTypeExecute201>(getPostBrokersTasksTaskTypesTaskTypeExecuteUrl(taskType),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersTasksTaskTypesTaskTypeExecuteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeExecute>>, TError,{taskType: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeExecute>>, TError,{taskType: string}, TContext> => {

const mutationKey = ['postBrokersTasksTaskTypesTaskTypeExecute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeExecute>>, {taskType: string}> = (props) => {
          const {taskType} = props ?? {};

          return  postBrokersTasksTaskTypesTaskTypeExecute(taskType,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksTaskTypesTaskTypeExecuteMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeExecute>>>
    
    export type PostBrokersTasksTaskTypesTaskTypeExecuteMutationError = unknown

    export const usePostBrokersTasksTaskTypesTaskTypeExecute = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeExecute>>, TError,{taskType: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeExecute>>,
        TError,
        {taskType: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksTaskTypesTaskTypeExecuteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all holds for a specific task type
 */
export const getGetBrokersTasksTaskTypesTaskTypeHoldsUrl = (taskType: string,) => {


  

  return `/api/web/brokers/tasks/task_types/${taskType}/holds`
}

export const getBrokersTasksTaskTypesTaskTypeHolds = async (taskType: string, options?: RequestInit): Promise<BrokersV2Hold[]> => {
  
  return customFetch<BrokersV2Hold[]>(getGetBrokersTasksTaskTypesTaskTypeHoldsUrl(taskType),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksTaskTypesTaskTypeHoldsQueryKey = (taskType?: string,) => {
    return [
    `/api/web/brokers/tasks/task_types/${taskType}/holds`
    ] as const;
    }

    
export const getGetBrokersTasksTaskTypesTaskTypeHoldsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError = unknown>(taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksTaskTypesTaskTypeHoldsQueryKey(taskType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>> = ({ signal }) => getBrokersTasksTaskTypesTaskTypeHolds(taskType, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(taskType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksTaskTypesTaskTypeHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>>
export type GetBrokersTasksTaskTypesTaskTypeHoldsQueryError = unknown


export function useGetBrokersTasksTaskTypesTaskTypeHolds<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError = unknown>(
 taskType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskTypesTaskTypeHolds<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError = unknown>(
 taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskTypesTaskTypeHolds<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError = unknown>(
 taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksTaskTypesTaskTypeHolds<TData = Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError = unknown>(
 taskType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskTypesTaskTypeHolds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksTaskTypesTaskTypeHoldsQueryOptions(taskType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new hold for a specific task type
 */
export const getPostBrokersTasksTaskTypesTaskTypeHoldsUrl = (taskType: string,) => {


  

  return `/api/web/brokers/tasks/task_types/${taskType}/holds`
}

export const postBrokersTasksTaskTypesTaskTypeHolds = async (taskType: string,
    postBrokersTasksTaskTypesTaskTypeHolds: PostBrokersTasksTaskTypesTaskTypeHolds, options?: RequestInit): Promise<BrokersV2Hold> => {
  
  return customFetch<BrokersV2Hold>(getPostBrokersTasksTaskTypesTaskTypeHoldsUrl(taskType),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersTasksTaskTypesTaskTypeHolds,)
  }
);}




export const getPostBrokersTasksTaskTypesTaskTypeHoldsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeHolds>>, TError,{taskType: string;data: PostBrokersTasksTaskTypesTaskTypeHolds}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeHolds>>, TError,{taskType: string;data: PostBrokersTasksTaskTypesTaskTypeHolds}, TContext> => {

const mutationKey = ['postBrokersTasksTaskTypesTaskTypeHolds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeHolds>>, {taskType: string;data: PostBrokersTasksTaskTypesTaskTypeHolds}> = (props) => {
          const {taskType,data} = props ?? {};

          return  postBrokersTasksTaskTypesTaskTypeHolds(taskType,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksTaskTypesTaskTypeHoldsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeHolds>>>
    export type PostBrokersTasksTaskTypesTaskTypeHoldsMutationBody = PostBrokersTasksTaskTypesTaskTypeHolds
    export type PostBrokersTasksTaskTypesTaskTypeHoldsMutationError = unknown

    export const usePostBrokersTasksTaskTypesTaskTypeHolds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeHolds>>, TError,{taskType: string;data: PostBrokersTasksTaskTypesTaskTypeHolds}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksTaskTypesTaskTypeHolds>>,
        TError,
        {taskType: string;data: PostBrokersTasksTaskTypesTaskTypeHolds},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksTaskTypesTaskTypeHoldsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get V2 task statistics (overall)
 */
export const getGetBrokersTasksV2StatisticsUrl = (params?: GetBrokersTasksV2StatisticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tasks/v2_statistics?${stringifiedParams}` : `/api/web/brokers/tasks/v2_statistics`
}

export const getBrokersTasksV2Statistics = async (params?: GetBrokersTasksV2StatisticsParams, options?: RequestInit): Promise<BrokersV2TaskStatistics> => {
  
  return customFetch<BrokersV2TaskStatistics>(getGetBrokersTasksV2StatisticsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksV2StatisticsQueryKey = (params?: GetBrokersTasksV2StatisticsParams,) => {
    return [
    `/api/web/brokers/tasks/v2_statistics`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTasksV2StatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError = unknown>(params?: GetBrokersTasksV2StatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksV2StatisticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>> = ({ signal }) => getBrokersTasksV2Statistics(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksV2StatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>>
export type GetBrokersTasksV2StatisticsQueryError = unknown


export function useGetBrokersTasksV2Statistics<TData = Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError = unknown>(
 params: undefined |  GetBrokersTasksV2StatisticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksV2Statistics<TData = Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError = unknown>(
 params?: GetBrokersTasksV2StatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksV2Statistics<TData = Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError = unknown>(
 params?: GetBrokersTasksV2StatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksV2Statistics<TData = Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError = unknown>(
 params?: GetBrokersTasksV2StatisticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Statistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksV2StatisticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all V2 holds with filtering
 */
export const getGetBrokersTasksV2HoldsUrl = (params?: GetBrokersTasksV2HoldsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tasks/v2_holds?${stringifiedParams}` : `/api/web/brokers/tasks/v2_holds`
}

export const getBrokersTasksV2Holds = async (params?: GetBrokersTasksV2HoldsParams, options?: RequestInit): Promise<BrokersV2Hold[]> => {
  
  return customFetch<BrokersV2Hold[]>(getGetBrokersTasksV2HoldsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksV2HoldsQueryKey = (params?: GetBrokersTasksV2HoldsParams,) => {
    return [
    `/api/web/brokers/tasks/v2_holds`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTasksV2HoldsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError = unknown>(params?: GetBrokersTasksV2HoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksV2HoldsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>> = ({ signal }) => getBrokersTasksV2Holds(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksV2HoldsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>>
export type GetBrokersTasksV2HoldsQueryError = unknown


export function useGetBrokersTasksV2Holds<TData = Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError = unknown>(
 params: undefined |  GetBrokersTasksV2HoldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksV2Holds>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksV2Holds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksV2Holds<TData = Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError = unknown>(
 params?: GetBrokersTasksV2HoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksV2Holds>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksV2Holds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksV2Holds<TData = Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError = unknown>(
 params?: GetBrokersTasksV2HoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksV2Holds<TData = Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError = unknown>(
 params?: GetBrokersTasksV2HoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2Holds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksV2HoldsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new V2 hold for a task type
 */
export const getPostBrokersTasksV2HoldsUrl = () => {


  

  return `/api/web/brokers/tasks/v2_holds`
}

export const postBrokersTasksV2Holds = async (postBrokersTasksV2Holds: PostBrokersTasksV2Holds, options?: RequestInit): Promise<BrokersV2Hold> => {
  
  return customFetch<BrokersV2Hold>(getPostBrokersTasksV2HoldsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersTasksV2Holds,)
  }
);}




export const getPostBrokersTasksV2HoldsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksV2Holds>>, TError,{data: PostBrokersTasksV2Holds}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksV2Holds>>, TError,{data: PostBrokersTasksV2Holds}, TContext> => {

const mutationKey = ['postBrokersTasksV2Holds'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksV2Holds>>, {data: PostBrokersTasksV2Holds}> = (props) => {
          const {data} = props ?? {};

          return  postBrokersTasksV2Holds(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksV2HoldsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksV2Holds>>>
    export type PostBrokersTasksV2HoldsMutationBody = PostBrokersTasksV2Holds
    export type PostBrokersTasksV2HoldsMutationError = unknown

    export const usePostBrokersTasksV2Holds = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksV2Holds>>, TError,{data: PostBrokersTasksV2Holds}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksV2Holds>>,
        TError,
        {data: PostBrokersTasksV2Holds},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksV2HoldsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a specific V2 hold
 */
export const getGetBrokersTasksV2HoldsHoldIdUrl = (holdId: string,) => {


  

  return `/api/web/brokers/tasks/v2_holds/${holdId}`
}

export const getBrokersTasksV2HoldsHoldId = async (holdId: string, options?: RequestInit): Promise<BrokersV2Hold> => {
  
  return customFetch<BrokersV2Hold>(getGetBrokersTasksV2HoldsHoldIdUrl(holdId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksV2HoldsHoldIdQueryKey = (holdId?: string,) => {
    return [
    `/api/web/brokers/tasks/v2_holds/${holdId}`
    ] as const;
    }

    
export const getGetBrokersTasksV2HoldsHoldIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError = unknown>(holdId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksV2HoldsHoldIdQueryKey(holdId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>> = ({ signal }) => getBrokersTasksV2HoldsHoldId(holdId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(holdId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksV2HoldsHoldIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>>
export type GetBrokersTasksV2HoldsHoldIdQueryError = unknown


export function useGetBrokersTasksV2HoldsHoldId<TData = Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError = unknown>(
 holdId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksV2HoldsHoldId<TData = Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError = unknown>(
 holdId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksV2HoldsHoldId<TData = Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError = unknown>(
 holdId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksV2HoldsHoldId<TData = Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError = unknown>(
 holdId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksV2HoldsHoldId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksV2HoldsHoldIdQueryOptions(holdId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete a V2 hold
 */
export const getDeleteBrokersTasksV2HoldsHoldIdUrl = (holdId: string,) => {


  

  return `/api/web/brokers/tasks/v2_holds/${holdId}`
}

export const deleteBrokersTasksV2HoldsHoldId = async (holdId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeleteBrokersTasksV2HoldsHoldIdUrl(holdId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteBrokersTasksV2HoldsHoldIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersTasksV2HoldsHoldId>>, TError,{holdId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersTasksV2HoldsHoldId>>, TError,{holdId: string}, TContext> => {

const mutationKey = ['deleteBrokersTasksV2HoldsHoldId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrokersTasksV2HoldsHoldId>>, {holdId: string}> = (props) => {
          const {holdId} = props ?? {};

          return  deleteBrokersTasksV2HoldsHoldId(holdId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrokersTasksV2HoldsHoldIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrokersTasksV2HoldsHoldId>>>
    
    export type DeleteBrokersTasksV2HoldsHoldIdMutationError = unknown

    export const useDeleteBrokersTasksV2HoldsHoldId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersTasksV2HoldsHoldId>>, TError,{holdId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrokersTasksV2HoldsHoldId>>,
        TError,
        {holdId: string},
        TContext
      > => {

      const mutationOptions = getDeleteBrokersTasksV2HoldsHoldIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a V2 hold (clear or reactivate)
 */
export const getPatchBrokersTasksV2HoldsHoldIdUrl = (holdId: string,) => {


  

  return `/api/web/brokers/tasks/v2_holds/${holdId}`
}

export const patchBrokersTasksV2HoldsHoldId = async (holdId: string,
    patchBrokersTasksV2HoldsHoldId: PatchBrokersTasksV2HoldsHoldId, options?: RequestInit): Promise<BrokersV2Hold> => {
  
  return customFetch<BrokersV2Hold>(getPatchBrokersTasksV2HoldsHoldIdUrl(holdId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTasksV2HoldsHoldId,)
  }
);}




export const getPatchBrokersTasksV2HoldsHoldIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksV2HoldsHoldId>>, TError,{holdId: string;data: PatchBrokersTasksV2HoldsHoldId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksV2HoldsHoldId>>, TError,{holdId: string;data: PatchBrokersTasksV2HoldsHoldId}, TContext> => {

const mutationKey = ['patchBrokersTasksV2HoldsHoldId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTasksV2HoldsHoldId>>, {holdId: string;data: PatchBrokersTasksV2HoldsHoldId}> = (props) => {
          const {holdId,data} = props ?? {};

          return  patchBrokersTasksV2HoldsHoldId(holdId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTasksV2HoldsHoldIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTasksV2HoldsHoldId>>>
    export type PatchBrokersTasksV2HoldsHoldIdMutationBody = PatchBrokersTasksV2HoldsHoldId
    export type PatchBrokersTasksV2HoldsHoldIdMutationError = unknown

    export const usePatchBrokersTasksV2HoldsHoldId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTasksV2HoldsHoldId>>, TError,{holdId: string;data: PatchBrokersTasksV2HoldsHoldId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTasksV2HoldsHoldId>>,
        TError,
        {holdId: string;data: PatchBrokersTasksV2HoldsHoldId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTasksV2HoldsHoldIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all task handlers
 */
export const getGetBrokersTasksHandlersUrl = () => {


  

  return `/api/web/brokers/tasks/handlers`
}

export const getBrokersTasksHandlers = async ( options?: RequestInit): Promise<BrokersHandler[]> => {
  
  return customFetch<BrokersHandler[]>(getGetBrokersTasksHandlersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksHandlersQueryKey = () => {
    return [
    `/api/web/brokers/tasks/handlers`
    ] as const;
    }

    
export const getGetBrokersTasksHandlersQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksHandlersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksHandlers>>> = ({ signal }) => getBrokersTasksHandlers({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksHandlersQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksHandlers>>>
export type GetBrokersTasksHandlersQueryError = unknown


export function useGetBrokersTasksHandlers<TData = Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlers<TData = Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlers>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlers<TData = Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksHandlers<TData = Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksHandlersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get task statistics for a specific handler
 */
export const getGetBrokersTasksHandlersHandlerNameStatisticsUrl = (handlerName: string,) => {


  

  return `/api/web/brokers/tasks/handlers/${handlerName}/statistics`
}

export const getBrokersTasksHandlersHandlerNameStatistics = async (handlerName: string, options?: RequestInit): Promise<BrokersJobStatistics> => {
  
  return customFetch<BrokersJobStatistics>(getGetBrokersTasksHandlersHandlerNameStatisticsUrl(handlerName),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksHandlersHandlerNameStatisticsQueryKey = (handlerName?: string,) => {
    return [
    `/api/web/brokers/tasks/handlers/${handlerName}/statistics`
    ] as const;
    }

    
export const getGetBrokersTasksHandlersHandlerNameStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError = unknown>(handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksHandlersHandlerNameStatisticsQueryKey(handlerName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>> = ({ signal }) => getBrokersTasksHandlersHandlerNameStatistics(handlerName, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(handlerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksHandlersHandlerNameStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>>
export type GetBrokersTasksHandlersHandlerNameStatisticsQueryError = unknown


export function useGetBrokersTasksHandlersHandlerNameStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError = unknown>(
 handlerName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlersHandlerNameStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlersHandlerNameStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksHandlersHandlerNameStatistics<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameStatistics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksHandlersHandlerNameStatisticsQueryOptions(handlerName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all jobs for a specific handler
 */
export const getGetBrokersTasksHandlersHandlerNameJobsUrl = (handlerName: string,) => {


  

  return `/api/web/brokers/tasks/handlers/${handlerName}/jobs`
}

export const getBrokersTasksHandlersHandlerNameJobs = async (handlerName: string, options?: RequestInit): Promise<BrokersTaskJob[]> => {
  
  return customFetch<BrokersTaskJob[]>(getGetBrokersTasksHandlersHandlerNameJobsUrl(handlerName),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksHandlersHandlerNameJobsQueryKey = (handlerName?: string,) => {
    return [
    `/api/web/brokers/tasks/handlers/${handlerName}/jobs`
    ] as const;
    }

    
export const getGetBrokersTasksHandlersHandlerNameJobsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError = unknown>(handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksHandlersHandlerNameJobsQueryKey(handlerName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>> = ({ signal }) => getBrokersTasksHandlersHandlerNameJobs(handlerName, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(handlerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksHandlersHandlerNameJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>>
export type GetBrokersTasksHandlersHandlerNameJobsQueryError = unknown


export function useGetBrokersTasksHandlersHandlerNameJobs<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError = unknown>(
 handlerName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlersHandlerNameJobs<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlersHandlerNameJobs<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksHandlersHandlerNameJobs<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksHandlersHandlerNameJobsQueryOptions(handlerName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new job for a specific handler
 */
export const getPostBrokersTasksHandlersHandlerNameJobsUrl = (handlerName: string,) => {


  

  return `/api/web/brokers/tasks/handlers/${handlerName}/jobs`
}

export const postBrokersTasksHandlersHandlerNameJobs = async (handlerName: string,
    postBrokersTasksHandlersHandlerNameJobs: PostBrokersTasksHandlersHandlerNameJobs, options?: RequestInit): Promise<BrokersTaskJob> => {
  
  return customFetch<BrokersTaskJob>(getPostBrokersTasksHandlersHandlerNameJobsUrl(handlerName),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersTasksHandlersHandlerNameJobs,)
  }
);}




export const getPostBrokersTasksHandlersHandlerNameJobsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksHandlersHandlerNameJobs>>, TError,{handlerName: string;data: PostBrokersTasksHandlersHandlerNameJobs}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksHandlersHandlerNameJobs>>, TError,{handlerName: string;data: PostBrokersTasksHandlersHandlerNameJobs}, TContext> => {

const mutationKey = ['postBrokersTasksHandlersHandlerNameJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksHandlersHandlerNameJobs>>, {handlerName: string;data: PostBrokersTasksHandlersHandlerNameJobs}> = (props) => {
          const {handlerName,data} = props ?? {};

          return  postBrokersTasksHandlersHandlerNameJobs(handlerName,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksHandlersHandlerNameJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksHandlersHandlerNameJobs>>>
    export type PostBrokersTasksHandlersHandlerNameJobsMutationBody = PostBrokersTasksHandlersHandlerNameJobs
    export type PostBrokersTasksHandlersHandlerNameJobsMutationError = unknown

    export const usePostBrokersTasksHandlersHandlerNameJobs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksHandlersHandlerNameJobs>>, TError,{handlerName: string;data: PostBrokersTasksHandlersHandlerNameJobs}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksHandlersHandlerNameJobs>>,
        TError,
        {handlerName: string;data: PostBrokersTasksHandlersHandlerNameJobs},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksHandlersHandlerNameJobsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get job summaries with task statistics for a specific handler
 */
export const getGetBrokersTasksHandlersHandlerNameJobsSummaryUrl = (handlerName: string,) => {


  

  return `/api/web/brokers/tasks/handlers/${handlerName}/jobs/summary`
}

export const getBrokersTasksHandlersHandlerNameJobsSummary = async (handlerName: string, options?: RequestInit): Promise<BrokersJobSummary[]> => {
  
  return customFetch<BrokersJobSummary[]>(getGetBrokersTasksHandlersHandlerNameJobsSummaryUrl(handlerName),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksHandlersHandlerNameJobsSummaryQueryKey = (handlerName?: string,) => {
    return [
    `/api/web/brokers/tasks/handlers/${handlerName}/jobs/summary`
    ] as const;
    }

    
export const getGetBrokersTasksHandlersHandlerNameJobsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError = unknown>(handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksHandlersHandlerNameJobsSummaryQueryKey(handlerName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>> = ({ signal }) => getBrokersTasksHandlersHandlerNameJobsSummary(handlerName, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(handlerName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksHandlersHandlerNameJobsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>>
export type GetBrokersTasksHandlersHandlerNameJobsSummaryQueryError = unknown


export function useGetBrokersTasksHandlersHandlerNameJobsSummary<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError = unknown>(
 handlerName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlersHandlerNameJobsSummary<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksHandlersHandlerNameJobsSummary<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksHandlersHandlerNameJobsSummary<TData = Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError = unknown>(
 handlerName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksHandlersHandlerNameJobsSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksHandlersHandlerNameJobsSummaryQueryOptions(handlerName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get individual task details
 */
export const getGetBrokersTasksTaskIdUrl = (taskId: string,) => {


  

  return `/api/web/brokers/tasks/${taskId}`
}

export const getBrokersTasksTaskId = async (taskId: string, options?: RequestInit): Promise<BrokersTaskDetail> => {
  
  return customFetch<BrokersTaskDetail>(getGetBrokersTasksTaskIdUrl(taskId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksTaskIdQueryKey = (taskId?: string,) => {
    return [
    `/api/web/brokers/tasks/${taskId}`
    ] as const;
    }

    
export const getGetBrokersTasksTaskIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError = unknown>(taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksTaskIdQueryKey(taskId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksTaskId>>> = ({ signal }) => getBrokersTasksTaskId(taskId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(taskId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksTaskIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksTaskId>>>
export type GetBrokersTasksTaskIdQueryError = unknown


export function useGetBrokersTasksTaskId<TData = Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError = unknown>(
 taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskId<TData = Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksTaskId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksTaskId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksTaskId<TData = Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksTaskId<TData = Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksTaskId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksTaskIdQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List task execution results ordered by start time (newest first)
 */
export const getGetBrokersTasksByIdTaskIdResultsUrl = (taskId: string,) => {


  

  return `/api/web/brokers/tasks/by_id/${taskId}/results`
}

export const getBrokersTasksByIdTaskIdResults = async (taskId: string, options?: RequestInit): Promise<BrokersTaskResult[]> => {
  
  return customFetch<BrokersTaskResult[]>(getGetBrokersTasksByIdTaskIdResultsUrl(taskId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksByIdTaskIdResultsQueryKey = (taskId?: string,) => {
    return [
    `/api/web/brokers/tasks/by_id/${taskId}/results`
    ] as const;
    }

    
export const getGetBrokersTasksByIdTaskIdResultsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError = unknown>(taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksByIdTaskIdResultsQueryKey(taskId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>> = ({ signal }) => getBrokersTasksByIdTaskIdResults(taskId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(taskId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksByIdTaskIdResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>>
export type GetBrokersTasksByIdTaskIdResultsQueryError = unknown


export function useGetBrokersTasksByIdTaskIdResults<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError = unknown>(
 taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksByIdTaskIdResults<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksByIdTaskIdResults<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksByIdTaskIdResults<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError = unknown>(
 taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksByIdTaskIdResultsQueryOptions(taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Build a Playwright execution command for the task
 */
export const getGetBrokersTasksByIdTaskIdPlaywrightCommandUrl = (taskId: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tasks/by_id/${taskId}/playwright_command?${stringifiedParams}` : `/api/web/brokers/tasks/by_id/${taskId}/playwright_command`
}

export const getBrokersTasksByIdTaskIdPlaywrightCommand = async (taskId: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams, options?: RequestInit): Promise<BrokersTaskCommand> => {
  
  return customFetch<BrokersTaskCommand>(getGetBrokersTasksByIdTaskIdPlaywrightCommandUrl(taskId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksByIdTaskIdPlaywrightCommandQueryKey = (taskId?: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams,) => {
    return [
    `/api/web/brokers/tasks/by_id/${taskId}/playwright_command`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTasksByIdTaskIdPlaywrightCommandQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError = unknown>(taskId: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksByIdTaskIdPlaywrightCommandQueryKey(taskId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>> = ({ signal }) => getBrokersTasksByIdTaskIdPlaywrightCommand(taskId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(taskId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksByIdTaskIdPlaywrightCommandQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>>
export type GetBrokersTasksByIdTaskIdPlaywrightCommandQueryError = unknown


export function useGetBrokersTasksByIdTaskIdPlaywrightCommand<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError = unknown>(
 taskId: string,
    params: undefined |  GetBrokersTasksByIdTaskIdPlaywrightCommandParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksByIdTaskIdPlaywrightCommand<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError = unknown>(
 taskId: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksByIdTaskIdPlaywrightCommand<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError = unknown>(
 taskId: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksByIdTaskIdPlaywrightCommand<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError = unknown>(
 taskId: string,
    params?: GetBrokersTasksByIdTaskIdPlaywrightCommandParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdPlaywrightCommand>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksByIdTaskIdPlaywrightCommandQueryOptions(taskId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Clear the execution lease for the task
 */
export const getDeleteBrokersTasksByIdTaskIdLeaseUrl = (taskId: string,
    params?: DeleteBrokersTasksByIdTaskIdLeaseParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/tasks/by_id/${taskId}/lease?${stringifiedParams}` : `/api/web/brokers/tasks/by_id/${taskId}/lease`
}

export const deleteBrokersTasksByIdTaskIdLease = async (taskId: string,
    params?: DeleteBrokersTasksByIdTaskIdLeaseParams, options?: RequestInit): Promise<BrokersTaskDetail> => {
  
  return customFetch<BrokersTaskDetail>(getDeleteBrokersTasksByIdTaskIdLeaseUrl(taskId,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteBrokersTasksByIdTaskIdLeaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersTasksByIdTaskIdLease>>, TError,{taskId: string;params?: DeleteBrokersTasksByIdTaskIdLeaseParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersTasksByIdTaskIdLease>>, TError,{taskId: string;params?: DeleteBrokersTasksByIdTaskIdLeaseParams}, TContext> => {

const mutationKey = ['deleteBrokersTasksByIdTaskIdLease'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrokersTasksByIdTaskIdLease>>, {taskId: string;params?: DeleteBrokersTasksByIdTaskIdLeaseParams}> = (props) => {
          const {taskId,params} = props ?? {};

          return  deleteBrokersTasksByIdTaskIdLease(taskId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrokersTasksByIdTaskIdLeaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrokersTasksByIdTaskIdLease>>>
    
    export type DeleteBrokersTasksByIdTaskIdLeaseMutationError = unknown

    export const useDeleteBrokersTasksByIdTaskIdLease = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrokersTasksByIdTaskIdLease>>, TError,{taskId: string;params?: DeleteBrokersTasksByIdTaskIdLeaseParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrokersTasksByIdTaskIdLease>>,
        TError,
        {taskId: string;params?: DeleteBrokersTasksByIdTaskIdLeaseParams},
        TContext
      > => {

      const mutationOptions = getDeleteBrokersTasksByIdTaskIdLeaseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Queue automated execution for the task if it is ready
 */
export const getPostBrokersTasksByIdTaskIdExecuteUrl = (taskId: string,) => {


  

  return `/api/web/brokers/tasks/by_id/${taskId}/execute`
}

export const postBrokersTasksByIdTaskIdExecute = async (taskId: string, options?: RequestInit): Promise<BrokersTaskDetail> => {
  
  return customFetch<BrokersTaskDetail>(getPostBrokersTasksByIdTaskIdExecuteUrl(taskId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersTasksByIdTaskIdExecuteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdExecute>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdExecute>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['postBrokersTasksByIdTaskIdExecute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdExecute>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  postBrokersTasksByIdTaskIdExecute(taskId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksByIdTaskIdExecuteMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdExecute>>>
    
    export type PostBrokersTasksByIdTaskIdExecuteMutationError = unknown

    export const usePostBrokersTasksByIdTaskIdExecute = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdExecute>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdExecute>>,
        TError,
        {taskId: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksByIdTaskIdExecuteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Reset the task status to pending
 */
export const getPostBrokersTasksByIdTaskIdResetToPendingUrl = (taskId: string,) => {


  

  return `/api/web/brokers/tasks/by_id/${taskId}/reset_to_pending`
}

export const postBrokersTasksByIdTaskIdResetToPending = async (taskId: string, options?: RequestInit): Promise<BrokersTaskDetail> => {
  
  return customFetch<BrokersTaskDetail>(getPostBrokersTasksByIdTaskIdResetToPendingUrl(taskId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostBrokersTasksByIdTaskIdResetToPendingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdResetToPending>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdResetToPending>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['postBrokersTasksByIdTaskIdResetToPending'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdResetToPending>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  postBrokersTasksByIdTaskIdResetToPending(taskId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTasksByIdTaskIdResetToPendingMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdResetToPending>>>
    
    export type PostBrokersTasksByIdTaskIdResetToPendingMutationError = unknown

    export const usePostBrokersTasksByIdTaskIdResetToPending = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdResetToPending>>, TError,{taskId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTasksByIdTaskIdResetToPending>>,
        TError,
        {taskId: string},
        TContext
      > => {

      const mutationOptions = getPostBrokersTasksByIdTaskIdResetToPendingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get detailed information for a specific task result
 */
export const getGetBrokersTasksByIdTaskIdResultsResultIdUrl = (taskId: string,
    resultId: string,) => {


  

  return `/api/web/brokers/tasks/by_id/${taskId}/results/${resultId}`
}

export const getBrokersTasksByIdTaskIdResultsResultId = async (taskId: string,
    resultId: string, options?: RequestInit): Promise<BrokersTaskResult> => {
  
  return customFetch<BrokersTaskResult>(getGetBrokersTasksByIdTaskIdResultsResultIdUrl(taskId,resultId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTasksByIdTaskIdResultsResultIdQueryKey = (taskId?: string,
    resultId?: string,) => {
    return [
    `/api/web/brokers/tasks/by_id/${taskId}/results/${resultId}`
    ] as const;
    }

    
export const getGetBrokersTasksByIdTaskIdResultsResultIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError = unknown>(taskId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTasksByIdTaskIdResultsResultIdQueryKey(taskId,resultId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>> = ({ signal }) => getBrokersTasksByIdTaskIdResultsResultId(taskId,resultId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(taskId && resultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTasksByIdTaskIdResultsResultIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>>
export type GetBrokersTasksByIdTaskIdResultsResultIdQueryError = unknown


export function useGetBrokersTasksByIdTaskIdResultsResultId<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError = unknown>(
 taskId: string,
    resultId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksByIdTaskIdResultsResultId<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError = unknown>(
 taskId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTasksByIdTaskIdResultsResultId<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError = unknown>(
 taskId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTasksByIdTaskIdResultsResultId<TData = Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError = unknown>(
 taskId: string,
    resultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTasksByIdTaskIdResultsResultId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTasksByIdTaskIdResultsResultIdQueryOptions(taskId,resultId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get Coverage Audit Logs w/ filtering and sorting
 */
export const getGetBrokersCoverageAuditLogsUrl = (params?: GetBrokersCoverageAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filters[member_ids][]","filters[reasons][]","filters[actions][]","filters[target_types][]","filters[created_by_broker_id][]","filters[corrected_by_broker_id][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/coverage_audit_logs?${stringifiedParams}` : `/api/web/brokers/coverage_audit_logs`
}

export const getBrokersCoverageAuditLogs = async (params?: GetBrokersCoverageAuditLogsParams, options?: RequestInit): Promise<BrokersPaginatedCoverageAuditLogList> => {
  
  return customFetch<BrokersPaginatedCoverageAuditLogList>(getGetBrokersCoverageAuditLogsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersCoverageAuditLogsQueryKey = (params?: GetBrokersCoverageAuditLogsParams,) => {
    return [
    `/api/web/brokers/coverage_audit_logs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersCoverageAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError = unknown>(params?: GetBrokersCoverageAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersCoverageAuditLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>> = ({ signal }) => getBrokersCoverageAuditLogs(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersCoverageAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>>
export type GetBrokersCoverageAuditLogsQueryError = unknown


export function useGetBrokersCoverageAuditLogs<TData = Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError = unknown>(
 params: undefined |  GetBrokersCoverageAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersCoverageAuditLogs<TData = Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError = unknown>(
 params?: GetBrokersCoverageAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersCoverageAuditLogs<TData = Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError = unknown>(
 params?: GetBrokersCoverageAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersCoverageAuditLogs<TData = Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError = unknown>(
 params?: GetBrokersCoverageAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersCoverageAuditLogs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersCoverageAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update a coverage audit log reason
 */
export const getPatchBrokersCoverageAuditLogsAuditLogIdUrl = (auditLogId: string,) => {


  

  return `/api/web/brokers/coverage_audit_logs/${auditLogId}`
}

export const patchBrokersCoverageAuditLogsAuditLogId = async (auditLogId: string,
    patchBrokersCoverageAuditLogsAuditLogId: PatchBrokersCoverageAuditLogsAuditLogId, options?: RequestInit): Promise<BrokersCoverageAuditLog> => {
  
  return customFetch<BrokersCoverageAuditLog>(getPatchBrokersCoverageAuditLogsAuditLogIdUrl(auditLogId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersCoverageAuditLogsAuditLogId,)
  }
);}




export const getPatchBrokersCoverageAuditLogsAuditLogIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersCoverageAuditLogsAuditLogId>>, TError,{auditLogId: string;data: PatchBrokersCoverageAuditLogsAuditLogId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersCoverageAuditLogsAuditLogId>>, TError,{auditLogId: string;data: PatchBrokersCoverageAuditLogsAuditLogId}, TContext> => {

const mutationKey = ['patchBrokersCoverageAuditLogsAuditLogId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersCoverageAuditLogsAuditLogId>>, {auditLogId: string;data: PatchBrokersCoverageAuditLogsAuditLogId}> = (props) => {
          const {auditLogId,data} = props ?? {};

          return  patchBrokersCoverageAuditLogsAuditLogId(auditLogId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersCoverageAuditLogsAuditLogIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersCoverageAuditLogsAuditLogId>>>
    export type PatchBrokersCoverageAuditLogsAuditLogIdMutationBody = PatchBrokersCoverageAuditLogsAuditLogId
    export type PatchBrokersCoverageAuditLogsAuditLogIdMutationError = unknown

    export const usePatchBrokersCoverageAuditLogsAuditLogId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersCoverageAuditLogsAuditLogId>>, TError,{auditLogId: string;data: PatchBrokersCoverageAuditLogsAuditLogId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersCoverageAuditLogsAuditLogId>>,
        TError,
        {auditLogId: string;data: PatchBrokersCoverageAuditLogsAuditLogId},
        TContext
      > => {

      const mutationOptions = getPatchBrokersCoverageAuditLogsAuditLogIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Workflows w/ filtering and sorting
 */
export const getGetBrokersTaskWorkflowsUrl = (params?: GetBrokersTaskWorkflowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filters[statuses][]","filters[workflow_types][]","filters[enrollment_ids][]","filters[member_ids][]","filters[broker_ids][]","filters[brokerage_ids][]","filters[carrier_names][]","filters[enrollment_categories][]","filters[employer_ids][]","filters[employer_review_statuses][]","filters[enrollment_event_types][]","filters[coverage_types][]","filters[next_task_execution_methods][]","filters[next_task_execution_contexts][]","filters[next_task_statuses][]","filters[workflow_task_types][]","filters[workflow_task_statuses][]","filters[workflow_task_execution_methods][]","filters[workflow_task_execution_contexts][]","filters[workflow_task_categories][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/brokers/task_workflows?${stringifiedParams}` : `/api/web/brokers/task_workflows`
}

export const getBrokersTaskWorkflows = async (params?: GetBrokersTaskWorkflowsParams, options?: RequestInit): Promise<BrokersPaginatedWorkflowList> => {
  
  return customFetch<BrokersPaginatedWorkflowList>(getGetBrokersTaskWorkflowsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTaskWorkflowsQueryKey = (params?: GetBrokersTaskWorkflowsParams,) => {
    return [
    `/api/web/brokers/task_workflows`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBrokersTaskWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError = unknown>(params?: GetBrokersTaskWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTaskWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>> = ({ signal }) => getBrokersTaskWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTaskWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>>
export type GetBrokersTaskWorkflowsQueryError = unknown


export function useGetBrokersTaskWorkflows<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError = unknown>(
 params: undefined |  GetBrokersTaskWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTaskWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTaskWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTaskWorkflows<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError = unknown>(
 params?: GetBrokersTaskWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTaskWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTaskWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTaskWorkflows<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError = unknown>(
 params?: GetBrokersTaskWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTaskWorkflows<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError = unknown>(
 params?: GetBrokersTaskWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTaskWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Bulk update workflows with AASM transitions and broker assignments
 */
export const getPatchBrokersTaskWorkflowsUrl = () => {


  

  return `/api/web/brokers/task_workflows`
}

export const patchBrokersTaskWorkflows = async (patchBrokersTaskWorkflows: PatchBrokersTaskWorkflows, options?: RequestInit): Promise<BrokersWorkflow[]> => {
  
  return customFetch<BrokersWorkflow[]>(getPatchBrokersTaskWorkflowsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchBrokersTaskWorkflows,)
  }
);}




export const getPatchBrokersTaskWorkflowsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTaskWorkflows>>, TError,{data: PatchBrokersTaskWorkflows}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTaskWorkflows>>, TError,{data: PatchBrokersTaskWorkflows}, TContext> => {

const mutationKey = ['patchBrokersTaskWorkflows'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBrokersTaskWorkflows>>, {data: PatchBrokersTaskWorkflows}> = (props) => {
          const {data} = props ?? {};

          return  patchBrokersTaskWorkflows(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBrokersTaskWorkflowsMutationResult = NonNullable<Awaited<ReturnType<typeof patchBrokersTaskWorkflows>>>
    export type PatchBrokersTaskWorkflowsMutationBody = PatchBrokersTaskWorkflows
    export type PatchBrokersTaskWorkflowsMutationError = unknown

    export const usePatchBrokersTaskWorkflows = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBrokersTaskWorkflows>>, TError,{data: PatchBrokersTaskWorkflows}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBrokersTaskWorkflows>>,
        TError,
        {data: PatchBrokersTaskWorkflows},
        TContext
      > => {

      const mutationOptions = getPatchBrokersTaskWorkflowsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get single workflow by ID
 */
export const getGetBrokersTaskWorkflowsIdUrl = (id: string,) => {


  

  return `/api/web/brokers/task_workflows/${id}`
}

export const getBrokersTaskWorkflowsId = async (id: string, options?: RequestInit): Promise<BrokersWorkflow> => {
  
  return customFetch<BrokersWorkflow>(getGetBrokersTaskWorkflowsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetBrokersTaskWorkflowsIdQueryKey = (id?: string,) => {
    return [
    `/api/web/brokers/task_workflows/${id}`
    ] as const;
    }

    
export const getGetBrokersTaskWorkflowsIdQueryOptions = <TData = Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrokersTaskWorkflowsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>> = ({ signal }) => getBrokersTaskWorkflowsId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrokersTaskWorkflowsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>>
export type GetBrokersTaskWorkflowsIdQueryError = unknown


export function useGetBrokersTaskWorkflowsId<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTaskWorkflowsId<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>,
          TError,
          Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrokersTaskWorkflowsId<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBrokersTaskWorkflowsId<TData = Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrokersTaskWorkflowsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrokersTaskWorkflowsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Trigger workflow state transition
 */
export const getPostBrokersTaskWorkflowsIdActionUrl = (id: string,
    action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback',) => {


  

  return `/api/web/brokers/task_workflows/${id}/${action}`
}

export const postBrokersTaskWorkflowsIdAction = async (id: string,
    action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback',
    postBrokersTaskWorkflowsIdAction: PostBrokersTaskWorkflowsIdAction, options?: RequestInit): Promise<BrokersWorkflow> => {
  
  return customFetch<BrokersWorkflow>(getPostBrokersTaskWorkflowsIdActionUrl(id,action),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postBrokersTaskWorkflowsIdAction,)
  }
);}




export const getPostBrokersTaskWorkflowsIdActionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTaskWorkflowsIdAction>>, TError,{id: string;action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback';data: PostBrokersTaskWorkflowsIdAction}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postBrokersTaskWorkflowsIdAction>>, TError,{id: string;action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback';data: PostBrokersTaskWorkflowsIdAction}, TContext> => {

const mutationKey = ['postBrokersTaskWorkflowsIdAction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBrokersTaskWorkflowsIdAction>>, {id: string;action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback';data: PostBrokersTaskWorkflowsIdAction}> = (props) => {
          const {id,action,data} = props ?? {};

          return  postBrokersTaskWorkflowsIdAction(id,action,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBrokersTaskWorkflowsIdActionMutationResult = NonNullable<Awaited<ReturnType<typeof postBrokersTaskWorkflowsIdAction>>>
    export type PostBrokersTaskWorkflowsIdActionMutationBody = PostBrokersTaskWorkflowsIdAction
    export type PostBrokersTaskWorkflowsIdActionMutationError = unknown

    export const usePostBrokersTaskWorkflowsIdAction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBrokersTaskWorkflowsIdAction>>, TError,{id: string;action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback';data: PostBrokersTaskWorkflowsIdAction}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBrokersTaskWorkflowsIdAction>>,
        TError,
        {id: string;action: 'start' | 'complete' | 'cancel' | 'pause' | 'resume' | 'reopen' | 'rollback';data: PostBrokersTaskWorkflowsIdAction},
        TContext
      > => {

      const mutationOptions = getPostBrokersTaskWorkflowsIdActionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get enabled payroll provider configs
 */
export const getGetQuotingPayrollProviderConfigsUrl = () => {


  

  return `/api/web/quoting/payroll_provider_configs`
}

export const getQuotingPayrollProviderConfigs = async ( options?: RequestInit): Promise<PayrollProviderConfigList> => {
  
  return customFetch<PayrollProviderConfigList>(getGetQuotingPayrollProviderConfigsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingPayrollProviderConfigsQueryKey = () => {
    return [
    `/api/web/quoting/payroll_provider_configs`
    ] as const;
    }

    
export const getGetQuotingPayrollProviderConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingPayrollProviderConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>> = ({ signal }) => getQuotingPayrollProviderConfigs({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingPayrollProviderConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>>
export type GetQuotingPayrollProviderConfigsQueryError = unknown


export function useGetQuotingPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>,
          TError,
          Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>,
          TError,
          Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingPayrollProviderConfigs<TData = Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPayrollProviderConfigs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingPayrollProviderConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List prospects
 */
export const getGetQuotingProspectsUrl = (params?: GetQuotingProspectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/prospects?${stringifiedParams}` : `/api/web/quoting/prospects`
}

export const getQuotingProspects = async (params?: GetQuotingProspectsParams, options?: RequestInit): Promise<QuotingPaginatedProspectList> => {
  
  return customFetch<QuotingPaginatedProspectList>(getGetQuotingProspectsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsQueryKey = (params?: GetQuotingProspectsParams,) => {
    return [
    `/api/web/quoting/prospects`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingProspectsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspects>>, TError = unknown>(params?: GetQuotingProspectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspects>>> = ({ signal }) => getQuotingProspects(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspects>>>
export type GetQuotingProspectsQueryError = unknown


export function useGetQuotingProspects<TData = Awaited<ReturnType<typeof getQuotingProspects>>, TError = unknown>(
 params: undefined |  GetQuotingProspectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspects>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspects<TData = Awaited<ReturnType<typeof getQuotingProspects>>, TError = unknown>(
 params?: GetQuotingProspectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspects>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspects<TData = Awaited<ReturnType<typeof getQuotingProspects>>, TError = unknown>(
 params?: GetQuotingProspectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspects<TData = Awaited<ReturnType<typeof getQuotingProspects>>, TError = unknown>(
 params?: GetQuotingProspectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a prospect
 */
export const getPostQuotingProspectsUrl = () => {


  

  return `/api/web/quoting/prospects`
}

export const postQuotingProspects = async ( options?: RequestInit): Promise<QuotingProspect> => {
  
  return customFetch<QuotingProspect>(getPostQuotingProspectsUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostQuotingProspectsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspects>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspects>>, TError,void, TContext> => {

const mutationKey = ['postQuotingProspects'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspects>>, void> = () => {
          

          return  postQuotingProspects(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspects>>>
    
    export type PostQuotingProspectsMutationError = unknown

    export const usePostQuotingProspects = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspects>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspects>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Return a prospect
 */
export const getGetQuotingProspectsIdUrl = (id: string,) => {


  

  return `/api/web/quoting/prospects/${id}`
}

export const getQuotingProspectsId = async (id: string, options?: RequestInit): Promise<QuotingProspect> => {
  
  return customFetch<QuotingProspect>(getGetQuotingProspectsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsIdQueryKey = (id?: string,) => {
    return [
    `/api/web/quoting/prospects/${id}`
    ] as const;
    }

    
export const getGetQuotingProspectsIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsId>>> = ({ signal }) => getQuotingProspectsId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsId>>>
export type GetQuotingProspectsIdQueryError = unknown


export function useGetQuotingProspectsId<TData = Awaited<ReturnType<typeof getQuotingProspectsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsId<TData = Awaited<ReturnType<typeof getQuotingProspectsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsId<TData = Awaited<ReturnType<typeof getQuotingProspectsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsId<TData = Awaited<ReturnType<typeof getQuotingProspectsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update a prospect
 */
export const getPutQuotingProspectsIdUrl = (id: string,) => {


  

  return `/api/web/quoting/prospects/${id}`
}

export const putQuotingProspectsId = async (id: string,
    putQuotingProspectsId: PutQuotingProspectsId, options?: RequestInit): Promise<QuotingProspect> => {
  
  return customFetch<QuotingProspect>(getPutQuotingProspectsIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putQuotingProspectsId,)
  }
);}




export const getPutQuotingProspectsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuotingProspectsId>>, TError,{id: string;data: PutQuotingProspectsId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putQuotingProspectsId>>, TError,{id: string;data: PutQuotingProspectsId}, TContext> => {

const mutationKey = ['putQuotingProspectsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putQuotingProspectsId>>, {id: string;data: PutQuotingProspectsId}> = (props) => {
          const {id,data} = props ?? {};

          return  putQuotingProspectsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutQuotingProspectsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putQuotingProspectsId>>>
    export type PutQuotingProspectsIdMutationBody = PutQuotingProspectsId
    export type PutQuotingProspectsIdMutationError = unknown

    export const usePutQuotingProspectsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuotingProspectsId>>, TError,{id: string;data: PutQuotingProspectsId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putQuotingProspectsId>>,
        TError,
        {id: string;data: PutQuotingProspectsId},
        TContext
      > => {

      const mutationOptions = getPutQuotingProspectsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List quotes
 */
export const getGetQuotingProspectsProspectIdQuotesUrl = (prospectId: string,
    params?: GetQuotingProspectsProspectIdQuotesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/prospects/${prospectId}/quotes?${stringifiedParams}` : `/api/web/quoting/prospects/${prospectId}/quotes`
}

export const getQuotingProspectsProspectIdQuotes = async (prospectId: string,
    params?: GetQuotingProspectsProspectIdQuotesParams, options?: RequestInit): Promise<QuotingPaginatedQuoteList> => {
  
  return customFetch<QuotingPaginatedQuoteList>(getGetQuotingProspectsProspectIdQuotesUrl(prospectId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdQuotesQueryKey = (prospectId?: string,
    params?: GetQuotingProspectsProspectIdQuotesParams,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/quotes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdQuotesQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError = unknown>(prospectId: string,
    params?: GetQuotingProspectsProspectIdQuotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdQuotesQueryKey(prospectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>> = ({ signal }) => getQuotingProspectsProspectIdQuotes(prospectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdQuotesQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>>
export type GetQuotingProspectsProspectIdQuotesQueryError = unknown


export function useGetQuotingProspectsProspectIdQuotes<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError = unknown>(
 prospectId: string,
    params: undefined |  GetQuotingProspectsProspectIdQuotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotes<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError = unknown>(
 prospectId: string,
    params?: GetQuotingProspectsProspectIdQuotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotes<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError = unknown>(
 prospectId: string,
    params?: GetQuotingProspectsProspectIdQuotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdQuotes<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError = unknown>(
 prospectId: string,
    params?: GetQuotingProspectsProspectIdQuotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdQuotesQueryOptions(prospectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a quote
 */
export const getPostQuotingProspectsProspectIdQuotesUrl = (prospectId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes`
}

export const postQuotingProspectsProspectIdQuotes = async (prospectId: string,
    postQuotingProspectsProspectIdQuotes: PostQuotingProspectsProspectIdQuotes, options?: RequestInit): Promise<QuotingQuote> => {
  
  return customFetch<QuotingQuote>(getPostQuotingProspectsProspectIdQuotesUrl(prospectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdQuotes,)
  }
);}




export const getPostQuotingProspectsProspectIdQuotesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotes>>, TError,{prospectId: string;data: PostQuotingProspectsProspectIdQuotes}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotes>>, TError,{prospectId: string;data: PostQuotingProspectsProspectIdQuotes}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotes>>, {prospectId: string;data: PostQuotingProspectsProspectIdQuotes}> = (props) => {
          const {prospectId,data} = props ?? {};

          return  postQuotingProspectsProspectIdQuotes(prospectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotes>>>
    export type PostQuotingProspectsProspectIdQuotesMutationBody = PostQuotingProspectsProspectIdQuotes
    export type PostQuotingProspectsProspectIdQuotesMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotes>>, TError,{prospectId: string;data: PostQuotingProspectsProspectIdQuotes}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotes>>,
        TError,
        {prospectId: string;data: PostQuotingProspectsProspectIdQuotes},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create user consent for estimated plan pricing
 */
export const getPostQuotingProspectsProspectIdQuotesUserConsentUrl = (prospectId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/user_consent`
}

export const postQuotingProspectsProspectIdQuotesUserConsent = async (prospectId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostQuotingProspectsProspectIdQuotesUserConsentUrl(prospectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostQuotingProspectsProspectIdQuotesUserConsentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesUserConsent>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesUserConsent>>, TError,{prospectId: string}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotesUserConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesUserConsent>>, {prospectId: string}> = (props) => {
          const {prospectId} = props ?? {};

          return  postQuotingProspectsProspectIdQuotesUserConsent(prospectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesUserConsentMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesUserConsent>>>
    
    export type PostQuotingProspectsProspectIdQuotesUserConsentMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotesUserConsent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesUserConsent>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesUserConsent>>,
        TError,
        {prospectId: string},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesUserConsentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Return a quote
 */
export const getGetQuotingProspectsProspectIdQuotesIdUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${id}`
}

export const getQuotingProspectsProspectIdQuotesId = async (prospectId: string,
    id: string, options?: RequestInit): Promise<QuotingQuote> => {
  
  return customFetch<QuotingQuote>(getGetQuotingProspectsProspectIdQuotesIdUrl(prospectId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdQuotesIdQueryKey = (prospectId?: string,
    id?: string,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/quotes/${id}`
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdQuotesIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError = unknown>(prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdQuotesIdQueryKey(prospectId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>> = ({ signal }) => getQuotingProspectsProspectIdQuotesId(prospectId,id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdQuotesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>>
export type GetQuotingProspectsProspectIdQuotesIdQueryError = unknown


export function useGetQuotingProspectsProspectIdQuotesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError = unknown>(
 prospectId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdQuotesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdQuotesIdQueryOptions(prospectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Partially update a quote
 */
export const getPatchQuotingProspectsProspectIdQuotesIdUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${id}`
}

export const patchQuotingProspectsProspectIdQuotesId = async (prospectId: string,
    id: string,
    patchQuotingProspectsProspectIdQuotesId: PatchQuotingProspectsProspectIdQuotesId, options?: RequestInit): Promise<QuotingQuote> => {
  
  return customFetch<QuotingQuote>(getPatchQuotingProspectsProspectIdQuotesIdUrl(prospectId,id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchQuotingProspectsProspectIdQuotesId,)
  }
);}




export const getPatchQuotingProspectsProspectIdQuotesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQuotingProspectsProspectIdQuotesId>>, TError,{prospectId: string;id: string;data: PatchQuotingProspectsProspectIdQuotesId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchQuotingProspectsProspectIdQuotesId>>, TError,{prospectId: string;id: string;data: PatchQuotingProspectsProspectIdQuotesId}, TContext> => {

const mutationKey = ['patchQuotingProspectsProspectIdQuotesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchQuotingProspectsProspectIdQuotesId>>, {prospectId: string;id: string;data: PatchQuotingProspectsProspectIdQuotesId}> = (props) => {
          const {prospectId,id,data} = props ?? {};

          return  patchQuotingProspectsProspectIdQuotesId(prospectId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchQuotingProspectsProspectIdQuotesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchQuotingProspectsProspectIdQuotesId>>>
    export type PatchQuotingProspectsProspectIdQuotesIdMutationBody = PatchQuotingProspectsProspectIdQuotesId
    export type PatchQuotingProspectsProspectIdQuotesIdMutationError = unknown

    export const usePatchQuotingProspectsProspectIdQuotesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchQuotingProspectsProspectIdQuotesId>>, TError,{prospectId: string;id: string;data: PatchQuotingProspectsProspectIdQuotesId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchQuotingProspectsProspectIdQuotesId>>,
        TError,
        {prospectId: string;id: string;data: PatchQuotingProspectsProspectIdQuotesId},
        TContext
      > => {

      const mutationOptions = getPatchQuotingProspectsProspectIdQuotesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Notify Slack about large self-serve opportunity
 */
export const getPostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${id}/notify_slack_about_large_self_serve_opportunity`
}

export const postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity = async (prospectId: string,
    id: string,
    postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity: PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityUrl(prospectId,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity,)
  }
);}




export const getPostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity>>, TError,{prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity>>, TError,{prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity>>, {prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity}> = (props) => {
          const {prospectId,id,data} = props ?? {};

          return  postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity(prospectId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity>>>
    export type PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityMutationBody = PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity
    export type PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity>>, TError,{prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity>>,
        TError,
        {prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunity},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesIdNotifySlackAboutLargeSelfServeOpportunityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get quote generation options
 */
export const getGetQuotingProspectsProspectIdQuotesIdGenerationOptionsUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${id}/generation_options`
}

export const getQuotingProspectsProspectIdQuotesIdGenerationOptions = async (prospectId: string,
    id: string, options?: RequestInit): Promise<QuotingQuoteGenerationOptions> => {
  
  return customFetch<QuotingQuoteGenerationOptions>(getGetQuotingProspectsProspectIdQuotesIdGenerationOptionsUrl(prospectId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdQuotesIdGenerationOptionsQueryKey = (prospectId?: string,
    id?: string,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/quotes/${id}/generation_options`
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdQuotesIdGenerationOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError = unknown>(prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdQuotesIdGenerationOptionsQueryKey(prospectId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>> = ({ signal }) => getQuotingProspectsProspectIdQuotesIdGenerationOptions(prospectId,id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdQuotesIdGenerationOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>>
export type GetQuotingProspectsProspectIdQuotesIdGenerationOptionsQueryError = unknown


export function useGetQuotingProspectsProspectIdQuotesIdGenerationOptions<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError = unknown>(
 prospectId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotesIdGenerationOptions<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotesIdGenerationOptions<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdQuotesIdGenerationOptions<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesIdGenerationOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdQuotesIdGenerationOptionsQueryOptions(prospectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generate a quote
 */
export const getPostQuotingProspectsProspectIdQuotesIdGenerateUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${id}/generate`
}

export const postQuotingProspectsProspectIdQuotesIdGenerate = async (prospectId: string,
    id: string,
    postQuotingProspectsProspectIdQuotesIdGenerate: PostQuotingProspectsProspectIdQuotesIdGenerate, options?: RequestInit): Promise<QuotingQuote> => {
  
  return customFetch<QuotingQuote>(getPostQuotingProspectsProspectIdQuotesIdGenerateUrl(prospectId,id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdQuotesIdGenerate,)
  }
);}




export const getPostQuotingProspectsProspectIdQuotesIdGenerateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdGenerate>>, TError,{prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdGenerate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdGenerate>>, TError,{prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdGenerate}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotesIdGenerate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdGenerate>>, {prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdGenerate}> = (props) => {
          const {prospectId,id,data} = props ?? {};

          return  postQuotingProspectsProspectIdQuotesIdGenerate(prospectId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesIdGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdGenerate>>>
    export type PostQuotingProspectsProspectIdQuotesIdGenerateMutationBody = PostQuotingProspectsProspectIdQuotesIdGenerate
    export type PostQuotingProspectsProspectIdQuotesIdGenerateMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotesIdGenerate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdGenerate>>, TError,{prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdGenerate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdGenerate>>,
        TError,
        {prospectId: string;id: string;data: PostQuotingProspectsProspectIdQuotesIdGenerate},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesIdGenerateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Finalize a quote, allowances, and employer
 */
export const getPostQuotingProspectsProspectIdQuotesIdFinalizeUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${id}/finalize`
}

export const postQuotingProspectsProspectIdQuotesIdFinalize = async (prospectId: string,
    id: string, options?: RequestInit): Promise<QuotingQuote> => {
  
  return customFetch<QuotingQuote>(getPostQuotingProspectsProspectIdQuotesIdFinalizeUrl(prospectId,id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostQuotingProspectsProspectIdQuotesIdFinalizeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdFinalize>>, TError,{prospectId: string;id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdFinalize>>, TError,{prospectId: string;id: string}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotesIdFinalize'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdFinalize>>, {prospectId: string;id: string}> = (props) => {
          const {prospectId,id} = props ?? {};

          return  postQuotingProspectsProspectIdQuotesIdFinalize(prospectId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesIdFinalizeMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdFinalize>>>
    
    export type PostQuotingProspectsProspectIdQuotesIdFinalizeMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotesIdFinalize = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdFinalize>>, TError,{prospectId: string;id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesIdFinalize>>,
        TError,
        {prospectId: string;id: string},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesIdFinalizeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List Benchmarks
 */
export const getGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksUrl = (prospectId: string,
    quoteId: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/benchmarks?${stringifiedParams}` : `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/benchmarks`
}

export const getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks = async (prospectId: string,
    quoteId: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksUrl(prospectId,quoteId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksQueryKey = (prospectId?: string,
    quoteId?: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/benchmarks`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError = unknown>(prospectId: string,
    quoteId: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksQueryKey(prospectId,quoteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>> = ({ signal }) => getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks(prospectId,quoteId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId && quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>>
export type GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksQueryError = unknown


export function useGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarks<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError = unknown>(
 prospectId: string,
    quoteId: string,
    params: undefined |  GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarks<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError = unknown>(
 prospectId: string,
    quoteId: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarks<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError = unknown>(
 prospectId: string,
    quoteId: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarks<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError = unknown>(
 prospectId: string,
    quoteId: string,
    params?: GetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdQuotesQuoteIdBenchmarksQueryOptions(prospectId,quoteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generate Benchmarks
 */
export const getPostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksUrl = (prospectId: string,
    quoteId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/benchmarks`
}

export const postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks = async (prospectId: string,
    quoteId: string,
    postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks: PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksUrl(prospectId,quoteId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks,)
  }
);}




export const getPostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError,{prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError,{prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, {prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks}> = (props) => {
          const {prospectId,quoteId,data} = props ?? {};

          return  postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks(prospectId,quoteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>>
    export type PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksMutationBody = PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks
    export type PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>, TError,{prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdBenchmarks>>,
        TError,
        {prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdBenchmarks},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesQuoteIdBenchmarksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create Allowances
 */
export const getPostQuotingProspectsProspectIdQuotesQuoteIdAllowancesUrl = (prospectId: string,
    quoteId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/quotes/${quoteId}/allowances`
}

export const postQuotingProspectsProspectIdQuotesQuoteIdAllowances = async (prospectId: string,
    quoteId: string,
    postQuotingProspectsProspectIdQuotesQuoteIdAllowances: PostQuotingProspectsProspectIdQuotesQuoteIdAllowances, options?: RequestInit): Promise<QuotingQuoteAllowance[]> => {
  
  return customFetch<QuotingQuoteAllowance[]>(getPostQuotingProspectsProspectIdQuotesQuoteIdAllowancesUrl(prospectId,quoteId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdQuotesQuoteIdAllowances,)
  }
);}




export const getPostQuotingProspectsProspectIdQuotesQuoteIdAllowancesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdAllowances>>, TError,{prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdAllowances}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdAllowances>>, TError,{prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdAllowances}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdQuotesQuoteIdAllowances'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdAllowances>>, {prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdAllowances}> = (props) => {
          const {prospectId,quoteId,data} = props ?? {};

          return  postQuotingProspectsProspectIdQuotesQuoteIdAllowances(prospectId,quoteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdAllowances>>>
    export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesMutationBody = PostQuotingProspectsProspectIdQuotesQuoteIdAllowances
    export type PostQuotingProspectsProspectIdQuotesQuoteIdAllowancesMutationError = unknown

    export const usePostQuotingProspectsProspectIdQuotesQuoteIdAllowances = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdAllowances>>, TError,{prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdAllowances}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdQuotesQuoteIdAllowances>>,
        TError,
        {prospectId: string;quoteId: string;data: PostQuotingProspectsProspectIdQuotesQuoteIdAllowances},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdQuotesQuoteIdAllowancesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List employee censuses
 */
export const getGetQuotingProspectsProspectIdCensusUrl = (prospectId: string,
    params?: GetQuotingProspectsProspectIdCensusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/prospects/${prospectId}/census?${stringifiedParams}` : `/api/web/quoting/prospects/${prospectId}/census`
}

export const getQuotingProspectsProspectIdCensus = async (prospectId: string,
    params?: GetQuotingProspectsProspectIdCensusParams, options?: RequestInit): Promise<QuotingPaginatedEmployeeCensusList> => {
  
  return customFetch<QuotingPaginatedEmployeeCensusList>(getGetQuotingProspectsProspectIdCensusUrl(prospectId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdCensusQueryKey = (prospectId?: string,
    params?: GetQuotingProspectsProspectIdCensusParams,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/census`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdCensusQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError = unknown>(prospectId: string,
    params?: GetQuotingProspectsProspectIdCensusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdCensusQueryKey(prospectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>> = ({ signal }) => getQuotingProspectsProspectIdCensus(prospectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdCensusQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>>
export type GetQuotingProspectsProspectIdCensusQueryError = unknown


export function useGetQuotingProspectsProspectIdCensus<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError = unknown>(
 prospectId: string,
    params: undefined |  GetQuotingProspectsProspectIdCensusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensus<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError = unknown>(
 prospectId: string,
    params?: GetQuotingProspectsProspectIdCensusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensus<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError = unknown>(
 prospectId: string,
    params?: GetQuotingProspectsProspectIdCensusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdCensus<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError = unknown>(
 prospectId: string,
    params?: GetQuotingProspectsProspectIdCensusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdCensusQueryOptions(prospectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create an employee census
 */
export const getPostQuotingProspectsProspectIdCensusUrl = (prospectId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census`
}

export const postQuotingProspectsProspectIdCensus = async (prospectId: string, options?: RequestInit): Promise<QuotingEmployeeCensus> => {
  
  return customFetch<QuotingEmployeeCensus>(getPostQuotingProspectsProspectIdCensusUrl(prospectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostQuotingProspectsProspectIdCensusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensus>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensus>>, TError,{prospectId: string}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdCensus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensus>>, {prospectId: string}> = (props) => {
          const {prospectId} = props ?? {};

          return  postQuotingProspectsProspectIdCensus(prospectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdCensusMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensus>>>
    
    export type PostQuotingProspectsProspectIdCensusMutationError = unknown

    export const usePostQuotingProspectsProspectIdCensus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensus>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensus>>,
        TError,
        {prospectId: string},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdCensusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a census for manual employee entry
 */
export const getPostQuotingProspectsProspectIdCensusManualUrl = (prospectId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/manual`
}

export const postQuotingProspectsProspectIdCensusManual = async (prospectId: string, options?: RequestInit): Promise<QuotingEmployeeCensus> => {
  
  return customFetch<QuotingEmployeeCensus>(getPostQuotingProspectsProspectIdCensusManualUrl(prospectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostQuotingProspectsProspectIdCensusManualMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusManual>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusManual>>, TError,{prospectId: string}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdCensusManual'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusManual>>, {prospectId: string}> = (props) => {
          const {prospectId} = props ?? {};

          return  postQuotingProspectsProspectIdCensusManual(prospectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdCensusManualMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusManual>>>
    
    export type PostQuotingProspectsProspectIdCensusManualMutationError = unknown

    export const usePostQuotingProspectsProspectIdCensusManual = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusManual>>, TError,{prospectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusManual>>,
        TError,
        {prospectId: string},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdCensusManualMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Return an employee census
 */
export const getGetQuotingProspectsProspectIdCensusIdUrl = (prospectId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/${id}`
}

export const getQuotingProspectsProspectIdCensusId = async (prospectId: string,
    id: string, options?: RequestInit): Promise<QuotingEmployeeCensus> => {
  
  return customFetch<QuotingEmployeeCensus>(getGetQuotingProspectsProspectIdCensusIdUrl(prospectId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdCensusIdQueryKey = (prospectId?: string,
    id?: string,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/census/${id}`
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdCensusIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError = unknown>(prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdCensusIdQueryKey(prospectId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>> = ({ signal }) => getQuotingProspectsProspectIdCensusId(prospectId,id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdCensusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>>
export type GetQuotingProspectsProspectIdCensusIdQueryError = unknown


export function useGetQuotingProspectsProspectIdCensusId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError = unknown>(
 prospectId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensusId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensusId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdCensusId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError = unknown>(
 prospectId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdCensusIdQueryOptions(prospectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List employees
 */
export const getGetQuotingProspectsProspectIdCensusCensusIdEmployeesUrl = (prospectId: string,
    censusId: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees?${stringifiedParams}` : `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees`
}

export const getQuotingProspectsProspectIdCensusCensusIdEmployees = async (prospectId: string,
    censusId: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams, options?: RequestInit): Promise<QuotingPaginatedEmployeeList> => {
  
  return customFetch<QuotingPaginatedEmployeeList>(getGetQuotingProspectsProspectIdCensusCensusIdEmployeesUrl(prospectId,censusId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdCensusCensusIdEmployeesQueryKey = (prospectId?: string,
    censusId?: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdCensusCensusIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError = unknown>(prospectId: string,
    censusId: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdCensusCensusIdEmployeesQueryKey(prospectId,censusId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>> = ({ signal }) => getQuotingProspectsProspectIdCensusCensusIdEmployees(prospectId,censusId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId && censusId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdCensusCensusIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>>
export type GetQuotingProspectsProspectIdCensusCensusIdEmployeesQueryError = unknown


export function useGetQuotingProspectsProspectIdCensusCensusIdEmployees<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    params: undefined |  GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensusCensusIdEmployees<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensusCensusIdEmployees<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdCensusCensusIdEmployees<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    params?: GetQuotingProspectsProspectIdCensusCensusIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdCensusCensusIdEmployeesQueryOptions(prospectId,censusId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create an employee
 */
export const getPostQuotingProspectsProspectIdCensusCensusIdEmployeesUrl = (prospectId: string,
    censusId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees`
}

export const postQuotingProspectsProspectIdCensusCensusIdEmployees = async (prospectId: string,
    censusId: string,
    postQuotingProspectsProspectIdCensusCensusIdEmployees: PostQuotingProspectsProspectIdCensusCensusIdEmployees, options?: RequestInit): Promise<QuotingEmployee> => {
  
  return customFetch<QuotingEmployee>(getPostQuotingProspectsProspectIdCensusCensusIdEmployeesUrl(prospectId,censusId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdCensusCensusIdEmployees,)
  }
);}




export const getPostQuotingProspectsProspectIdCensusCensusIdEmployeesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployees}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployees}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdCensusCensusIdEmployees'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployees>>, {prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployees}> = (props) => {
          const {prospectId,censusId,data} = props ?? {};

          return  postQuotingProspectsProspectIdCensusCensusIdEmployees(prospectId,censusId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployees>>>
    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesMutationBody = PostQuotingProspectsProspectIdCensusCensusIdEmployees
    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesMutationError = unknown

    export const usePostQuotingProspectsProspectIdCensusCensusIdEmployees = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployees>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployees}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployees>>,
        TError,
        {prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployees},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdCensusCensusIdEmployeesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Bulk create employees
 */
export const getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateUrl = (prospectId: string,
    censusId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees/bulk_create`
}

export const postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate = async (prospectId: string,
    censusId: string,
    postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate, options?: RequestInit): Promise<QuotingEmployee[]> => {
  
  return customFetch<QuotingEmployee[]>(getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateUrl(prospectId,censusId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate,)
  }
);}




export const getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate>>, {prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate}> = (props) => {
          const {prospectId,censusId,data} = props ?? {};

          return  postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate(prospectId,censusId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate>>>
    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateMutationBody = PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate
    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateMutationError = unknown

    export const usePostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate>>,
        TError,
        {prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreate},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Return an employee
 */
export const getGetQuotingProspectsProspectIdCensusCensusIdEmployeesIdUrl = (prospectId: string,
    censusId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees/${id}`
}

export const getQuotingProspectsProspectIdCensusCensusIdEmployeesId = async (prospectId: string,
    censusId: string,
    id: string, options?: RequestInit): Promise<QuotingEmployee> => {
  
  return customFetch<QuotingEmployee>(getGetQuotingProspectsProspectIdCensusCensusIdEmployeesIdUrl(prospectId,censusId,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingProspectsProspectIdCensusCensusIdEmployeesIdQueryKey = (prospectId?: string,
    censusId?: string,
    id?: string,) => {
    return [
    `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees/${id}`
    ] as const;
    }

    
export const getGetQuotingProspectsProspectIdCensusCensusIdEmployeesIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError = unknown>(prospectId: string,
    censusId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingProspectsProspectIdCensusCensusIdEmployeesIdQueryKey(prospectId,censusId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>> = ({ signal }) => getQuotingProspectsProspectIdCensusCensusIdEmployeesId(prospectId,censusId,id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(prospectId && censusId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingProspectsProspectIdCensusCensusIdEmployeesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>>
export type GetQuotingProspectsProspectIdCensusCensusIdEmployeesIdQueryError = unknown


export function useGetQuotingProspectsProspectIdCensusCensusIdEmployeesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensusCensusIdEmployeesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingProspectsProspectIdCensusCensusIdEmployeesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingProspectsProspectIdCensusCensusIdEmployeesId<TData = Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError = unknown>(
 prospectId: string,
    censusId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingProspectsProspectIdCensusCensusIdEmployeesIdQueryOptions(prospectId,censusId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update an employee
 */
export const getPutQuotingProspectsProspectIdCensusCensusIdEmployeesIdUrl = (prospectId: string,
    censusId: string,
    id: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees/${id}`
}

export const putQuotingProspectsProspectIdCensusCensusIdEmployeesId = async (prospectId: string,
    censusId: string,
    id: string,
    putQuotingProspectsProspectIdCensusCensusIdEmployeesId: PutQuotingProspectsProspectIdCensusCensusIdEmployeesId, options?: RequestInit): Promise<QuotingEmployee> => {
  
  return customFetch<QuotingEmployee>(getPutQuotingProspectsProspectIdCensusCensusIdEmployeesIdUrl(prospectId,censusId,id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putQuotingProspectsProspectIdCensusCensusIdEmployeesId,)
  }
);}




export const getPutQuotingProspectsProspectIdCensusCensusIdEmployeesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError,{prospectId: string;censusId: string;id: string;data: PutQuotingProspectsProspectIdCensusCensusIdEmployeesId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError,{prospectId: string;censusId: string;id: string;data: PutQuotingProspectsProspectIdCensusCensusIdEmployeesId}, TContext> => {

const mutationKey = ['putQuotingProspectsProspectIdCensusCensusIdEmployeesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, {prospectId: string;censusId: string;id: string;data: PutQuotingProspectsProspectIdCensusCensusIdEmployeesId}> = (props) => {
          const {prospectId,censusId,id,data} = props ?? {};

          return  putQuotingProspectsProspectIdCensusCensusIdEmployeesId(prospectId,censusId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putQuotingProspectsProspectIdCensusCensusIdEmployeesId>>>
    export type PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdMutationBody = PutQuotingProspectsProspectIdCensusCensusIdEmployeesId
    export type PutQuotingProspectsProspectIdCensusCensusIdEmployeesIdMutationError = unknown

    export const usePutQuotingProspectsProspectIdCensusCensusIdEmployeesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuotingProspectsProspectIdCensusCensusIdEmployeesId>>, TError,{prospectId: string;censusId: string;id: string;data: PutQuotingProspectsProspectIdCensusCensusIdEmployeesId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putQuotingProspectsProspectIdCensusCensusIdEmployeesId>>,
        TError,
        {prospectId: string;censusId: string;id: string;data: PutQuotingProspectsProspectIdCensusCensusIdEmployeesId},
        TContext
      > => {

      const mutationOptions = getPutQuotingProspectsProspectIdCensusCensusIdEmployeesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Bulk replace dependents for prospect employees
 */
export const getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsUrl = (prospectId: string,
    censusId: string,) => {


  

  return `/api/web/quoting/prospects/${prospectId}/census/${censusId}/employees/bulk_replace_dependents`
}

export const postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents = async (prospectId: string,
    censusId: string,
    postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents, options?: RequestInit): Promise<QuotingEmployee[]> => {
  
  return customFetch<QuotingEmployee[]>(getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsUrl(prospectId,censusId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents,)
  }
);}




export const getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents}, TContext> => {

const mutationKey = ['postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents>>, {prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents}> = (props) => {
          const {prospectId,censusId,data} = props ?? {};

          return  postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents(prospectId,censusId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents>>>
    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsMutationBody = PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents
    export type PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsMutationError = unknown

    export const usePostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents>>, TError,{prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents>>,
        TError,
        {prospectId: string;censusId: string;data: PostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependents},
        TContext
      > => {

      const mutationOptions = getPostQuotingProspectsProspectIdCensusCensusIdEmployeesBulkReplaceDependentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a quote by ID
 */
export const getGetQuotingQuoteResultsQuoteIdUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/quote_results/${quoteId}`
}

export const getQuotingQuoteResultsQuoteId = async (quoteId: string, options?: RequestInit): Promise<QuotingQuote> => {
  
  return customFetch<QuotingQuote>(getGetQuotingQuoteResultsQuoteIdUrl(quoteId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdQueryKey = (quoteId?: string,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}`
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError = unknown>(quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdQueryKey(quoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>> = ({ signal }) => getQuotingQuoteResultsQuoteId(quoteId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>>
export type GetQuotingQuoteResultsQuoteIdQueryError = unknown


export function useGetQuotingQuoteResultsQuoteId<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError = unknown>(
 quoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteId<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteId<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteId<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdQueryOptions(quoteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List the Quote's employees' cost and affordability results
 */
export const getGetQuotingQuoteResultsQuoteIdResultsUrl = (quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/quote_results/${quoteId}/results?${stringifiedParams}` : `/api/web/quoting/quote_results/${quoteId}/results`
}

export const getQuotingQuoteResultsQuoteIdResults = async (quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams, options?: RequestInit): Promise<QuotingQuoteResult[]> => {
  
  return customFetch<QuotingQuoteResult[]>(getGetQuotingQuoteResultsQuoteIdResultsUrl(quoteId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdResultsQueryKey = (quoteId?: string,
    params?: GetQuotingQuoteResultsQuoteIdResultsParams,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}/results`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdResultsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError = unknown>(quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdResultsQueryKey(quoteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>> = ({ signal }) => getQuotingQuoteResultsQuoteIdResults(quoteId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>>
export type GetQuotingQuoteResultsQuoteIdResultsQueryError = unknown


export function useGetQuotingQuoteResultsQuoteIdResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteIdResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdResultsQueryOptions(quoteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List the Flat Allowance Quotes employees
 */
export const getGetQuotingQuoteResultsQuoteIdFlatAllowanceResultsUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/quote_results/${quoteId}/flat_allowance_results`
}

export const getQuotingQuoteResultsQuoteIdFlatAllowanceResults = async (quoteId: string, options?: RequestInit): Promise<QuotingQuoteResult[]> => {
  
  return customFetch<QuotingQuoteResult[]>(getGetQuotingQuoteResultsQuoteIdFlatAllowanceResultsUrl(quoteId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdFlatAllowanceResultsQueryKey = (quoteId?: string,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}/flat_allowance_results`
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdFlatAllowanceResultsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError = unknown>(quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdFlatAllowanceResultsQueryKey(quoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>> = ({ signal }) => getQuotingQuoteResultsQuoteIdFlatAllowanceResults(quoteId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdFlatAllowanceResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>>
export type GetQuotingQuoteResultsQuoteIdFlatAllowanceResultsQueryError = unknown


export function useGetQuotingQuoteResultsQuoteIdFlatAllowanceResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError = unknown>(
 quoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdFlatAllowanceResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdFlatAllowanceResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteIdFlatAllowanceResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdFlatAllowanceResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdFlatAllowanceResultsQueryOptions(quoteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Share the Quote with an individual
 */
export const getPostQuotingQuoteResultsQuoteIdInviteUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/quote_results/${quoteId}/invite`
}

export const postQuotingQuoteResultsQuoteIdInvite = async (quoteId: string,
    postQuotingQuoteResultsQuoteIdInvite: PostQuotingQuoteResultsQuoteIdInvite, options?: RequestInit): Promise<ResourceAccessTokensInvitationResult[]> => {
  
  return customFetch<ResourceAccessTokensInvitationResult[]>(getPostQuotingQuoteResultsQuoteIdInviteUrl(quoteId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postQuotingQuoteResultsQuoteIdInvite,)
  }
);}




export const getPostQuotingQuoteResultsQuoteIdInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingQuoteResultsQuoteIdInvite>>, TError,{quoteId: string;data: PostQuotingQuoteResultsQuoteIdInvite}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuotingQuoteResultsQuoteIdInvite>>, TError,{quoteId: string;data: PostQuotingQuoteResultsQuoteIdInvite}, TContext> => {

const mutationKey = ['postQuotingQuoteResultsQuoteIdInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuotingQuoteResultsQuoteIdInvite>>, {quoteId: string;data: PostQuotingQuoteResultsQuoteIdInvite}> = (props) => {
          const {quoteId,data} = props ?? {};

          return  postQuotingQuoteResultsQuoteIdInvite(quoteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuotingQuoteResultsQuoteIdInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postQuotingQuoteResultsQuoteIdInvite>>>
    export type PostQuotingQuoteResultsQuoteIdInviteMutationBody = PostQuotingQuoteResultsQuoteIdInvite
    export type PostQuotingQuoteResultsQuoteIdInviteMutationError = unknown

    export const usePostQuotingQuoteResultsQuoteIdInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuotingQuoteResultsQuoteIdInvite>>, TError,{quoteId: string;data: PostQuotingQuoteResultsQuoteIdInvite}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuotingQuoteResultsQuoteIdInvite>>,
        TError,
        {quoteId: string;data: PostQuotingQuoteResultsQuoteIdInvite},
        TContext
      > => {

      const mutationOptions = getPostQuotingQuoteResultsQuoteIdInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List the Resource Access Token Recipients for a Quote
 */
export const getGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/quote_results/${quoteId}/resource_access_token_recipients`
}

export const getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients = async (quoteId: string, options?: RequestInit): Promise<ResourceAccessTokensResourceAccessTokenRecipient[]> => {
  
  return customFetch<ResourceAccessTokensResourceAccessTokenRecipient[]>(getGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsUrl(quoteId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsQueryKey = (quoteId?: string,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}/resource_access_token_recipients`
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError = unknown>(quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsQueryKey(quoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>> = ({ signal }) => getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients(quoteId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>>
export type GetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsQueryError = unknown


export function useGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError = unknown>(
 quoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdResourceAccessTokenRecipients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdResourceAccessTokenRecipientsQueryOptions(quoteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get recommended benchmark results
 */
export const getGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/quote_results/${quoteId}/recommended_benchmark_results`
}

export const getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults = async (quoteId: string, options?: RequestInit): Promise<QuotingRecommendedQuoteResults> => {
  
  return customFetch<QuotingRecommendedQuoteResults>(getGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsUrl(quoteId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsQueryKey = (quoteId?: string,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}/recommended_benchmark_results`
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError = unknown>(quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsQueryKey(quoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>> = ({ signal }) => getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults(quoteId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>>
export type GetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsQueryError = unknown


export function useGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError = unknown>(
 quoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdRecommendedBenchmarkResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdRecommendedBenchmarkResultsQueryOptions(quoteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get plan availability by rating area
 */
export const getGetQuotingQuoteResultsQuoteIdPlanAvailabilityUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/quote_results/${quoteId}/plan_availability`
}

export const getQuotingQuoteResultsQuoteIdPlanAvailability = async (quoteId: string, options?: RequestInit): Promise<QuotingPlanAvailability[]> => {
  
  return customFetch<QuotingPlanAvailability[]>(getGetQuotingQuoteResultsQuoteIdPlanAvailabilityUrl(quoteId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdPlanAvailabilityQueryKey = (quoteId?: string,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}/plan_availability`
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdPlanAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError = unknown>(quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdPlanAvailabilityQueryKey(quoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>> = ({ signal }) => getQuotingQuoteResultsQuoteIdPlanAvailability(quoteId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdPlanAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>>
export type GetQuotingQuoteResultsQuoteIdPlanAvailabilityQueryError = unknown


export function useGetQuotingQuoteResultsQuoteIdPlanAvailability<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError = unknown>(
 quoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdPlanAvailability<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdPlanAvailability<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteIdPlanAvailability<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError = unknown>(
 quoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlanAvailability>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdPlanAvailabilityQueryOptions(quoteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get medical plans based on employee data
 */
export const getGetQuotingQuoteResultsQuoteIdPlansUrl = (quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/quote_results/${quoteId}/plans?${stringifiedParams}` : `/api/web/quoting/quote_results/${quoteId}/plans`
}

export const getQuotingQuoteResultsQuoteIdPlans = async (quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams, options?: RequestInit): Promise<QuotingMedicalPlanDisplayItem> => {
  
  return customFetch<QuotingMedicalPlanDisplayItem>(getGetQuotingQuoteResultsQuoteIdPlansUrl(quoteId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingQuoteResultsQuoteIdPlansQueryKey = (quoteId?: string,
    params?: GetQuotingQuoteResultsQuoteIdPlansParams,) => {
    return [
    `/api/web/quoting/quote_results/${quoteId}/plans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingQuoteResultsQuoteIdPlansQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError = unknown>(quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingQuoteResultsQuoteIdPlansQueryKey(quoteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>> = ({ signal }) => getQuotingQuoteResultsQuoteIdPlans(quoteId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingQuoteResultsQuoteIdPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>>
export type GetQuotingQuoteResultsQuoteIdPlansQueryError = unknown


export function useGetQuotingQuoteResultsQuoteIdPlans<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdPlans<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>,
          TError,
          Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingQuoteResultsQuoteIdPlans<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingQuoteResultsQuoteIdPlans<TData = Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingQuoteResultsQuoteIdPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingQuoteResultsQuoteIdPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingQuoteResultsQuoteIdPlansQueryOptions(quoteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get quote pricing for a specific workflow type
 */
export const getGetQuotingPricesQuoteIdUrl = (quoteId: string,
    params: GetQuotingPricesQuoteIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/quoting/prices/${quoteId}?${stringifiedParams}` : `/api/web/quoting/prices/${quoteId}`
}

export const getQuotingPricesQuoteId = async (quoteId: string,
    params: GetQuotingPricesQuoteIdParams, options?: RequestInit): Promise<QuotingQuotePricing> => {
  
  return customFetch<QuotingQuotePricing>(getGetQuotingPricesQuoteIdUrl(quoteId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetQuotingPricesQuoteIdQueryKey = (quoteId?: string,
    params?: GetQuotingPricesQuoteIdParams,) => {
    return [
    `/api/web/quoting/prices/${quoteId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetQuotingPricesQuoteIdQueryOptions = <TData = Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError = unknown>(quoteId: string,
    params: GetQuotingPricesQuoteIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQuotingPricesQuoteIdQueryKey(quoteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>> = ({ signal }) => getQuotingPricesQuoteId(quoteId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(quoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQuotingPricesQuoteIdQueryResult = NonNullable<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>>
export type GetQuotingPricesQuoteIdQueryError = unknown


export function useGetQuotingPricesQuoteId<TData = Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingPricesQuoteIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingPricesQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingPricesQuoteId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingPricesQuoteId<TData = Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingPricesQuoteIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuotingPricesQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getQuotingPricesQuoteId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetQuotingPricesQuoteId<TData = Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingPricesQuoteIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetQuotingPricesQuoteId<TData = Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError = unknown>(
 quoteId: string,
    params: GetQuotingPricesQuoteIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuotingPricesQuoteId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQuotingPricesQuoteIdQueryOptions(quoteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update quote pricing
 */
export const getPutQuotingPricesQuoteIdUrl = (quoteId: string,) => {


  

  return `/api/web/quoting/prices/${quoteId}`
}

export const putQuotingPricesQuoteId = async (quoteId: string,
    putQuotingPricesQuoteId: PutQuotingPricesQuoteId, options?: RequestInit): Promise<QuotingQuotePricing> => {
  
  return customFetch<QuotingQuotePricing>(getPutQuotingPricesQuoteIdUrl(quoteId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putQuotingPricesQuoteId,)
  }
);}




export const getPutQuotingPricesQuoteIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuotingPricesQuoteId>>, TError,{quoteId: string;data: PutQuotingPricesQuoteId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putQuotingPricesQuoteId>>, TError,{quoteId: string;data: PutQuotingPricesQuoteId}, TContext> => {

const mutationKey = ['putQuotingPricesQuoteId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putQuotingPricesQuoteId>>, {quoteId: string;data: PutQuotingPricesQuoteId}> = (props) => {
          const {quoteId,data} = props ?? {};

          return  putQuotingPricesQuoteId(quoteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutQuotingPricesQuoteIdMutationResult = NonNullable<Awaited<ReturnType<typeof putQuotingPricesQuoteId>>>
    export type PutQuotingPricesQuoteIdMutationBody = PutQuotingPricesQuoteId
    export type PutQuotingPricesQuoteIdMutationError = unknown

    export const usePutQuotingPricesQuoteId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putQuotingPricesQuoteId>>, TError,{quoteId: string;data: PutQuotingPricesQuoteId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putQuotingPricesQuoteId>>,
        TError,
        {quoteId: string;data: PutQuotingPricesQuoteId},
        TContext
      > => {

      const mutationOptions = getPutQuotingPricesQuoteIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get additional pending participants for the member
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsUrl = (enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants?${stringifiedParams}` : `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants = async (enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipantsList> => {
  
  return customFetch<MemberOnboardingAdditionalParticipantsList>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsUrl(enrollmentEventId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsQueryKey = (enrollmentEventId?: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError = unknown>(enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsQueryKey(enrollmentEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants(enrollmentEventId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError = unknown>(
 enrollmentEventId: string,
    params: undefined |  GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError = unknown>(
 enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError = unknown>(
 enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError = unknown>(
 enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsQueryOptions(enrollmentEventId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create an additional participant
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants = async (enrollmentEventId: string,
    postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipant> => {
  
  return customFetch<MemberOnboardingAdditionalParticipant>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants,)
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>>
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsMutationBody = PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants>>,
        TError,
        {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipants},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Bulk update additional participants
 */
export const getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/bulk_update`
}

export const patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate = async (enrollmentEventId: string,
    patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipantsList> => {
  
  return customFetch<MemberOnboardingAdditionalParticipantsList>(getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateUrl(enrollmentEventId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate,)
  }
);}




export const getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate>>, TError,{enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate>>, TError,{enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate}, TContext> => {

const mutationKey = ['patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate>>, {enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate>>>
    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateMutationBody = PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate
    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateMutationError = unknown

    export const usePatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate>>, TError,{enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate>>,
        TError,
        {enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdate},
        TContext
      > => {

      const mutationOptions = getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsBulkUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get an additional participant
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUrl = (enrollmentEventId: string,
    participantId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/${participantId}`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId = async (enrollmentEventId: string,
    participantId: string, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipant> => {
  
  return customFetch<MemberOnboardingAdditionalParticipant>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUrl(enrollmentEventId,participantId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdQueryKey = (enrollmentEventId?: string,
    participantId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/${participantId}`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError = unknown>(enrollmentEventId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdQueryKey(enrollmentEventId,participantId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId(enrollmentEventId,participantId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId && participantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError = unknown>(
 enrollmentEventId: string,
    participantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError = unknown>(
 enrollmentEventId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError = unknown>(
 enrollmentEventId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError = unknown>(
 enrollmentEventId: string,
    participantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdQueryOptions(enrollmentEventId,participantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete an additional participant
 */
export const getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUrl = (enrollmentEventId: string,
    participantId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/${participantId}`
}

export const deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId = async (enrollmentEventId: string,
    participantId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUrl(enrollmentEventId,participantId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError,{enrollmentEventId: string;participantId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError,{enrollmentEventId: string;participantId: string}, TContext> => {

const mutationKey = ['deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, {enrollmentEventId: string;participantId: string}> = (props) => {
          const {enrollmentEventId,participantId} = props ?? {};

          return  deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId(enrollmentEventId,participantId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>>
    
    export type DeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationError = unknown

    export const useDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError,{enrollmentEventId: string;participantId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>,
        TError,
        {enrollmentEventId: string;participantId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update an additional participant
 */
export const getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUrl = (enrollmentEventId: string,
    participantId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/${participantId}`
}

export const patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId = async (enrollmentEventId: string,
    participantId: string,
    patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipant> => {
  
  return customFetch<MemberOnboardingAdditionalParticipant>(getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUrl(enrollmentEventId,participantId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId,)
  }
);}




export const getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError,{enrollmentEventId: string;participantId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError,{enrollmentEventId: string;participantId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId}, TContext> => {

const mutationKey = ['patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, {enrollmentEventId: string;participantId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId}> = (props) => {
          const {enrollmentEventId,participantId,data} = props ?? {};

          return  patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId(enrollmentEventId,participantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>>
    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationBody = PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId
    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationError = unknown

    export const usePatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>, TError,{enrollmentEventId: string;participantId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId>>,
        TError,
        {enrollmentEventId: string;participantId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantId},
        TContext
      > => {

      const mutationOptions = getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Mark a participant to be removed from plan selection
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemovedUrl = (enrollmentEventId: string,
    participantId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/${participantId}/mark_as_removed`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved = async (enrollmentEventId: string,
    participantId: string, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipant> => {
  
  return customFetch<MemberOnboardingAdditionalParticipant>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemovedUrl(enrollmentEventId,participantId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemovedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved>>, TError,{enrollmentEventId: string;participantId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved>>, TError,{enrollmentEventId: string;participantId: string}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved>>, {enrollmentEventId: string;participantId: string}> = (props) => {
          const {enrollmentEventId,participantId} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved(enrollmentEventId,participantId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemovedMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved>>>
    
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemovedMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved>>, TError,{enrollmentEventId: string;participantId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemoved>>,
        TError,
        {enrollmentEventId: string;participantId: string},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdMarkAsRemovedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Undo the deletion of a participant from plan selection
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemoveUrl = (enrollmentEventId: string,
    participantId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/additional_participants/${participantId}/undo_remove`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove = async (enrollmentEventId: string,
    participantId: string, options?: RequestInit): Promise<MemberOnboardingAdditionalParticipant> => {
  
  return customFetch<MemberOnboardingAdditionalParticipant>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemoveUrl(enrollmentEventId,participantId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove>>, TError,{enrollmentEventId: string;participantId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove>>, TError,{enrollmentEventId: string;participantId: string}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove>>, {enrollmentEventId: string;participantId: string}> = (props) => {
          const {enrollmentEventId,participantId} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove(enrollmentEventId,participantId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove>>>
    
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemoveMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove>>, TError,{enrollmentEventId: string;participantId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemove>>,
        TError,
        {enrollmentEventId: string;participantId: string},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdAdditionalParticipantsParticipantIdUndoRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the onboarding context for an enrollment event
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/onboarding`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingOnboarding> => {
  
  return customFetch<MemberOnboardingOnboarding>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/onboarding`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update the onboarding context for an enrollment event
 */
export const getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/onboarding`
}

export const patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding = async (enrollmentEventId: string,
    patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding, options?: RequestInit): Promise<MemberOnboardingOnboarding> => {
  
  return customFetch<MemberOnboardingOnboarding>(getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingUrl(enrollmentEventId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding,)
  }
);}




export const getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError,{enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError,{enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding}, TContext> => {

const mutationKey = ['patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, {enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>>
    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMutationBody = PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding
    export type PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMutationError = unknown

    export const usePatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>, TError,{enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding>>,
        TError,
        {enrollmentEventId: string;data: PatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboarding},
        TContext
      > => {

      const mutationOptions = getPatchMemberOnboardingEnrollmentEventsEnrollmentEventIdOnboardingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create an enrollment
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/enrollments/enroll`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll = async (enrollmentEventId: string,
    postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll, options?: RequestInit): Promise<MemberOnboardingMemberEnrollment> => {
  
  return customFetch<MemberOnboardingMemberEnrollment>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll,)
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll>>, {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll>>>
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollMutationBody = PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll>>,
        TError,
        {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnroll},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Finalizes all enrollments for the user
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/enrollments/finalize_enrollments`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments = async (enrollmentEventId: string,
    postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments, options?: RequestInit): Promise<MemberOnboardingOnboarding> => {
  
  return customFetch<MemberOnboardingOnboarding>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments,)
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments>>, {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments>>>
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsMutationBody = PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments>>,
        TError,
        {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollments},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsFinalizeEnrollmentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete an enrollment
 */
export const getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanIdUrl = (enrollmentEventId: string,
    enrollmentOrSelectedPlanId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/enrollments/${enrollmentOrSelectedPlanId}`
}

export const deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId = async (enrollmentEventId: string,
    enrollmentOrSelectedPlanId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanIdUrl(enrollmentEventId,enrollmentOrSelectedPlanId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId>>, TError,{enrollmentEventId: string;enrollmentOrSelectedPlanId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId>>, TError,{enrollmentEventId: string;enrollmentOrSelectedPlanId: string}, TContext> => {

const mutationKey = ['deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId>>, {enrollmentEventId: string;enrollmentOrSelectedPlanId: string}> = (props) => {
          const {enrollmentEventId,enrollmentOrSelectedPlanId} = props ?? {};

          return  deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId(enrollmentEventId,enrollmentOrSelectedPlanId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId>>>
    
    export type DeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanIdMutationError = unknown

    export const useDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId>>, TError,{enrollmentEventId: string;enrollmentOrSelectedPlanId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanId>>,
        TError,
        {enrollmentEventId: string;enrollmentOrSelectedPlanId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdEnrollmentsEnrollmentOrSelectedPlanIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get available medical plans for the member
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansUrl = (enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["metal_tier[]","plan_type[]","carrier_name[]","sort[]","provider_npis[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/medical_plans?${stringifiedParams}` : `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/medical_plans`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans = async (enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams, options?: RequestInit): Promise<MemberOnboardingMedicalPlanDisplayItemList> => {
  
  return customFetch<MemberOnboardingMedicalPlanDisplayItemList>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansUrl(enrollmentEventId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansQueryKey = (enrollmentEventId?: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/medical_plans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError = unknown>(enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansQueryKey(enrollmentEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans(enrollmentEventId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError = unknown>(
 enrollmentEventId: string,
    params: undefined |  GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError = unknown>(
 enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError = unknown>(
 enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError = unknown>(
 enrollmentEventId: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansQueryOptions(enrollmentEventId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get medical plan details for specific plans
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsUrl = (enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["plan_ids[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/medical_plans/details?${stringifiedParams}` : `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/medical_plans/details`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails = async (enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams, options?: RequestInit): Promise<MemberOnboardingMedicalPlanDisplayItemDetailsList> => {
  
  return customFetch<MemberOnboardingMedicalPlanDisplayItemDetailsList>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsUrl(enrollmentEventId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsQueryKey = (enrollmentEventId?: string,
    params?: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/medical_plans/details`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError = unknown>(enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsQueryKey(enrollmentEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails(enrollmentEventId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError = unknown>(
 enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError = unknown>(
 enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError = unknown>(
 enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError = unknown>(
 enrollmentEventId: string,
    params: GetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdMedicalPlansDetailsQueryOptions(enrollmentEventId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get available dental plans for the member
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/dental_plans`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingDentalPlanList> => {
  
  return customFetch<MemberOnboardingDentalPlanList>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/dental_plans`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdDentalPlansQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get vision plans
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/vision_plans`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingVisionPlanList> => {
  
  return customFetch<MemberOnboardingVisionPlanList>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/vision_plans`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdVisionPlansQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create an off-Thatch enrollment
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/off_thatch_enrollments/enroll`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll = async (enrollmentEventId: string,
    postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll, options?: RequestInit): Promise<MemberOnboardingMemberEnrollment> => {
  
  return customFetch<MemberOnboardingMemberEnrollment>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll,)
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll>>, {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll>>>
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollMutationBody = PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll>>,
        TError,
        {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnroll},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdOffThatchEnrollmentsEnrollMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete all providers associated with the member's plan ichra config
 */
export const getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAllUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/providers/delete_all`
}

export const deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll = async (enrollmentEventId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAllUrl(enrollmentEventId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAllMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll>>, TError,{enrollmentEventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll>>, TError,{enrollmentEventId: string}, TContext> => {

const mutationKey = ['deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll>>, {enrollmentEventId: string}> = (props) => {
          const {enrollmentEventId} = props ?? {};

          return  deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll(enrollmentEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAllMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll>>>
    
    export type DeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAllMutationError = unknown

    export const useDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll>>, TError,{enrollmentEventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAll>>,
        TError,
        {enrollmentEventId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMemberOnboardingEnrollmentEventsEnrollmentEventIdProvidersDeleteAllMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get carrier contract agreement for the member
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/carrier_agreements/contract_agreement`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingCarrierAgreement> => {
  
  return customFetch<MemberOnboardingCarrierAgreement>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/carrier_agreements/contract_agreement`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsContractAgreementQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get carrier arbitration for the member
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/carrier_agreements/arbitration`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingCarrierAgreement> => {
  
  return customFetch<MemberOnboardingCarrierAgreement>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/carrier_agreements/arbitration`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitration>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdCarrierAgreementsArbitrationQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get plan change summary for the member from a given enrollment event
 */
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/plan_change_summary`
}

export const getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingMemberPlanChangesProps> => {
  
  return customFetch<MemberOnboardingMemberPlanChangesProps>(getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/plan_change_summary`
    ] as const;
    }

    
export const getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>> = ({ signal }) => getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>>
export type GetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryQueryError = unknown


export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary<TData = Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingEnrollmentEventsEnrollmentEventIdPlanChangeSummaryQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create selected plans for the straight renewal
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlansUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/selected_plans/create_straight_renewal_selected_plans`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingSelectedPlansList> => {
  
  return customFetch<MemberOnboardingSelectedPlansList>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlansUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlansMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans>>, TError,{enrollmentEventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans>>, TError,{enrollmentEventId: string}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans>>, {enrollmentEventId: string}> = (props) => {
          const {enrollmentEventId} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans(enrollmentEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlansMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans>>>
    
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlansMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans>>, TError,{enrollmentEventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlans>>,
        TError,
        {enrollmentEventId: string},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateStraightRenewalSelectedPlansMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create medicare selected plan placeholder to be used when a member or covered dependent is eligible for Medicare
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholderUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/selected_plans/create_medicare_selected_plan_placeholder`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder = async (enrollmentEventId: string, options?: RequestInit): Promise<MemberOnboardingSelectedPlan> => {
  
  return customFetch<MemberOnboardingSelectedPlan>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholderUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder>>, TError,{enrollmentEventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder>>, TError,{enrollmentEventId: string}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder>>, {enrollmentEventId: string}> = (props) => {
          const {enrollmentEventId} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder(enrollmentEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholderMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder>>>
    
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholderMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder>>, TError,{enrollmentEventId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholder>>,
        TError,
        {enrollmentEventId: string},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSelectedPlansCreateMedicareSelectedPlanPlaceholderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update smart budget recommendations for the enrollment event
 */
export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/smart_budget/recommendations`
}

export const postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations = async (enrollmentEventId: string,
    postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations, options?: RequestInit): Promise<MemberOnboardingSmartBudgetRecommendations> => {
  
  return customFetch<MemberOnboardingSmartBudgetRecommendations>(getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsUrl(enrollmentEventId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations,)
  }
);}




export const getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations}, TContext> => {

const mutationKey = ['postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations>>, {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations}> = (props) => {
          const {enrollmentEventId,data} = props ?? {};

          return  postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations(enrollmentEventId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations>>>
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsMutationBody = PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations
    export type PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsMutationError = unknown

    export const usePostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations>>, TError,{enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations>>,
        TError,
        {enrollmentEventId: string;data: PostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendations},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingEnrollmentEventsEnrollmentEventIdSmartBudgetRecommendationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a plan selection preference
 */
export const getPostMemberOnboardingPlanSelectionPreferencesUrl = () => {


  

  return `/api/web/member_onboarding/plan_selection_preferences`
}

export const postMemberOnboardingPlanSelectionPreferences = async (postMemberOnboardingPlanSelectionPreferences: PostMemberOnboardingPlanSelectionPreferences, options?: RequestInit): Promise<MemberOnboardingPlanSelectionPreference> => {
  
  return customFetch<MemberOnboardingPlanSelectionPreference>(getPostMemberOnboardingPlanSelectionPreferencesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingPlanSelectionPreferences,)
  }
);}




export const getPostMemberOnboardingPlanSelectionPreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferences>>, TError,{data: PostMemberOnboardingPlanSelectionPreferences}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferences>>, TError,{data: PostMemberOnboardingPlanSelectionPreferences}, TContext> => {

const mutationKey = ['postMemberOnboardingPlanSelectionPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferences>>, {data: PostMemberOnboardingPlanSelectionPreferences}> = (props) => {
          const {data} = props ?? {};

          return  postMemberOnboardingPlanSelectionPreferences(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingPlanSelectionPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferences>>>
    export type PostMemberOnboardingPlanSelectionPreferencesMutationBody = PostMemberOnboardingPlanSelectionPreferences
    export type PostMemberOnboardingPlanSelectionPreferencesMutationError = unknown

    export const usePostMemberOnboardingPlanSelectionPreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferences>>, TError,{data: PostMemberOnboardingPlanSelectionPreferences}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferences>>,
        TError,
        {data: PostMemberOnboardingPlanSelectionPreferences},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingPlanSelectionPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Either create or update the plan selection preference for a given year
 */
export const getPostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateUrl = () => {


  

  return `/api/web/member_onboarding/plan_selection_preferences/create_or_update`
}

export const postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate = async (postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate, options?: RequestInit): Promise<MemberOnboardingPlanSelectionPreference> => {
  
  return customFetch<MemberOnboardingPlanSelectionPreference>(getPostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate,)
  }
);}




export const getPostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate>>, TError,{data: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate>>, TError,{data: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate}, TContext> => {

const mutationKey = ['postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate>>, {data: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate}> = (props) => {
          const {data} = props ?? {};

          return  postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate>>>
    export type PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateMutationBody = PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate
    export type PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateMutationError = unknown

    export const usePostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate>>, TError,{data: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingPlanSelectionPreferencesCreateOrUpdate>>,
        TError,
        {data: PostMemberOnboardingPlanSelectionPreferencesCreateOrUpdate},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingPlanSelectionPreferencesCreateOrUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a plan selection preference
 */
export const getGetMemberOnboardingPlanSelectionPreferencesIdUrl = (id: string,) => {


  

  return `/api/web/member_onboarding/plan_selection_preferences/${id}`
}

export const getMemberOnboardingPlanSelectionPreferencesId = async (id: string, options?: RequestInit): Promise<MemberOnboardingPlanSelectionPreference> => {
  
  return customFetch<MemberOnboardingPlanSelectionPreference>(getGetMemberOnboardingPlanSelectionPreferencesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingPlanSelectionPreferencesIdQueryKey = (id?: string,) => {
    return [
    `/api/web/member_onboarding/plan_selection_preferences/${id}`
    ] as const;
    }

    
export const getGetMemberOnboardingPlanSelectionPreferencesIdQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingPlanSelectionPreferencesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>> = ({ signal }) => getMemberOnboardingPlanSelectionPreferencesId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingPlanSelectionPreferencesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>>
export type GetMemberOnboardingPlanSelectionPreferencesIdQueryError = unknown


export function useGetMemberOnboardingPlanSelectionPreferencesId<TData = Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingPlanSelectionPreferencesId<TData = Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingPlanSelectionPreferencesId<TData = Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingPlanSelectionPreferencesId<TData = Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingPlanSelectionPreferencesId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingPlanSelectionPreferencesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Partially update the plan selection preference
 */
export const getPatchMemberOnboardingPlanSelectionPreferencesIdUrl = (id: string,) => {


  

  return `/api/web/member_onboarding/plan_selection_preferences/${id}`
}

export const patchMemberOnboardingPlanSelectionPreferencesId = async (id: string,
    patchMemberOnboardingPlanSelectionPreferencesId: PatchMemberOnboardingPlanSelectionPreferencesId, options?: RequestInit): Promise<MemberOnboardingPlanSelectionPreference> => {
  
  return customFetch<MemberOnboardingPlanSelectionPreference>(getPatchMemberOnboardingPlanSelectionPreferencesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchMemberOnboardingPlanSelectionPreferencesId,)
  }
);}




export const getPatchMemberOnboardingPlanSelectionPreferencesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingPlanSelectionPreferencesId>>, TError,{id: string;data: PatchMemberOnboardingPlanSelectionPreferencesId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingPlanSelectionPreferencesId>>, TError,{id: string;data: PatchMemberOnboardingPlanSelectionPreferencesId}, TContext> => {

const mutationKey = ['patchMemberOnboardingPlanSelectionPreferencesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMemberOnboardingPlanSelectionPreferencesId>>, {id: string;data: PatchMemberOnboardingPlanSelectionPreferencesId}> = (props) => {
          const {id,data} = props ?? {};

          return  patchMemberOnboardingPlanSelectionPreferencesId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMemberOnboardingPlanSelectionPreferencesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchMemberOnboardingPlanSelectionPreferencesId>>>
    export type PatchMemberOnboardingPlanSelectionPreferencesIdMutationBody = PatchMemberOnboardingPlanSelectionPreferencesId
    export type PatchMemberOnboardingPlanSelectionPreferencesIdMutationError = unknown

    export const usePatchMemberOnboardingPlanSelectionPreferencesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMemberOnboardingPlanSelectionPreferencesId>>, TError,{id: string;data: PatchMemberOnboardingPlanSelectionPreferencesId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMemberOnboardingPlanSelectionPreferencesId>>,
        TError,
        {id: string;data: PatchMemberOnboardingPlanSelectionPreferencesId},
        TContext
      > => {

      const mutationOptions = getPatchMemberOnboardingPlanSelectionPreferencesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get recommended plans
 */
export const getGetMemberOnboardingRecommendedPlansUrl = (params?: GetMemberOnboardingRecommendedPlansParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/member_onboarding/recommended_plans?${stringifiedParams}` : `/api/web/member_onboarding/recommended_plans`
}

export const getMemberOnboardingRecommendedPlans = async (params?: GetMemberOnboardingRecommendedPlansParams, options?: RequestInit): Promise<MemberOnboardingRecommendedPlanListByCategory> => {
  
  return customFetch<MemberOnboardingRecommendedPlanListByCategory>(getGetMemberOnboardingRecommendedPlansUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingRecommendedPlansQueryKey = (params?: GetMemberOnboardingRecommendedPlansParams,) => {
    return [
    `/api/web/member_onboarding/recommended_plans`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMemberOnboardingRecommendedPlansQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError = unknown>(params?: GetMemberOnboardingRecommendedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingRecommendedPlansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>> = ({ signal }) => getMemberOnboardingRecommendedPlans(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingRecommendedPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>>
export type GetMemberOnboardingRecommendedPlansQueryError = unknown


export function useGetMemberOnboardingRecommendedPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError = unknown>(
 params: undefined |  GetMemberOnboardingRecommendedPlansParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingRecommendedPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError = unknown>(
 params?: GetMemberOnboardingRecommendedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingRecommendedPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError = unknown>(
 params?: GetMemberOnboardingRecommendedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingRecommendedPlans<TData = Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError = unknown>(
 params?: GetMemberOnboardingRecommendedPlansParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingRecommendedPlans>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingRecommendedPlansQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Enroll in a recommended medical plan
 */
export const getPostMemberOnboardingRecommendedPlansSelectUrl = () => {


  

  return `/api/web/member_onboarding/recommended_plans/select`
}

export const postMemberOnboardingRecommendedPlansSelect = async (postMemberOnboardingRecommendedPlansSelect: PostMemberOnboardingRecommendedPlansSelect, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostMemberOnboardingRecommendedPlansSelectUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingRecommendedPlansSelect,)
  }
);}




export const getPostMemberOnboardingRecommendedPlansSelectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingRecommendedPlansSelect>>, TError,{data: PostMemberOnboardingRecommendedPlansSelect}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingRecommendedPlansSelect>>, TError,{data: PostMemberOnboardingRecommendedPlansSelect}, TContext> => {

const mutationKey = ['postMemberOnboardingRecommendedPlansSelect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingRecommendedPlansSelect>>, {data: PostMemberOnboardingRecommendedPlansSelect}> = (props) => {
          const {data} = props ?? {};

          return  postMemberOnboardingRecommendedPlansSelect(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingRecommendedPlansSelectMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingRecommendedPlansSelect>>>
    export type PostMemberOnboardingRecommendedPlansSelectMutationBody = PostMemberOnboardingRecommendedPlansSelect
    export type PostMemberOnboardingRecommendedPlansSelectMutationError = unknown

    export const usePostMemberOnboardingRecommendedPlansSelect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingRecommendedPlansSelect>>, TError,{data: PostMemberOnboardingRecommendedPlansSelect}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingRecommendedPlansSelect>>,
        TError,
        {data: PostMemberOnboardingRecommendedPlansSelect},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingRecommendedPlansSelectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Opt out of coverage for a specific year
 */
export const getPutMemberOnboardingMemberIchraConfigOptOutUrl = () => {


  

  return `/api/web/member_onboarding/member_ichra_config/opt_out`
}

export const putMemberOnboardingMemberIchraConfigOptOut = async (putMemberOnboardingMemberIchraConfigOptOut: PutMemberOnboardingMemberIchraConfigOptOut, options?: RequestInit): Promise<MemberICHRAConfig> => {
  
  return customFetch<MemberICHRAConfig>(getPutMemberOnboardingMemberIchraConfigOptOutUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putMemberOnboardingMemberIchraConfigOptOut,)
  }
);}




export const getPutMemberOnboardingMemberIchraConfigOptOutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemberOnboardingMemberIchraConfigOptOut>>, TError,{data: PutMemberOnboardingMemberIchraConfigOptOut}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putMemberOnboardingMemberIchraConfigOptOut>>, TError,{data: PutMemberOnboardingMemberIchraConfigOptOut}, TContext> => {

const mutationKey = ['putMemberOnboardingMemberIchraConfigOptOut'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMemberOnboardingMemberIchraConfigOptOut>>, {data: PutMemberOnboardingMemberIchraConfigOptOut}> = (props) => {
          const {data} = props ?? {};

          return  putMemberOnboardingMemberIchraConfigOptOut(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMemberOnboardingMemberIchraConfigOptOutMutationResult = NonNullable<Awaited<ReturnType<typeof putMemberOnboardingMemberIchraConfigOptOut>>>
    export type PutMemberOnboardingMemberIchraConfigOptOutMutationBody = PutMemberOnboardingMemberIchraConfigOptOut
    export type PutMemberOnboardingMemberIchraConfigOptOutMutationError = unknown

    export const usePutMemberOnboardingMemberIchraConfigOptOut = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemberOnboardingMemberIchraConfigOptOut>>, TError,{data: PutMemberOnboardingMemberIchraConfigOptOut}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMemberOnboardingMemberIchraConfigOptOut>>,
        TError,
        {data: PutMemberOnboardingMemberIchraConfigOptOut},
        TContext
      > => {

      const mutationOptions = getPutMemberOnboardingMemberIchraConfigOptOutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Start phone number verification process
 */
export const getPostMemberOnboardingPhoneVerificationStartUrl = () => {


  

  return `/api/web/member_onboarding/phone_verification/start`
}

export const postMemberOnboardingPhoneVerificationStart = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostMemberOnboardingPhoneVerificationStartUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMemberOnboardingPhoneVerificationStartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationStart>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationStart>>, TError,void, TContext> => {

const mutationKey = ['postMemberOnboardingPhoneVerificationStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationStart>>, void> = () => {
          

          return  postMemberOnboardingPhoneVerificationStart(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingPhoneVerificationStartMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationStart>>>
    
    export type PostMemberOnboardingPhoneVerificationStartMutationError = unknown

    export const usePostMemberOnboardingPhoneVerificationStart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationStart>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationStart>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingPhoneVerificationStartMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Verify phone number with the provided code
 */
export const getPostMemberOnboardingPhoneVerificationVerifyUrl = () => {


  

  return `/api/web/member_onboarding/phone_verification/verify`
}

export const postMemberOnboardingPhoneVerificationVerify = async (postMemberOnboardingPhoneVerificationVerify: PostMemberOnboardingPhoneVerificationVerify, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostMemberOnboardingPhoneVerificationVerifyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingPhoneVerificationVerify,)
  }
);}




export const getPostMemberOnboardingPhoneVerificationVerifyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationVerify>>, TError,{data: PostMemberOnboardingPhoneVerificationVerify}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationVerify>>, TError,{data: PostMemberOnboardingPhoneVerificationVerify}, TContext> => {

const mutationKey = ['postMemberOnboardingPhoneVerificationVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationVerify>>, {data: PostMemberOnboardingPhoneVerificationVerify}> = (props) => {
          const {data} = props ?? {};

          return  postMemberOnboardingPhoneVerificationVerify(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingPhoneVerificationVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationVerify>>>
    export type PostMemberOnboardingPhoneVerificationVerifyMutationBody = PostMemberOnboardingPhoneVerificationVerify
    export type PostMemberOnboardingPhoneVerificationVerifyMutationError = unknown

    export const usePostMemberOnboardingPhoneVerificationVerify = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationVerify>>, TError,{data: PostMemberOnboardingPhoneVerificationVerify}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingPhoneVerificationVerify>>,
        TError,
        {data: PostMemberOnboardingPhoneVerificationVerify},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingPhoneVerificationVerifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all in network verification tasks for a member
 */
export const getGetMemberOnboardingInNetworkVerificationUrl = () => {


  

  return `/api/web/member_onboarding/in_network_verification`
}

export const getMemberOnboardingInNetworkVerification = async ( options?: RequestInit): Promise<MemberOnboardingInNetworkVerificationRecord> => {
  
  return customFetch<MemberOnboardingInNetworkVerificationRecord>(getGetMemberOnboardingInNetworkVerificationUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingInNetworkVerificationQueryKey = () => {
    return [
    `/api/web/member_onboarding/in_network_verification`
    ] as const;
    }

    
export const getGetMemberOnboardingInNetworkVerificationQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingInNetworkVerificationQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>> = ({ signal }) => getMemberOnboardingInNetworkVerification({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingInNetworkVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>>
export type GetMemberOnboardingInNetworkVerificationQueryError = unknown


export function useGetMemberOnboardingInNetworkVerification<TData = Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingInNetworkVerification<TData = Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingInNetworkVerification<TData = Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingInNetworkVerification<TData = Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingInNetworkVerification>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingInNetworkVerificationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a verification task for in network status
 */
export const getPostMemberOnboardingInNetworkVerificationUrl = () => {


  

  return `/api/web/member_onboarding/in_network_verification`
}

export const postMemberOnboardingInNetworkVerification = async (postMemberOnboardingInNetworkVerification: PostMemberOnboardingInNetworkVerification, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostMemberOnboardingInNetworkVerificationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMemberOnboardingInNetworkVerification,)
  }
);}




export const getPostMemberOnboardingInNetworkVerificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingInNetworkVerification>>, TError,{data: PostMemberOnboardingInNetworkVerification}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingInNetworkVerification>>, TError,{data: PostMemberOnboardingInNetworkVerification}, TContext> => {

const mutationKey = ['postMemberOnboardingInNetworkVerification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingInNetworkVerification>>, {data: PostMemberOnboardingInNetworkVerification}> = (props) => {
          const {data} = props ?? {};

          return  postMemberOnboardingInNetworkVerification(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingInNetworkVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingInNetworkVerification>>>
    export type PostMemberOnboardingInNetworkVerificationMutationBody = PostMemberOnboardingInNetworkVerification
    export type PostMemberOnboardingInNetworkVerificationMutationError = unknown

    export const usePostMemberOnboardingInNetworkVerification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingInNetworkVerification>>, TError,{data: PostMemberOnboardingInNetworkVerification}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingInNetworkVerification>>,
        TError,
        {data: PostMemberOnboardingInNetworkVerification},
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingInNetworkVerificationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a proof of coverage document
 */
export const getPostMemberOnboardingProofOfCoverageUploadUrl = () => {


  

  return `/api/web/member_onboarding/proof_of_coverage/upload`
}

export const postMemberOnboardingProofOfCoverageUpload = async ( options?: RequestInit): Promise<MemberOnboardingProofOfCoverage> => {
  
  return customFetch<MemberOnboardingProofOfCoverage>(getPostMemberOnboardingProofOfCoverageUploadUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMemberOnboardingProofOfCoverageUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingProofOfCoverageUpload>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingProofOfCoverageUpload>>, TError,void, TContext> => {

const mutationKey = ['postMemberOnboardingProofOfCoverageUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMemberOnboardingProofOfCoverageUpload>>, void> = () => {
          

          return  postMemberOnboardingProofOfCoverageUpload(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMemberOnboardingProofOfCoverageUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postMemberOnboardingProofOfCoverageUpload>>>
    
    export type PostMemberOnboardingProofOfCoverageUploadMutationError = unknown

    export const usePostMemberOnboardingProofOfCoverageUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMemberOnboardingProofOfCoverageUpload>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMemberOnboardingProofOfCoverageUpload>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMemberOnboardingProofOfCoverageUploadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetches the most recent proof of coverage document
 */
export const getGetMemberOnboardingProofOfCoverageMostRecentUrl = (params?: GetMemberOnboardingProofOfCoverageMostRecentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/member_onboarding/proof_of_coverage/most_recent?${stringifiedParams}` : `/api/web/member_onboarding/proof_of_coverage/most_recent`
}

export const getMemberOnboardingProofOfCoverageMostRecent = async (params?: GetMemberOnboardingProofOfCoverageMostRecentParams, options?: RequestInit): Promise<MemberOnboardingProofOfCoverage> => {
  
  return customFetch<MemberOnboardingProofOfCoverage>(getGetMemberOnboardingProofOfCoverageMostRecentUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMemberOnboardingProofOfCoverageMostRecentQueryKey = (params?: GetMemberOnboardingProofOfCoverageMostRecentParams,) => {
    return [
    `/api/web/member_onboarding/proof_of_coverage/most_recent`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMemberOnboardingProofOfCoverageMostRecentQueryOptions = <TData = Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError = unknown>(params?: GetMemberOnboardingProofOfCoverageMostRecentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemberOnboardingProofOfCoverageMostRecentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>> = ({ signal }) => getMemberOnboardingProofOfCoverageMostRecent(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemberOnboardingProofOfCoverageMostRecentQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>>
export type GetMemberOnboardingProofOfCoverageMostRecentQueryError = unknown


export function useGetMemberOnboardingProofOfCoverageMostRecent<TData = Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError = unknown>(
 params: undefined |  GetMemberOnboardingProofOfCoverageMostRecentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingProofOfCoverageMostRecent<TData = Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError = unknown>(
 params?: GetMemberOnboardingProofOfCoverageMostRecentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>,
          TError,
          Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemberOnboardingProofOfCoverageMostRecent<TData = Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError = unknown>(
 params?: GetMemberOnboardingProofOfCoverageMostRecentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMemberOnboardingProofOfCoverageMostRecent<TData = Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError = unknown>(
 params?: GetMemberOnboardingProofOfCoverageMostRecentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberOnboardingProofOfCoverageMostRecent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemberOnboardingProofOfCoverageMostRecentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete a proof of coverage document
 */
export const getDeleteMemberOnboardingProofOfCoverageFileIdUrl = (fileId: string,) => {


  

  return `/api/web/member_onboarding/proof_of_coverage/${fileId}`
}

export const deleteMemberOnboardingProofOfCoverageFileId = async (fileId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeleteMemberOnboardingProofOfCoverageFileIdUrl(fileId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteMemberOnboardingProofOfCoverageFileIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingProofOfCoverageFileId>>, TError,{fileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingProofOfCoverageFileId>>, TError,{fileId: string}, TContext> => {

const mutationKey = ['deleteMemberOnboardingProofOfCoverageFileId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMemberOnboardingProofOfCoverageFileId>>, {fileId: string}> = (props) => {
          const {fileId} = props ?? {};

          return  deleteMemberOnboardingProofOfCoverageFileId(fileId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMemberOnboardingProofOfCoverageFileIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMemberOnboardingProofOfCoverageFileId>>>
    
    export type DeleteMemberOnboardingProofOfCoverageFileIdMutationError = unknown

    export const useDeleteMemberOnboardingProofOfCoverageFileId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemberOnboardingProofOfCoverageFileId>>, TError,{fileId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMemberOnboardingProofOfCoverageFileId>>,
        TError,
        {fileId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMemberOnboardingProofOfCoverageFileIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get ADP configuration
 */
export const getGetPayrollAdpConfigUrl = () => {


  

  return `/api/web/payroll/adp/config`
}

export const getPayrollAdpConfig = async ( options?: RequestInit): Promise<PayrollAdpConfig> => {
  
  return customFetch<PayrollAdpConfig>(getGetPayrollAdpConfigUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollAdpConfigQueryKey = () => {
    return [
    `/api/web/payroll/adp/config`
    ] as const;
    }

    
export const getGetPayrollAdpConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollAdpConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollAdpConfig>>> = ({ signal }) => getPayrollAdpConfig({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollAdpConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollAdpConfig>>>
export type GetPayrollAdpConfigQueryError = unknown


export function useGetPayrollAdpConfig<TData = Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollAdpConfig>>,
          TError,
          Awaited<ReturnType<typeof getPayrollAdpConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollAdpConfig<TData = Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollAdpConfig>>,
          TError,
          Awaited<ReturnType<typeof getPayrollAdpConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollAdpConfig<TData = Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollAdpConfig<TData = Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollAdpConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get ADP authorization URI
 */
export const getPostPayrollAdpConnectAuthorizeUriUrl = () => {


  

  return `/api/web/payroll/adp/connect/authorize_uri`
}

export const postPayrollAdpConnectAuthorizeUri = async (postPayrollAdpConnectAuthorizeUri: PostPayrollAdpConnectAuthorizeUri, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollAdpConnectAuthorizeUriUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollAdpConnectAuthorizeUri,)
  }
);}




export const getPostPayrollAdpConnectAuthorizeUriMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollAdpConnectAuthorizeUri>>, TError,{data: PostPayrollAdpConnectAuthorizeUri}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollAdpConnectAuthorizeUri>>, TError,{data: PostPayrollAdpConnectAuthorizeUri}, TContext> => {

const mutationKey = ['postPayrollAdpConnectAuthorizeUri'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollAdpConnectAuthorizeUri>>, {data: PostPayrollAdpConnectAuthorizeUri}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollAdpConnectAuthorizeUri(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollAdpConnectAuthorizeUriMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollAdpConnectAuthorizeUri>>>
    export type PostPayrollAdpConnectAuthorizeUriMutationBody = PostPayrollAdpConnectAuthorizeUri
    export type PostPayrollAdpConnectAuthorizeUriMutationError = unknown

    export const usePostPayrollAdpConnectAuthorizeUri = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollAdpConnectAuthorizeUri>>, TError,{data: PostPayrollAdpConnectAuthorizeUri}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollAdpConnectAuthorizeUri>>,
        TError,
        {data: PostPayrollAdpConnectAuthorizeUri},
        TContext
      > => {

      const mutationOptions = getPostPayrollAdpConnectAuthorizeUriMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Handle ADP OAuth callback or ADP consent manager redirect
 */
export const getGetPayrollAdpConnectCallbackUrl = (params?: GetPayrollAdpConnectCallbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/adp/connect/callback?${stringifiedParams}` : `/api/web/payroll/adp/connect/callback`
}

export const getPayrollAdpConnectCallback = async (params?: GetPayrollAdpConnectCallbackParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetPayrollAdpConnectCallbackUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollAdpConnectCallbackQueryKey = (params?: GetPayrollAdpConnectCallbackParams,) => {
    return [
    `/api/web/payroll/adp/connect/callback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollAdpConnectCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError = unknown>(params?: GetPayrollAdpConnectCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollAdpConnectCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>> = ({ signal }) => getPayrollAdpConnectCallback(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollAdpConnectCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>>
export type GetPayrollAdpConnectCallbackQueryError = unknown


export function useGetPayrollAdpConnectCallback<TData = Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError = unknown>(
 params: undefined |  GetPayrollAdpConnectCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>,
          TError,
          Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollAdpConnectCallback<TData = Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError = unknown>(
 params?: GetPayrollAdpConnectCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>,
          TError,
          Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollAdpConnectCallback<TData = Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError = unknown>(
 params?: GetPayrollAdpConnectCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollAdpConnectCallback<TData = Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError = unknown>(
 params?: GetPayrollAdpConnectCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollAdpConnectCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollAdpConnectCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List deductions for a pay period
 */
export const getGetPayrollConsistentDeductionsUrl = (params: GetPayrollConsistentDeductionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/consistent_deductions?${stringifiedParams}` : `/api/web/payroll/consistent_deductions`
}

export const getPayrollConsistentDeductions = async (params: GetPayrollConsistentDeductionsParams, options?: RequestInit): Promise<PayrollPayPeriodConsistentDeductionsList> => {
  
  return customFetch<PayrollPayPeriodConsistentDeductionsList>(getGetPayrollConsistentDeductionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollConsistentDeductionsQueryKey = (params?: GetPayrollConsistentDeductionsParams,) => {
    return [
    `/api/web/payroll/consistent_deductions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollConsistentDeductionsQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError = unknown>(params: GetPayrollConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollConsistentDeductionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>> = ({ signal }) => getPayrollConsistentDeductions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollConsistentDeductionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>>
export type GetPayrollConsistentDeductionsQueryError = unknown


export function useGetPayrollConsistentDeductions<TData = Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError = unknown>(
 params: GetPayrollConsistentDeductionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollConsistentDeductions>>,
          TError,
          Awaited<ReturnType<typeof getPayrollConsistentDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollConsistentDeductions<TData = Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError = unknown>(
 params: GetPayrollConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollConsistentDeductions>>,
          TError,
          Awaited<ReturnType<typeof getPayrollConsistentDeductions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollConsistentDeductions<TData = Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError = unknown>(
 params: GetPayrollConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollConsistentDeductions<TData = Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError = unknown>(
 params: GetPayrollConsistentDeductionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollConsistentDeductions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollConsistentDeductionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a connect session for the Payroll::ProviderConfig
 */
export const getPostPayrollFinchCreateConnectSessionUrl = () => {


  

  return `/api/web/payroll/finch/create_connect_session`
}

export const postPayrollFinchCreateConnectSession = async (postPayrollFinchCreateConnectSession: PostPayrollFinchCreateConnectSession, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollFinchCreateConnectSessionUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollFinchCreateConnectSession,)
  }
);}




export const getPostPayrollFinchCreateConnectSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchCreateConnectSession>>, TError,{data: PostPayrollFinchCreateConnectSession}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchCreateConnectSession>>, TError,{data: PostPayrollFinchCreateConnectSession}, TContext> => {

const mutationKey = ['postPayrollFinchCreateConnectSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollFinchCreateConnectSession>>, {data: PostPayrollFinchCreateConnectSession}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollFinchCreateConnectSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollFinchCreateConnectSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollFinchCreateConnectSession>>>
    export type PostPayrollFinchCreateConnectSessionMutationBody = PostPayrollFinchCreateConnectSession
    export type PostPayrollFinchCreateConnectSessionMutationError = unknown

    export const usePostPayrollFinchCreateConnectSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchCreateConnectSession>>, TError,{data: PostPayrollFinchCreateConnectSession}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollFinchCreateConnectSession>>,
        TError,
        {data: PostPayrollFinchCreateConnectSession},
        TContext
      > => {

      const mutationOptions = getPostPayrollFinchCreateConnectSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a reauthentication session for the employer's Finch connection
 */
export const getPostPayrollFinchCreateReauthenticationSessionUrl = () => {


  

  return `/api/web/payroll/finch/create_reauthentication_session`
}

export const postPayrollFinchCreateReauthenticationSession = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollFinchCreateReauthenticationSessionUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostPayrollFinchCreateReauthenticationSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchCreateReauthenticationSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchCreateReauthenticationSession>>, TError,void, TContext> => {

const mutationKey = ['postPayrollFinchCreateReauthenticationSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollFinchCreateReauthenticationSession>>, void> = () => {
          

          return  postPayrollFinchCreateReauthenticationSession(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollFinchCreateReauthenticationSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollFinchCreateReauthenticationSession>>>
    
    export type PostPayrollFinchCreateReauthenticationSessionMutationError = unknown

    export const usePostPayrollFinchCreateReauthenticationSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchCreateReauthenticationSession>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollFinchCreateReauthenticationSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayrollFinchCreateReauthenticationSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Exchange an authorization code for an access token and store it on the employer's payroll config
 */
export const getPostPayrollFinchExchangeAuthorizationCodeUrl = () => {


  

  return `/api/web/payroll/finch/exchange_authorization_code`
}

export const postPayrollFinchExchangeAuthorizationCode = async (postPayrollFinchExchangeAuthorizationCode: PostPayrollFinchExchangeAuthorizationCode, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollFinchExchangeAuthorizationCodeUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollFinchExchangeAuthorizationCode,)
  }
);}




export const getPostPayrollFinchExchangeAuthorizationCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchExchangeAuthorizationCode>>, TError,{data: PostPayrollFinchExchangeAuthorizationCode}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchExchangeAuthorizationCode>>, TError,{data: PostPayrollFinchExchangeAuthorizationCode}, TContext> => {

const mutationKey = ['postPayrollFinchExchangeAuthorizationCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollFinchExchangeAuthorizationCode>>, {data: PostPayrollFinchExchangeAuthorizationCode}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollFinchExchangeAuthorizationCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollFinchExchangeAuthorizationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollFinchExchangeAuthorizationCode>>>
    export type PostPayrollFinchExchangeAuthorizationCodeMutationBody = PostPayrollFinchExchangeAuthorizationCode
    export type PostPayrollFinchExchangeAuthorizationCodeMutationError = unknown

    export const usePostPayrollFinchExchangeAuthorizationCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollFinchExchangeAuthorizationCode>>, TError,{data: PostPayrollFinchExchangeAuthorizationCode}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollFinchExchangeAuthorizationCode>>,
        TError,
        {data: PostPayrollFinchExchangeAuthorizationCode},
        TContext
      > => {

      const mutationOptions = getPostPayrollFinchExchangeAuthorizationCodeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a Kombo Connect link
 */
export const getPostPayrollKomboCreateConnectLinkUrl = () => {


  

  return `/api/web/payroll/kombo/create_connect_link`
}

export const postPayrollKomboCreateConnectLink = async (postPayrollKomboCreateConnectLink: PostPayrollKomboCreateConnectLink, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollKomboCreateConnectLinkUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollKomboCreateConnectLink,)
  }
);}




export const getPostPayrollKomboCreateConnectLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboCreateConnectLink>>, TError,{data: PostPayrollKomboCreateConnectLink}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboCreateConnectLink>>, TError,{data: PostPayrollKomboCreateConnectLink}, TContext> => {

const mutationKey = ['postPayrollKomboCreateConnectLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollKomboCreateConnectLink>>, {data: PostPayrollKomboCreateConnectLink}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollKomboCreateConnectLink(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollKomboCreateConnectLinkMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollKomboCreateConnectLink>>>
    export type PostPayrollKomboCreateConnectLinkMutationBody = PostPayrollKomboCreateConnectLink
    export type PostPayrollKomboCreateConnectLinkMutationError = unknown

    export const usePostPayrollKomboCreateConnectLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboCreateConnectLink>>, TError,{data: PostPayrollKomboCreateConnectLink}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollKomboCreateConnectLink>>,
        TError,
        {data: PostPayrollKomboCreateConnectLink},
        TContext
      > => {

      const mutationOptions = getPostPayrollKomboCreateConnectLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a Kombo Connect reconnect link
 */
export const getPostPayrollKomboCreateReconnectLinkUrl = () => {


  

  return `/api/web/payroll/kombo/create_reconnect_link`
}

export const postPayrollKomboCreateReconnectLink = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollKomboCreateReconnectLinkUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostPayrollKomboCreateReconnectLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboCreateReconnectLink>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboCreateReconnectLink>>, TError,void, TContext> => {

const mutationKey = ['postPayrollKomboCreateReconnectLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollKomboCreateReconnectLink>>, void> = () => {
          

          return  postPayrollKomboCreateReconnectLink(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollKomboCreateReconnectLinkMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollKomboCreateReconnectLink>>>
    
    export type PostPayrollKomboCreateReconnectLinkMutationError = unknown

    export const usePostPayrollKomboCreateReconnectLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboCreateReconnectLink>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollKomboCreateReconnectLink>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayrollKomboCreateReconnectLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Activate a Kombo integration
 */
export const getPostPayrollKomboActivateUrl = () => {


  

  return `/api/web/payroll/kombo/activate`
}

export const postPayrollKomboActivate = async (postPayrollKomboActivate: PostPayrollKomboActivate, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollKomboActivateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollKomboActivate,)
  }
);}




export const getPostPayrollKomboActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboActivate>>, TError,{data: PostPayrollKomboActivate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboActivate>>, TError,{data: PostPayrollKomboActivate}, TContext> => {

const mutationKey = ['postPayrollKomboActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollKomboActivate>>, {data: PostPayrollKomboActivate}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollKomboActivate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollKomboActivateMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollKomboActivate>>>
    export type PostPayrollKomboActivateMutationBody = PostPayrollKomboActivate
    export type PostPayrollKomboActivateMutationError = unknown

    export const usePostPayrollKomboActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollKomboActivate>>, TError,{data: PostPayrollKomboActivate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollKomboActivate>>,
        TError,
        {data: PostPayrollKomboActivate},
        TContext
      > => {

      const mutationOptions = getPostPayrollKomboActivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the employer's payroll config
 */
export const getGetPayrollManageConfigUrl = () => {


  

  return `/api/web/payroll/manage/config`
}

export const getPayrollManageConfig = async ( options?: RequestInit): Promise<PayrollPayrollConfig> => {
  
  return customFetch<PayrollPayrollConfig>(getGetPayrollManageConfigUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollManageConfigQueryKey = () => {
    return [
    `/api/web/payroll/manage/config`
    ] as const;
    }

    
export const getGetPayrollManageConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollManageConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollManageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollManageConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollManageConfig>>> = ({ signal }) => getPayrollManageConfig({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollManageConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollManageConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollManageConfig>>>
export type GetPayrollManageConfigQueryError = unknown


export function useGetPayrollManageConfig<TData = Awaited<ReturnType<typeof getPayrollManageConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollManageConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollManageConfig>>,
          TError,
          Awaited<ReturnType<typeof getPayrollManageConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollManageConfig<TData = Awaited<ReturnType<typeof getPayrollManageConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollManageConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollManageConfig>>,
          TError,
          Awaited<ReturnType<typeof getPayrollManageConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollManageConfig<TData = Awaited<ReturnType<typeof getPayrollManageConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollManageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollManageConfig<TData = Awaited<ReturnType<typeof getPayrollManageConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollManageConfig>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollManageConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Disconnect the existing payroll connection
 */
export const getPostPayrollManageDisconnectUrl = () => {


  

  return `/api/web/payroll/manage/disconnect`
}

export const postPayrollManageDisconnect = async ( options?: RequestInit): Promise<PayrollPayrollConfig> => {
  
  return customFetch<PayrollPayrollConfig>(getPostPayrollManageDisconnectUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostPayrollManageDisconnectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageDisconnect>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageDisconnect>>, TError,void, TContext> => {

const mutationKey = ['postPayrollManageDisconnect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollManageDisconnect>>, void> = () => {
          

          return  postPayrollManageDisconnect(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollManageDisconnectMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollManageDisconnect>>>
    
    export type PostPayrollManageDisconnectMutationError = unknown

    export const usePostPayrollManageDisconnect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageDisconnect>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollManageDisconnect>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayrollManageDisconnectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update automated deductions settings
 */
export const getPostPayrollManageAutomatedDeductionsUrl = () => {


  

  return `/api/web/payroll/manage/automated_deductions`
}

export const postPayrollManageAutomatedDeductions = async (postPayrollManageAutomatedDeductions: PostPayrollManageAutomatedDeductions, options?: RequestInit): Promise<PayrollPayrollConfig> => {
  
  return customFetch<PayrollPayrollConfig>(getPostPayrollManageAutomatedDeductionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollManageAutomatedDeductions,)
  }
);}




export const getPostPayrollManageAutomatedDeductionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageAutomatedDeductions>>, TError,{data: PostPayrollManageAutomatedDeductions}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageAutomatedDeductions>>, TError,{data: PostPayrollManageAutomatedDeductions}, TContext> => {

const mutationKey = ['postPayrollManageAutomatedDeductions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollManageAutomatedDeductions>>, {data: PostPayrollManageAutomatedDeductions}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollManageAutomatedDeductions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollManageAutomatedDeductionsMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollManageAutomatedDeductions>>>
    export type PostPayrollManageAutomatedDeductionsMutationBody = PostPayrollManageAutomatedDeductions
    export type PostPayrollManageAutomatedDeductionsMutationError = unknown

    export const usePostPayrollManageAutomatedDeductions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageAutomatedDeductions>>, TError,{data: PostPayrollManageAutomatedDeductions}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollManageAutomatedDeductions>>,
        TError,
        {data: PostPayrollManageAutomatedDeductions},
        TContext
      > => {

      const mutationOptions = getPostPayrollManageAutomatedDeductionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Hide the automated deductions notice banner
 */
export const getPostPayrollManageHideAutomatedDeductionsNoticeUrl = () => {


  

  return `/api/web/payroll/manage/hide_automated_deductions_notice`
}

export const postPayrollManageHideAutomatedDeductionsNotice = async ( options?: RequestInit): Promise<PayrollPayrollConfig> => {
  
  return customFetch<PayrollPayrollConfig>(getPostPayrollManageHideAutomatedDeductionsNoticeUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostPayrollManageHideAutomatedDeductionsNoticeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageHideAutomatedDeductionsNotice>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageHideAutomatedDeductionsNotice>>, TError,void, TContext> => {

const mutationKey = ['postPayrollManageHideAutomatedDeductionsNotice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollManageHideAutomatedDeductionsNotice>>, void> = () => {
          

          return  postPayrollManageHideAutomatedDeductionsNotice(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollManageHideAutomatedDeductionsNoticeMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollManageHideAutomatedDeductionsNotice>>>
    
    export type PostPayrollManageHideAutomatedDeductionsNoticeMutationError = unknown

    export const usePostPayrollManageHideAutomatedDeductionsNotice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollManageHideAutomatedDeductionsNotice>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollManageHideAutomatedDeductionsNotice>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPayrollManageHideAutomatedDeductionsNoticeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a link token for the Payroll::ProviderConfig
 */
export const getPostPayrollMergeCreateLinkTokenUrl = () => {


  

  return `/api/web/payroll/merge/create_link_token`
}

export const postPayrollMergeCreateLinkToken = async (postPayrollMergeCreateLinkToken: PostPayrollMergeCreateLinkToken, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollMergeCreateLinkTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollMergeCreateLinkToken,)
  }
);}




export const getPostPayrollMergeCreateLinkTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeCreateLinkToken>>, TError,{data: PostPayrollMergeCreateLinkToken}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeCreateLinkToken>>, TError,{data: PostPayrollMergeCreateLinkToken}, TContext> => {

const mutationKey = ['postPayrollMergeCreateLinkToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollMergeCreateLinkToken>>, {data: PostPayrollMergeCreateLinkToken}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollMergeCreateLinkToken(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollMergeCreateLinkTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollMergeCreateLinkToken>>>
    export type PostPayrollMergeCreateLinkTokenMutationBody = PostPayrollMergeCreateLinkToken
    export type PostPayrollMergeCreateLinkTokenMutationError = unknown

    export const usePostPayrollMergeCreateLinkToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeCreateLinkToken>>, TError,{data: PostPayrollMergeCreateLinkToken}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollMergeCreateLinkToken>>,
        TError,
        {data: PostPayrollMergeCreateLinkToken},
        TContext
      > => {

      const mutationOptions = getPostPayrollMergeCreateLinkTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Exchange an public token for an account token and store it on the employer's payroll config
 */
export const getPostPayrollMergeExchangePublicTokenUrl = () => {


  

  return `/api/web/payroll/merge/exchange_public_token`
}

export const postPayrollMergeExchangePublicToken = async (postPayrollMergeExchangePublicToken: PostPayrollMergeExchangePublicToken, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollMergeExchangePublicTokenUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollMergeExchangePublicToken,)
  }
);}




export const getPostPayrollMergeExchangePublicTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeExchangePublicToken>>, TError,{data: PostPayrollMergeExchangePublicToken}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeExchangePublicToken>>, TError,{data: PostPayrollMergeExchangePublicToken}, TContext> => {

const mutationKey = ['postPayrollMergeExchangePublicToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollMergeExchangePublicToken>>, {data: PostPayrollMergeExchangePublicToken}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollMergeExchangePublicToken(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollMergeExchangePublicTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollMergeExchangePublicToken>>>
    export type PostPayrollMergeExchangePublicTokenMutationBody = PostPayrollMergeExchangePublicToken
    export type PostPayrollMergeExchangePublicTokenMutationError = unknown

    export const usePostPayrollMergeExchangePublicToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeExchangePublicToken>>, TError,{data: PostPayrollMergeExchangePublicToken}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollMergeExchangePublicToken>>,
        TError,
        {data: PostPayrollMergeExchangePublicToken},
        TContext
      > => {

      const mutationOptions = getPostPayrollMergeExchangePublicTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Attach employer to a shared Merge connection
 */
export const getPostPayrollMergeSharedConnectionUrl = () => {


  

  return `/api/web/payroll/merge/shared_connection`
}

export const postPayrollMergeSharedConnection = async (postPayrollMergeSharedConnection: PostPayrollMergeSharedConnection, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollMergeSharedConnectionUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollMergeSharedConnection,)
  }
);}




export const getPostPayrollMergeSharedConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeSharedConnection>>, TError,{data: PostPayrollMergeSharedConnection}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeSharedConnection>>, TError,{data: PostPayrollMergeSharedConnection}, TContext> => {

const mutationKey = ['postPayrollMergeSharedConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollMergeSharedConnection>>, {data: PostPayrollMergeSharedConnection}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollMergeSharedConnection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollMergeSharedConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollMergeSharedConnection>>>
    export type PostPayrollMergeSharedConnectionMutationBody = PostPayrollMergeSharedConnection
    export type PostPayrollMergeSharedConnectionMutationError = unknown

    export const usePostPayrollMergeSharedConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollMergeSharedConnection>>, TError,{data: PostPayrollMergeSharedConnection}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollMergeSharedConnection>>,
        TError,
        {data: PostPayrollMergeSharedConnection},
        TContext
      > => {

      const mutationOptions = getPostPayrollMergeSharedConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List pay periods
 */
export const getGetPayrollPayPeriodsUrl = (params: GetPayrollPayPeriodsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/pay_periods?${stringifiedParams}` : `/api/web/payroll/pay_periods`
}

export const getPayrollPayPeriods = async (params: GetPayrollPayPeriodsParams, options?: RequestInit): Promise<PayrollPayPeriodList> => {
  
  return customFetch<PayrollPayPeriodList>(getGetPayrollPayPeriodsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollPayPeriodsQueryKey = (params?: GetPayrollPayPeriodsParams,) => {
    return [
    `/api/web/payroll/pay_periods`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollPayPeriodsQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError = unknown>(params: GetPayrollPayPeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollPayPeriodsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollPayPeriods>>> = ({ signal }) => getPayrollPayPeriods(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollPayPeriodsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollPayPeriods>>>
export type GetPayrollPayPeriodsQueryError = unknown


export function useGetPayrollPayPeriods<TData = Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError = unknown>(
 params: GetPayrollPayPeriodsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollPayPeriods>>,
          TError,
          Awaited<ReturnType<typeof getPayrollPayPeriods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollPayPeriods<TData = Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError = unknown>(
 params: GetPayrollPayPeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollPayPeriods>>,
          TError,
          Awaited<ReturnType<typeof getPayrollPayPeriods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollPayPeriods<TData = Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError = unknown>(
 params: GetPayrollPayPeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollPayPeriods<TData = Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError = unknown>(
 params: GetPayrollPayPeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPayPeriods>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollPayPeriodsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List pay schedules
 */
export const getGetPayrollPaySchedulesUrl = (params?: GetPayrollPaySchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/pay_schedules?${stringifiedParams}` : `/api/web/payroll/pay_schedules`
}

export const getPayrollPaySchedules = async (params?: GetPayrollPaySchedulesParams, options?: RequestInit): Promise<PayrollPayScheduleList> => {
  
  return customFetch<PayrollPayScheduleList>(getGetPayrollPaySchedulesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollPaySchedulesQueryKey = (params?: GetPayrollPaySchedulesParams,) => {
    return [
    `/api/web/payroll/pay_schedules`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollPaySchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError = unknown>(params?: GetPayrollPaySchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollPaySchedulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollPaySchedules>>> = ({ signal }) => getPayrollPaySchedules(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollPaySchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollPaySchedules>>>
export type GetPayrollPaySchedulesQueryError = unknown


export function useGetPayrollPaySchedules<TData = Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError = unknown>(
 params: undefined |  GetPayrollPaySchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollPaySchedules>>,
          TError,
          Awaited<ReturnType<typeof getPayrollPaySchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollPaySchedules<TData = Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError = unknown>(
 params?: GetPayrollPaySchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollPaySchedules>>,
          TError,
          Awaited<ReturnType<typeof getPayrollPaySchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollPaySchedules<TData = Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError = unknown>(
 params?: GetPayrollPaySchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollPaySchedules<TData = Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError = unknown>(
 params?: GetPayrollPaySchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollPaySchedulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a pay schedule
 */
export const getPostPayrollPaySchedulesUrl = () => {


  

  return `/api/web/payroll/pay_schedules`
}

export const postPayrollPaySchedules = async (postPayrollPaySchedules: PostPayrollPaySchedules, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPayrollPaySchedulesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPayrollPaySchedules,)
  }
);}




export const getPostPayrollPaySchedulesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollPaySchedules>>, TError,{data: PostPayrollPaySchedules}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollPaySchedules>>, TError,{data: PostPayrollPaySchedules}, TContext> => {

const mutationKey = ['postPayrollPaySchedules'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollPaySchedules>>, {data: PostPayrollPaySchedules}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollPaySchedules(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollPaySchedulesMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollPaySchedules>>>
    export type PostPayrollPaySchedulesMutationBody = PostPayrollPaySchedules
    export type PostPayrollPaySchedulesMutationError = unknown

    export const usePostPayrollPaySchedules = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollPaySchedules>>, TError,{data: PostPayrollPaySchedules}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollPaySchedules>>,
        TError,
        {data: PostPayrollPaySchedules},
        TContext
      > => {

      const mutationOptions = getPostPayrollPaySchedulesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Preview the next three potential pay dates
 */
export const getGetPayrollPaySchedulesPreviewUrl = (params: GetPayrollPaySchedulesPreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/pay_schedules/preview?${stringifiedParams}` : `/api/web/payroll/pay_schedules/preview`
}

export const getPayrollPaySchedulesPreview = async (params: GetPayrollPaySchedulesPreviewParams, options?: RequestInit): Promise<PayrollSamplePayPeriodList> => {
  
  return customFetch<PayrollSamplePayPeriodList>(getGetPayrollPaySchedulesPreviewUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollPaySchedulesPreviewQueryKey = (params?: GetPayrollPaySchedulesPreviewParams,) => {
    return [
    `/api/web/payroll/pay_schedules/preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollPaySchedulesPreviewQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError = unknown>(params: GetPayrollPaySchedulesPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollPaySchedulesPreviewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>> = ({ signal }) => getPayrollPaySchedulesPreview(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollPaySchedulesPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>>
export type GetPayrollPaySchedulesPreviewQueryError = unknown


export function useGetPayrollPaySchedulesPreview<TData = Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError = unknown>(
 params: GetPayrollPaySchedulesPreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>,
          TError,
          Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollPaySchedulesPreview<TData = Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError = unknown>(
 params: GetPayrollPaySchedulesPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>,
          TError,
          Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollPaySchedulesPreview<TData = Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError = unknown>(
 params: GetPayrollPaySchedulesPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollPaySchedulesPreview<TData = Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError = unknown>(
 params: GetPayrollPaySchedulesPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollPaySchedulesPreview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollPaySchedulesPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Edit a pay schedule
 */
export const getPutPayrollPaySchedulesIdUrl = (id: string,) => {


  

  return `/api/web/payroll/pay_schedules/${id}`
}

export const putPayrollPaySchedulesId = async (id: string,
    putPayrollPaySchedulesId: PutPayrollPaySchedulesId, options?: RequestInit): Promise<PayrollPaySchedule> => {
  
  return customFetch<PayrollPaySchedule>(getPutPayrollPaySchedulesIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putPayrollPaySchedulesId,)
  }
);}




export const getPutPayrollPaySchedulesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollPaySchedulesId>>, TError,{id: string;data: PutPayrollPaySchedulesId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollPaySchedulesId>>, TError,{id: string;data: PutPayrollPaySchedulesId}, TContext> => {

const mutationKey = ['putPayrollPaySchedulesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollPaySchedulesId>>, {id: string;data: PutPayrollPaySchedulesId}> = (props) => {
          const {id,data} = props ?? {};

          return  putPayrollPaySchedulesId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollPaySchedulesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollPaySchedulesId>>>
    export type PutPayrollPaySchedulesIdMutationBody = PutPayrollPaySchedulesId
    export type PutPayrollPaySchedulesIdMutationError = unknown

    export const usePutPayrollPaySchedulesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollPaySchedulesId>>, TError,{id: string;data: PutPayrollPaySchedulesId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollPaySchedulesId>>,
        TError,
        {id: string;data: PutPayrollPaySchedulesId},
        TContext
      > => {

      const mutationOptions = getPutPayrollPaySchedulesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deactivate a pay schedule
 */
export const getDeletePayrollPaySchedulesDeactivateUrl = (params: DeletePayrollPaySchedulesDeactivateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/pay_schedules/deactivate?${stringifiedParams}` : `/api/web/payroll/pay_schedules/deactivate`
}

export const deletePayrollPaySchedulesDeactivate = async (params: DeletePayrollPaySchedulesDeactivateParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeletePayrollPaySchedulesDeactivateUrl(params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeletePayrollPaySchedulesDeactivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollPaySchedulesDeactivate>>, TError,{params: DeletePayrollPaySchedulesDeactivateParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayrollPaySchedulesDeactivate>>, TError,{params: DeletePayrollPaySchedulesDeactivateParams}, TContext> => {

const mutationKey = ['deletePayrollPaySchedulesDeactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayrollPaySchedulesDeactivate>>, {params: DeletePayrollPaySchedulesDeactivateParams}> = (props) => {
          const {params} = props ?? {};

          return  deletePayrollPaySchedulesDeactivate(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayrollPaySchedulesDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayrollPaySchedulesDeactivate>>>
    
    export type DeletePayrollPaySchedulesDeactivateMutationError = unknown

    export const useDeletePayrollPaySchedulesDeactivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollPaySchedulesDeactivate>>, TError,{params: DeletePayrollPaySchedulesDeactivateParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayrollPaySchedulesDeactivate>>,
        TError,
        {params: DeletePayrollPaySchedulesDeactivateParams},
        TContext
      > => {

      const mutationOptions = getDeletePayrollPaySchedulesDeactivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove an employee from a pay schedule
 */
export const getDeletePayrollPaySchedulesRemoveEmployeeUrl = (params: DeletePayrollPaySchedulesRemoveEmployeeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/payroll/pay_schedules/remove_employee?${stringifiedParams}` : `/api/web/payroll/pay_schedules/remove_employee`
}

export const deletePayrollPaySchedulesRemoveEmployee = async (params: DeletePayrollPaySchedulesRemoveEmployeeParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeletePayrollPaySchedulesRemoveEmployeeUrl(params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeletePayrollPaySchedulesRemoveEmployeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollPaySchedulesRemoveEmployee>>, TError,{params: DeletePayrollPaySchedulesRemoveEmployeeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayrollPaySchedulesRemoveEmployee>>, TError,{params: DeletePayrollPaySchedulesRemoveEmployeeParams}, TContext> => {

const mutationKey = ['deletePayrollPaySchedulesRemoveEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayrollPaySchedulesRemoveEmployee>>, {params: DeletePayrollPaySchedulesRemoveEmployeeParams}> = (props) => {
          const {params} = props ?? {};

          return  deletePayrollPaySchedulesRemoveEmployee(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayrollPaySchedulesRemoveEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayrollPaySchedulesRemoveEmployee>>>
    
    export type DeletePayrollPaySchedulesRemoveEmployeeMutationError = unknown

    export const useDeletePayrollPaySchedulesRemoveEmployee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollPaySchedulesRemoveEmployee>>, TError,{params: DeletePayrollPaySchedulesRemoveEmployeeParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayrollPaySchedulesRemoveEmployee>>,
        TError,
        {params: DeletePayrollPaySchedulesRemoveEmployeeParams},
        TContext
      > => {

      const mutationOptions = getDeletePayrollPaySchedulesRemoveEmployeeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List employees without a pay schedule assignment
 */
export const getGetPayrollUnassignedEmployeesUrl = () => {


  

  return `/api/web/payroll/unassigned_employees`
}

export const getPayrollUnassignedEmployees = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetPayrollUnassignedEmployeesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPayrollUnassignedEmployeesQueryKey = () => {
    return [
    `/api/web/payroll/unassigned_employees`
    ] as const;
    }

    
export const getGetPayrollUnassignedEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollUnassignedEmployeesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>> = ({ signal }) => getPayrollUnassignedEmployees({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollUnassignedEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>>
export type GetPayrollUnassignedEmployeesQueryError = unknown


export function useGetPayrollUnassignedEmployees<TData = Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUnassignedEmployees<TData = Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUnassignedEmployees<TData = Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayrollUnassignedEmployees<TData = Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUnassignedEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollUnassignedEmployeesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a reimbursement
 */
export const getPostReimbursementsUrl = () => {


  

  return `/api/web/reimbursements`
}

export const postReimbursements = async (postReimbursementsBodyOne: PostReimbursementsBodyOne, options?: RequestInit): Promise<ReimbursementsReimbursementCreated> => {
  
  return customFetch<ReimbursementsReimbursementCreated>(getPostReimbursementsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postReimbursementsBodyOne,)
  }
);}




export const getPostReimbursementsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReimbursements>>, TError,{data: PostReimbursementsBodyOne}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postReimbursements>>, TError,{data: PostReimbursementsBodyOne}, TContext> => {

const mutationKey = ['postReimbursements'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postReimbursements>>, {data: PostReimbursementsBodyOne}> = (props) => {
          const {data} = props ?? {};

          return  postReimbursements(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostReimbursementsMutationResult = NonNullable<Awaited<ReturnType<typeof postReimbursements>>>
    export type PostReimbursementsMutationBody = PostReimbursementsBodyOne
    export type PostReimbursementsMutationError = unknown

    export const usePostReimbursements = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReimbursements>>, TError,{data: PostReimbursementsBodyOne}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postReimbursements>>,
        TError,
        {data: PostReimbursementsBodyOne},
        TContext
      > => {

      const mutationOptions = getPostReimbursementsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get minimum allowed transaction date
 */
export const getGetReimbursementsMinAllowedTransactionDateUrl = () => {


  

  return `/api/web/reimbursements/min_allowed_transaction_date`
}

export const getReimbursementsMinAllowedTransactionDate = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetReimbursementsMinAllowedTransactionDateUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetReimbursementsMinAllowedTransactionDateQueryKey = () => {
    return [
    `/api/web/reimbursements/min_allowed_transaction_date`
    ] as const;
    }

    
export const getGetReimbursementsMinAllowedTransactionDateQueryOptions = <TData = Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReimbursementsMinAllowedTransactionDateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>> = ({ signal }) => getReimbursementsMinAllowedTransactionDate({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReimbursementsMinAllowedTransactionDateQueryResult = NonNullable<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>>
export type GetReimbursementsMinAllowedTransactionDateQueryError = unknown


export function useGetReimbursementsMinAllowedTransactionDate<TData = Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>,
          TError,
          Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReimbursementsMinAllowedTransactionDate<TData = Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>,
          TError,
          Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReimbursementsMinAllowedTransactionDate<TData = Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReimbursementsMinAllowedTransactionDate<TData = Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReimbursementsMinAllowedTransactionDate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReimbursementsMinAllowedTransactionDateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List marketplace products
 */
export const getGetMarketplaceProductsUrl = (params?: GetMarketplaceProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/marketplace/products?${stringifiedParams}` : `/api/web/marketplace/products`
}

export const getMarketplaceProducts = async (params?: GetMarketplaceProductsParams, options?: RequestInit): Promise<MarketplaceProductList> => {
  
  return customFetch<MarketplaceProductList>(getGetMarketplaceProductsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMarketplaceProductsQueryKey = (params?: GetMarketplaceProductsParams,) => {
    return [
    `/api/web/marketplace/products`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMarketplaceProductsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceProducts>>, TError = unknown>(params?: GetMarketplaceProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceProductsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceProducts>>> = ({ signal }) => getMarketplaceProducts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketplaceProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceProducts>>>
export type GetMarketplaceProductsQueryError = unknown


export function useGetMarketplaceProducts<TData = Awaited<ReturnType<typeof getMarketplaceProducts>>, TError = unknown>(
 params: undefined |  GetMarketplaceProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketplaceProducts>>,
          TError,
          Awaited<ReturnType<typeof getMarketplaceProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketplaceProducts<TData = Awaited<ReturnType<typeof getMarketplaceProducts>>, TError = unknown>(
 params?: GetMarketplaceProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketplaceProducts>>,
          TError,
          Awaited<ReturnType<typeof getMarketplaceProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketplaceProducts<TData = Awaited<ReturnType<typeof getMarketplaceProducts>>, TError = unknown>(
 params?: GetMarketplaceProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMarketplaceProducts<TData = Awaited<ReturnType<typeof getMarketplaceProducts>>, TError = unknown>(
 params?: GetMarketplaceProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceProducts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketplaceProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Submit a new product request
 */
export const getPostMarketplaceProductRequestUrl = () => {


  

  return `/api/web/marketplace/product/request`
}

export const postMarketplaceProductRequest = async (postMarketplaceProductRequest: PostMarketplaceProductRequest, options?: RequestInit): Promise<MarketplaceProductRequest> => {
  
  return customFetch<MarketplaceProductRequest>(getPostMarketplaceProductRequestUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMarketplaceProductRequest,)
  }
);}




export const getPostMarketplaceProductRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketplaceProductRequest>>, TError,{data: PostMarketplaceProductRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketplaceProductRequest>>, TError,{data: PostMarketplaceProductRequest}, TContext> => {

const mutationKey = ['postMarketplaceProductRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketplaceProductRequest>>, {data: PostMarketplaceProductRequest}> = (props) => {
          const {data} = props ?? {};

          return  postMarketplaceProductRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketplaceProductRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketplaceProductRequest>>>
    export type PostMarketplaceProductRequestMutationBody = PostMarketplaceProductRequest
    export type PostMarketplaceProductRequestMutationError = unknown

    export const usePostMarketplaceProductRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketplaceProductRequest>>, TError,{data: PostMarketplaceProductRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketplaceProductRequest>>,
        TError,
        {data: PostMarketplaceProductRequest},
        TContext
      > => {

      const mutationOptions = getPostMarketplaceProductRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Add authenticated member as employee to Happiest Baby
 */
export const getPostMarketplacePartnersHappiestBabyAddEmployeeUrl = () => {


  

  return `/api/web/marketplace/partners/happiest_baby/add_employee`
}

export const postMarketplacePartnersHappiestBabyAddEmployee = async ( options?: RequestInit): Promise<MarketplaceHappiestBabyAddEmployeeResult> => {
  
  return customFetch<MarketplaceHappiestBabyAddEmployeeResult>(getPostMarketplacePartnersHappiestBabyAddEmployeeUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostMarketplacePartnersHappiestBabyAddEmployeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketplacePartnersHappiestBabyAddEmployee>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketplacePartnersHappiestBabyAddEmployee>>, TError,void, TContext> => {

const mutationKey = ['postMarketplacePartnersHappiestBabyAddEmployee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketplacePartnersHappiestBabyAddEmployee>>, void> = () => {
          

          return  postMarketplacePartnersHappiestBabyAddEmployee(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketplacePartnersHappiestBabyAddEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketplacePartnersHappiestBabyAddEmployee>>>
    
    export type PostMarketplacePartnersHappiestBabyAddEmployeeMutationError = unknown

    export const usePostMarketplacePartnersHappiestBabyAddEmployee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketplacePartnersHappiestBabyAddEmployee>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketplacePartnersHappiestBabyAddEmployee>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMarketplacePartnersHappiestBabyAddEmployeeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a hosted checkout purchase
 */
export const getPostMarketplacePurchasesUrl = () => {


  

  return `/api/web/marketplace/purchases`
}

export const postMarketplacePurchases = async (postMarketplacePurchases: PostMarketplacePurchases, options?: RequestInit): Promise<MarketplacePurchase> => {
  
  return customFetch<MarketplacePurchase>(getPostMarketplacePurchasesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postMarketplacePurchases,)
  }
);}




export const getPostMarketplacePurchasesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketplacePurchases>>, TError,{data: PostMarketplacePurchases}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketplacePurchases>>, TError,{data: PostMarketplacePurchases}, TContext> => {

const mutationKey = ['postMarketplacePurchases'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketplacePurchases>>, {data: PostMarketplacePurchases}> = (props) => {
          const {data} = props ?? {};

          return  postMarketplacePurchases(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketplacePurchasesMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketplacePurchases>>>
    export type PostMarketplacePurchasesMutationBody = PostMarketplacePurchases
    export type PostMarketplacePurchasesMutationError = unknown

    export const usePostMarketplacePurchases = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketplacePurchases>>, TError,{data: PostMarketplacePurchases}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketplacePurchases>>,
        TError,
        {data: PostMarketplacePurchases},
        TContext
      > => {

      const mutationOptions = getPostMarketplacePurchasesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the current employer's banking account information
 */
export const getGetEmployersBankingAccountUrl = () => {


  

  return `/api/web/employers/banking/account`
}

export const getEmployersBankingAccount = async ( options?: RequestInit): Promise<EmployersBankingPlaidAccount> => {
  
  return customFetch<EmployersBankingPlaidAccount>(getGetEmployersBankingAccountUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersBankingAccountQueryKey = () => {
    return [
    `/api/web/employers/banking/account`
    ] as const;
    }

    
export const getGetEmployersBankingAccountQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersBankingAccountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersBankingAccount>>> = ({ signal }) => getEmployersBankingAccount({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersBankingAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersBankingAccount>>>
export type GetEmployersBankingAccountQueryError = unknown


export function useGetEmployersBankingAccount<TData = Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersBankingAccount>>,
          TError,
          Awaited<ReturnType<typeof getEmployersBankingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersBankingAccount<TData = Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersBankingAccount>>,
          TError,
          Awaited<ReturnType<typeof getEmployersBankingAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersBankingAccount<TData = Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersBankingAccount<TData = Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersBankingAccount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersBankingAccountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a Plaid link token for the current employer's banking connection
 */
export const getPostEmployersBankingPlaidCreateTokenUrl = () => {


  

  return `/api/web/employers/banking/plaid/create_token`
}

export const postEmployersBankingPlaidCreateToken = async ( options?: RequestInit): Promise<EmployersBankingPlaidLinkToken> => {
  
  return customFetch<EmployersBankingPlaidLinkToken>(getPostEmployersBankingPlaidCreateTokenUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostEmployersBankingPlaidCreateTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersBankingPlaidCreateToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersBankingPlaidCreateToken>>, TError,void, TContext> => {

const mutationKey = ['postEmployersBankingPlaidCreateToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersBankingPlaidCreateToken>>, void> = () => {
          

          return  postEmployersBankingPlaidCreateToken(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersBankingPlaidCreateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersBankingPlaidCreateToken>>>
    
    export type PostEmployersBankingPlaidCreateTokenMutationError = unknown

    export const usePostEmployersBankingPlaidCreateToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersBankingPlaidCreateToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersBankingPlaidCreateToken>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostEmployersBankingPlaidCreateTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Process the Plaid link callback
 */
export const getPostEmployersBankingPlaidProcessLinkUrl = () => {


  

  return `/api/web/employers/banking/plaid/process_link`
}

export const postEmployersBankingPlaidProcessLink = async (postEmployersBankingPlaidProcessLink: PostEmployersBankingPlaidProcessLink, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostEmployersBankingPlaidProcessLinkUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersBankingPlaidProcessLink,)
  }
);}




export const getPostEmployersBankingPlaidProcessLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersBankingPlaidProcessLink>>, TError,{data: PostEmployersBankingPlaidProcessLink}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersBankingPlaidProcessLink>>, TError,{data: PostEmployersBankingPlaidProcessLink}, TContext> => {

const mutationKey = ['postEmployersBankingPlaidProcessLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersBankingPlaidProcessLink>>, {data: PostEmployersBankingPlaidProcessLink}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersBankingPlaidProcessLink(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersBankingPlaidProcessLinkMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersBankingPlaidProcessLink>>>
    export type PostEmployersBankingPlaidProcessLinkMutationBody = PostEmployersBankingPlaidProcessLink
    export type PostEmployersBankingPlaidProcessLinkMutationError = unknown

    export const usePostEmployersBankingPlaidProcessLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersBankingPlaidProcessLink>>, TError,{data: PostEmployersBankingPlaidProcessLink}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersBankingPlaidProcessLink>>,
        TError,
        {data: PostEmployersBankingPlaidProcessLink},
        TContext
      > => {

      const mutationOptions = getPostEmployersBankingPlaidProcessLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List employees for the current employer
 */
export const getGetEmployersEmployeesUrl = (params?: GetEmployersEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/employers/employees?${stringifiedParams}` : `/api/web/employers/employees`
}

export const getEmployersEmployees = async (params?: GetEmployersEmployeesParams, options?: RequestInit): Promise<EmployersEmployeesList> => {
  
  return customFetch<EmployersEmployeesList>(getGetEmployersEmployeesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersEmployeesQueryKey = (params?: GetEmployersEmployeesParams,) => {
    return [
    `/api/web/employers/employees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmployersEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersEmployees>>, TError = unknown>(params?: GetEmployersEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersEmployeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersEmployees>>> = ({ signal }) => getEmployersEmployees(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersEmployees>>>
export type GetEmployersEmployeesQueryError = unknown


export function useGetEmployersEmployees<TData = Awaited<ReturnType<typeof getEmployersEmployees>>, TError = unknown>(
 params: undefined |  GetEmployersEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployees<TData = Awaited<ReturnType<typeof getEmployersEmployees>>, TError = unknown>(
 params?: GetEmployersEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployees<TData = Awaited<ReturnType<typeof getEmployersEmployees>>, TError = unknown>(
 params?: GetEmployersEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersEmployees<TData = Awaited<ReturnType<typeof getEmployersEmployees>>, TError = unknown>(
 params?: GetEmployersEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch employees for a pay schedule
 */
export const getGetEmployersEmployeesPaySchedulesPayScheduleIdUrl = (payScheduleId: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/employers/employees/pay_schedules/${payScheduleId}?${stringifiedParams}` : `/api/web/employers/employees/pay_schedules/${payScheduleId}`
}

export const getEmployersEmployeesPaySchedulesPayScheduleId = async (payScheduleId: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams, options?: RequestInit): Promise<EmployersEmployeesList> => {
  
  return customFetch<EmployersEmployeesList>(getGetEmployersEmployeesPaySchedulesPayScheduleIdUrl(payScheduleId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersEmployeesPaySchedulesPayScheduleIdQueryKey = (payScheduleId?: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams,) => {
    return [
    `/api/web/employers/employees/pay_schedules/${payScheduleId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmployersEmployeesPaySchedulesPayScheduleIdQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError = unknown>(payScheduleId: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersEmployeesPaySchedulesPayScheduleIdQueryKey(payScheduleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>> = ({ signal }) => getEmployersEmployeesPaySchedulesPayScheduleId(payScheduleId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(payScheduleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersEmployeesPaySchedulesPayScheduleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>>
export type GetEmployersEmployeesPaySchedulesPayScheduleIdQueryError = unknown


export function useGetEmployersEmployeesPaySchedulesPayScheduleId<TData = Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError = unknown>(
 payScheduleId: string,
    params: undefined |  GetEmployersEmployeesPaySchedulesPayScheduleIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployeesPaySchedulesPayScheduleId<TData = Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError = unknown>(
 payScheduleId: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployeesPaySchedulesPayScheduleId<TData = Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError = unknown>(
 payScheduleId: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersEmployeesPaySchedulesPayScheduleId<TData = Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError = unknown>(
 payScheduleId: string,
    params?: GetEmployersEmployeesPaySchedulesPayScheduleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesPaySchedulesPayScheduleId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersEmployeesPaySchedulesPayScheduleIdQueryOptions(payScheduleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Assign employees to pay schedule
 */
export const getPostEmployersEmployeesPaySchedulesPayScheduleIdUrl = (payScheduleId: string,) => {


  

  return `/api/web/employers/employees/pay_schedules/${payScheduleId}`
}

export const postEmployersEmployeesPaySchedulesPayScheduleId = async (payScheduleId: string,
    postEmployersEmployeesPaySchedulesPayScheduleId: PostEmployersEmployeesPaySchedulesPayScheduleId, options?: RequestInit): Promise<EmployersEmployeesList> => {
  
  return customFetch<EmployersEmployeesList>(getPostEmployersEmployeesPaySchedulesPayScheduleIdUrl(payScheduleId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersEmployeesPaySchedulesPayScheduleId,)
  }
);}




export const getPostEmployersEmployeesPaySchedulesPayScheduleIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployeesPaySchedulesPayScheduleId>>, TError,{payScheduleId: string;data: PostEmployersEmployeesPaySchedulesPayScheduleId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployeesPaySchedulesPayScheduleId>>, TError,{payScheduleId: string;data: PostEmployersEmployeesPaySchedulesPayScheduleId}, TContext> => {

const mutationKey = ['postEmployersEmployeesPaySchedulesPayScheduleId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersEmployeesPaySchedulesPayScheduleId>>, {payScheduleId: string;data: PostEmployersEmployeesPaySchedulesPayScheduleId}> = (props) => {
          const {payScheduleId,data} = props ?? {};

          return  postEmployersEmployeesPaySchedulesPayScheduleId(payScheduleId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersEmployeesPaySchedulesPayScheduleIdMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersEmployeesPaySchedulesPayScheduleId>>>
    export type PostEmployersEmployeesPaySchedulesPayScheduleIdMutationBody = PostEmployersEmployeesPaySchedulesPayScheduleId
    export type PostEmployersEmployeesPaySchedulesPayScheduleIdMutationError = unknown

    export const usePostEmployersEmployeesPaySchedulesPayScheduleId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployeesPaySchedulesPayScheduleId>>, TError,{payScheduleId: string;data: PostEmployersEmployeesPaySchedulesPayScheduleId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersEmployeesPaySchedulesPayScheduleId>>,
        TError,
        {payScheduleId: string;data: PostEmployersEmployeesPaySchedulesPayScheduleId},
        TContext
      > => {

      const mutationOptions = getPostEmployersEmployeesPaySchedulesPayScheduleIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List employees that need to be deduplicated
 */
export const getGetEmployersEmployeesDuplicatesUrl = (params?: GetEmployersEmployeesDuplicatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/employers/employees/duplicates?${stringifiedParams}` : `/api/web/employers/employees/duplicates`
}

export const getEmployersEmployeesDuplicates = async (params?: GetEmployersEmployeesDuplicatesParams, options?: RequestInit): Promise<EmployersEmployeesList> => {
  
  return customFetch<EmployersEmployeesList>(getGetEmployersEmployeesDuplicatesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersEmployeesDuplicatesQueryKey = (params?: GetEmployersEmployeesDuplicatesParams,) => {
    return [
    `/api/web/employers/employees/duplicates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmployersEmployeesDuplicatesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError = unknown>(params?: GetEmployersEmployeesDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersEmployeesDuplicatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>> = ({ signal }) => getEmployersEmployeesDuplicates(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersEmployeesDuplicatesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>>
export type GetEmployersEmployeesDuplicatesQueryError = unknown


export function useGetEmployersEmployeesDuplicates<TData = Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError = unknown>(
 params: undefined |  GetEmployersEmployeesDuplicatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployeesDuplicates<TData = Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError = unknown>(
 params?: GetEmployersEmployeesDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployeesDuplicates<TData = Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError = unknown>(
 params?: GetEmployersEmployeesDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersEmployeesDuplicates<TData = Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError = unknown>(
 params?: GetEmployersEmployeesDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployeesDuplicates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersEmployeesDuplicatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Deduplicate employees
 */
export const getPostEmployersEmployeesDuplicatesUrl = () => {


  

  return `/api/web/employers/employees/duplicates`
}

export const postEmployersEmployeesDuplicates = async (postEmployersEmployeesDuplicates: PostEmployersEmployeesDuplicates, options?: RequestInit): Promise<EmployersEmployee> => {
  
  return customFetch<EmployersEmployee>(getPostEmployersEmployeesDuplicatesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersEmployeesDuplicates,)
  }
);}




export const getPostEmployersEmployeesDuplicatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployeesDuplicates>>, TError,{data: PostEmployersEmployeesDuplicates}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployeesDuplicates>>, TError,{data: PostEmployersEmployeesDuplicates}, TContext> => {

const mutationKey = ['postEmployersEmployeesDuplicates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersEmployeesDuplicates>>, {data: PostEmployersEmployeesDuplicates}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersEmployeesDuplicates(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersEmployeesDuplicatesMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersEmployeesDuplicates>>>
    export type PostEmployersEmployeesDuplicatesMutationBody = PostEmployersEmployeesDuplicates
    export type PostEmployersEmployeesDuplicatesMutationError = unknown

    export const usePostEmployersEmployeesDuplicates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployeesDuplicates>>, TError,{data: PostEmployersEmployeesDuplicates}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersEmployeesDuplicates>>,
        TError,
        {data: PostEmployersEmployeesDuplicates},
        TContext
      > => {

      const mutationOptions = getPostEmployersEmployeesDuplicatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create employer ichra allowance amounts from a quote
 */
export const getPostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteUrl = () => {


  

  return `/api/web/employers/employer_ichra_allowance_amounts/generate_from_quote`
}

export const postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote = async (postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote: PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote,)
  }
);}




export const getPostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote>>, TError,{data: PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote>>, TError,{data: PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote}, TContext> => {

const mutationKey = ['postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote>>, {data: PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote>>>
    export type PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteMutationBody = PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote
    export type PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteMutationError = unknown

    export const usePostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote>>, TError,{data: PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersEmployerIchraAllowanceAmountsGenerateFromQuote>>,
        TError,
        {data: PostEmployersEmployerIchraAllowanceAmountsGenerateFromQuote},
        TContext
      > => {

      const mutationOptions = getPostEmployersEmployerIchraAllowanceAmountsGenerateFromQuoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List all employers administered by the user
 */
export const getGetEmployersEmployersUrl = () => {


  

  return `/api/web/employers/employers`
}

export const getEmployersEmployers = async ( options?: RequestInit): Promise<EmployersEmployer[]> => {
  
  return customFetch<EmployersEmployer[]>(getGetEmployersEmployersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersEmployersQueryKey = () => {
    return [
    `/api/web/employers/employers`
    ] as const;
    }

    
export const getGetEmployersEmployersQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersEmployers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersEmployersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersEmployers>>> = ({ signal }) => getEmployersEmployers({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersEmployers>>>
export type GetEmployersEmployersQueryError = unknown


export function useGetEmployersEmployers<TData = Awaited<ReturnType<typeof getEmployersEmployers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployers>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployers<TData = Awaited<ReturnType<typeof getEmployersEmployers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployers>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployers<TData = Awaited<ReturnType<typeof getEmployersEmployers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersEmployers<TData = Awaited<ReturnType<typeof getEmployersEmployers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersEmployersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create an employer.
 */
export const getPostEmployersEmployersUrl = () => {


  

  return `/api/web/employers/employers`
}

export const postEmployersEmployers = async (postEmployersEmployers: PostEmployersEmployers, options?: RequestInit): Promise<EmployersEmployer> => {
  
  return customFetch<EmployersEmployer>(getPostEmployersEmployersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersEmployers,)
  }
);}




export const getPostEmployersEmployersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployers>>, TError,{data: PostEmployersEmployers}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployers>>, TError,{data: PostEmployersEmployers}, TContext> => {

const mutationKey = ['postEmployersEmployers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersEmployers>>, {data: PostEmployersEmployers}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersEmployers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersEmployersMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersEmployers>>>
    export type PostEmployersEmployersMutationBody = PostEmployersEmployers
    export type PostEmployersEmployersMutationError = unknown

    export const usePostEmployersEmployers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployers>>, TError,{data: PostEmployersEmployers}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersEmployers>>,
        TError,
        {data: PostEmployersEmployers},
        TContext
      > => {

      const mutationOptions = getPostEmployersEmployersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Set the current employer for the user
 */
export const getPostEmployersEmployersSetCurrentEmployerUrl = () => {


  

  return `/api/web/employers/employers/set_current_employer`
}

export const postEmployersEmployersSetCurrentEmployer = async (postEmployersEmployersSetCurrentEmployer: PostEmployersEmployersSetCurrentEmployer, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostEmployersEmployersSetCurrentEmployerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersEmployersSetCurrentEmployer,)
  }
);}




export const getPostEmployersEmployersSetCurrentEmployerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployersSetCurrentEmployer>>, TError,{data: PostEmployersEmployersSetCurrentEmployer}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployersSetCurrentEmployer>>, TError,{data: PostEmployersEmployersSetCurrentEmployer}, TContext> => {

const mutationKey = ['postEmployersEmployersSetCurrentEmployer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersEmployersSetCurrentEmployer>>, {data: PostEmployersEmployersSetCurrentEmployer}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersEmployersSetCurrentEmployer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersEmployersSetCurrentEmployerMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersEmployersSetCurrentEmployer>>>
    export type PostEmployersEmployersSetCurrentEmployerMutationBody = PostEmployersEmployersSetCurrentEmployer
    export type PostEmployersEmployersSetCurrentEmployerMutationError = unknown

    export const usePostEmployersEmployersSetCurrentEmployer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersEmployersSetCurrentEmployer>>, TError,{data: PostEmployersEmployersSetCurrentEmployer}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersEmployersSetCurrentEmployer>>,
        TError,
        {data: PostEmployersEmployersSetCurrentEmployer},
        TContext
      > => {

      const mutationOptions = getPostEmployersEmployersSetCurrentEmployerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get an employer by ID.
 */
export const getGetEmployersEmployersIdUrl = (id: string,) => {


  

  return `/api/web/employers/employers/${id}`
}

export const getEmployersEmployersId = async (id: string, options?: RequestInit): Promise<EmployersEmployer> => {
  
  return customFetch<EmployersEmployer>(getGetEmployersEmployersIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersEmployersIdQueryKey = (id?: string,) => {
    return [
    `/api/web/employers/employers/${id}`
    ] as const;
    }

    
export const getGetEmployersEmployersIdQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersEmployersId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersEmployersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersEmployersId>>> = ({ signal }) => getEmployersEmployersId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersEmployersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersEmployersId>>>
export type GetEmployersEmployersIdQueryError = unknown


export function useGetEmployersEmployersId<TData = Awaited<ReturnType<typeof getEmployersEmployersId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployersId>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployersId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployersId<TData = Awaited<ReturnType<typeof getEmployersEmployersId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployersId>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployersId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployersId<TData = Awaited<ReturnType<typeof getEmployersEmployersId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersEmployersId<TData = Awaited<ReturnType<typeof getEmployersEmployersId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersEmployersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all compliance Owners for the employer
 */
export const getGetEmployersEmployersIdOwnersUrl = (id: string,) => {


  

  return `/api/web/employers/employers/${id}/owners`
}

export const getEmployersEmployersIdOwners = async (id: string, options?: RequestInit): Promise<EmployersComplianceOwner[]> => {
  
  return customFetch<EmployersComplianceOwner[]>(getGetEmployersEmployersIdOwnersUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersEmployersIdOwnersQueryKey = (id?: string,) => {
    return [
    `/api/web/employers/employers/${id}/owners`
    ] as const;
    }

    
export const getGetEmployersEmployersIdOwnersQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersEmployersIdOwnersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>> = ({ signal }) => getEmployersEmployersIdOwners(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersEmployersIdOwnersQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>>
export type GetEmployersEmployersIdOwnersQueryError = unknown


export function useGetEmployersEmployersIdOwners<TData = Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployersIdOwners<TData = Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>,
          TError,
          Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersEmployersIdOwners<TData = Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersEmployersIdOwners<TData = Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersEmployersIdOwners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersEmployersIdOwnersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update the owner invitation form status
 */
export const getPutEmployersEmployersIdUpdateOwnerInvitationFormStatusUrl = (id: string,) => {


  

  return `/api/web/employers/employers/${id}/update_owner_invitation_form_status`
}

export const putEmployersEmployersIdUpdateOwnerInvitationFormStatus = async (id: string,
    putEmployersEmployersIdUpdateOwnerInvitationFormStatus: PutEmployersEmployersIdUpdateOwnerInvitationFormStatus, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPutEmployersEmployersIdUpdateOwnerInvitationFormStatusUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putEmployersEmployersIdUpdateOwnerInvitationFormStatus,)
  }
);}




export const getPutEmployersEmployersIdUpdateOwnerInvitationFormStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEmployersEmployersIdUpdateOwnerInvitationFormStatus>>, TError,{id: string;data: PutEmployersEmployersIdUpdateOwnerInvitationFormStatus}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putEmployersEmployersIdUpdateOwnerInvitationFormStatus>>, TError,{id: string;data: PutEmployersEmployersIdUpdateOwnerInvitationFormStatus}, TContext> => {

const mutationKey = ['putEmployersEmployersIdUpdateOwnerInvitationFormStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEmployersEmployersIdUpdateOwnerInvitationFormStatus>>, {id: string;data: PutEmployersEmployersIdUpdateOwnerInvitationFormStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putEmployersEmployersIdUpdateOwnerInvitationFormStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEmployersEmployersIdUpdateOwnerInvitationFormStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putEmployersEmployersIdUpdateOwnerInvitationFormStatus>>>
    export type PutEmployersEmployersIdUpdateOwnerInvitationFormStatusMutationBody = PutEmployersEmployersIdUpdateOwnerInvitationFormStatus
    export type PutEmployersEmployersIdUpdateOwnerInvitationFormStatusMutationError = unknown

    export const usePutEmployersEmployersIdUpdateOwnerInvitationFormStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEmployersEmployersIdUpdateOwnerInvitationFormStatus>>, TError,{id: string;data: PutEmployersEmployersIdUpdateOwnerInvitationFormStatus}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEmployersEmployersIdUpdateOwnerInvitationFormStatus>>,
        TError,
        {id: string;data: PutEmployersEmployersIdUpdateOwnerInvitationFormStatus},
        TContext
      > => {

      const mutationOptions = getPutEmployersEmployersIdUpdateOwnerInvitationFormStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update the employer's profile
 */
export const getPutEmployersEmployersIdProfileUrl = (id: string,) => {


  

  return `/api/web/employers/employers/${id}/profile`
}

export const putEmployersEmployersIdProfile = async (id: string,
    putEmployersEmployersIdProfile: PutEmployersEmployersIdProfile, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPutEmployersEmployersIdProfileUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putEmployersEmployersIdProfile,)
  }
);}




export const getPutEmployersEmployersIdProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEmployersEmployersIdProfile>>, TError,{id: string;data: PutEmployersEmployersIdProfile}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putEmployersEmployersIdProfile>>, TError,{id: string;data: PutEmployersEmployersIdProfile}, TContext> => {

const mutationKey = ['putEmployersEmployersIdProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEmployersEmployersIdProfile>>, {id: string;data: PutEmployersEmployersIdProfile}> = (props) => {
          const {id,data} = props ?? {};

          return  putEmployersEmployersIdProfile(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEmployersEmployersIdProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putEmployersEmployersIdProfile>>>
    export type PutEmployersEmployersIdProfileMutationBody = PutEmployersEmployersIdProfile
    export type PutEmployersEmployersIdProfileMutationError = unknown

    export const usePutEmployersEmployersIdProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEmployersEmployersIdProfile>>, TError,{id: string;data: PutEmployersEmployersIdProfile}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEmployersEmployersIdProfile>>,
        TError,
        {id: string;data: PutEmployersEmployersIdProfile},
        TContext
      > => {

      const mutationOptions = getPutEmployersEmployersIdProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Register a user
 */
export const getPostEmployersRegistrationUrl = () => {


  

  return `/api/web/employers/registration`
}

export const postEmployersRegistration = async (postEmployersRegistration: PostEmployersRegistration, options?: RequestInit): Promise<EmployersCreatedUser> => {
  
  return customFetch<EmployersCreatedUser>(getPostEmployersRegistrationUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersRegistration,)
  }
);}




export const getPostEmployersRegistrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersRegistration>>, TError,{data: PostEmployersRegistration}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersRegistration>>, TError,{data: PostEmployersRegistration}, TContext> => {

const mutationKey = ['postEmployersRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersRegistration>>, {data: PostEmployersRegistration}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersRegistration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersRegistration>>>
    export type PostEmployersRegistrationMutationBody = PostEmployersRegistration
    export type PostEmployersRegistrationMutationError = unknown

    export const usePostEmployersRegistration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersRegistration>>, TError,{data: PostEmployersRegistration}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersRegistration>>,
        TError,
        {data: PostEmployersRegistration},
        TContext
      > => {

      const mutationOptions = getPostEmployersRegistrationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a new employee status report
 */
export const getPostEmployersReportingEmployeeStatusUrl = () => {


  

  return `/api/web/employers/reporting/employee_status`
}

export const postEmployersReportingEmployeeStatus = async (postEmployersReportingEmployeeStatus: PostEmployersReportingEmployeeStatus, options?: RequestInit): Promise<ReportingReport> => {
  
  return customFetch<ReportingReport>(getPostEmployersReportingEmployeeStatusUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersReportingEmployeeStatus,)
  }
);}




export const getPostEmployersReportingEmployeeStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersReportingEmployeeStatus>>, TError,{data: PostEmployersReportingEmployeeStatus}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersReportingEmployeeStatus>>, TError,{data: PostEmployersReportingEmployeeStatus}, TContext> => {

const mutationKey = ['postEmployersReportingEmployeeStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersReportingEmployeeStatus>>, {data: PostEmployersReportingEmployeeStatus}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersReportingEmployeeStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersReportingEmployeeStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersReportingEmployeeStatus>>>
    export type PostEmployersReportingEmployeeStatusMutationBody = PostEmployersReportingEmployeeStatus
    export type PostEmployersReportingEmployeeStatusMutationError = unknown

    export const usePostEmployersReportingEmployeeStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersReportingEmployeeStatus>>, TError,{data: PostEmployersReportingEmployeeStatus}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersReportingEmployeeStatus>>,
        TError,
        {data: PostEmployersReportingEmployeeStatus},
        TContext
      > => {

      const mutationOptions = getPostEmployersReportingEmployeeStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a new employer billing invoice report
 */
export const getPostEmployersReportingEmployerBillingInvoiceUrl = () => {


  

  return `/api/web/employers/reporting/employer_billing_invoice`
}

export const postEmployersReportingEmployerBillingInvoice = async (postEmployersReportingEmployerBillingInvoice: PostEmployersReportingEmployerBillingInvoice, options?: RequestInit): Promise<ReportingReport> => {
  
  return customFetch<ReportingReport>(getPostEmployersReportingEmployerBillingInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersReportingEmployerBillingInvoice,)
  }
);}




export const getPostEmployersReportingEmployerBillingInvoiceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersReportingEmployerBillingInvoice>>, TError,{data: PostEmployersReportingEmployerBillingInvoice}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersReportingEmployerBillingInvoice>>, TError,{data: PostEmployersReportingEmployerBillingInvoice}, TContext> => {

const mutationKey = ['postEmployersReportingEmployerBillingInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersReportingEmployerBillingInvoice>>, {data: PostEmployersReportingEmployerBillingInvoice}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersReportingEmployerBillingInvoice(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersReportingEmployerBillingInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersReportingEmployerBillingInvoice>>>
    export type PostEmployersReportingEmployerBillingInvoiceMutationBody = PostEmployersReportingEmployerBillingInvoice
    export type PostEmployersReportingEmployerBillingInvoiceMutationError = unknown

    export const usePostEmployersReportingEmployerBillingInvoice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersReportingEmployerBillingInvoice>>, TError,{data: PostEmployersReportingEmployerBillingInvoice}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersReportingEmployerBillingInvoice>>,
        TError,
        {data: PostEmployersReportingEmployerBillingInvoice},
        TContext
      > => {

      const mutationOptions = getPostEmployersReportingEmployerBillingInvoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the options for completing the onboarding process for an employer.
 */
export const getGetEmployersOnboardingCompleteOptionsUrl = () => {


  

  return `/api/web/employers/onboarding/complete_options`
}

export const getEmployersOnboardingCompleteOptions = async ( options?: RequestInit): Promise<EmployersCompleteOnboardingOptions> => {
  
  return customFetch<EmployersCompleteOnboardingOptions>(getGetEmployersOnboardingCompleteOptionsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersOnboardingCompleteOptionsQueryKey = () => {
    return [
    `/api/web/employers/onboarding/complete_options`
    ] as const;
    }

    
export const getGetEmployersOnboardingCompleteOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersOnboardingCompleteOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>> = ({ signal }) => getEmployersOnboardingCompleteOptions({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersOnboardingCompleteOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>>
export type GetEmployersOnboardingCompleteOptionsQueryError = unknown


export function useGetEmployersOnboardingCompleteOptions<TData = Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>,
          TError,
          Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersOnboardingCompleteOptions<TData = Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>,
          TError,
          Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersOnboardingCompleteOptions<TData = Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersOnboardingCompleteOptions<TData = Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersOnboardingCompleteOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersOnboardingCompleteOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Complete the onboarding process for an employer.
 */
export const getPostEmployersOnboardingCompleteUrl = () => {


  

  return `/api/web/employers/onboarding/complete`
}

export const postEmployersOnboardingComplete = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostEmployersOnboardingCompleteUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostEmployersOnboardingCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersOnboardingComplete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersOnboardingComplete>>, TError,void, TContext> => {

const mutationKey = ['postEmployersOnboardingComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersOnboardingComplete>>, void> = () => {
          

          return  postEmployersOnboardingComplete(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersOnboardingCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersOnboardingComplete>>>
    
    export type PostEmployersOnboardingCompleteMutationError = unknown

    export const usePostEmployersOnboardingComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersOnboardingComplete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersOnboardingComplete>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostEmployersOnboardingCompleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a renewal config
 */
export const getGetEmployersRenewalsRenewalConfigsIdUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}`
}

export const getEmployersRenewalsRenewalConfigsId = async (id: string, options?: RequestInit): Promise<EmployersRenewalsRenewalConfig> => {
  
  return customFetch<EmployersRenewalsRenewalConfig>(getGetEmployersRenewalsRenewalConfigsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersRenewalsRenewalConfigsIdQueryKey = (id?: string,) => {
    return [
    `/api/web/employers/renewals/renewal_configs/${id}`
    ] as const;
    }

    
export const getGetEmployersRenewalsRenewalConfigsIdQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersRenewalsRenewalConfigsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>> = ({ signal }) => getEmployersRenewalsRenewalConfigsId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersRenewalsRenewalConfigsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>>
export type GetEmployersRenewalsRenewalConfigsIdQueryError = unknown


export function useGetEmployersRenewalsRenewalConfigsId<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsId<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsId<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersRenewalsRenewalConfigsId<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersRenewalsRenewalConfigsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update a renewal config
 */
export const getPatchEmployersRenewalsRenewalConfigsIdUpdateUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/update`
}

export const patchEmployersRenewalsRenewalConfigsIdUpdate = async (id: string,
    patchEmployersRenewalsRenewalConfigsIdUpdate: PatchEmployersRenewalsRenewalConfigsIdUpdate, options?: RequestInit): Promise<EmployersRenewalsRenewalConfig> => {
  
  return customFetch<EmployersRenewalsRenewalConfig>(getPatchEmployersRenewalsRenewalConfigsIdUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchEmployersRenewalsRenewalConfigsIdUpdate,)
  }
);}




export const getPatchEmployersRenewalsRenewalConfigsIdUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUpdate>>, TError,{id: string;data: PatchEmployersRenewalsRenewalConfigsIdUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUpdate>>, TError,{id: string;data: PatchEmployersRenewalsRenewalConfigsIdUpdate}, TContext> => {

const mutationKey = ['patchEmployersRenewalsRenewalConfigsIdUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUpdate>>, {id: string;data: PatchEmployersRenewalsRenewalConfigsIdUpdate}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEmployersRenewalsRenewalConfigsIdUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEmployersRenewalsRenewalConfigsIdUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUpdate>>>
    export type PatchEmployersRenewalsRenewalConfigsIdUpdateMutationBody = PatchEmployersRenewalsRenewalConfigsIdUpdate
    export type PatchEmployersRenewalsRenewalConfigsIdUpdateMutationError = unknown

    export const usePatchEmployersRenewalsRenewalConfigsIdUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUpdate>>, TError,{id: string;data: PatchEmployersRenewalsRenewalConfigsIdUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUpdate>>,
        TError,
        {id: string;data: PatchEmployersRenewalsRenewalConfigsIdUpdate},
        TContext
      > => {

      const mutationOptions = getPatchEmployersRenewalsRenewalConfigsIdUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Confirm Renewal Config and create ICHRA Config and Allowances for renewal year
 */
export const getPostEmployersRenewalsRenewalConfigsIdConfirmUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/confirm`
}

export const postEmployersRenewalsRenewalConfigsIdConfirm = async (id: string, options?: RequestInit): Promise<EmployersRenewalsRenewalConfig> => {
  
  return customFetch<EmployersRenewalsRenewalConfig>(getPostEmployersRenewalsRenewalConfigsIdConfirmUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostEmployersRenewalsRenewalConfigsIdConfirmMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersRenewalsRenewalConfigsIdConfirm>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersRenewalsRenewalConfigsIdConfirm>>, TError,{id: string}, TContext> => {

const mutationKey = ['postEmployersRenewalsRenewalConfigsIdConfirm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersRenewalsRenewalConfigsIdConfirm>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postEmployersRenewalsRenewalConfigsIdConfirm(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersRenewalsRenewalConfigsIdConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersRenewalsRenewalConfigsIdConfirm>>>
    
    export type PostEmployersRenewalsRenewalConfigsIdConfirmMutationError = unknown

    export const usePostEmployersRenewalsRenewalConfigsIdConfirm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersRenewalsRenewalConfigsIdConfirm>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersRenewalsRenewalConfigsIdConfirm>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostEmployersRenewalsRenewalConfigsIdConfirmMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Upload finalized employee CSV file
 */
export const getPatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdatesUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/upload_employee_census_updates`
}

export const patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates = async (id: string, options?: RequestInit): Promise<QuotingEmployeeCensus> => {
  
  return customFetch<QuotingEmployeeCensus>(getPatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdatesUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}




export const getPatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdatesMutationResult = NonNullable<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates>>>
    
    export type PatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdatesMutationError = unknown

    export const usePatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdates>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchEmployersRenewalsRenewalConfigsIdUploadEmployeeCensusUpdatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get employees for a renewal config
 */
export const getGetEmployersRenewalsRenewalConfigsIdEmployeesUrl = (id: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[employment_types][]","filter[enrollment_statuses][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/employers/renewals/renewal_configs/${id}/employees?${stringifiedParams}` : `/api/web/employers/renewals/renewal_configs/${id}/employees`
}

export const getEmployersRenewalsRenewalConfigsIdEmployees = async (id: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams, options?: RequestInit): Promise<EmployersRenewalsPaginatedEmployeeList> => {
  
  return customFetch<EmployersRenewalsPaginatedEmployeeList>(getGetEmployersRenewalsRenewalConfigsIdEmployeesUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersRenewalsRenewalConfigsIdEmployeesQueryKey = (id?: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams,) => {
    return [
    `/api/web/employers/renewals/renewal_configs/${id}/employees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmployersRenewalsRenewalConfigsIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError = unknown>(id: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersRenewalsRenewalConfigsIdEmployeesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>> = ({ signal }) => getEmployersRenewalsRenewalConfigsIdEmployees(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersRenewalsRenewalConfigsIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>>
export type GetEmployersRenewalsRenewalConfigsIdEmployeesQueryError = unknown


export function useGetEmployersRenewalsRenewalConfigsIdEmployees<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError = unknown>(
 id: string,
    params: undefined |  GetEmployersRenewalsRenewalConfigsIdEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdEmployees<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError = unknown>(
 id: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdEmployees<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError = unknown>(
 id: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersRenewalsRenewalConfigsIdEmployees<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError = unknown>(
 id: string,
    params?: GetEmployersRenewalsRenewalConfigsIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployees>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersRenewalsRenewalConfigsIdEmployeesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get metadata for employees
 */
export const getGetEmployersRenewalsRenewalConfigsIdEmployeesMetadataUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/employees/metadata`
}

export const getEmployersRenewalsRenewalConfigsIdEmployeesMetadata = async (id: string, options?: RequestInit): Promise<EmployersRenewalsEmployeeListMetadata> => {
  
  return customFetch<EmployersRenewalsEmployeeListMetadata>(getGetEmployersRenewalsRenewalConfigsIdEmployeesMetadataUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersRenewalsRenewalConfigsIdEmployeesMetadataQueryKey = (id?: string,) => {
    return [
    `/api/web/employers/renewals/renewal_configs/${id}/employees/metadata`
    ] as const;
    }

    
export const getGetEmployersRenewalsRenewalConfigsIdEmployeesMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersRenewalsRenewalConfigsIdEmployeesMetadataQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>> = ({ signal }) => getEmployersRenewalsRenewalConfigsIdEmployeesMetadata(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersRenewalsRenewalConfigsIdEmployeesMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>>
export type GetEmployersRenewalsRenewalConfigsIdEmployeesMetadataQueryError = unknown


export function useGetEmployersRenewalsRenewalConfigsIdEmployeesMetadata<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdEmployeesMetadata<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdEmployeesMetadata<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersRenewalsRenewalConfigsIdEmployeesMetadata<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdEmployeesMetadata>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersRenewalsRenewalConfigsIdEmployeesMetadataQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update all renewal config employees to eligible
 */
export const getPatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligibleUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/employees/mark_all_eligible`
}

export const patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible = async (id: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligibleUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}




export const getPatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligibleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligibleMutationResult = NonNullable<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible>>>
    
    export type PatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligibleMutationError = unknown

    export const usePatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligible>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchEmployersRenewalsRenewalConfigsIdEmployeesMarkAllEligibleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the quote results for a renewal config
 */
export const getGetEmployersRenewalsRenewalConfigsIdQuoteResultsUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/quote_results`
}

export const getEmployersRenewalsRenewalConfigsIdQuoteResults = async (id: string, options?: RequestInit): Promise<EmployersRenewalsRenewalQuoteResults> => {
  
  return customFetch<EmployersRenewalsRenewalQuoteResults>(getGetEmployersRenewalsRenewalConfigsIdQuoteResultsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersRenewalsRenewalConfigsIdQuoteResultsQueryKey = (id?: string,) => {
    return [
    `/api/web/employers/renewals/renewal_configs/${id}/quote_results`
    ] as const;
    }

    
export const getGetEmployersRenewalsRenewalConfigsIdQuoteResultsQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersRenewalsRenewalConfigsIdQuoteResultsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>> = ({ signal }) => getEmployersRenewalsRenewalConfigsIdQuoteResults(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersRenewalsRenewalConfigsIdQuoteResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>>
export type GetEmployersRenewalsRenewalConfigsIdQuoteResultsQueryError = unknown


export function useGetEmployersRenewalsRenewalConfigsIdQuoteResults<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdQuoteResults<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdQuoteResults<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersRenewalsRenewalConfigsIdQuoteResults<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdQuoteResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersRenewalsRenewalConfigsIdQuoteResultsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the rate summary for renewal config
 */
export const getGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryUrl = (id: string,) => {


  

  return `/api/web/employers/renewals/renewal_configs/${id}/insurance_plans/rate_summary`
}

export const getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary = async (id: string, options?: RequestInit): Promise<EmployersRenewalsRateSummaryList> => {
  
  return customFetch<EmployersRenewalsRateSummaryList>(getGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryQueryKey = (id?: string,) => {
    return [
    `/api/web/employers/renewals/renewal_configs/${id}/insurance_plans/rate_summary`
    ] as const;
    }

    
export const getGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>> = ({ signal }) => getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>>
export type GetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryQueryError = unknown


export function useGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>,
          TError,
          Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary<TData = Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmployersRenewalsRenewalConfigsIdInsurancePlansRateSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new compliance owner
 */
export const getPostEmployersOwnersUrl = () => {


  

  return `/api/web/employers/owners`
}

export const postEmployersOwners = async (postEmployersOwners: PostEmployersOwners, options?: RequestInit): Promise<EmployersComplianceOwner> => {
  
  return customFetch<EmployersComplianceOwner>(getPostEmployersOwnersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postEmployersOwners,)
  }
);}




export const getPostEmployersOwnersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersOwners>>, TError,{data: PostEmployersOwners}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmployersOwners>>, TError,{data: PostEmployersOwners}, TContext> => {

const mutationKey = ['postEmployersOwners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmployersOwners>>, {data: PostEmployersOwners}> = (props) => {
          const {data} = props ?? {};

          return  postEmployersOwners(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmployersOwnersMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployersOwners>>>
    export type PostEmployersOwnersMutationBody = PostEmployersOwners
    export type PostEmployersOwnersMutationError = unknown

    export const usePostEmployersOwners = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmployersOwners>>, TError,{data: PostEmployersOwners}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmployersOwners>>,
        TError,
        {data: PostEmployersOwners},
        TContext
      > => {

      const mutationOptions = getPostEmployersOwnersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update an existing compliance owner
 */
export const getPutEmployersOwnersIdUrl = (id: string,) => {


  

  return `/api/web/employers/owners/${id}`
}

export const putEmployersOwnersId = async (id: string,
    putEmployersOwnersId: PutEmployersOwnersId, options?: RequestInit): Promise<EmployersComplianceOwner> => {
  
  return customFetch<EmployersComplianceOwner>(getPutEmployersOwnersIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putEmployersOwnersId,)
  }
);}




export const getPutEmployersOwnersIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEmployersOwnersId>>, TError,{id: string;data: PutEmployersOwnersId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putEmployersOwnersId>>, TError,{id: string;data: PutEmployersOwnersId}, TContext> => {

const mutationKey = ['putEmployersOwnersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEmployersOwnersId>>, {id: string;data: PutEmployersOwnersId}> = (props) => {
          const {id,data} = props ?? {};

          return  putEmployersOwnersId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEmployersOwnersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEmployersOwnersId>>>
    export type PutEmployersOwnersIdMutationBody = PutEmployersOwnersId
    export type PutEmployersOwnersIdMutationError = unknown

    export const usePutEmployersOwnersId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEmployersOwnersId>>, TError,{id: string;data: PutEmployersOwnersId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEmployersOwnersId>>,
        TError,
        {id: string;data: PutEmployersOwnersId},
        TContext
      > => {

      const mutationOptions = getPutEmployersOwnersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a compliance owner
 */
export const getDeleteEmployersOwnersIdUrl = (id: string,) => {


  

  return `/api/web/employers/owners/${id}`
}

export const deleteEmployersOwnersId = async (id: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getDeleteEmployersOwnersIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteEmployersOwnersIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployersOwnersId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmployersOwnersId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteEmployersOwnersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmployersOwnersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEmployersOwnersId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmployersOwnersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmployersOwnersId>>>
    
    export type DeleteEmployersOwnersIdMutationError = unknown

    export const useDeleteEmployersOwnersId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmployersOwnersId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmployersOwnersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEmployersOwnersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Import ADP prospect from a JWT
 */
export const getPostPartnersAdpEmbeddedImportProspectUrl = () => {


  

  return `/api/web/partners/adp/embedded/import_prospect`
}

export const postPartnersAdpEmbeddedImportProspect = async (postPartnersAdpEmbeddedImportProspect: PostPartnersAdpEmbeddedImportProspect, options?: RequestInit): Promise<WebAPIEntitiesAdpProspectImportResponse> => {
  
  return customFetch<WebAPIEntitiesAdpProspectImportResponse>(getPostPartnersAdpEmbeddedImportProspectUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPartnersAdpEmbeddedImportProspect,)
  }
);}




export const getPostPartnersAdpEmbeddedImportProspectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedImportProspect>>, TError,{data: PostPartnersAdpEmbeddedImportProspect}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedImportProspect>>, TError,{data: PostPartnersAdpEmbeddedImportProspect}, TContext> => {

const mutationKey = ['postPartnersAdpEmbeddedImportProspect'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersAdpEmbeddedImportProspect>>, {data: PostPartnersAdpEmbeddedImportProspect}> = (props) => {
          const {data} = props ?? {};

          return  postPartnersAdpEmbeddedImportProspect(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersAdpEmbeddedImportProspectMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersAdpEmbeddedImportProspect>>>
    export type PostPartnersAdpEmbeddedImportProspectMutationBody = PostPartnersAdpEmbeddedImportProspect
    export type PostPartnersAdpEmbeddedImportProspectMutationError = unknown

    export const usePostPartnersAdpEmbeddedImportProspect = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedImportProspect>>, TError,{data: PostPartnersAdpEmbeddedImportProspect}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersAdpEmbeddedImportProspect>>,
        TError,
        {data: PostPartnersAdpEmbeddedImportProspect},
        TContext
      > => {

      const mutationOptions = getPostPartnersAdpEmbeddedImportProspectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get ADP job status by ID
 */
export const getGetPartnersAdpEmbeddedJobIdStatusUrl = (jobId: string,) => {


  

  return `/api/web/partners/adp/embedded/${jobId}/status`
}

export const getPartnersAdpEmbeddedJobIdStatus = async (jobId: string, options?: RequestInit): Promise<WebAPIEntitiesAdpJob> => {
  
  return customFetch<WebAPIEntitiesAdpJob>(getGetPartnersAdpEmbeddedJobIdStatusUrl(jobId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPartnersAdpEmbeddedJobIdStatusQueryKey = (jobId?: string,) => {
    return [
    `/api/web/partners/adp/embedded/${jobId}/status`
    ] as const;
    }

    
export const getGetPartnersAdpEmbeddedJobIdStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError = unknown>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnersAdpEmbeddedJobIdStatusQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>> = ({ signal }) => getPartnersAdpEmbeddedJobIdStatus(jobId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnersAdpEmbeddedJobIdStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>>
export type GetPartnersAdpEmbeddedJobIdStatusQueryError = unknown


export function useGetPartnersAdpEmbeddedJobIdStatus<TData = Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError = unknown>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>,
          TError,
          Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersAdpEmbeddedJobIdStatus<TData = Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError = unknown>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>,
          TError,
          Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersAdpEmbeddedJobIdStatus<TData = Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError = unknown>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPartnersAdpEmbeddedJobIdStatus<TData = Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError = unknown>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersAdpEmbeddedJobIdStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPartnersAdpEmbeddedJobIdStatusQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exchange a completed ADP job and JWT for an employer onboarding redirect URL
 */
export const getPostPartnersAdpEmbeddedJobIdOnboardingSessionUrl = (jobId: string,) => {


  

  return `/api/web/partners/adp/embedded/${jobId}/onboarding_session`
}

export const postPartnersAdpEmbeddedJobIdOnboardingSession = async (jobId: string,
    postPartnersAdpEmbeddedJobIdOnboardingSession: PostPartnersAdpEmbeddedJobIdOnboardingSession, options?: RequestInit): Promise<PartnersAdpOnboardingSessionRedirect> => {
  
  return customFetch<PartnersAdpOnboardingSessionRedirect>(getPostPartnersAdpEmbeddedJobIdOnboardingSessionUrl(jobId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPartnersAdpEmbeddedJobIdOnboardingSession,)
  }
);}




export const getPostPartnersAdpEmbeddedJobIdOnboardingSessionMutationOptions = <TError = ValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedJobIdOnboardingSession>>, TError,{jobId: string;data: PostPartnersAdpEmbeddedJobIdOnboardingSession}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedJobIdOnboardingSession>>, TError,{jobId: string;data: PostPartnersAdpEmbeddedJobIdOnboardingSession}, TContext> => {

const mutationKey = ['postPartnersAdpEmbeddedJobIdOnboardingSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersAdpEmbeddedJobIdOnboardingSession>>, {jobId: string;data: PostPartnersAdpEmbeddedJobIdOnboardingSession}> = (props) => {
          const {jobId,data} = props ?? {};

          return  postPartnersAdpEmbeddedJobIdOnboardingSession(jobId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersAdpEmbeddedJobIdOnboardingSessionMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersAdpEmbeddedJobIdOnboardingSession>>>
    export type PostPartnersAdpEmbeddedJobIdOnboardingSessionMutationBody = PostPartnersAdpEmbeddedJobIdOnboardingSession
    export type PostPartnersAdpEmbeddedJobIdOnboardingSessionMutationError = ValidationError

    export const usePostPartnersAdpEmbeddedJobIdOnboardingSession = <TError = ValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedJobIdOnboardingSession>>, TError,{jobId: string;data: PostPartnersAdpEmbeddedJobIdOnboardingSession}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersAdpEmbeddedJobIdOnboardingSession>>,
        TError,
        {jobId: string;data: PostPartnersAdpEmbeddedJobIdOnboardingSession},
        TContext
      > => {

      const mutationOptions = getPostPartnersAdpEmbeddedJobIdOnboardingSessionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Reset ADP employer data for testing (non-production only)
 */
export const getPostPartnersAdpEmbeddedResetEmployerDataUrl = () => {


  

  return `/api/web/partners/adp/embedded/reset_employer_data`
}

export const postPartnersAdpEmbeddedResetEmployerData = async (postPartnersAdpEmbeddedResetEmployerData: PostPartnersAdpEmbeddedResetEmployerData, options?: RequestInit): Promise<PartnersAdpResetResponse> => {
  
  return customFetch<PartnersAdpResetResponse>(getPostPartnersAdpEmbeddedResetEmployerDataUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPartnersAdpEmbeddedResetEmployerData,)
  }
);}




export const getPostPartnersAdpEmbeddedResetEmployerDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedResetEmployerData>>, TError,{data: PostPartnersAdpEmbeddedResetEmployerData}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedResetEmployerData>>, TError,{data: PostPartnersAdpEmbeddedResetEmployerData}, TContext> => {

const mutationKey = ['postPartnersAdpEmbeddedResetEmployerData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersAdpEmbeddedResetEmployerData>>, {data: PostPartnersAdpEmbeddedResetEmployerData}> = (props) => {
          const {data} = props ?? {};

          return  postPartnersAdpEmbeddedResetEmployerData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersAdpEmbeddedResetEmployerDataMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersAdpEmbeddedResetEmployerData>>>
    export type PostPartnersAdpEmbeddedResetEmployerDataMutationBody = PostPartnersAdpEmbeddedResetEmployerData
    export type PostPartnersAdpEmbeddedResetEmployerDataMutationError = unknown

    export const usePostPartnersAdpEmbeddedResetEmployerData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersAdpEmbeddedResetEmployerData>>, TError,{data: PostPartnersAdpEmbeddedResetEmployerData}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersAdpEmbeddedResetEmployerData>>,
        TError,
        {data: PostPartnersAdpEmbeddedResetEmployerData},
        TContext
      > => {

      const mutationOptions = getPostPartnersAdpEmbeddedResetEmployerDataMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get session data for the onboarding session user (no magic-link)
 */
export const getGetPartnersEmbeddedOnboardingSessionStatusUrl = () => {


  

  return `/api/web/partners/embedded_onboarding/session_status`
}

export const getPartnersEmbeddedOnboardingSessionStatus = async ( options?: RequestInit): Promise<PartnersEmbeddedSessionStatus> => {
  
  return customFetch<PartnersEmbeddedSessionStatus>(getGetPartnersEmbeddedOnboardingSessionStatusUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPartnersEmbeddedOnboardingSessionStatusQueryKey = () => {
    return [
    `/api/web/partners/embedded_onboarding/session_status`
    ] as const;
    }

    
export const getGetPartnersEmbeddedOnboardingSessionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnersEmbeddedOnboardingSessionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>> = ({ signal }) => getPartnersEmbeddedOnboardingSessionStatus({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnersEmbeddedOnboardingSessionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>>
export type GetPartnersEmbeddedOnboardingSessionStatusQueryError = unknown


export function useGetPartnersEmbeddedOnboardingSessionStatus<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>,
          TError,
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersEmbeddedOnboardingSessionStatus<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>,
          TError,
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersEmbeddedOnboardingSessionStatus<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPartnersEmbeddedOnboardingSessionStatus<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingSessionStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPartnersEmbeddedOnboardingSessionStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a one-time magic link for embedded onboarding
 */
export const getPostPartnersEmbeddedOnboardingMagicLinkUrl = () => {


  

  return `/api/web/partners/embedded_onboarding/magic_link`
}

export const postPartnersEmbeddedOnboardingMagicLink = async ( options?: RequestInit): Promise<PartnersEmbeddedMagicLink> => {
  
  return customFetch<PartnersEmbeddedMagicLink>(getPostPartnersEmbeddedOnboardingMagicLinkUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostPartnersEmbeddedOnboardingMagicLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingMagicLink>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingMagicLink>>, TError,void, TContext> => {

const mutationKey = ['postPartnersEmbeddedOnboardingMagicLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingMagicLink>>, void> = () => {
          

          return  postPartnersEmbeddedOnboardingMagicLink(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersEmbeddedOnboardingMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingMagicLink>>>
    
    export type PostPartnersEmbeddedOnboardingMagicLinkMutationError = unknown

    export const usePostPartnersEmbeddedOnboardingMagicLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingMagicLink>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingMagicLink>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostPartnersEmbeddedOnboardingMagicLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get partner data for the embedded onboarding session
 */
export const getGetPartnersEmbeddedOnboardingPartnerDataUrl = () => {


  

  return `/api/web/partners/embedded_onboarding/partner_data`
}

export const getPartnersEmbeddedOnboardingPartnerData = async ( options?: RequestInit): Promise<PartnersPartner> => {
  
  return customFetch<PartnersPartner>(getGetPartnersEmbeddedOnboardingPartnerDataUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPartnersEmbeddedOnboardingPartnerDataQueryKey = () => {
    return [
    `/api/web/partners/embedded_onboarding/partner_data`
    ] as const;
    }

    
export const getGetPartnersEmbeddedOnboardingPartnerDataQueryOptions = <TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnersEmbeddedOnboardingPartnerDataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>> = ({ signal }) => getPartnersEmbeddedOnboardingPartnerData({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnersEmbeddedOnboardingPartnerDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>>
export type GetPartnersEmbeddedOnboardingPartnerDataQueryError = unknown


export function useGetPartnersEmbeddedOnboardingPartnerData<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>,
          TError,
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersEmbeddedOnboardingPartnerData<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>,
          TError,
          Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersEmbeddedOnboardingPartnerData<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPartnersEmbeddedOnboardingPartnerData<TData = Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmbeddedOnboardingPartnerData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPartnersEmbeddedOnboardingPartnerDataQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Set password and associate onboarding user as employer admin
 */
export const getPostPartnersEmbeddedOnboardingSetPasswordUrl = () => {


  

  return `/api/web/partners/embedded_onboarding/set_password`
}

export const postPartnersEmbeddedOnboardingSetPassword = async (postPartnersEmbeddedOnboardingSetPassword: PostPartnersEmbeddedOnboardingSetPassword, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostPartnersEmbeddedOnboardingSetPasswordUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPartnersEmbeddedOnboardingSetPassword,)
  }
);}




export const getPostPartnersEmbeddedOnboardingSetPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingSetPassword>>, TError,{data: PostPartnersEmbeddedOnboardingSetPassword}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingSetPassword>>, TError,{data: PostPartnersEmbeddedOnboardingSetPassword}, TContext> => {

const mutationKey = ['postPartnersEmbeddedOnboardingSetPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingSetPassword>>, {data: PostPartnersEmbeddedOnboardingSetPassword}> = (props) => {
          const {data} = props ?? {};

          return  postPartnersEmbeddedOnboardingSetPassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersEmbeddedOnboardingSetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingSetPassword>>>
    export type PostPartnersEmbeddedOnboardingSetPasswordMutationBody = PostPartnersEmbeddedOnboardingSetPassword
    export type PostPartnersEmbeddedOnboardingSetPasswordMutationError = unknown

    export const usePostPartnersEmbeddedOnboardingSetPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingSetPassword>>, TError,{data: PostPartnersEmbeddedOnboardingSetPassword}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersEmbeddedOnboardingSetPassword>>,
        TError,
        {data: PostPartnersEmbeddedOnboardingSetPassword},
        TContext
      > => {

      const mutationOptions = getPostPartnersEmbeddedOnboardingSetPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List employers for partner admin view
 */
export const getGetPartnersEmployersUrl = (params?: GetPartnersEmployersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[assignee_ids][]","filter[statuses][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/partners/employers?${stringifiedParams}` : `/api/web/partners/employers`
}

export const getPartnersEmployers = async (params?: GetPartnersEmployersParams, options?: RequestInit): Promise<PartnersEmployer[]> => {
  
  return customFetch<PartnersEmployer[]>(getGetPartnersEmployersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPartnersEmployersQueryKey = (params?: GetPartnersEmployersParams,) => {
    return [
    `/api/web/partners/employers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPartnersEmployersQueryOptions = <TData = Awaited<ReturnType<typeof getPartnersEmployers>>, TError = unknown>(params?: GetPartnersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnersEmployersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnersEmployers>>> = ({ signal }) => getPartnersEmployers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmployers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnersEmployersQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnersEmployers>>>
export type GetPartnersEmployersQueryError = unknown


export function useGetPartnersEmployers<TData = Awaited<ReturnType<typeof getPartnersEmployers>>, TError = unknown>(
 params: undefined |  GetPartnersEmployersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmployers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersEmployers>>,
          TError,
          Awaited<ReturnType<typeof getPartnersEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersEmployers<TData = Awaited<ReturnType<typeof getPartnersEmployers>>, TError = unknown>(
 params?: GetPartnersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmployers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersEmployers>>,
          TError,
          Awaited<ReturnType<typeof getPartnersEmployers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersEmployers<TData = Awaited<ReturnType<typeof getPartnersEmployers>>, TError = unknown>(
 params?: GetPartnersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPartnersEmployers<TData = Awaited<ReturnType<typeof getPartnersEmployers>>, TError = unknown>(
 params?: GetPartnersEmployersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersEmployers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPartnersEmployersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update employer assignee
 */
export const getPatchPartnersEmployersIdAssigneeUrl = (id: string,) => {


  

  return `/api/web/partners/employers/${id}/assignee`
}

export const patchPartnersEmployersIdAssignee = async (id: string,
    patchPartnersEmployersIdAssignee: PatchPartnersEmployersIdAssignee, options?: RequestInit): Promise<PartnersEmployer> => {
  
  return customFetch<PartnersEmployer>(getPatchPartnersEmployersIdAssigneeUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchPartnersEmployersIdAssignee,)
  }
);}




export const getPatchPartnersEmployersIdAssigneeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPartnersEmployersIdAssignee>>, TError,{id: string;data: PatchPartnersEmployersIdAssignee}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPartnersEmployersIdAssignee>>, TError,{id: string;data: PatchPartnersEmployersIdAssignee}, TContext> => {

const mutationKey = ['patchPartnersEmployersIdAssignee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPartnersEmployersIdAssignee>>, {id: string;data: PatchPartnersEmployersIdAssignee}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPartnersEmployersIdAssignee(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPartnersEmployersIdAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof patchPartnersEmployersIdAssignee>>>
    export type PatchPartnersEmployersIdAssigneeMutationBody = PatchPartnersEmployersIdAssignee
    export type PatchPartnersEmployersIdAssigneeMutationError = unknown

    export const usePatchPartnersEmployersIdAssignee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPartnersEmployersIdAssignee>>, TError,{id: string;data: PatchPartnersEmployersIdAssignee}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchPartnersEmployersIdAssignee>>,
        TError,
        {id: string;data: PatchPartnersEmployersIdAssignee},
        TContext
      > => {

      const mutationOptions = getPatchPartnersEmployersIdAssigneeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List partner admins for a partner
 */
export const getGetPartnersPartnerIdPartnerAdminsUrl = (partnerId: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[roles][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/partners/${partnerId}/partner_admins?${stringifiedParams}` : `/api/web/partners/${partnerId}/partner_admins`
}

export const getPartnersPartnerIdPartnerAdmins = async (partnerId: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams, options?: RequestInit): Promise<PartnersPaginatedPartnerAdminList> => {
  
  return customFetch<PartnersPaginatedPartnerAdminList>(getGetPartnersPartnerIdPartnerAdminsUrl(partnerId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPartnersPartnerIdPartnerAdminsQueryKey = (partnerId?: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams,) => {
    return [
    `/api/web/partners/${partnerId}/partner_admins`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPartnersPartnerIdPartnerAdminsQueryOptions = <TData = Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError = unknown>(partnerId: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPartnersPartnerIdPartnerAdminsQueryKey(partnerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>> = ({ signal }) => getPartnersPartnerIdPartnerAdmins(partnerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPartnersPartnerIdPartnerAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>>
export type GetPartnersPartnerIdPartnerAdminsQueryError = unknown


export function useGetPartnersPartnerIdPartnerAdmins<TData = Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError = unknown>(
 partnerId: string,
    params: undefined |  GetPartnersPartnerIdPartnerAdminsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>,
          TError,
          Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersPartnerIdPartnerAdmins<TData = Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError = unknown>(
 partnerId: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>,
          TError,
          Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPartnersPartnerIdPartnerAdmins<TData = Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError = unknown>(
 partnerId: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPartnersPartnerIdPartnerAdmins<TData = Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError = unknown>(
 partnerId: string,
    params?: GetPartnersPartnerIdPartnerAdminsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnersPartnerIdPartnerAdmins>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPartnersPartnerIdPartnerAdminsQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a partner admin
 */
export const getPostPartnersPartnerIdPartnerAdminsUrl = (partnerId: string,) => {


  

  return `/api/web/partners/${partnerId}/partner_admins`
}

export const postPartnersPartnerIdPartnerAdmins = async (partnerId: string,
    postPartnersPartnerIdPartnerAdmins: PostPartnersPartnerIdPartnerAdmins, options?: RequestInit): Promise<PartnersPartnerAdmin> => {
  
  return customFetch<PartnersPartnerAdmin>(getPostPartnersPartnerIdPartnerAdminsUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postPartnersPartnerIdPartnerAdmins,)
  }
);}




export const getPostPartnersPartnerIdPartnerAdminsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdmins>>, TError,{partnerId: string;data: PostPartnersPartnerIdPartnerAdmins}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdmins>>, TError,{partnerId: string;data: PostPartnersPartnerIdPartnerAdmins}, TContext> => {

const mutationKey = ['postPartnersPartnerIdPartnerAdmins'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdmins>>, {partnerId: string;data: PostPartnersPartnerIdPartnerAdmins}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  postPartnersPartnerIdPartnerAdmins(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersPartnerIdPartnerAdminsMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdmins>>>
    export type PostPartnersPartnerIdPartnerAdminsMutationBody = PostPartnersPartnerIdPartnerAdmins
    export type PostPartnersPartnerIdPartnerAdminsMutationError = unknown

    export const usePostPartnersPartnerIdPartnerAdmins = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdmins>>, TError,{partnerId: string;data: PostPartnersPartnerIdPartnerAdmins}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdmins>>,
        TError,
        {partnerId: string;data: PostPartnersPartnerIdPartnerAdmins},
        TContext
      > => {

      const mutationOptions = getPostPartnersPartnerIdPartnerAdminsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Resend an invite to a partner admin
 */
export const getPostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInviteUrl = (partnerId: string,
    partnerAdminId: string,) => {


  

  return `/api/web/partners/${partnerId}/partner_admins/${partnerAdminId}/resend_invite`
}

export const postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite = async (partnerId: string,
    partnerAdminId: string, options?: RequestInit): Promise<PartnersPartnerAdmin> => {
  
  return customFetch<PartnersPartnerAdmin>(getPostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInviteUrl(partnerId,partnerAdminId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite>>, TError,{partnerId: string;partnerAdminId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite>>, TError,{partnerId: string;partnerAdminId: string}, TContext> => {

const mutationKey = ['postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite>>, {partnerId: string;partnerAdminId: string}> = (props) => {
          const {partnerId,partnerAdminId} = props ?? {};

          return  postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite(partnerId,partnerAdminId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite>>>
    
    export type PostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInviteMutationError = unknown

    export const usePostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite>>, TError,{partnerId: string;partnerAdminId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInvite>>,
        TError,
        {partnerId: string;partnerAdminId: string},
        TContext
      > => {

      const mutationOptions = getPostPartnersPartnerIdPartnerAdminsPartnerAdminIdResendInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a partner admin
 */
export const getPutPartnersPartnerIdPartnerAdminsPartnerAdminIdUrl = (partnerId: string,
    partnerAdminId: string,) => {


  

  return `/api/web/partners/${partnerId}/partner_admins/${partnerAdminId}`
}

export const putPartnersPartnerIdPartnerAdminsPartnerAdminId = async (partnerId: string,
    partnerAdminId: string,
    putPartnersPartnerIdPartnerAdminsPartnerAdminId: PutPartnersPartnerIdPartnerAdminsPartnerAdminId, options?: RequestInit): Promise<PartnersPartnerAdmin> => {
  
  return customFetch<PartnersPartnerAdmin>(getPutPartnersPartnerIdPartnerAdminsPartnerAdminIdUrl(partnerId,partnerAdminId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putPartnersPartnerIdPartnerAdminsPartnerAdminId,)
  }
);}




export const getPutPartnersPartnerIdPartnerAdminsPartnerAdminIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPartnersPartnerIdPartnerAdminsPartnerAdminId>>, TError,{partnerId: string;partnerAdminId: string;data: PutPartnersPartnerIdPartnerAdminsPartnerAdminId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putPartnersPartnerIdPartnerAdminsPartnerAdminId>>, TError,{partnerId: string;partnerAdminId: string;data: PutPartnersPartnerIdPartnerAdminsPartnerAdminId}, TContext> => {

const mutationKey = ['putPartnersPartnerIdPartnerAdminsPartnerAdminId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPartnersPartnerIdPartnerAdminsPartnerAdminId>>, {partnerId: string;partnerAdminId: string;data: PutPartnersPartnerIdPartnerAdminsPartnerAdminId}> = (props) => {
          const {partnerId,partnerAdminId,data} = props ?? {};

          return  putPartnersPartnerIdPartnerAdminsPartnerAdminId(partnerId,partnerAdminId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPartnersPartnerIdPartnerAdminsPartnerAdminIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPartnersPartnerIdPartnerAdminsPartnerAdminId>>>
    export type PutPartnersPartnerIdPartnerAdminsPartnerAdminIdMutationBody = PutPartnersPartnerIdPartnerAdminsPartnerAdminId
    export type PutPartnersPartnerIdPartnerAdminsPartnerAdminIdMutationError = unknown

    export const usePutPartnersPartnerIdPartnerAdminsPartnerAdminId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPartnersPartnerIdPartnerAdminsPartnerAdminId>>, TError,{partnerId: string;partnerAdminId: string;data: PutPartnersPartnerIdPartnerAdminsPartnerAdminId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPartnersPartnerIdPartnerAdminsPartnerAdminId>>,
        TError,
        {partnerId: string;partnerAdminId: string;data: PutPartnersPartnerIdPartnerAdminsPartnerAdminId},
        TContext
      > => {

      const mutationOptions = getPutPartnersPartnerIdPartnerAdminsPartnerAdminIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove a partner admin
 */
export const getDeletePartnersPartnerIdPartnerAdminsPartnerAdminIdUrl = (partnerId: string,
    partnerAdminId: string,) => {


  

  return `/api/web/partners/${partnerId}/partner_admins/${partnerAdminId}`
}

export const deletePartnersPartnerIdPartnerAdminsPartnerAdminId = async (partnerId: string,
    partnerAdminId: string, options?: RequestInit): Promise<PartnersPartnerAdmin> => {
  
  return customFetch<PartnersPartnerAdmin>(getDeletePartnersPartnerIdPartnerAdminsPartnerAdminIdUrl(partnerId,partnerAdminId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeletePartnersPartnerIdPartnerAdminsPartnerAdminIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePartnersPartnerIdPartnerAdminsPartnerAdminId>>, TError,{partnerId: string;partnerAdminId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePartnersPartnerIdPartnerAdminsPartnerAdminId>>, TError,{partnerId: string;partnerAdminId: string}, TContext> => {

const mutationKey = ['deletePartnersPartnerIdPartnerAdminsPartnerAdminId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePartnersPartnerIdPartnerAdminsPartnerAdminId>>, {partnerId: string;partnerAdminId: string}> = (props) => {
          const {partnerId,partnerAdminId} = props ?? {};

          return  deletePartnersPartnerIdPartnerAdminsPartnerAdminId(partnerId,partnerAdminId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePartnersPartnerIdPartnerAdminsPartnerAdminIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePartnersPartnerIdPartnerAdminsPartnerAdminId>>>
    
    export type DeletePartnersPartnerIdPartnerAdminsPartnerAdminIdMutationError = unknown

    export const useDeletePartnersPartnerIdPartnerAdminsPartnerAdminId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePartnersPartnerIdPartnerAdminsPartnerAdminId>>, TError,{partnerId: string;partnerAdminId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePartnersPartnerIdPartnerAdminsPartnerAdminId>>,
        TError,
        {partnerId: string;partnerAdminId: string},
        TContext
      > => {

      const mutationOptions = getDeletePartnersPartnerIdPartnerAdminsPartnerAdminIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Exchange a resource access token for a cookie if the token is valid
 */
export const getPatchResourceAccessTokensIdRedeemUrl = (id: string,) => {


  

  return `/api/web/resource_access_tokens/${id}/redeem`
}

export const patchResourceAccessTokensIdRedeem = async (id: string, options?: RequestInit): Promise<ResourceAccessTokensRedemptionResult> => {
  
  return customFetch<ResourceAccessTokensRedemptionResult>(getPatchResourceAccessTokensIdRedeemUrl(id),
  {      
    ...options,
    method: 'PATCH'
    
    
  }
);}




export const getPatchResourceAccessTokensIdRedeemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchResourceAccessTokensIdRedeem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchResourceAccessTokensIdRedeem>>, TError,{id: string}, TContext> => {

const mutationKey = ['patchResourceAccessTokensIdRedeem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchResourceAccessTokensIdRedeem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patchResourceAccessTokensIdRedeem(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchResourceAccessTokensIdRedeemMutationResult = NonNullable<Awaited<ReturnType<typeof patchResourceAccessTokensIdRedeem>>>
    
    export type PatchResourceAccessTokensIdRedeemMutationError = unknown

    export const usePatchResourceAccessTokensIdRedeem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchResourceAccessTokensIdRedeem>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchResourceAccessTokensIdRedeem>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatchResourceAccessTokensIdRedeemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get transactions for the member
 */
export const getGetMembersTransactionsUrl = (params: GetMembersTransactionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["categories[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/members/transactions?${stringifiedParams}` : `/api/web/members/transactions`
}

export const getMembersTransactions = async (params: GetMembersTransactionsParams, options?: RequestInit): Promise<MembersPaginatedBalanceTransactionList> => {
  
  return customFetch<MembersPaginatedBalanceTransactionList>(getGetMembersTransactionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersTransactionsQueryKey = (params?: GetMembersTransactionsParams,) => {
    return [
    `/api/web/members/transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMembersTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getMembersTransactions>>, TError = unknown>(params: GetMembersTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersTransactions>>> = ({ signal }) => getMembersTransactions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersTransactions>>>
export type GetMembersTransactionsQueryError = unknown


export function useGetMembersTransactions<TData = Awaited<ReturnType<typeof getMembersTransactions>>, TError = unknown>(
 params: GetMembersTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersTransactions>>,
          TError,
          Awaited<ReturnType<typeof getMembersTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersTransactions<TData = Awaited<ReturnType<typeof getMembersTransactions>>, TError = unknown>(
 params: GetMembersTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersTransactions>>,
          TError,
          Awaited<ReturnType<typeof getMembersTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersTransactions<TData = Awaited<ReturnType<typeof getMembersTransactions>>, TError = unknown>(
 params: GetMembersTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersTransactions<TData = Awaited<ReturnType<typeof getMembersTransactions>>, TError = unknown>(
 params: GetMembersTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get balance or deductions & monthly breakdown for the member with a given plan year
 */
export const getGetMembersTransactionsBalanceAndBreakdownsUrl = (params: GetMembersTransactionsBalanceAndBreakdownsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/members/transactions/balance_and_breakdowns?${stringifiedParams}` : `/api/web/members/transactions/balance_and_breakdowns`
}

export const getMembersTransactionsBalanceAndBreakdowns = async (params: GetMembersTransactionsBalanceAndBreakdownsParams, options?: RequestInit): Promise<MembersBalance> => {
  
  return customFetch<MembersBalance>(getGetMembersTransactionsBalanceAndBreakdownsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersTransactionsBalanceAndBreakdownsQueryKey = (params?: GetMembersTransactionsBalanceAndBreakdownsParams,) => {
    return [
    `/api/web/members/transactions/balance_and_breakdowns`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMembersTransactionsBalanceAndBreakdownsQueryOptions = <TData = Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError = unknown>(params: GetMembersTransactionsBalanceAndBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersTransactionsBalanceAndBreakdownsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>> = ({ signal }) => getMembersTransactionsBalanceAndBreakdowns(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersTransactionsBalanceAndBreakdownsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>>
export type GetMembersTransactionsBalanceAndBreakdownsQueryError = unknown


export function useGetMembersTransactionsBalanceAndBreakdowns<TData = Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError = unknown>(
 params: GetMembersTransactionsBalanceAndBreakdownsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>,
          TError,
          Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersTransactionsBalanceAndBreakdowns<TData = Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError = unknown>(
 params: GetMembersTransactionsBalanceAndBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>,
          TError,
          Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersTransactionsBalanceAndBreakdowns<TData = Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError = unknown>(
 params: GetMembersTransactionsBalanceAndBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersTransactionsBalanceAndBreakdowns<TData = Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError = unknown>(
 params: GetMembersTransactionsBalanceAndBreakdownsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersTransactionsBalanceAndBreakdowns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersTransactionsBalanceAndBreakdownsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the deposit account details for the member
 */
export const getGetMembersDepositAccountDetailsUrl = (params: GetMembersDepositAccountDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/members/deposit_account_details?${stringifiedParams}` : `/api/web/members/deposit_account_details`
}

export const getMembersDepositAccountDetails = async (params: GetMembersDepositAccountDetailsParams, options?: RequestInit): Promise<DepositAccountDetail> => {
  
  return customFetch<DepositAccountDetail>(getGetMembersDepositAccountDetailsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersDepositAccountDetailsQueryKey = (params?: GetMembersDepositAccountDetailsParams,) => {
    return [
    `/api/web/members/deposit_account_details`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMembersDepositAccountDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError = unknown>(params: GetMembersDepositAccountDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersDepositAccountDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>> = ({ signal }) => getMembersDepositAccountDetails(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersDepositAccountDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>>
export type GetMembersDepositAccountDetailsQueryError = unknown


export function useGetMembersDepositAccountDetails<TData = Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError = unknown>(
 params: GetMembersDepositAccountDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersDepositAccountDetails>>,
          TError,
          Awaited<ReturnType<typeof getMembersDepositAccountDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersDepositAccountDetails<TData = Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError = unknown>(
 params: GetMembersDepositAccountDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersDepositAccountDetails>>,
          TError,
          Awaited<ReturnType<typeof getMembersDepositAccountDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersDepositAccountDetails<TData = Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError = unknown>(
 params: GetMembersDepositAccountDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersDepositAccountDetails<TData = Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError = unknown>(
 params: GetMembersDepositAccountDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersDepositAccountDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersDepositAccountDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List enrollments
 */
export const getGetMembersEnrollmentsUrl = (params: GetMembersEnrollmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/members/enrollments?${stringifiedParams}` : `/api/web/members/enrollments`
}

export const getMembersEnrollments = async (params: GetMembersEnrollmentsParams, options?: RequestInit): Promise<MembersCategorizedEnrollments> => {
  
  return customFetch<MembersCategorizedEnrollments>(getGetMembersEnrollmentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersEnrollmentsQueryKey = (params?: GetMembersEnrollmentsParams,) => {
    return [
    `/api/web/members/enrollments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMembersEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof getMembersEnrollments>>, TError = unknown>(params: GetMembersEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersEnrollmentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersEnrollments>>> = ({ signal }) => getMembersEnrollments(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersEnrollments>>>
export type GetMembersEnrollmentsQueryError = unknown


export function useGetMembersEnrollments<TData = Awaited<ReturnType<typeof getMembersEnrollments>>, TError = unknown>(
 params: GetMembersEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getMembersEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersEnrollments<TData = Awaited<ReturnType<typeof getMembersEnrollments>>, TError = unknown>(
 params: GetMembersEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersEnrollments>>,
          TError,
          Awaited<ReturnType<typeof getMembersEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersEnrollments<TData = Awaited<ReturnType<typeof getMembersEnrollments>>, TError = unknown>(
 params: GetMembersEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersEnrollments<TData = Awaited<ReturnType<typeof getMembersEnrollments>>, TError = unknown>(
 params: GetMembersEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersEnrollments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersEnrollmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all instructions for a member
 */
export const getGetMembersInstructionsUrl = (params?: GetMembersInstructionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/members/instructions?${stringifiedParams}` : `/api/web/members/instructions`
}

export const getMembersInstructions = async (params?: GetMembersInstructionsParams, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetMembersInstructionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersInstructionsQueryKey = (params?: GetMembersInstructionsParams,) => {
    return [
    `/api/web/members/instructions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMembersInstructionsQueryOptions = <TData = Awaited<ReturnType<typeof getMembersInstructions>>, TError = unknown>(params?: GetMembersInstructionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersInstructionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersInstructions>>> = ({ signal }) => getMembersInstructions(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersInstructionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersInstructions>>>
export type GetMembersInstructionsQueryError = unknown


export function useGetMembersInstructions<TData = Awaited<ReturnType<typeof getMembersInstructions>>, TError = unknown>(
 params: undefined |  GetMembersInstructionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersInstructions>>,
          TError,
          Awaited<ReturnType<typeof getMembersInstructions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersInstructions<TData = Awaited<ReturnType<typeof getMembersInstructions>>, TError = unknown>(
 params?: GetMembersInstructionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersInstructions>>,
          TError,
          Awaited<ReturnType<typeof getMembersInstructions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersInstructions<TData = Awaited<ReturnType<typeof getMembersInstructions>>, TError = unknown>(
 params?: GetMembersInstructionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersInstructions<TData = Awaited<ReturnType<typeof getMembersInstructions>>, TError = unknown>(
 params?: GetMembersInstructionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersInstructionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get instructions for a member's latest enrollment event
 */
export const getGetMembersInstructionsLatestEnrollmentEventUrl = () => {


  

  return `/api/web/members/instructions/latest_enrollment_event`
}

export const getMembersInstructionsLatestEnrollmentEvent = async ( options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetMembersInstructionsLatestEnrollmentEventUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersInstructionsLatestEnrollmentEventQueryKey = () => {
    return [
    `/api/web/members/instructions/latest_enrollment_event`
    ] as const;
    }

    
export const getGetMembersInstructionsLatestEnrollmentEventQueryOptions = <TData = Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersInstructionsLatestEnrollmentEventQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>> = ({ signal }) => getMembersInstructionsLatestEnrollmentEvent({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersInstructionsLatestEnrollmentEventQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>>
export type GetMembersInstructionsLatestEnrollmentEventQueryError = unknown


export function useGetMembersInstructionsLatestEnrollmentEvent<TData = Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>,
          TError,
          Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersInstructionsLatestEnrollmentEvent<TData = Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>,
          TError,
          Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersInstructionsLatestEnrollmentEvent<TData = Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersInstructionsLatestEnrollmentEvent<TData = Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsLatestEnrollmentEvent>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersInstructionsLatestEnrollmentEventQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get instructions for a member by enrollment event ID
 */
export const getGetMembersInstructionsEnrollmentEventIdEnrollmentEventIdUrl = (enrollmentEventId: string,) => {


  

  return `/api/web/members/instructions/enrollment_event_id/${enrollmentEventId}`
}

export const getMembersInstructionsEnrollmentEventIdEnrollmentEventId = async (enrollmentEventId: string, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getGetMembersInstructionsEnrollmentEventIdEnrollmentEventIdUrl(enrollmentEventId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersInstructionsEnrollmentEventIdEnrollmentEventIdQueryKey = (enrollmentEventId?: string,) => {
    return [
    `/api/web/members/instructions/enrollment_event_id/${enrollmentEventId}`
    ] as const;
    }

    
export const getGetMembersInstructionsEnrollmentEventIdEnrollmentEventIdQueryOptions = <TData = Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError = unknown>(enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersInstructionsEnrollmentEventIdEnrollmentEventIdQueryKey(enrollmentEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>> = ({ signal }) => getMembersInstructionsEnrollmentEventIdEnrollmentEventId(enrollmentEventId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(enrollmentEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersInstructionsEnrollmentEventIdEnrollmentEventIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>>
export type GetMembersInstructionsEnrollmentEventIdEnrollmentEventIdQueryError = unknown


export function useGetMembersInstructionsEnrollmentEventIdEnrollmentEventId<TData = Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError = unknown>(
 enrollmentEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>,
          TError,
          Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersInstructionsEnrollmentEventIdEnrollmentEventId<TData = Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>,
          TError,
          Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersInstructionsEnrollmentEventIdEnrollmentEventId<TData = Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersInstructionsEnrollmentEventIdEnrollmentEventId<TData = Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError = unknown>(
 enrollmentEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersInstructionsEnrollmentEventIdEnrollmentEventId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersInstructionsEnrollmentEventIdEnrollmentEventIdQueryOptions(enrollmentEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update an instruction (currently only the status)
 */
export const getPatchMembersInstructionsInstructionIdUrl = (instructionId: string,) => {


  

  return `/api/web/members/instructions/${instructionId}`
}

export const patchMembersInstructionsInstructionId = async (instructionId: string,
    patchMembersInstructionsInstructionId: PatchMembersInstructionsInstructionId, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPatchMembersInstructionsInstructionIdUrl(instructionId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchMembersInstructionsInstructionId,)
  }
);}




export const getPatchMembersInstructionsInstructionIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMembersInstructionsInstructionId>>, TError,{instructionId: string;data: PatchMembersInstructionsInstructionId}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMembersInstructionsInstructionId>>, TError,{instructionId: string;data: PatchMembersInstructionsInstructionId}, TContext> => {

const mutationKey = ['patchMembersInstructionsInstructionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMembersInstructionsInstructionId>>, {instructionId: string;data: PatchMembersInstructionsInstructionId}> = (props) => {
          const {instructionId,data} = props ?? {};

          return  patchMembersInstructionsInstructionId(instructionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMembersInstructionsInstructionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchMembersInstructionsInstructionId>>>
    export type PatchMembersInstructionsInstructionIdMutationBody = PatchMembersInstructionsInstructionId
    export type PatchMembersInstructionsInstructionIdMutationError = unknown

    export const usePatchMembersInstructionsInstructionId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMembersInstructionsInstructionId>>, TError,{instructionId: string;data: PatchMembersInstructionsInstructionId}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMembersInstructionsInstructionId>>,
        TError,
        {instructionId: string;data: PatchMembersInstructionsInstructionId},
        TContext
      > => {

      const mutationOptions = getPatchMembersInstructionsInstructionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get Reimbursements
 */
export const getGetMembersReimbursementsUrl = (params?: GetMembersReimbursementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["filter[states][]","filter[purposes][]","filter[enrollment_categories][]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/members/reimbursements?${stringifiedParams}` : `/api/web/members/reimbursements`
}

export const getMembersReimbursements = async (params?: GetMembersReimbursementsParams, options?: RequestInit): Promise<MembersPaginatedReimbursements> => {
  
  return customFetch<MembersPaginatedReimbursements>(getGetMembersReimbursementsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMembersReimbursementsQueryKey = (params?: GetMembersReimbursementsParams,) => {
    return [
    `/api/web/members/reimbursements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMembersReimbursementsQueryOptions = <TData = Awaited<ReturnType<typeof getMembersReimbursements>>, TError = unknown>(params?: GetMembersReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersReimbursements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembersReimbursementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembersReimbursements>>> = ({ signal }) => getMembersReimbursements(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembersReimbursements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMembersReimbursementsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembersReimbursements>>>
export type GetMembersReimbursementsQueryError = unknown


export function useGetMembersReimbursements<TData = Awaited<ReturnType<typeof getMembersReimbursements>>, TError = unknown>(
 params: undefined |  GetMembersReimbursementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersReimbursements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersReimbursements>>,
          TError,
          Awaited<ReturnType<typeof getMembersReimbursements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersReimbursements<TData = Awaited<ReturnType<typeof getMembersReimbursements>>, TError = unknown>(
 params?: GetMembersReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersReimbursements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMembersReimbursements>>,
          TError,
          Awaited<ReturnType<typeof getMembersReimbursements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMembersReimbursements<TData = Awaited<ReturnType<typeof getMembersReimbursements>>, TError = unknown>(
 params?: GetMembersReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersReimbursements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMembersReimbursements<TData = Awaited<ReturnType<typeof getMembersReimbursements>>, TError = unknown>(
 params?: GetMembersReimbursementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMembersReimbursements>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMembersReimbursementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get report status and download URL
 */
export const getGetReportingIdUrl = (id: string,) => {


  

  return `/api/web/reporting/${id}`
}

export const getReportingId = async (id: string, options?: RequestInit): Promise<ReportingReport> => {
  
  return customFetch<ReportingReport>(getGetReportingIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetReportingIdQueryKey = (id?: string,) => {
    return [
    `/api/web/reporting/${id}`
    ] as const;
    }

    
export const getGetReportingIdQueryOptions = <TData = Awaited<ReturnType<typeof getReportingId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportingId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportingIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportingId>>> = ({ signal }) => getReportingId(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportingId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportingIdQueryResult = NonNullable<Awaited<ReturnType<typeof getReportingId>>>
export type GetReportingIdQueryError = unknown


export function useGetReportingId<TData = Awaited<ReturnType<typeof getReportingId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportingId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportingId>>,
          TError,
          Awaited<ReturnType<typeof getReportingId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportingId<TData = Awaited<ReturnType<typeof getReportingId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportingId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportingId>>,
          TError,
          Awaited<ReturnType<typeof getReportingId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportingId<TData = Awaited<ReturnType<typeof getReportingId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportingId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReportingId<TData = Awaited<ReturnType<typeof getReportingId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportingId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportingIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get next pending prompt for the current user
 */
export const getGetFeedbackPromptsNextUrl = (params?: GetFeedbackPromptsNextParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["keys[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/web/feedback/prompts/next?${stringifiedParams}` : `/api/web/feedback/prompts/next`
}

export const getFeedbackPromptsNext = async (params?: GetFeedbackPromptsNextParams, options?: RequestInit): Promise<WebAPIFeedbackEntitiesPrompt> => {
  
  return customFetch<WebAPIFeedbackEntitiesPrompt>(getGetFeedbackPromptsNextUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetFeedbackPromptsNextQueryKey = (params?: GetFeedbackPromptsNextParams,) => {
    return [
    `/api/web/feedback/prompts/next`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFeedbackPromptsNextQueryOptions = <TData = Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError = unknown>(params?: GetFeedbackPromptsNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedbackPromptsNextQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedbackPromptsNext>>> = ({ signal }) => getFeedbackPromptsNext(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeedbackPromptsNextQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedbackPromptsNext>>>
export type GetFeedbackPromptsNextQueryError = unknown


export function useGetFeedbackPromptsNext<TData = Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError = unknown>(
 params: undefined |  GetFeedbackPromptsNextParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackPromptsNext>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackPromptsNext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedbackPromptsNext<TData = Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError = unknown>(
 params?: GetFeedbackPromptsNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedbackPromptsNext>>,
          TError,
          Awaited<ReturnType<typeof getFeedbackPromptsNext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedbackPromptsNext<TData = Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError = unknown>(
 params?: GetFeedbackPromptsNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedbackPromptsNext<TData = Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError = unknown>(
 params?: GetFeedbackPromptsNextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedbackPromptsNext>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedbackPromptsNextQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a pending prompt for the current user (idempotent per key)
 */
export const getPostFeedbackPromptsUrl = () => {


  

  return `/api/web/feedback/prompts`
}

export const postFeedbackPrompts = async (postFeedbackPrompts: PostFeedbackPrompts, options?: RequestInit): Promise<WebAPIFeedbackEntitiesPrompt> => {
  
  return customFetch<WebAPIFeedbackEntitiesPrompt>(getPostFeedbackPromptsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postFeedbackPrompts,)
  }
);}




export const getPostFeedbackPromptsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedbackPrompts>>, TError,{data: PostFeedbackPrompts}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postFeedbackPrompts>>, TError,{data: PostFeedbackPrompts}, TContext> => {

const mutationKey = ['postFeedbackPrompts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFeedbackPrompts>>, {data: PostFeedbackPrompts}> = (props) => {
          const {data} = props ?? {};

          return  postFeedbackPrompts(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFeedbackPromptsMutationResult = NonNullable<Awaited<ReturnType<typeof postFeedbackPrompts>>>
    export type PostFeedbackPromptsMutationBody = PostFeedbackPrompts
    export type PostFeedbackPromptsMutationError = unknown

    export const usePostFeedbackPrompts = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedbackPrompts>>, TError,{data: PostFeedbackPrompts}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFeedbackPrompts>>,
        TError,
        {data: PostFeedbackPrompts},
        TContext
      > => {

      const mutationOptions = getPostFeedbackPromptsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Dismiss a prompt
 */
export const getPostFeedbackPromptsIdDismissUrl = (id: string,) => {


  

  return `/api/web/feedback/prompts/${id}/dismiss`
}

export const postFeedbackPromptsIdDismiss = async (id: string, options?: RequestInit): Promise<WebAPIFeedbackEntitiesPrompt> => {
  
  return customFetch<WebAPIFeedbackEntitiesPrompt>(getPostFeedbackPromptsIdDismissUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPostFeedbackPromptsIdDismissMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedbackPromptsIdDismiss>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postFeedbackPromptsIdDismiss>>, TError,{id: string}, TContext> => {

const mutationKey = ['postFeedbackPromptsIdDismiss'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFeedbackPromptsIdDismiss>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFeedbackPromptsIdDismiss(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFeedbackPromptsIdDismissMutationResult = NonNullable<Awaited<ReturnType<typeof postFeedbackPromptsIdDismiss>>>
    
    export type PostFeedbackPromptsIdDismissMutationError = unknown

    export const usePostFeedbackPromptsIdDismiss = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedbackPromptsIdDismiss>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFeedbackPromptsIdDismiss>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFeedbackPromptsIdDismissMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a feedback submission
 */
export const getPostFeedbackSubmissionsUrl = () => {


  

  return `/api/web/feedback/submissions`
}

export const postFeedbackSubmissions = async (postFeedbackSubmissions: PostFeedbackSubmissions, options?: RequestInit): Promise<WebAPIFeedbackEntitiesSubmission> => {
  
  return customFetch<WebAPIFeedbackEntitiesSubmission>(getPostFeedbackSubmissionsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postFeedbackSubmissions,)
  }
);}




export const getPostFeedbackSubmissionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedbackSubmissions>>, TError,{data: PostFeedbackSubmissions}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postFeedbackSubmissions>>, TError,{data: PostFeedbackSubmissions}, TContext> => {

const mutationKey = ['postFeedbackSubmissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFeedbackSubmissions>>, {data: PostFeedbackSubmissions}> = (props) => {
          const {data} = props ?? {};

          return  postFeedbackSubmissions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFeedbackSubmissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postFeedbackSubmissions>>>
    export type PostFeedbackSubmissionsMutationBody = PostFeedbackSubmissions
    export type PostFeedbackSubmissionsMutationError = unknown

    export const usePostFeedbackSubmissions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFeedbackSubmissions>>, TError,{data: PostFeedbackSubmissions}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFeedbackSubmissions>>,
        TError,
        {data: PostFeedbackSubmissions},
        TContext
      > => {

      const mutationOptions = getPostFeedbackSubmissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List all organization relationships for the current user
 */
export const getGetUsersOrganizationsUrl = () => {


  

  return `/api/web/users/organizations`
}

export const getUsersOrganizations = async ( options?: RequestInit): Promise<UsersUserOrganizations> => {
  
  return customFetch<UsersUserOrganizations>(getGetUsersOrganizationsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUsersOrganizationsQueryKey = () => {
    return [
    `/api/web/users/organizations`
    ] as const;
    }

    
export const getGetUsersOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getUsersOrganizations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersOrganizationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersOrganizations>>> = ({ signal }) => getUsersOrganizations({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersOrganizations>>>
export type GetUsersOrganizationsQueryError = unknown


export function useGetUsersOrganizations<TData = Awaited<ReturnType<typeof getUsersOrganizations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getUsersOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersOrganizations<TData = Awaited<ReturnType<typeof getUsersOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getUsersOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersOrganizations<TData = Awaited<ReturnType<typeof getUsersOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUsersOrganizations<TData = Awaited<ReturnType<typeof getUsersOrganizations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersOrganizations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Set the current organization
 */
export const getPostUsersOrganizationsSetCurrentUrl = () => {


  

  return `/api/web/users/organizations/set_current`
}

export const postUsersOrganizationsSetCurrent = async (postUsersOrganizationsSetCurrent: PostUsersOrganizationsSetCurrent, options?: RequestInit): Promise<unknown> => {
  
  return customFetch<unknown>(getPostUsersOrganizationsSetCurrentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postUsersOrganizationsSetCurrent,)
  }
);}




export const getPostUsersOrganizationsSetCurrentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersOrganizationsSetCurrent>>, TError,{data: PostUsersOrganizationsSetCurrent}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsersOrganizationsSetCurrent>>, TError,{data: PostUsersOrganizationsSetCurrent}, TContext> => {

const mutationKey = ['postUsersOrganizationsSetCurrent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersOrganizationsSetCurrent>>, {data: PostUsersOrganizationsSetCurrent}> = (props) => {
          const {data} = props ?? {};

          return  postUsersOrganizationsSetCurrent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsersOrganizationsSetCurrentMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersOrganizationsSetCurrent>>>
    export type PostUsersOrganizationsSetCurrentMutationBody = PostUsersOrganizationsSetCurrent
    export type PostUsersOrganizationsSetCurrentMutationError = unknown

    export const usePostUsersOrganizationsSetCurrent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersOrganizationsSetCurrent>>, TError,{data: PostUsersOrganizationsSetCurrent}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUsersOrganizationsSetCurrent>>,
        TError,
        {data: PostUsersOrganizationsSetCurrent},
        TContext
      > => {

      const mutationOptions = getPostUsersOrganizationsSetCurrentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
